{
    "brand": "Merke",
    "brands": "Merker",
    "brands_index_description": "Koble produktene dine til merker for å la kundene filtrere på merke i butikken. Du kan også vise merkenavnet som tittel på produktkortene — endre «Tittel i produktboks» under Produktboks i designbyggeren.",
    "brands_open_design_editor": "Åpne designbyggeren",
    "brands_page": "Merkeside",
    "type_name": "Typenavn",
    "new_brand": "Nytt merke",
    "no_brand": "— Ingen merke —",
    "select_a_brand": "Velg et merke",
    "delete_brand": "Slett merke",
    "brand_type_name_help": "Etikett for denne merketypen, f.eks. Produsent eller Leverandør.",
    "set_brand": "Sett merke",
    "set_brand_action_description": "Tildel et merke til de valgte produktene",
    "remove_brand": "Fjern merke",
    "remove_brand_action_description": "Fjern merket fra de valgte produktene",
    "are_you_sure_you_want_to_remove_the_brand_from_{count}_products": "Er du sikker på at du vil fjerne merket fra {count} produkt? | Er du sikker på at du vil fjerne merket fra {count} produkter?",
    "set_brand_modal_description": "Velg et merke som skal tildeles de valgte produktene.",
    "set_brand_on_x_amount_of_products": "Sett merke på {count} produkt | Sett merke på {count} produkter",
    "delete_brand_modal_description": "Dette vil slette merket {name}, brukt av {count} produkt | Dette vil slette merket {name}, brukt av {count} produkter",
    "brand_deleted": "Merke slettet",
    "brand_updated": "Merke oppdatert",
    "brand_created": "Merke opprettet",
    "product_brand_tooltip": "Merket som er tilknyttet dette produktet.",
    "product_box_title_mode": "Tittel i produktboks",
    "product_box_title_mode_description": "Velg om produktboksen viser produktnavn med ingress, eller merkenavn med produktnavn.",
    "product_box_title_mode_name": "Produktnavn + ingress",
    "product_box_title_mode_brand": "Merke + produktnavn",
    "brand_display": "Merkevisning",
    "brand_display_description": "Erstatt produkttittelen med merkenavnet, med eller uten logo over. Produktnavnet vises i liten tekst under, og merket lenker til merkesiden.",
    "brand_display_hidden": "skjult",
    "brand_display_name": "merkenavn som tittel",
    "brand_display_logo": "logo og merkenavn som tittel",
    "google_category_column": "Google-kategori",
    "sale_price_filter": "tilbudspris",
    "with_sale_price": "med tilbudspris",
    "without_sale_price": "uten tilbudspris",
    "stock_tracking_filter": "lageroversikt",
    "with_stock_tracking": "med lageroversikt",
    "without_stock_tracking": "uten lageroversikt",
    "set_product_form": "velg produktskjema",
    "remove_product_form": "fjern produktskjema",
    "set_product_form_action_description": "Koble et skjema med fritekstfelt til de valgte produktene",
    "remove_product_form_action_description": "Fjern produktskjemaet fra de valgte produktene",
    "set_product_form_for_x_amount_of_products": "Velg produktskjema for {count} produkt | Velg produktskjema for {count} produkter",
    "set_product_form_modal_description": "Produktene får det valgte skjemaet på produktsiden. Eksisterende skjema erstattes.",
    "are_you_sure_you_want_to_remove_product_form_from_{count}_products": "Er du sikker på at du vil fjerne produktskjemaet fra {count} produkt? | Er du sikker på at du vil fjerne produktskjemaet fra {count} produkter?",
    "enable_stock_notifications": "aktiver lagervarsler",
    "disable_stock_notifications": "deaktiver lagervarsler",
    "enable_stock_notifications_action_description": "La kunder melde seg på varsel når produktene kommer tilbake på lager",
    "disable_stock_notifications_action_description": "Skru av lagervarsel-påmelding for de valgte produktene",
    "are_you_sure_you_want_to_enable_stock_notifications_for_{count}_products": "Er du sikker på at du vil aktivere lagervarsler for {count} produkt? | Er du sikker på at du vil aktivere lagervarsler for {count} produkter?",
    "are_you_sure_you_want_to_disable_stock_notifications_for_{count}_products": "Er du sikker på at du vil deaktivere lagervarsler for {count} produkt? | Er du sikker på at du vil deaktivere lagervarsler for {count} produkter?",
    "category_column_manual_only_hint": "Viser kun manuelle kategorier",
    "filter": "filter",
    "no_products_match_the_current_filters": "Ingen produkter matcher gjeldende filtre eller søk",
    "showing_results_from_to_of_total": "Viser {from}–{to} av {total}",
    "out_of_stock": "ikke på lager",
    "columns": "kolonner",
    "column_price": "pris",
    "stock_empty": "Tom",
    "search_for_products_sku_or_gtin": "Søk etter produkter, SKU eller GTIN …",
    "add_badges": "Legg til badges",
    "remove_badges": "Fjern badges",
    "add_badges_products_action_description": "Legg til badges til de valgte produktene",
    "remove_badges_products_action_description": "Fjern badges fra de valgte produktene",
    "delete_tags_action_description": "Slett de valgte taggene og fjern dem fra alle produkter",
    "add_product_to_categories_action_description": "Legg produktet til i de valgte kategoriene",
    "move_to_top_action_description": "Flytt de valgte produktene først i kategorien",
    "remove_from_category_action_description": "Fjern de valgte produktene fra kategorien",
    "add_badges_to_x_amount_of_products": "Legg til badges til {count} produkt | Legg til badges til {count} produkter",
    "remove_badges_from_x_amount_of_products": "Fjern badges fra {count} produkt | Fjern badges fra {count} produkter",
    "add_x_badges": "Legg til {count} badge | Legg til {count} badges",
    "remove_x_badges": "Fjern {count} badge | Fjern {count} badges",
    "add_badges_modal_description": "Eventuelle produkter som allerede har de valgte badgene, vil ikke få dem lagt til igjen",
    "bulk_group_visibility": "synlighet",
    "bulk_group_prices": "priser",
    "bulk_group_organize": "organiser",
    "bulk_group_connections": "koblinger",
    "bulk_group_data": "data",
    "bulk_group_remove": "fjern",
    "all_actions": "alle handlinger",
    "quick_actions_label": "hurtig",
    "search_actions_placeholder": "Søk etter handling — pris, tags, slett …",
    "no_actions_found_for": "Ingen handlinger passer «{query}»",
    "select_current_page_only": "Velg kun denne siden",
    "all_x_products_selected": "alle {count} valgt",
    "x_of_y_actions": "{x} av {y} handlinger",
    "palette_navigate": "naviger",
    "palette_choose": "velg",
    "bulk_group_stock": "lager",
    "bulk_group_images": "bilder",
    "set_stock": "sett lagerantall",
    "adjust_stock": "juster lagerantall",
    "set_stock_action_description": "Sett samme lagerantall for de valgte produktene",
    "adjust_stock_action_description": "Øk eller reduser lagerantallet for de valgte produktene",
    "set_stock_for_x_amount_of_products": "Sett lagerantall for {count} produkt | Sett lagerantall for {count} produkter",
    "adjust_stock_for_x_amount_of_products": "Juster lagerantall for {count} produkt | Juster lagerantall for {count} produkter",
    "set_stock_modal_description": "Alle valgte produkter får det samme lagerantallet",
    "adjust_stock_modal_description": "Lagerantallet endres med verdien du oppgir, og stopper på null",
    "new_stock_value": "nytt lagerantall",
    "stock_adjustment_label": "endring i antall (bruk minus for å redusere)",
    "bulk_stock_applies_to_all_variants": "For produkter med varianter oppdateres alle variantene.",
    "no_tags_created_yet": "Ingen tags er opprettet ennå",
    "general.brand_asc": "Merke A–Å",
    "general.brand_desc": "Merke Å–A",
    "webhook": "webhooks",
    "dashboard": "dashbord",
    "sales": "salg",
    "orders": "ordre",
    "contacts": "kontakter",
    "customers": "kunder",
    "companies": "bedrifter",
    "customer_groups": "kundegrupper",
    "typography": "typografi",
    "colors": "farger",
    "products": "Produkter",
    "listings": "Oppføringer",
    "product_card": "Produktboks",
    "product_card_layout": "Layout",
    "product_card_badges": "Rabattmerker og merkelapper",
    "product_card_variants": "Variantvalg",
    "product_card_colors": "Farger",
    "product_management": "Produkthåndtering",
    "product": "Produkt",
    "all_products": "alle produkter",
    "categories": "Kategorier",
    "discounts": "rabatter",
    "marketing": "markedsføring",
    "newsletter_subscribers": "nyhetsbrevmottakere",
    "subscribers": "Abonnenter",
    "pages": "sider",
    "fixed_pages": "Faste sider",
    "fixed_text_updated": "Tekst oppdatert",
    "design": "design",
    "themes": "temaer",
    "reports": "rapporter",
    "settings": "innstillinger",
    "general": "generelt",
    "accounting": "Regnskap",
    "b2b_and_wholesale": "B2B",
    "users": "brukere",
    "shipping": "frakt",
    "working": "Arbeider...",
    "customs_data_help": "Brukes til tolldeklarasjon når en sending krysser en landegrense – også for innenlandsordre der transportruten går via utlandet.",
    "hs_code": "HS-kode (tolltariff)",
    "hs_code_placeholder": "F.eks. 6109.10",
    "hs_code_check_unknown": "HS-koden finnes ikke i tolltariffen. Du kan lagre den likevel, men kontroller den mot",
    "hs_code_check_tariff_link": "Tolletatens tolltariff",
    "country_of_origin": "Opprinnelsesland",
    "country_of_origin_placeholder": "Søk etter land...",
    "customs_description": "Tolldeklarasjonstekst",
    "customs_description_placeholder": "Kort beskrivelse av varen for tollmyndigheter, om ingenting defineres brukes ingress.",
    "customs_data_title": "Tolldata",
    "hs_code_batch_link_lead": "Mangler flere produkter HS-kode?",
    "hs_code_batch_link": "Foreslå koder for alle på én gang",
    "missing_customs_cta": "{count} produkt mangler tolldata | {count} produkter mangler tolldata",
    "missing_customs_banner_title": "{count} produkt mangler HS-kode | {count} produkter mangler HS-kode",
    "missing_customs_banner_body": "Sendinger til Nord-Norge kan bli transportert via Sverige eller Finland. For slike sendinger kreves HS-kode på produktene.",
    "missing_customs_banner_link": "Se produktene",
    "hs_code_explainer_summary": "Hvorfor trenger produktene HS-kode? Manglende kode kan gi problemer med transporten og økte kostnader.",
    "hs_code_explainer_nvit_title": "Sender du varer mellom Sør- og Nord-Norge? Da kan du være omfattet av nye krav til vareinformasjon.",
    "hs_code_explainer_nvit_body": "Varer som sendes fra ett sted i Norge til et annet, men som transporteres gjennom Sverige eller Finland underveis, regnes som <strong>norske varer i transitt (NVIT)</strong>. For slike forsendelser må transportøren ha mer detaljert informasjon om varene. Blant annet skal hver varetype ha et korrekt <strong>sekssifret HS-varenummer (HS-kode)</strong>. Manglende eller mangelfull informasjon kan føre til problemer med transporten og potensielt økte kostnader.",
    "hs_code_explainer_what_title": "Hva er en HS-kode?",
    "hs_code_explainer_what_body": "En <strong>HS-kode</strong> er et internasjonalt varenummer som brukes til å klassifisere hva slags vare som sendes. Ulike typer produkter har forskjellige HS-koder. Derfor er det viktig at produktene i nettbutikken din har riktig kode.",
    "hs_code_explainer_help_title": "Vi hjelper deg med jobben",
    "hs_code_explainer_help_body": "Har du mange produktlinjer, kan det være krevende å legge til alle HS-kodene. Vi har derfor utviklet en tjeneste som skal hjelpe deg i dette arbeidet. AI-funksjonen er laget for å gjøre arbeidet med klassifisering raskere, men forslagene bør kontrolleres før de tas i bruk. <strong>Du som vareeier er ansvarlig for at HS-koden og øvrige vareopplysninger som oppgis til transportøren er korrekte.</strong> Er du usikker på klassifiseringen av en vare, anbefaler vi å kontrollere den mot Tolletatens tolltariff eller kontakte Tolletaten for veiledning. Når en HS-kode er registrert på produktet, sendes den automatisk til transportøren når frakten bookes.",
    "hs_code_explainer_link": "Les mer om NVIT hos Tolletaten",
    "all_products_have_hs_code": "Alle produkter har HS-kode",
    "all_products_have_hs_code_help": "Ingen produkter mangler tolltariff-data akkurat nå.",
    "add_hs_code": "Legg til HS-kode",
    "import_customs_data": "Importer tolldata",
    "export_customs_data": "Eksporter alle produkter",
    "customs_export_failed": "Kunne ikke eksportere tolldata",
    "customs_import_failed": "Kunne ikke importere tolldata",
    "customs_import_result_page_title": "Importresultat",
    "customs_import_result_heading": "Resultat av tolldata-import",
    "total_rows_processed": "Rader behandlet",
    "successfully_updated": "Vellykket oppdatert",
    "rejected_rows": "Avviste rader",
    "customs_import_all_succeeded": "Alle rader ble importert uten feil.",
    "customs_import_how_to_fix": "Last ned feilrapporten under for å se alle avviste rader. Rett opp verdiene direkte i filen og last den opp på nytt via Importer-knappen.",
    "customs_import_preview_truncated": "Viser de første {shown} av {total} avviste radene. Last ned feilrapporten for å se alle.",
    "download_error_report": "Last ned feilrapport (CSV)",
    "row": "Rad",
    "problem": "Problem",
    "rejected_value": "Avvist verdi",
    "rows_with_warnings": "Rader med advarsel",
    "customs_import_warnings_help": "Disse radene ble oppdatert, men HS-koden ble ikke gjenkjent som en 6-sifret kode i tolltariffen. Kontroller kodene mot Tolletatens tolltariff.",
    "saved_value": "Lagret verdi",
    "customs_import_reason_invalid_product_id": "Produkt-ID mangler eller er ikke et tall.",
    "customs_import_reason_product_not_found": "Produktet finnes ikke.",
    "customs_import_reason_variant_row": "Variantrad ignorert (tolldata lagres per produkt).",
    "customs_import_reason_hs_code_not_recognized": "HS-koden er lagret, men finnes ikke i tolltariffen. Kontroller den.",
    "customs_import_reason_invalid_country_code": "Opprinnelseslandet er ikke en gyldig ISO 3166-1 alpha-2 kode.",
    "customs_import_reason_description_too_long": "Tollbeskrivelsen er lengre enn 255 tegn.",
    "could_not_read_upload": "Filen kunne ikke leses.",
    "csv_missing_header_row": "CSV-filen mangler en gyldig overskriftsrad.",
    "csv_no_customs_columns_found": "Fant ingen tollkolonner (HS-kode, Opprinnelsesland, Tolldeklarasjon) i CSV.",
    "suggest_hs_code": "Foreslå HS-kode",
    "suggesting_hs_code": "Foreslår...",
    "suggested_hs_code": "Foreslått HS-kode",
    "ai_confidence": "KI-sikkerhet",
    "accept": "Bruk",
    "dismiss": "Avvis",
    "hs_code_suggester_unavailable": "Forslagstjenesten er ikke tilgjengelig akkurat nå. Prøv igjen om litt.",
    "hs_code_suggest_trial": "HS-kodeforslag er en AI-funksjon og krever et betalt abonnement.",
    "hs_code_suggest_topup_link": "Fyll på AI-saldo",
    "hs_code_suggest_charged": "Belastet {amount} · saldo {balance}",
    "hs_code_suggest_cached": "Gratis (bufret forslag) · saldo {balance}",
    "hs_code_suggest_empty_title": "Gi produktet et navn før du ber om et forslag.",
    "hs_code_batch_intro_title": "Få forslag til manglende HS-koder",
    "hs_code_batch_intro_body": "Få AI-forslag basert på produktinformasjonen. Du velger hvilke koder som lagres.",
    "hs_code_batch_scope_short": "Kjøringen gjelder hele butikken, ikke bare søket eller siden du ser.",
    "hs_code_batch_scope": "Henter forslag for alle aktuelle produkter uten HS-kode i butikken, også på andre sider og utenfor søket ditt. Produkter som allerede behandles eller har et forslag til vurdering, sendes ikke på nytt.",
    "hs_code_batch_sending_help": "Hold siden åpen til alle produktene er sendt. Deretter kan du forlate siden mens forslagene behandles.",
    "hs_code_batch_processing_help": "Innsendingen er avsluttet. Sendte produkter behandles i bakgrunnen. Du kan forlate siden og komme tilbake hit for å se resultatene.",
    "hs_code_batch_review_help": "Ingen koder lagres før du godtar dem. Betalingen gjelder genereringen av forslag, også hvis du avviser dem.",
    "hs_code_batch_confidence_help": "Prosenten er AI-ens egen vurdering, ikke en garanti for riktig kode.",
    "hs_code_batch_bulk_scope": "Gjelder alle forslag som oppfyller grensen, også utenfor søket og på andre sider.",
    "hs_code_batch_threshold_empty": "Ingen forslag oppfyller valgt grense. Vurder forslagene enkeltvis, eller velg en lavere grense.",
    "hs_code_batch_view_reasoning": "Se begrunnelse",
    "hs_code_batch_page_help": "{count} produkter mangler HS-kode. Fyll inn manuelt, importer tolldata eller hent AI-forslag.",
    "hs_code_batch_reserved": "reservert {amount}",
    "hs_code_batch_try_again": "Vent litt før du prøver igjen.",
    "hs_code_batch_run": "Foreslå HS-koder ({count})",
    "hs_code_batch_confirm_title": "Hent HS-kodeforslag ({count})",
    "hs_code_batch_confirm_price": "Anslag: {estimate} totalt · {price} per nytt forslag",
    "hs_code_batch_confirm_body": "Faktisk pris og beløpet som reserveres fra AI-saldoen kan være høyere enn anslaget. Ubrukt reservasjon tilbakeføres. Gjenbrukte, bufrede forslag er gratis.",
    "hs_code_batch_start": "Send til behandling",
    "hs_code_batch_submitting": "Sender {done} av {total} produkter …",
    "hs_code_batch_processing": "Henter forslag … {done} av {total} ferdig",
    "hs_code_batch_completed": "{suggested} forslag klare · {failed} uten forslag · belastet {amount}",
    "hs_code_batch_unreachable": "Får ikke kontakt med AI-tjenesten akkurat nå.",
    "hs_code_batch_overdue": "Tar lengre tid enn vanlig.",
    "hs_code_batch_failed": "En kjøring mislyktes ({code}). Se belastet beløp i oppsummeringen.",
    "hs_code_batch_insufficient": "Saldoen strakk ikke til: {sent} av {total} produkter sendt.",
    "hs_code_batch_accept_all": "Godta alle med minst {percent} % sikkerhet ({count})",
    "hs_code_batch_accept_all_confirm": "Bekreft: godta {count}",
    "hs_code_batch_accepted_count": "{count} koder lagret",
    "hs_code_with_suggestion": "Med forslag",
    "hs_code_no_suggestion": "Ingen forslag",
    "hs_code_no_suggestion_empty_title": "Produktet mangler navn",
    "hs_code_no_suggestion_invalid_result": "AI-tjenesten svarte med en kode som ikke finnes i tolltariffen.",
    "hs_code_no_suggestion_not_found": "Kjøringen finnes ikke lenger hos AI-tjenesten.",
    "hs_code_saved": "Lagret {code}",
    "hs_code_dismissed": "Avvist",
    "hs_code_already_decided": "Denne raden er allerede avgjort.",
    "hs_code_already_set": "Produktet har allerede en HS-kode.",
    "hs_code_changed_since_recheck": "HS-koden ble endret etter at kontrollen startet.",
    "hs_code_no_suggestions_to_review": "Ingen forslag å vurdere. Kjør Foreslå HS-koder for å hente nye.",
    "hs_code_suggestion_column": "Forslag",
    "hs_code_confidence_threshold": "Minste AI-sikkerhet",
    "hs_code_not_recognized": "HS-koden :code finnes ikke i tolltariffen.",
    "hs_code_tab_missing": "Mangler HS-kode",
    "hs_code_tab_recheck": "Kontroller lagrede koder",
    "hs_code_recheck_intro_title": "Kontroller lagrede HS-koder",
    "hs_code_recheck_intro_body": "Hent et nytt AI-forslag for produkter som allerede har en HS-kode. Der forslaget stemmer med den lagrede koden, markeres produktet som bekreftet. Bare avvik vises her for vurdering.",
    "hs_code_recheck_scope_short": "Gjelder alle produkter med lagret HS-kode, også koder du har lagt inn selv. Vil du kontrollere bare noen produkter, velger du dem i produktlisten og velger Kontroller HS-koder.",
    "hs_code_recheck_run": "Kontroller lagrede koder ({count})",
    "hs_code_recheck_confirm_title": "Kontroller lagrede HS-koder ({count})",
    "hs_code_recheck_confirm_selected_title": "Kontroller {count} valgte produkter",
    "hs_code_recheck_scope": "Henter et nytt forslag for hvert produkt med lagret HS-kode. Lagrede koder endres ikke før du erstatter dem.",
    "hs_code_recheck_selected_without_code": "{count} av de valgte produktene har ingen lagret kode. Du finner dem under Mangler HS-kode.",
    "hs_code_recheck_selection_expired": "Utvalget fra produktlisten er utløpt, så kjøringen gjelder alle lagrede koder.",
    "hs_code_batch_redo_waiting": "Hent også nye forslag for de {count} produktene som venter på vurdering",
    "hs_code_recheck_saved": "Lagret",
    "hs_code_recheck_suggested": "foreslått",
    "hs_code_recheck_replace": "Erstatt",
    "hs_code_recheck_keep": "Behold",
    "hs_code_recheck_kept": "Beholdt {code}",
    "hs_code_recheck_completed": "{confirmed} bekreftet · {differ} avvik · {failed} uten forslag · belastet {amount}",
    "hs_code_recheck_replace_all": "Erstatt alle med minst {percent} % sikkerhet ({count})",
    "hs_code_recheck_replace_all_confirm": "Bekreft: erstatt {count}",
    "hs_code_recheck_replaced_count": "{count} koder erstattet",
    "hs_code_recheck_bulk_scope": "Erstatter den lagrede koden på alle avvik som når terskelen, også koder du har lagt inn selv, andre sider og treff utenfor søket ditt.",
    "hs_code_recheck_empty_help": "Kjør en kontroll for å sammenligne lagrede koder med et nytt forslag.",
    "country_code_must_be_a_string": "Landkoden må være tekst.",
    "country_code_not_recognized": "Landkoden :code er ikke en gyldig ISO 3166-1 alpha-2-kode.",
    "packages": "pakker",
    "order_notifications": "ordrevarslinger",
    "billing": "faktureringsinformasjon",
    "legal": "juridisk",
    "domains": "domener",
    "seo_and_analytics": "SEO og analytics",
    "payment_providers": "betalingsleverandører",
    "api_access": "API-tilgang",
    "add_product": "legg til produkt",
    "all": "alle",
    "none": "ingen",
    "draft": "utkast",
    "visible": "Synlig",
    "hidden": "Skjult",
    "name": "Navn",
    "name_in_the_store": "navn i butikken",
    "status": "status",
    "last_updated": "sist oppdatert",
    "draft_without_name": "utkast uten navn",
    "save": "lagre",
    "save_amount": "Spar",
    "saving": "Lagrer...",
    "this_shipping_method_requires_configuration": "Denne fraktmåten krever konfigurasjon.",
    "go_to_apps": "Gå til apps",
    "to_enable_and_configure_this_shipping_method": "for å aktivere og konfigurere denne fraktmåten.",
    "fallback_shipping_configuration": "Konfigurasjon av reservefrakt",
    "what_is_fallback_shipping": "Hva er reservefrakt?",
    "fallback_shipping_description": "Reservefrakt er et backup fraktalternativ som sikrer at kunder alltid har minst én fraktmetode tilgjengelig ved checkout. Det gir en pålitelig fraktmulighet når alle andre fraktleverandører er utilgjengelige eller deaktivert.",
    "when_activated": "Når aktivert",
    "fallback_shipping_activation_condition": "Når ingen vanlige fraktmetoder (Bring, 24Shipping, osv.) er tilgjengelige eller aktivert",
    "fallback_shipping_name": "Skriv inn navn på fraktmetode",
    "enter_price": "Skriv inn pris",
    "submit": "Send inn",
    "skip": "Hopp over",
    "product_name": "produktnavn",
    "lead_paragraph": "ingress",
    "product_information": "produktinformasjon",
    "product_layout": "produktoppsett",
    "image": "bilde | bilder",
    "image_height_desktop": "Bildehøyde på desktop",
    "image_height_mobile": "Bildehøyde på mobil",
    "image_height_adapt_first": "Tilpass første bilde",
    "image_aspect_ultrawide": "Ultrabred (21:9)",
    "image_height_ratio_description": "Forholdsvalgene gir alle bildene samme ramme på alle skjermbredder. «Tilpass første bilde» bruker det første bildets forhold på hele slideren.",
    "image_title": "bildetittel",
    "auto": "Auto",
    "gtin": "GTIN",
    "upload_a_file": "last opp en fil",
    "or_drag_and_drop": "eller dra og slipp",
    "up_to": "opp til",
    "price": "pris | priser",
    "sale_price": "salgspris | salgspriser",
    "sale_price_incl_vat": "Tilbudspris inkl. MVA",
    "compare_at": "førpris",
    "tax_rate": "MVA-sats",
    "cost_price": "innkjøpspris",
    "in_stock": "lagerantall",
    "sku": "SKU",
    "is_visible": "er synlig",
    "edit_profile": "rediger profil",
    "log_out": "logg ut",
    "profile_information": "profilinformasjon",
    "update_your_account_information": "Oppdater din konto's profilinformasjon.",
    "email_cannot_be_changed_create_new_user": "e-postadressen din kan ikke endres. For å bruke en annen adresse må det opprettes en ny bruker.",
    "email": "e-post",
    "email_address": "e-postadresse",
    "password": "passord",
    "repeat_password": "gjenta passord",
    "update_password": "oppdater passord",
    "ensure_your_account_is_using": "Sørg for at kontoen din bruker et langt, tilfeldig passord for å være sikker.",
    "current_password": "nåværende passord",
    "new_password": "nytt passord",
    "confirm_password": "bekreft passord",
    "delete_account": "slett konto",
    "once_your_account_is_deleted": "Når kontoen din er slettet, vil alle dens ressurser og data bli permanent slettet. Før du sletter kontoen din, må du laste ned eventuelle data eller informasjon du ønsker å beholde.",
    "your_email_is_unverified": "Din e-postadresse er ikke bekreftet",
    "click_to_resend_verification_email": "Klikk her for å sende bekreftelses-e-posten på nytt.",
    "verification_link_has_been_sent": "En ny bekreftelseslenke er sendt til din e-postadresse.",
    "saved": "lagret",
    "are_you_sure_you_want_to_delete_your_account": "Er du sikker på at du vil slette kontoen din?",
    "cancel": "avbryt",
    "remember_me": "husk meg",
    "forgot_your_password": "glemt passordet ditt?",
    "log_in": "logg inn",
    "forgot_your_password_no_problem": "Har du glemt passordet ditt? Ingen problem. Bare oppgi din e-postadresse, så sender vi deg en lenke for tilbakestilling av passordet som lar deg velge et nytt.",
    "email_password_reset_link": "send e-post med lenke for passordtilbakestilling",
    "logged_in": "Du er logget inn!",
    "description": "Beskrivelse",
    "title": "tittel",
    "slug": "sti",
    "add_category": "legg til kategori",
    "edit_main_menu": "Rediger hovedmeny",
    "include_subcategories": "inkluder underkategorier",
    "new_subcategory": "ny underkategori",
    "new_subcategory_in": "ny underkategori i {category}",
    "new_top_level_category": "ny hovedkategori",
    "category_creation_also_adds_to_menu": "Kategorien blir ogs\u00e5 lagt inn i hovedmenyen p\u00e5 dette stedet.",
    "category_creation_needs_one_category": "Du har valgt flere kategorier. Velg \u00e9n for \u00e5 opprette en kategori et bestemt sted.",
    "menu_depth_reached_cannot_nest": "Hovedmenyen kan ikke ha flere enn tre niv\u00e5er, s\u00e5 denne kategorien kan ikke f\u00e5 underkategorier.",
    "new_product_here": "nytt produkt her",
    "will_be_added_to_category": "legges til i kategorien",
    "selected category could not be found": "Fant ikke den valgte kategorien.",
    "cannot_attach_products_to_a_smart_category": "Smarte kategorier styres av kriterier, så produkter kan ikke legges til manuelt.",
    "menu_placement": "plassering i hovedmeny",
    "no_menu_placement": "ingen plassering",
    "menu_placement_top_level": "\u00f8verste niv\u00e5 i hovedmenyen",
    "list_view": "listevisning",
    "hierarchy_view": "hierarkivisning",
    "not_in_main_navigation": "ikke i hovedmeny",
    "add_new_category": "legg til ny kategori",
    "category_title_placeholder": "f.eks. Klær",
    "search": "søk",
    "search_products": "Søk etter produkter",
    "add_products": "legg til produkter",
    "create": "opprett",
    "product_description_name": "fanenavn",
    "product_description_placeholder": "Størrelsesguide",
    "are_you_sure_you_want_to_delete": "er du sikker på at du ønsker å slette {name}?",
    "item_deleted": ":name slettet",
    "item_created": ":name opprettet",
    "update_product_description_name": "oppdater fanenavn",
    "images": "bilder",
    "files": "filer",
    "variants": "varianter",
    "no_variants": "Ingen varianter",
    "option": "alternativ | alternativ",
    "option_value": "alternativ-verdi | alternativ-verdier",
    "select": "velg:",
    "cant_delete_last_option_value_please_add_another_or_delete_the_option": "Siste alternativ-verdi kan ikke slettes, vennligst legg til et annet først, eller slette hele alternativet.",
    "edit": "rediger",
    "done": "utført",
    "already_exists": "finnes allerede",
    "add_first_option_value": "Legg til første alternativ-verdi",
    "is_new": "ny",
    "enabled": "aktiv",
    "actions": "handlinger",
    "set_count_variants_to_enabled_status": "Velg ønsket status for variantene ({qty} stk)",
    "disabled_variants_will_not_be_buyable": "Deaktiverte varianter vil ikke være kjøpbare",
    "please_wait": "Vennligst vent",
    "active": "aktiv",
    "inactive": "inaktiv",
    "navigation": "navigasjon",
    "menu": "meny | menyer",
    "add_menu": "legg til meny",
    "menu_item": "menypunkt | menypunkter",
    "add": "legg til",
    "variant": "Variant",
    "stock": "varelager",
    "search_engine_listing": "Søkemotoroppføring",
    "characters_of_available_used": "{characters} tegn brukt av {available} tilgjengelig",
    "slug_change_warning": "Advarsel: Endring av URL-stien til produktet ditt kan påvirke rangeringen i søkemotorer negativt. Søkemotorer som Google kan allerede ha indeksert den eksisterende URL-en, og endring av den vil bryte eksisterende lenker og kreve ny indeksering.",
    "change": "endre",
    "change_dates": "Endre datoer",
    "pricing_and_tax": "Pris og MVA",
    "prices_are_defined_on_variant_level": "Priser er definert på variant-nivå",
    "discount_rate": "rabattsats",
    "discount_percentage": "Rabattprosent",
    "price_including_vat": "pris inkl. MVA",
    "price_excluding_vat": "pris eks. MVA",
    "excluding_vat": "eks. MVA",
    "compare_at_price": "førpris",
    "optional": "Valgfritt",
    "price_adjustment": "prisjustering",
    "price_adjustment_including_vat": "prisjustering inkl. MVA",
    "margin": "Margin",
    "preview": "forhåndsvisning",
    "close": "lukk",
    "text_editor_empty_placeholder": "Klikk for å skrive tekst…",
    "delete": "slett",
    "deleted": "slettet",
    "weight": "vekt",
    "height": "høyde",
    "length": "lengde",
    "width": "bredde",
    "create_new_product": "opprett nytt produkt",
    "translate": "oversett",
    "quantity_for_sale": "antall til salgs",
    "track_inventory": "benytt lageroversikt",
    "calculated_from_variants": "beregnet fra varianter",
    "inventory": "varelager",
    "keeps_track_of_stock_as_you_sell_items": "holder telling på varelager når du selger varer",
    "allow_backorder": "tillat restordre",
    "continue_selling_when_out_of_stock": "Dette betyr at selv om varelageret er tomt, kan kunden fortsette å bestille varen.",
    "visibility": "synlighet",
    "requires_shipping": "krever frakt",
    "weight_from": "minimumsvekt",
    "weight_to": "maksvekt",
    "buying_this_product_means_shipping_will_be_required": "å kjøpe dette produktet innebærer at frakt vil være nødvendig",
    "text": "tekst",
    "add_page": "legg til side",
    "new_page": "ny side",
    "page_name": "sidenavn",
    "are_you_sure_you_want_to_delete_the_page": "Er du sikker på at du vil slette side {page}?",
    "delete_page": "Slett side",
    "could_not_add_requested_quantity_of_item_to_cart_there_is_insufficient_stock_available": "Kunne ikke legge til ønsket antall av varen i handlekurven. Utilstrekkelig antall på lager.",
    "item_must_have_quantity_greater_than_zero": "Varen må ha et antall større enn null.",
    "view_store": "Se butikken",
    "cart_quantity_reduced_due_to_insufficient_stock": "Antall i handlekurven ble redusert på grunn av utilstrekkelig antall på lager.",
    "cart_item_removed_because_it_was_no_longer_buyable": "En vare ble fjernet fra handlevognen fordi den ikke lenger er tilgjengelig.",
    "could_not_add_item_to_cart_it_is_not_available_for_purchase": "En vare kunne ikke legges i handlevognen, den er ikke tilgjengelig for kjøp.",
    "show_order_summary": "vis handlevogn",
    "hide_order_summary": "skjul handlevogn",
    "in_your_cart": "i handlekurven",
    "header": "header",
    "product_slider": "produktslider",
    "product_grid": "produktgrid",
    "single_product": "enkeltprodukt",
    "image_slider": "bildeslider",
    "image_grid": "bildegrid",
    "bento_grid": "Bento-grid",
    "bento_layout_variant": "Oppsett",
    "bento_layout_variant_description": "Velg hvordan rutene plasseres i rutenettet",
    "bento_variant_feature_left": "Fremhevet venstre",
    "bento_variant_feature_right": "Fremhevet høyre",
    "bento_variant_showcase": "Utstilling",
    "bento_variant_mosaic": "Mosaikk",
    "bento_variant_hero": "Toppbanner",
    "bento_variant_strips": "Striper",
    "bento_row_height": "Høyde på ruter",
    "bento_row_height_description": "Grunnhøyde for hver rute (px). Store ruter blir et multiplum av denne.",
    "before_after_image": "før/etter-bilde",
    "logo_slider": "logo-slider",
    "block_description_logo_slider": "En rad med logoer som beveger seg automatisk – kontinuerlig rulling eller sidevis.",
    "logos": "logoer",
    "logo_slider_logos_description": "Last opp logoene som skal vises. SVG, PNG, JPG og WebP støttes.",
    "logos_per_view_desktop": "logoer i bredden (desktop)",
    "logos_per_view_mobile": "logoer i bredden (mobil)",
    "logo_slider_logo_height": "logohøyde (px)",
    "logo_slider_movement_style": "bevegelse",
    "logo_slider_movement_style_description": "Kontinuerlig rulling glir jevnt sidelengs; sidevis bytter noen logoer om gangen.",
    "logo_slider_movement_paged": "sidevis autoplay",
    "logo_slider_movement_marquee": "kontinuerlig rulling",
    "logo_slider_autoplay_interval": "autoplay-hastighet",
    "logo_slider_marquee_speed": "rullehastighet",
    "logo_slider_speed_slow": "treg",
    "logo_slider_speed_normal": "normal",
    "logo_slider_speed_fast": "rask",
    "logo_slider_pause_on_hover": "pause ved hover",
    "logo_slider_controls_paged_only": "Gjelder kun ved sidevis autoplay.",
    "image_grid_slider": "bildegrid slider",
    "footer": "footer",
    "text_content": "tekstinnhold",
    "campaign_bar": "kampanjelinje",
    "phone": "telefon",
    "phone_number": "telefonnummer",
    "store_information": "firmaopplysninger",
    "company_name": "firmanavn",
    "company_number": "organisasjonsnummer",
    "address": "adresse",
    "address2": "adresse 2",
    "postal_code": "postnummer",
    "city": "poststed",
    "about_store_settings": "Denne informasjonen vil bli synlig for kunder og besøkende i nettbutikken",
    "about_contact_settings": "Tillat kunder og besøkende å stille alle spørsmål til butikken",
    "notify_on_new_customer": "Varsle meg om nye kunder",
    "notify_on_new_customer_description": "Send en e-post til adressen over når en ny kunde registrerer seg i nettbutikken.",
    "billing_information": "Informasjon 24Nettbutikk vil bruke for å fakturere for nettbutikken",
    "created": "opprettet",
    "created_at": "opprettet",
    "csv_export": "CSV-eksport",
    "newsletter_form": "nyhetsbrevpåmelding",
    "primary_color": "primærfarge",
    "secondary_color": "sekundærfarge",
    "call_to_action_color": "call-to-action farge",
    "call_to_action_text_color": "call-to-action tekstfarge",
    "buy_button_color_mode": "Farge på kjøpsknapper",
    "buy_button_color_mode_description": "Gjelder Kjøp og Les mer på produktkort, Legg i handlekurv, Til handlekurv, Til kassen og knappene i kassen. Vipps-knappen beholder sine egne farger.",
    "buy_button_color_mode_c2a": "Call-to-action fargen",
    "buy_button_color_mode_custom": "Egen farge",
    "buy_button_color": "Bakgrunn på kjøpsknapper",
    "buy_button_text_color": "Tekst på kjøpsknapper",
    "buy_button_color_disabled_hint": "Velg «Egen farge» under «Farge på kjøpsknapper» for å endre.",
    "sale_price_color": "Tilbudspris-farge",
    "sale_price_color_description": "Farge på tilbudsprisen når produktet er på salg.",
    "social_media_use_text_color": "Sosiale medier følger tekstfargen",
    "social_media_use_text_color_description": "Ikonene for sosiale medier bruker tekstfargen der de vises: footerens tekstfarge i footeren og mobilmenyens tekstfarge i menyen. Skru av for å velge én egen farge.",
    "social_media_color": "Farge på sosiale medier",
    "social_media_color_description": "Brukes på ikonene for sosiale medier i footeren og mobilmenyen.",
    "social_media_color_disabled_hint": "Skru av «Sosiale medier følger tekstfargen» for å velge farge.",
    "headlines_color": "Kategorioverskrifter",
    "buttons_background_color": "bakgrunnsfarge knapper",
    "buttons_text_color": "tekstfarge knapper",
    "social_media_icons": "sosiale medie ikoner",
    "breadcrumbs_background_color": "bakgrunnsfarge brødsmuler",
    "breadcrumbs_text_color": "tekstfarge brødsmuler",
    "content": "innhold",
    "layout": "layout",
    "appearance": "utseende",
    "behavior": "oppførsel",
    "mobile": "mobil",
    "pages_content": "Tekstinnhold",
    "background_color": "bakgrunnsfarge",
    "background_image": "bakgrunnsbilde",
    "text_color": "tekstfarge",
    "logo": "logo",
    "logo_width": "logo bredde",
    "logo_height": "logo høyde",
    "header_logo_width_description": "Endrer bredden på logoen. Denne endringen gjelder for alle headervarianter. Tekstlogo påvirkes ikke.",
    "header_logo_height_description": "Endrer høyden på logoen. Denne endringen gjelder for alle headervarianter. Tekstlogo påvirkes ikke.",
    "icon_color": "ikonfarge",
    "icon_size": "ikonstørrelse",
    "icon_stroke_width": "ikontykkelse",
    "main_navigation_background_color": "hovednavigasjon bakgrunnsfarge",
    "main_navigation_text_color": "hovednavigasjon tekstfarge",
    "main_navigation_hover_underline_color": "hovednavigasjon hover understrek farge",
    "mobile_sticky_navigation_background": "sticky mobil-navigasjon bakgrunnsfarge",
    "mobile_sticky_navigation_icon_color": "sticky mobil-navigasjon ikonfarge",
    "block_name": "blokknavn",
    "list_name": "listenavn",
    "number_of_products_to_show": "antall produkter å vise",
    "get_products_from": "hent produkter fra",
    "number_of_columns_on_desktop": "antall kolonner på skrivebordet",
    "number_of_columns_on_mobile": "antall kolonner på mobiltelefon",
    "slider_name": "slidernavn",
    "grid_name": "gridnavn",
    "footer_background_color": "footer bakgrunnsfarge",
    "footer_text_color": "footer tekstfarge",
    "footer_bottom_section_background_color": "footer bunndel bakgrunnsfarge",
    "footer_bottom_section_text_color": "footer bunndel tekstfarge",
    "at_least_one_variant_must_be_active": "Minst én variant må være aktiv",
    "variant_limit_reached": "Variantgrensen er nådd",
    "could_not_create_tag": "Kunne ikke opprette taggen",
    "could_not_save": "Kunne ikke lagre",
    "error_encountered_while_saving_please_check_the_form": "Feil oppstod under lagring. Vennligst sjekk skjemaet og prøv igjen",
    "changes_saved!": "Endringer lagret!",
    "the_price_must_be_greater_than_0": "Prisen må være større enn 0",
    "category_type": "kategori type",
    "category_smart": "smart kategori",
    "category_manual": "manuell kategori",
    "category_type_description": "en smart kategori er en dynamisk kategori som automatisk inkluderer produkter basert på en rekke regler, mens en manuell kategori er en statisk kategori som du manuelt legger til produkter i.",
    "criteria_product_age": "produktets alder",
    "criteria_has_tag": "produkt-tag",
    "criteria_product_category": "produktets kategori",
    "criteria_product_stock_status": "produktets varelager",
    "criteria_product_title": "produktets tittel",
    "to_be_included_in_this_smart_category": "for å bli inkludert i denne smart-kategorien",
    "smart_criteria": "smart-kriterier",
    "smart_category": "smart kategori",
    "attribute": "attributt",
    "operator": "forhold",
    "criteria": "kriterie",
    "smart_criteria_all": "alle kriterier må være oppfylt",
    "smart_criteria_any": "ett av kriteriene må være oppfylt",
    "smart_criteria_product_title": "produktets tittel",
    "smart_criteria_has_tag": "produkt-tag",
    "smart_criteria_product_category": "produktets kategori",
    "smart_criteria_product_stock_status": "produktets varelager",
    "smart_criteria_product_age": "produktets alder",
    "smart_criteria_operator_is_equals_to": "er",
    "smart_criteria_operator_is_not_equals_to": "er ikke",
    "smart_criteria_operator_contains": "inneholder",
    "smart_criteria_operator_does_not_contain": "inneholder ikke",
    "smart_criteria_operator_starts_with": "starter med",
    "smart_criteria_operator_ends_with": "slutter med",
    "smart_criteria_operator_is_greater_than": "er større enn",
    "smart_criteria_operator_is_less_than": "er mindre enn",
    "smart_criteria_operator_created_last_days": "er yngre enn {days} dager",
    "smart_criteria_operator_created_before_days": "er eldre enn {days} dager",
    "add_new_criteria": "legg til nytt kriterie",
    "category_deleted": "Kategori slettet",
    "manual_shipment": "manuell forsendelse",
    "carrier": "fraktselskap",
    "tracking_number": "sporingsnummer",
    "tracking_url": "sporings-URL",
    "notify_customer_of_shipment_via_email": "Send kunden en e-post om forsendelsen",
    "order": "Ordre",
    "of": "av",
    "customer": "kunde",
    "contact_information": "kontaktopplysninger",
    "delivery_address": "leveringsadresse",
    "billing_address": "fakturaadresse",
    "same_as_delivery_address": "samme som leveringsadresse",
    "fulfill": "send",
    "invoice_number_start_title": "Velg første fakturanummer",
    "invoice_number_start_label": "Første fakturanummer",
    "invoice_number_start_intro": "Dette blir fakturanummeret på din første forsendelse.",
    "invoice_number_start_point_auto": "Hver forsendelse etter denne får neste nummer automatisk, ett høyere.",
    "invoice_number_start_point_match": "Bruker du allerede et regnskapssystem som Tripletex? Skriv inn samme startnummer som du bruker der.",
    "invoice_number_start_point_fresh": "Har du ingen fakturaer der ennå? Bruk hvilket nummer du vil. Vi anbefaler 10000.",
    "invoice_number_start_warn_title": "Greit å vite",
    "invoice_number_start_warn_locked": "Når et nummer er brukt, kan du ikke endre det selv.",
    "invoice_number_start_warn_law": "Etter bokføringsloven må numrene være i rekkefølge uten hull.",
    "invoice_number_start_warn_support": "Trenger du en endring senere, eller er usikker på hvilket nummer du skal velge? Ta kontakt med support, så hjelper vi deg.",
    "refund_noun": "Retur / Kreditering",
    "refund_action": "krediter",
    "fulfillment": "Forsendelse / Faktura",
    "quantity": "antall",
    "timeline": "tidslinje",
    "add_internal_comment": "legg til intern kommentar",
    "here_you_can_add_notes_to_the_order_that_are_only_visible_to_you_or_other_staff": "Her kan du legge til notater til ordren, som kun er synlige for deg eller andre ansatte.",
    "unfulfilled_items": "ubehandlede ordrelinjer",
    "restock_items": "tilbakefør varer til lager",
    "notify_customer_of_refund": "varsle kunde om kreditering",
    "reason_for_refund": "årsak til kreditering",
    "only_visible_to_you_and_your_staff": "kun synlig for deg og dine ansatte",
    "cant_increase_shipping_cost": "Kan ikke øke fraktkostnaden",
    "fulfill_items_action": "opprett forsendelse",
    "all_orders": "alle ordre",
    "print_documents": "skriv ut dokumenter",
    "sum": "sum",
    "generate_return_label": "generer returetikett",
    "return_label": "Returetikett",
    "book_return_label": "Bestill returetikett",
    "your_return_label_is_ready": "Din returetikett er klar",
    "include_qr_code": "Inkluder QR-kode",
    "return_product": "Returprodukt",
    "return_label_was_booked": "Returetikett ble bestilt",
    "return_label_was_booked_for_fulfillment_:fulfillmentId": "Returetikett ble bestilt for forsendelse #:fulfillmentId",
    "return_items": "Returvarer",
    "select_at_least_one_item": "Velg minst én vare",
    "item_not_found_in_fulfillment": "Vare ikke funnet i forsendelsen",
    "logistics_provider_not_available_for_returns": "Valgt fraktleverandør er ikke tilgjengelig for retur",
    "return_quantity_exceeds_fulfilled_quantity": "Returantall overstiger sendt antall",
    "return_quantity_exceeds_returnable_quantity": "Returantall overstiger returnerbart antall",
    "edit_order": "rediger ordre",
    "summary": "oppsummering",
    "quantity_will_be_changed_from_to": "antall vil bli redusert fra {from} til {to}",
    "unit_price": "Enhetspris",
    "discount_all_items": "Rabatt på alle varer",
    "apply": "Bruk",
    "unit_price_will_change_from_to": "enhetspris vil endres fra {from} til {to}",
    "remaining_total_will_change_from_to": "gjenværende total vil endres fra {from} til {to}",
    "cant_increase_unit_price": "Enhetsprisen kan ikke økes",
    "will_be_removed": "vil bli fjernet",
    "shipping_price_will_change_from_to": "fraktprisen vil endres fra {from} til {to}",
    "reason_for_change": "årsak til endring",
    "the_order_will_be_empty": "Ingen varer vil gjenstå i ordren",
    "cancel_all_remaining_action": "kanseler alle resterende",
    "refund_not_supported": "kreditering støttes ikke",
    "this_payment_method_does_not_support_refunds": "Denne betalingsmetoden støtter ikke kreditering",
    "please_contact_customer_support_for_more_information": "Vennligst kontakt kundestøtte for mer informasjon",
    "this_payment_method_does_not_support_editing": "Denne betalingsmetoden støtter ikke redigering",
    "phone_number_not_provided": "telefonnummer ikke oppgitt",
    "purchase_order": "innkjøpsordre",
    "project": "prosjekt",
    "department": "avdeling",
    "company": "bedrift",
    "fulfilled": "behandlet",
    "pending": "ubehandlet",
    "partially_fulfilled": "delsendt",
    "tags": "tags",
    "unfulfilled": "ikke sendt",
    "tag": "legg til tagg",
    "remove_tag": "fjern tagg",
    "date": "dato",
    "since": "Siden",
    "total": "totalt",
    "before_discount": "Total før rabatt",
    "total_discount": "Total rabatt",
    "payment": "betaling",
    "items_selected": "{n} linje valgt | {n} linjer valgt",
    "select_action": "velg handling",
    "add_a_new_tag_to_the_selected_orders": "legg til en ny tagg på de valgte ordrene",
    "remove_a_new_tag_to_the_selected_orders": "fjern en tagg fra de valgte ordrene",
    "vipps": "vipps",
    "add_tag_to": "legg til tagg på",
    "cancelled_order_items": "kansellerte ordrelinjer",
    "order_summary": "ordreoppsummering",
    "original_order": "opprinnelig ordre",
    "cancelled_at": "kansellert",
    "nothing_left_to_refund": "ingenting igjen å kreditere",
    "order_number": "ordrenummer",
    "original_sum": "opprinnelig sum",
    "payment_method": "betalingsmetode",
    "shipping_method": "fraktmetode",
    "shipping_expected_delivery_prefix": "Forventet levering",
    "shipping_delivery_within_working_days": "Levering innen :days virkedag|Levering innen :days virkedager",
    "shipping_checkout_display_heading": "Visning i kassen",
    "shipping_checkout_display_description": "Velg hvilken informasjon fra transportørene som vises på leveringsmåtene i kassen.",
    "shipping_checkout_display_count": "{shown} av {total} vises",
    "shipping_checkout_group_delivery_time": "Leveringstid",
    "shipping_checkout_group_service_info": "Tjenesteinformasjon",
    "shipping_checkout_display_handover_warning": "Du har ikke satt opp utleveringsplan ennå. Uten den regner transportøren med at pakken leveres videre med én gang, og leveringsdatoene blir for optimistiske.",
    "shipping_checkout_display_updated": "Visning i kassen er oppdatert",
    "shipping_checkout_toggle_unavailable": "Ingen aktive transportører tilbyr dette",
    "shipping_show_delivery_estimate": "Forventet leveringsdato",
    "shipping_show_delivery_estimate_help": "Viser «Forventet levering torsdag 4. september» på hver leveringsmåte.",
    "shipping_show_delivery_dates": "Valg av leveringsdag",
    "shipping_show_delivery_dates_help": "Lar kunden velge blant transportørens alternative leveringsdager på hjemlevering.",
    "shipping_show_service_description": "Tjenestebeskrivelse",
    "shipping_show_service_description_help": "Transportørens egen forklaring av hva leveringsmåten innebærer.",
    "shipping_show_environmental": "Miljømerking",
    "shipping_show_environmental_help": "Viser «Leveres med elbil» når transportøren melder utslippsfri levering.",
    "shipping_show_pickup_point_details": "Detaljer om hentested",
    "shipping_show_pickup_point_details_help": "Avstand, åpningstider og kartlenke på hvert hentested.",
    "shipping_show_delivery_at_door": "Legg pakken på døren",
    "shipping_show_delivery_at_door_help": "Lar kunden be om at pakken settes utenfor døren når den ikke passer i postkassen.",
    "checkout_shipping_heading": "Levering",
    "checkout_shipping_choose_method": "Velg leveringsmåte",
    "checkout_shipping_free": "Gratis",
    "checkout_shipping_price_excluding_vat": "{price} ekskl. mva",
    "checkout_shipping_show_all": "Vis alle leveringsmåter ({count})",
    "checkout_shipping_show_fewer": "Vis færre leveringsmåter",
    "checkout_shipping_updating": "Oppdaterer leveringsvalg …",
    "checkout_shipping_free_shipping_nudge": "Handle for {amount} til og få denne frakten gratis",
    "checkout_shipping_choose_delivery_day": "Velg leveringsdag",
    "checkout_shipping_fastest": "Raskest",
    "checkout_shipping_delivery_at_door": "Legg pakken utenfor døren min hvis den ikke får plass i postkassen",
    "checkout_pickup_choose": "Velg hentested",
    "checkout_pickup_change": "Endre hentested",
    "checkout_pickup_close": "Lukk",
    "checkout_pickup_show_more": "Vis flere hentesteder ({count})",
    "checkout_pickup_show_fewer": "Vis færre hentesteder",
    "checkout_pickup_view_on_map": "Vis i kart",
    "checkout_pickup_map_open": "Vis {name} i kart",
    "checkout_pickup_map_frame_title": "Kart over {name}",
    "checkout_pickup_map_loading": "Laster kart …",
    "checkout_pickup_map_unavailable": "Kartet kunne ikke lastes. Adressen står over.",
    "checkout_pickup_map_directions": "Veibeskrivelse",
    "checkout_pickup_map_previous": "Forrige",
    "checkout_pickup_map_next": "Neste",
    "checkout_pickup_map_position": "{current} av {total}",
    "checkout_pickup_map_choose": "Velg dette hentestedet",
    "checkout_pickup_map_current": "Valgt hentested",
    "delivery_time_window": "kl. {range}",
    "shipping_environmental_label": "Leveres med elbil",
    "shipping_environmental_description": "Pakken leveres med elbil fra lokal terminal til valgt leveringsadresse",
    "shipping_address": "Fraktadresse",
    "about_shipping_address_settings": "Adressen butikken sender varer fra. Brukes som avsender ved fraktbestilling og for å beregne fraktpriser i kassen. Firmaadressen brukes hvis dette er tomt.",
    "cancel_all_remaining_explanation": "Dette vil kansellere alle resterende varer i ordren. Dersom du ønsker å kansellere bare en del av ordren, kan du gjøre dette ved å redigere ordren, eller ved å sende den gyldige delen av ordren først.",
    "this_action_can_not_be_undone": "Denne handlingen kan ikke angres!",
    "product_is_visible_in_your_store": "Skal produktet være synlig i butikken?",
    "note_that_might_not_be_buyable_even_if_visible": "Merk at produktet kanskje ikke er kjøpbart selv om det er synlig, f.eks. hvis det er utsolgt, eller dersom ingen pris er satt",
    "add_sales_price": "legg til tilbudspris",
    "add_another_sales_price": "Legg til en ny tilbudspris",
    "apply_changes": "Bruk endringer",
    "percentage_off": "{percentage}% avslag",
    "percentage": "Prosent",
    "fixed_amount": "fast beløp",
    "discount_type": "tilbudstype",
    "starts_at": "starter",
    "starts_immediately_no_end_date": "Starter umiddelbart, ingen sluttdato",
    "ends_at": "slutter",
    "does_the_offer_have_an_end_date": "skal tilbudet ha en sluttdato?",
    "new": "ny",
    "no_end": "Ingen slutt",
    "product_name_placeholder": "f.eks. Supertrendy t-skjorte",
    "eg_color_or_size": "f.eks. farge eller størrelse",
    "eg_red_or_large": "f.eks. rød eller stor",
    "show_title": "Vis navn",
    "product_form_display_style": "Visningsstil",
    "product_form_display_style_description": "Kort er dagens boks med egne farger. Innebygd fjerner boksen og arver produktsidens farger. Sammenleggbar viser en knapp som åpner skjemaet; den er åpen fra start når skjemaet har påkrevde felt.",
    "product_form_display_card": "Kort",
    "product_form_display_inline": "Innebygd",
    "product_form_display_collapsible": "Sammenleggbar",
    "product_form_collapsible_label": "Knappetekst for sammenleggbar visning",
    "product_form_collapsible_label_description": "Brukes bare når visningsstilen er Sammenleggbar.",
    "product_form_use_field_widths": "Bruk feltbredder fra skjemabyggeren",
    "product_form_use_field_widths_description": "Felt satt til halv bredde i skjemabyggeren står side om side. Avslått stabler alle feltene.",
    "product_form_options_as_buttons": "Vis valg som knapper",
    "product_form_options_as_buttons_description": "Nedtrekkslister med få valg vises som knapper, og ja/nei-felt som en bryter.",
    "product_form_options_as_buttons_max": "Maks antall valg som knapper",
    "product_form_additional_cost_style": "Tilleggskostnad",
    "product_form_additional_cost_line": "Egen linje",
    "product_form_additional_cost_badge": "Merke ved tittelen",
    "product_form_required_hint": "Valider før handlekurv",
    "product_form_required_hint_description": "Stopper «Legg i handlekurv» når påkrevde felt mangler, markerer feltene og sier hvilke som må fylles ut.",
    "show_the_title_when_viewing_this_category_in_your_store": "Vis navnet øverst når kategorien vises i butikken",
    "display": "visning",
    "products_matching_these_criteria": "aktive produkter passer til disse kriteriene",
    "no_products_shown_without_criteria": "uten noen valgte kriterier, vil ikke kategorien inneholde noen produkter",
    "api_tokens": "API nøkler",
    "eg_main_navigation": "f. eks. Hovednavigasjon",
    "search_for_a_category": "Søk etter en kategori, produkt, side eller velg et menyelement fra rullegardinlisten",
    "back": "tilbake",
    "menu_item_successfully_added": "Menyelementet ble lagt til!",
    "organize_menu_info": "For å organisere menyen, klikk og hold på de seks små prikkene ved siden av et menyelement. Dra elementet opp eller ned til ønsket plassering for å flytte det. For å lage en trestruktur, dra elementet litt til høyre under et annet menyelement for å gjøre det til en undermeny.",
    "menu_name_for_internal_use": "Til internt bruk",
    "menu_name_for_external_use": "Synlig i butikken når menyen blir brukt i footeren",
    "edit_active_theme": "rediger aktivt tema",
    "organization": "organisering",
    "mega_menu": "megameny",
    "mega_menu_images_title": "Bilder i megamenyen",
    "mega_menu_images_immediate_hint": "Bildene vises til høyre i megamenyen. Opplasting og sletting skjer umiddelbart — tekst, lenker og innstillinger lagres med Lagre-knappen.",
    "mega_menu_images_max_reached": "Du kan maksimalt laste opp fire bilder.",
    "add_image": "Legg til bilde",
    "text_position": "Tekstplassering",
    "text_position_below": "Under bildet",
    "text_position_overlay": "På bildet",
    "mega_menu_images_tooltip": "Administrer bilder i megamenyen",
    "mega_menu_images_save_first": "Lagre menyen før du legger til bilder",
    "image_uploaded": "Bildet ble lastet opp",
    "image_deleted": "Bildet ble slettet",
    "image_text": "Bildetekst",
    "uploading": "Laster opp",
    "navigation_set_mega_menu": "Velg om hovedmenypunktet skal være en megameny",
    "mega_menu_info": "En megameny er en utvidet nedtrekksmeny som viser mange valg eller komplekse strukturer på en organisert og visuell måte. Den brukes når et hovedmenypunkt har mange menypunkter i seg, eller trenger å gi brukerne rask oversikt over alternativer.",
    "google_taxonomy": "Google produktklassifikasjon",
    "refurbished": "overhalt (reparert)",
    "used": "brukt",
    "is_product_of_an_erotic_nature": "produktet er av erotisk natur",
    "condition_of_product": "produktets tilstand",
    "product_category": "produktkategori",
    "product_categories": "Produktkategorier",
    "google_product_category_info": "velg en av Googles definerte produktkategorier, eller la feltet stå tomt for automatisk kategorisering av Google",
    "google_erotic_nature_info": "indikerer at produktet inneholder seksuelt utfordrende innhold",
    "google_product_condition_info": "produktets tilstand ved salgstidspunktet",
    "store_name": "butikknavn",
    "store_description": "butikkens beskrivelse",
    "store_description_info": "Gi en beskrivelse som kan brukes for søkemotorer. Maks 320 tegn",
    "google_site_verification": "google-verifisering av nettsted",
    "google_site_verification_info": "Lim inn innholdsverdien (content) fra metataggen «google-site-verification» du får fra Google Search Console.",
    "general.newest": "Nyeste",
    "general.alphabetical": "Alfabetisk",
    "general.price_low_to_high": "Pris lav til høy",
    "general.price_high_to_low": "Pris høy til lav",
    "general.manual_order": "Butikkens rekkefølge",
    "general.business": "Bedrift",
    "general.personal": "Privatperson",
    "two_factor_authentication": "to-faktor autentisering",
    "add_additional_security_to_your_account_using_two_factor_authentication": "Legg til ekstra sikkerhet på kontoen din ved å bruke to-faktor autentisering",
    "you_have_enabled_two_factor_authentication": "Du har aktivert to-faktor autentisering",
    "finish_enabling_two_factor_authentication": "Fullør aktivering av to-faktor autentisering",
    "you_have_not_enabled_two_factor_authentication": "Du har ikke aktivert to-faktor autentisering",
    "when_two_factor_authentication_is_enabled": "Når to-faktor autentisering er aktivert, vil du bli bedt om å oppgi en engangskode i tillegg til passordet ditt når du logger inn. Koden genereres av Google Authenticator app'en på telefonen din.",
    "to_finish_enabling_two_factor_authentication": "For å fullføre aktiveringen av to-faktor autentisering, skann følgende QR-kode ved hjelp av telefonens autentiseringsapp eller skriv inn oppsett-nøkkelen.",
    "two_factor_authentication_is_now_enabled": "To-faktor autentisering er nå aktivert, scan QR-koden eller skriv inn oppsett-nøkkelen i din autentiseringsapp.",
    "setup_key": "oppsett-nøkkel",
    "store_these_codes_recovery_codes_in_a_secure_password_manager": "Lagre disse gjenopprettingskodene i en sikker passordbehandler, de kan brukes til å få tilgang til kontoen din hvis du mister tilgang til autentiseringsappen.",
    "enable": "aktiver",
    "confirm": "bekreft",
    "regenerate_recovery_codes": "generer nye gjenopprettingskoder",
    "show_recovery_codes": "vis gjenopprettingskoder",
    "disable": "deaktiver",
    "for_your_security_please_confirm_your_password_to_continue": "For din sikkerhet, bekreft passordet ditt for å fortsette",
    "code": "kode",
    "browser_sessions": "nettlesersesjoner",
    "manage_and_logout_your_active_sessions_on_other_browsers_and_devices": "Administrer og logg ut av dine aktive sesjoner på andre nettlesere og enheter",
    "if_necessary_you_may_log_out_of_all_of_your_other_browser_sessions": "Hvis nødvendig kan du logge ut av alle andre nettlesersesjoner på alle enhetene dine. Noen av dine siste sesjoner er listet opp nedenfor; listen kan imidlertid ikke være fullstendig. Hvis du føler at kontoen din er kompromittert, bør du også oppdatere passordet ditt.",
    "this_device": "denne enheten",
    "last_active": "sist aktiv",
    "log_out_of_other_browser_sessions": "logg ut av andre nettlesersesjoner",
    "please_enter_your_password_to_confirm_you_would_like_to_log_out_of_your_other_browser_sessions_across_all_of_your_devices": "Vennligst skriv inn passordet ditt for å bekrefte at du vil logge ut av andre nettlesersesjoner på alle enhetene dine",
    "google_taxonomy_is_used_for": "Google produktklassifikasjon brukes for å kategorisere produkter i Google Shopping og andre tjenester som konsumerer produktlister. Det er viktig å velge riktig kategori for produktene dine for å sikre at de vises riktig i disse tjenestene.",
    "empty_state_text": "Her var det tomt gitt!",
    "add_file": "Legg til fil",
    "choose_file": "Velg fil",
    "search_files": "Søk i filer",
    "general.date_desc": "Dato (nyeste)",
    "general.date_asc": "Dato (eldste)",
    "general.alphabetical_asc": "Alfabetisk (A - Å)",
    "general.alphabetical_desc": "Alfabetisk (Å - A)",
    "general.sorting": "Sortering",
    "general.relevance": "Relevanse",
    "files_uploaded": "Fil(er) lastet opp",
    "file_deleted": "Fil slettet",
    "something_went_wrong_during_delete": "Noe gikk galt under slettingen",
    "something_went_wrong_during_upload": "Noe gikk galt under opplastingen",
    "clear_selection": "Fjern markering",
    "cannot_find_any_files_where_name_contains": "Finner ingen filer hvor navnet inneholder",
    "add_link": "Legg til link",
    "filter_filetype": "Filtrer filtype",
    "something_went_wrong_during_theme_update": "Noe gikk galt under oppdatering av temaet",
    "theme_updated": "Tema oppdatert",
    "alt_text": "Alt tekst",
    "week": "{n} uke | {n} uker",
    "product_reviews": "Produktanmeldelser",
    "product_reviews_description": "Få tilbakemeldinger på produktopplevelser fra faktiske kjøpere, og velg å vis disse på produktsidene",
    "product_reviews_headline": "Produktanmeldelser – bygg tillit og øk salget",
    "product_reviews_subline": "Ekte tilbakemeldinger fra kundene dine er gull verdt. Med appen Produktanmeldelser blir det enkelt å samle inn og vise frem produktomtaler i nettbutikken din – helt automatisk.\nNår en kunde har gjennomført et kjøp, får de etter et valgfritt antall uker en oppfordring om å legge igjen en anmeldelse og gi produktet en vurdering fra 1 til 5 stjerner. På den måten får du <strong>ekte erfaringer fra kunder som faktisk har kjøpt produktet</strong – ikke tilfeldige eller falske vurderinger.",
    "product_reviews_why_are_reviews_important": "Hvorfor er produktanmeldelser så viktige?",
    "product_reviews_why_are_reviews_important_1": "<strong>Bygg tillit:</strong> 9 av 10 kunder leser produktanmeldelser før de handler. Ekte omtaler gir trygghet og gjør at flere fullfører kjøpet.",
    "product_reviews_why_are_reviews_important_2": "<strong>Få innsikt:</strong> Tilbakemeldingene gir deg verdifull innsikt i hva kundene liker – og hva du kan forbedre.",
    "product_reviews_why_are_reviews_important_3": "<strong>Øk konverteringene:</strong> Produkter med anmeldelser selger mer. Kunder stoler på andre kunder.",
    "product_reviews_why_are_reviews_important_4": "<strong>Bedre synlighet:</strong> Anmeldelser kan bidra til bedre rangering i Google, fordi unikt innhold oppdateres jevnlig.",
    "how_it_works": "Slik fungerer det",
    "product_reviews_how_it_works_1": "Kunden kjøper et produkt i din nettbutikk.",
    "product_reviews_how_it_works_2": "Etter et valgfritt antall uker mottar de en e-post med oppfordring om å legge igjen en anmeldelse.",
    "product_reviews_how_it_works_3": "Innsendte produktanmeldelser vises i administrasjonspanelet og du kan velge å publisere eller slette anmeldelsen.",
    "product_reviews_how_it_works_4": "Anmeldelsen blir synlig i nettbutikken.",
    "reviews": "Anmeldelser",
    "rating": "Vurdering",
    "published": "Publisert",
    "not_published": "Ikke publisert",
    "not_saved_yet": "Ikke lagret",
    "the_review": "anmeldelsen",
    "unknown_error_occurred_try_again_or_contact": "Ukjent feil oppstod. Prøv igjen, eller ta kontakt med support",
    "anonymous": "Anonym",
    "from": "Fra",
    "to": "Til",
    "past_twenty_four_hours": "Siste 24 timer",
    "past_seven_days": "Siste 7 dager",
    "past_thirty_days": "Siste 30 dager",
    "or": "Eller",
    "clear_filters": "Fjern filtre",
    "published_status": "Publisert status",
    "number_slider_filter_information": "Dra glidebryteren eller skriv inn tallene du vil filtrere etter",
    "has_text": "Har tekst",
    "does_not_have_text": "Har ikke tekst",
    "thank_you_for_your_purchase": "Takk for handelen!",
    "new_purchase_in_your_store": "Ny ordre i nettbutikken :storeName",
    "store": "Nettbutikk",
    "review_email_active": "Automatisk e-postutsendelse for anmeldelser aktiv",
    "review_email_delay": "Forsinkelse før e-postutsendelse",
    "review_email_active_description": "Send automatisk en e-post til kundene etter en fastsatt forsinkelse, og be dem vurdere produktet de har kjøpt",
    "review_email_delay_description": "Hvor mange uker etter at ordren er markert som behandlet, bør vurderings-e-posten sendes?",
    "review_email_description": "E-postadressen som vurderings-e-posten vil bli sendt fra",
    "cannot_publish_review_without_text": "Kan ikke publisere en anmeldelse uten tekst",
    "all_reviews": "Alle anmeldelser",
    "product_reviews_index_description": "En oversikt over alle produktanmeldelser. Du kan publisere eller avpublisere anmeldelser direkte fra tabellen. Hold musepekeren over eller klikk på anmeldelsesteksten for å lese hele anmeldelsen.",
    "showing_single_review": "Viser en enkelt anmeldelse",
    "show_all_reviews": "Vis alle anmeldelser",
    "review": "Anmeldelse",
    "cannot_be_published_because_of_no_text": "Kan ikke publiseres fordi det ikke er noen tekst",
    "store_status": "Åpne / Lukk butikken",
    "maintenance_mode": "Vedlikeholdsmodus",
    "maintenance_password": "Vedlikeholdspassord",
    "maintenance_title": "Vedlikeholdstittel",
    "maintenance_message": "Vedlikeholdsmelding",
    "shipping_methods": "Fraktmetoder",
    "modify_shipping_price": "Juster fraktkostnad",
    "shipping__replace": "Erstatt fraktprisen",
    "shipping__modify_int": "Kostnadsjustering kroner",
    "shipping__modify_percentage": "Kostnadsjustering prosent",
    "shipping__use_list_price": "Bruk listepris",
    "shipping__positive_percentage_hint": "Du har oppgitt en positiv prosent. Dette betyr at fraktprisen økes i kassa.",
    "shipping__negative_percentage_hint": "Du har oppgitt en negativ prosent. Dette betyr at fraktprisen reduseres i kasse.",
    "info_shipping__replace": "Legg inn helt egen fraktpris. Det betyr at prisen du legger inn, vil erstatte eventuell listepris som kommer fra tredjepart (Eks: Bring, Postnord)",
    "info_shipping__modify_int": "Øk eller senk listepris som kommer fra tredjepart med et fast kronebeløp. Kunden vil betale listepris, pluss/minus justeringen som har blitt lagt inn her.",
    "info_shipping__modify_percentage": "Kunden betaler listepris med en prosentjustering.",
    "info_shipping__use_list_price": "Ikke gjør noen kostnadsjusteringer på denne fraktmåten, slik at fraktprisen kun er basert på listepris fra leverandøren (Eks: Bring, Postnord).",
    "percentage_amount": "Prosentbeløp",
    "replace_with_new_price": "Erstatt med ny pris",
    "shipping_method_updated": "Fraktmetode oppdatert",
    "shipping_limits": "Begrensninger",
    "shipping_limit_none": "Ingen",
    "shipping_min_order_value": "Minste ordresum (kr)",
    "shipping_min_order_value_help": "Leveringsmåten tilbys ikke når ordresummen inkl. mva. er lavere enn dette.",
    "shipping_max_order_value": "Største ordresum (kr)",
    "shipping_max_order_value_help": "Leveringsmåten tilbys ikke når ordresummen inkl. mva. er høyere enn dette.",
    "shipping_max_order_value_below_min": "Største ordresum kan ikke være lavere enn minste ordresum.",
    "shipping_delivery_at_door_max_order_value": "Levering på døren bare til og med ordresum (kr)",
    "shipping_delivery_at_door_max_order_value_help": "Over dette beløpet får kunden ikke valget om å sette pakken utenfor døren, men kan fortsatt velge leveringsmåten. Pakken leveres i postkassen som vanlig, og går til et utleveringssted i stedet for utenfor døren hvis den ikke får plass.",
    "shipping_price_must_be_whole_kroner": "Prisen må være i hele kroner, uten øre.",
    "shipping_percentage_must_be_whole_number": "Prosentsatsen må være et heltall.",
    "shipping_method_created": "Fraktmetode opprettet",
    "shipping_method_deleted": "Fraktmetode slettet",
    "shipping_vat_description": "Slå av hvis butikken ikke skal beregne MVA på frakt. Innstillingen gjelder alle fraktmetoder. Eksisterende ordrer påvirkes ikke. For fraktmetoder fra transportører (Posten/Bring, PostNord, 24Shipping) betyr dette at kunden betaler kun nettoprisen fra transportøren.",
    "shipping_vat_label": "Beregn MVA på frakt",
    "shipping_vat_section_heading": "MVA på frakt",
    "shipping_vat_setting_updated": "MVA-innstilling for frakt oppdatert",
    "list_price": "Listepris",
    "add_coupon": "Legg til rabattkode",
    "coupons": "Rabattkoder",
    "gavekort": "Gavekort",
    "customer_club": "Kundeklubb",
    "customer_club_description": "La kundene samle poeng på kjøp og bruke dem som rabatt på senere ordrer.",
    "customer_club_configure": "Konfigurer",
    "customer_club_open": "Åpne",
    "customer_club_members": "Medlemmer",
    "customer_club_heading": "Kundeklubb - belønn og skap lojale kunder med opptjente poenger",
    "customer_club_sub_heading": "Kundeklubben er utviklet for å styrke kundelojalitet i nettbutikken. Registrerte kunder opptjener poeng ved kjøp av produkter, og disse poengene kan brukes til rabatterte priser på produkter i butikken.",
    "why_use_customer_club": "Hvilke muligheter har man i kundeklubben",
    "why_use_customer_club_1": "Poeng per krone - Bestem hvor mange poeng kunden tjener for hver krone som handles",
    "why_use_customer_club_2": "Verdi per poeng - Bestem hvor mye hvert poeng er verdt som rabatt ved bruk",
    "why_use_customer_club_3": "Velkomstbonus - Bestem antall poeng som tildeles automatisk når kunden melder seg inn første gang",
    "why_use_customer_club_4": "Ventetid - Bestem hvor mange dager etter levering det går før poengene blir tilgjengelige for kunden",
    "customer_club_closer": "Kundene får full oversikt over tilgjengelige poeng på Min side. Kundeklubben gir kundene en sterk motivasjon til å registrere seg i nettbutikken og komme tilbake for å bruke poengene på nye kjøp. På produktsiden vises hvor mange poeng man opptjener ved kjøp av produktet. Denne informasjonen er også synlig for uregistrerte kunder, og fungerer som et insentiv til å registrere seg.",
    "customer_club_emails_tab": "E-poster",
    "customer_club_emails_intro": "Tilpass e-postene som sendes til kundeklubb-medlemmer. Du kan slå hver e-post av og på, og endre emne, innhold og knappetekst.",
    "customer_club_signup_email_heading": "Velkomstbonus-e-post",
    "customer_club_signup_email_description": "Sendes når en kunde får velkomstbonus. Krever at du har satt et antall velkomstpoeng under Innstillinger — uten bonus sendes ingen e-post.",
    "customer_club_earned_email_heading": "Opptjente poeng",
    "customer_club_earned_email_description": "Sendes når en kunde tjener poeng på en bestilling.",
    "customer_club_email_subject": "E-postemne",
    "customer_club_email_body": "E-postinnhold",
    "customer_club_email_button_text": "Knappetekst",
    "customer_club_signup_placeholders_hint": "Bruk {points} for å sette inn antall velkomstpoeng.",
    "customer_club_earned_placeholders_hint": "Bruk {points} for antall opptjente poeng og {availableFrom} for når poengene blir tilgjengelige. Hvis du ikke har satt karantenetid, blir {availableFrom} samme dag som e-posten sendes — vurder å fjerne den setningen fra meldingen i så fall.",
    "save_changes": "Lagre endringer",
    "changes_saved": "Endringene er lagret",
    "customer_club_active_members": "aktive medlemmer",
    "customer_club_points_in_circulation": "poeng i omløp",
    "customer_club_search_placeholder": "Søk på navn eller e-post…",
    "customer_club_filter_all": "Alle medlemmer",
    "customer_club_filter_active": "Aktive",
    "customer_club_filter_former": "Tidligere",
    "customer_club_member_since": "Medlem siden",
    "customer_club_available": "Tilgjengelig",
    "customer_club_pending": "Ventende",
    "customer_club_status_active": "Aktivt medlem",
    "customer_club_status_former": "Tidligere",
    "customer_club_no_members_yet": "Ingen medlemmer ennå.",
    "customer_club_landing_headline": "Bygg kundelojalitet med klubb-poeng.",
    "customer_club_landing_subline": "Kundene tjener poeng på hvert kjøp og bruker dem som rabatt på senere ordrer. Du bestemmer opptjenings- og innløsningsrate.",
    "customer_club_landing_advantages_title": "Fordeler med kundeklubb",
    "customer_club_landing_advantage_1": "Økt gjenkjøp og livsverdi per kunde.",
    "customer_club_landing_advantage_2": "Full kontroll over opptjenings- og innløsningsrate — justerbart når som helst.",
    "customer_club_landing_advantage_3": "Signup-bonus, karantene og oppsigelses-flyt bygget inn.",
    "customer_club_landing_advantage_4": "Mva-korrekt rabatt-modell — ingen utgående mva på utstedte poeng.",
    "customer_club_landing_how_q": "Hvordan fungerer det?",
    "customer_club_landing_how_a": "Kunden melder seg inn i klubben ved registrering eller i handlekurven. Etter kjøp opptjenes poeng basert på vareverdi (eksklusive frakt). Poengene har en valgfri karantene-periode før de kan brukes. Ved innløsning fordeles rabatten over varelinjene og reduserer mva-grunnlaget korrekt.",
    "customer_club_landing_vat_q": "Hvordan påvirker det mva-regnskapet?",
    "customer_club_landing_vat_a": "Klubb-poeng behandles som rabatt (prisavslag), ikke som betalingsmiddel. Dette er i tråd med EU-domstolens avgjørelse i C-436/24 Lyko og norsk mval. §4-2. Mva beregnes på det faktiske reduserte vederlaget; ingen ekstra mva-konsekvens ved utstedelse av poeng.",
    "customer_club_settings": "Innstillinger",
    "customer_club_enable": "Aktiver kundeklubb",
    "customer_club_enable_hint": "Når aktivert kan kunder opptjene og bruke klubb-poeng på denne butikken.",
    "customer_club_line_adjustment": "Kundeklubb (:points poeng brukt)",
    "customer_club_order_discount_row": "Kundeklubb-rabatt ({points} poeng brukt)",
    "customer_club_order_email": "Ordre-e-post (Kustom)",
    "customer_club_account": "Klubbkonto",
    "customer_club_disabled_notice": "Aktiver kundeklubb først for å konfigurere disse innstillingene.",
    "customer_club_inactive_cta_title": "Kundeklubben er deaktivert",
    "customer_club_texts_tab": "Tekster",
    "customer_club_texts_intro": "Tilpass tekstene og utseendet på kundeklubb-boksen som vises på produktsiden. Poeng-beregningen styres av innstillingene og kan ikke endres her.",
    "customer_club_design_heading": "Utseende",
    "customer_club_design_description": "Vis eller skjul boksene på produktsiden og tilpass fargene.",
    "customer_club_product_show_register_box_title": "Vis innmelding-boks",
    "customer_club_product_show_register_box_help": "Vises til besøkende som ikke er medlemmer.",
    "customer_club_product_show_member_box_title": "Vis medlems-boks",
    "customer_club_product_show_member_box_help": "Vises til innloggede medlemmer.",
    "customer_club_product_box_bg_color_title": "Bakgrunnsfarge",
    "customer_club_product_box_text_color_title": "Tekstfarge",
    "customer_club_texts_register_heading": "Ikke-medlem — produktsiden",
    "customer_club_texts_register_intro": "Disse tekstene vises for besøkende som ikke er medlemmer ennå. Bruk {points} for antall poeng kunden tjener på produktet og {value} for hva poengene er verdt.",
    "customer_club_texts_member_heading": "Medlem — produktsiden",
    "customer_club_texts_member_intro": "Tilpass tittelen og legg til en valgfri tekst. Bruk {points} i tittelen for å vise antall poeng kunden tjener.",
    "customer_club_product_register_title_label": "Tittel",
    "customer_club_product_register_description_title": "Beskrivelse",
    "customer_club_product_register_button_title": "Knappetekst",
    "customer_club_product_member_title_label": "Tittel",
    "customer_club_product_member_description_title": "Beskrivelse (valgfri)",
    "customer_club_product_title_points_hint": "Bruk {points} for antall poeng kunden tjener på dette produktet.",
    "customer_club_product_value_points_hint": "Bruk {points} og {value} for antall poeng og kroneverdi.",
    "customer_club_texts_preview_not_member": "Forhåndsvisning — ikke medlem",
    "customer_club_texts_preview_member": "Forhåndsvisning — medlem",
    "customer_club_box_hidden": "Boksen er skjult",
    "customer_club_former_members_on_page": "Tidligere på siden",
    "customer_club_members_empty_title": "Ingen medlemmer ennå",
    "customer_club_members_empty_hint": "Når kunder melder seg inn vises de her.",
    "customer_club_quarantine_preset_immediate": "Umiddelbart",
    "customer_club_quarantine_preset_recommended": "14 dager",
    "customer_club_quarantine_preset_strict": "30 dager",
    "customer_club_signup_bonus_disabled_hint": "Sett til 0 for å deaktivere velkomstbonus og velkomst-e-post.",
    "customer_club_signup_bonus_value_hint": "Verdt {value} med dagens innløsningsrate.",
    "customer_club_signup_email_trigger": "Sendes når en ny kunde får velkomstbonus.",
    "customer_club_earned_email_trigger": "Sendes etter levering, når karantenetiden i Innstillinger > 0.",
    "customer_club_email_preview_greeting": "Hei, {fornavn}",
    "view_details": "Se detaljer",
    "customer_club_presets_title": "Forhåndsvalg",
    "customer_club_presets_hint": "Velg et utgangspunkt — du kan justere ratene under.",
    "customer_club_preset_simple_name": "Enkel",
    "customer_club_preset_simple_desc": "1 kr tilbake per 100 kr",
    "customer_club_preset_standard_name": "Standard",
    "customer_club_preset_standard_desc": "3 kr tilbake per 100 kr",
    "customer_club_preset_generous_name": "Generøs",
    "customer_club_preset_generous_desc": "5 kr tilbake per 100 kr",
    "customer_club_earn_rate": "Opptjeningsrate",
    "customer_club_earn_rate_hint": "Hvor mange poeng kunden tjener per beløp handlet. Eksempel: 1 poeng per 100 kr gir 5 poeng på en handel for 500 kr.",
    "customer_club_earn_rate_tooltip": "Bestemmer hvor raskt kundene tjener poeng. Kombineres med innløsningsraten — endrer du den ene, endres den effektive cashback-prosenten.",
    "customer_club_earn_rate_points": "Poeng",
    "customer_club_earn_rate_amount": "kr handlet",
    "customer_club_redemption_rate": "Innløsningsrate",
    "customer_club_redemption_multiplier": "Verdi av 1 poeng (kr)",
    "customer_club_redemption_rate_hint": "Hvor mye rabatt kunden får når poeng innløses. Eksempel: 10 poeng = 1 kr rabatt betyr at 100 poeng gir 10 kr rabatt.",
    "customer_club_redemption_rate_tooltip": "Bestemmer hvor mye hvert poeng er verdt når kunden bruker det. Husk: å endre denne i etterkant endrer verdien av alle poeng som allerede er i omløp.",
    "customer_club_redemption_rate_points": "Poeng",
    "customer_club_redemption_rate_amount": "kr rabatt",
    "customer_club_rate_summary_earn": "Tilsvarer: tjen {points} poeng for hver {kr} kunden handler for.",
    "customer_club_rate_summary_redemption": "Tilsvarer: {points} poeng = {kr} i rabatt.",
    "customer_club_quarantine_days": "Ventetid før poeng kan brukes",
    "customer_club_quarantine_days_hint": "Velg en kort forsinkelse før poengene blir tilgjengelige.",
    "customer_club_quarantine_days_tooltip": "Hvor mange dager etter at ordren er behandlet må gå før poengene blir tilgjengelige for kunden. Anbefaling: minst angreretts-perioden (14 dager) pluss vanlig leveringstid, for å unngå å gi ut poeng på ordrer som returneres.",
    "customer_club_signup_bonus": "Velkomstbonus (poeng)",
    "customer_club_signup_bonus_hint": "Antall poeng som gis når brukeren blir med i kundeklubben for første gang, ingen hvis 0.",
    "customer_club_signup_bonus_tooltip": "Engangsbonus i poeng som gis automatisk når en kunde melder seg inn i klubben for første gang. Settes til 0 for å skru av velkomstbonusen helt.",
    "customer_club_calculator_title": "Kalkulator",
    "customer_club_calculator_hint": "Se hvordan gjeldende rater virker i praksis.",
    "customer_club_calculator_example_line": "Et kjøp på kr 500",
    "customer_club_calculator_points_earned": "Kunden tjener",
    "customer_club_calculator_discount_next_order": "Som gir rabatt på neste ordre",
    "customer_club_calculator_effective": "Effektiv cashback",
    "customer_club_calculator_cashback_exceeds_title": "Effektiv cashback er over 100%.",
    "customer_club_calculator_cashback_exceeds": "Kunden får tilbake mer i rabatt enn de betaler. Juster ratene.",
    "customer_club_rate_change_before": "Før:",
    "customer_club_rate_change_after": "Etter:",
    "customer_club_rate_change_delta": "Endring:",
    "customer_club_rate_change_warning_title": "Advarsel: rateendring",
    "customer_club_rate_change_warning_body": "Å endre innløsningsraten endrer verdien av alle opptjente poeng som er i omløp.",
    "customer_club_status_former_long": "Tidligere medlem",
    "customer_club_status_not_member": "Ikke medlem",
    "customer_club_event_type_signup_bonus": "Velkomstbonus",
    "customer_club_event_type_earned": "Opptjent",
    "customer_club_event_type_redeemed": "Innløst",
    "customer_club_event_type_earning_reversed": "Opptjening trukket tilbake",
    "customer_club_event_type_redemption_restored": "Innløsning tilbakeført",
    "customer_club_event_type_admin_adjusted": "Admin-justering",
    "customer_club_event_type_membership_joined": "Meldt inn",
    "customer_club_event_type_membership_cancelled": "Meldt ut",
    "customer_club_event_signup_bonus_description": "Signup-bonus",
    "customer_club_event_order_reference": "Ordre #{id}",
    "customer_club_event_order_refunded": "Ordre #{id} ble refundert",
    "customer_club_event_order_reduced": "Ordre #{id} ble redusert",
    "customer_club_event_member_joined": "Meldt inn",
    "customer_club_event_cancelled_by_customer": "Meldt av av kunden",
    "customer_club_event_cancelled_by_admin": "Meldt av av admin",
    "customer_club_event_cancelled_by_admin_with_reason": "Meldt av av admin: {reason}",
    "customer_club_total_earned": "Totalt opptjent",
    "customer_club_total_redeemed": "Totalt brukt",
    "customer_club_adjust_points": "Juster poeng",
    "customer_club_cancel_membership_button": "Meld kunden av",
    "customer_club_history_heading": "Historikk",
    "customer_club_history_col_time": "Tid",
    "customer_club_history_col_type": "Type",
    "customer_club_history_col_description": "Beskrivelse",
    "customer_club_history_col_change": "Endring",
    "customer_club_history_empty": "Ingen hendelser",
    "customer_club_settings_intro_description": "La kundene tjene poeng for hver handel og bruke dem som rabatt på senere kjøp. Kundene ser kundeklubben på kassekvitteringen og på Min side i nettbutikken.",
    "customer_club_group_activation": "Aktivering og velkomst",
    "customer_club_group_activation_description": "Skru på kundeklubben og bestem velkomstbonusen til nye medlemmer.",
    "customer_club_group_earning": "Opptjening",
    "customer_club_group_earning_description": "Hvordan kundene tjener poeng, med valgfri karantenetid før poengene kan brukes.",
    "customer_club_group_redemption": "Innløsning",
    "customer_club_group_redemption_description": "Hvor mye hvert poeng er verdt når kundene bruker det som rabatt.",
    "customer_club_for_every": "For hver",
    "customer_club_ratio_give": "gi kunden",
    "customer_club_ratio_equals_discount": "= rabatt på",
    "customer_club_kr_label": "kr",
    "customer_club_kr_discount": "kr rabatt",
    "customer_club_points_label": "poeng",
    "customer_club_product_register_description_help": "Teksten som vises under poeng-informasjonen på produktsiden for besøkende som ikke er medlem.",
    "customer_club_product_register_bonus_title": "Velkomstbonus (valgfri)",
    "customer_club_product_register_bonus_help": "Vises under beskrivelsen for besøkende som ikke er medlem, og bare når velkomstbonusen i innstillingene er over null. Bruk {bonus} for antall poeng og {bonus_value} for kroneverdien. Tøm feltet for å skjule linjen.",
    "customer_club_product_register_button_help": "Teksten på knappen som oppfordrer besøkende til å bli medlem.",
    "customer_club_product_member_description_help": "Valgfri tekst som vises under poeng-informasjonen for innloggede medlemmer.",
    "customer_club_product_member_description_placeholder": "F.eks. Dine poeng kan brukes i kassen ved neste kjøp.",
    "customer_club_product_box_bg_color_help": "Bakgrunnsfarge for kundeklubb-boksene på produktsiden.",
    "customer_club_product_box_text_color_help": "Tekstfarge for innholdet i kundeklubb-boksene på produktsiden.",
    "more_info": "Mer info",
    "quick_start": "Hurtigoppsett",
    "quick_start_description": "Velg en startpakke for å fylle inn vanlige verdier.",
    "discard": "Forkast",
    "customer_club_preview_title": "Slik fungerer kundeklubben din",
    "customer_club_preview_description": "Oppsummering basert på gjeldende innstillinger. Oppdateres mens du endrer feltene.",
    "customer_club_journey_title": "Eksempel på kundereise",
    "customer_club_journey_step_join_title": "Kunden melder seg på klubben",
    "customer_club_journey_step_shop_title": "Kunden handler for {amount} kr",
    "customer_club_journey_step_wait_title": "Poengene blir tilgjengelige",
    "customer_club_journey_step_wait_metric": "Etter {days} dager",
    "customer_club_journey_step_redeem_title": "Kunden bruker {points} poeng i kassa",
    "customer_club_active_state_title": "Kundeklubben er aktiv",
    "customer_club_active_state_hint": "Kundene kan tjene og bruke poeng.",
    "customer_club_inactive_state_title": "Kundeklubben er ikke aktiv",
    "customer_club_inactive_state_hint": "Skru på bryteren til høyre for å aktivere kundeklubben.",
    "customer_club_inactive_flash": "Kundeklubben er ikke aktiv.",
    "customer_club_join_welcome_with_bonus": "Velkommen! Du har fått :points poeng i innmeldingsbonus.",
    "customer_club_join_welcome_back": "Velkommen tilbake! Saldoen din er gjenopprettet.",
    "customer_club_join_welcome": "Velkommen til kundeklubben!",
    "customer_club_join_error_already_member": "Du er allerede medlem av kundeklubben.",
    "customer_club_join_error_b2b_only": "Kundeklubben er kun tilgjengelig for privatkunder.",
    "customer_club_join_error_default": "Innmelding feilet. Prøv igjen eller ta kontakt med oss.",
    "customer_club_leave_error_not_member": "Du er ikke medlem av kundeklubben.",
    "customer_club_leave_error_default": "Utmelding feilet. Prøv igjen eller ta kontakt med oss.",
    "customer_club_leave_success": "Du er meldt ut av kundeklubben.",
    "customer_club_adjustment_registered": "Justering registrert",
    "customer_club_membership_cancelled": "Medlemskap avsluttet",
    "customer_club_validation_earn_rate_invalid": "Opptjenings-rate må være positivt heltall.",
    "customer_club_validation_redemption_rate_invalid": "Innløsnings-rate må være positivt heltall.",
    "customer_club_validation_quarantine_days_invalid": "Karantene-dager må være ≥ 0.",
    "customer_club_validation_signup_bonus_invalid": "Signup-bonus må være ≥ 0.",
    "customer_club_validation_reason_required": "Årsak er påkrevd.",
    "customer_club_validation_reason_required_admin": "Årsak er påkrevd ved admin-cancellering.",
    "customer_club_validation_delta_nonzero": "Endring må være ulik 0.",
    "customer_club_validation_redemption_amount_not_integer_ore": "1 poeng må tilsvare heltall øre. Prøv :suggestions i stedet.",
    "customer_club_validation_cashback_over_100": "Effektiv cashback er :percent% — må være ≤ 100%.",
    "create_new_coupon": "Opprett ny rabattkode",
    "edit_coupon": "Rediger rabattkode",
    "coupon_code": "Rabattkode",
    "discount": "Rabatt",
    "discount_amount": "Rabattmengde",
    "apply_to": "Gjelder for",
    "active_dates": "Aktive datoer",
    "start_date": "Startdato",
    "has_expiry_date": "Har utløpsdato",
    "expiry_date": "Utløpsdato",
    "all_buyables": "Alle produkter",
    "selected_buyables": "Utvalgte produkter",
    "all_buyables_except": "Alle produkter unntatt utvalgte",
    "amount_off_products": "Rabatt på produkter",
    "free_shipping": "Gratis frakt",
    "limits": "Begrensninger",
    "max_shipping_price": "Maks fraktpris",
    "expired": "Utløpt",
    "start_typing_to_create_a_new_tag": "Begynn å skrive for å lage en ny tag",
    "start_typing_to_create_a_new_badge": "Begynn å skrive for å lage en ny badge",
    "select_products": "Velg produkter",
    "x_products_selected": "{count} produkt markert | {count} produkter markert",
    "select_all": "Velg alle",
    "select_listings": "Velg oppføringer",
    "x_listings_selected": "{count} oppføring markert | {count} oppføringer markert",
    "showing_all_listing_types": "Viser alle typer oppføringer",
    "listings_in_category": "Produkter etc.",
    "listings_matching_smart_criteria": "Produkter etc. som matcher kriteriene",
    "are_you_sure_you_want_to_delete_the_coupon": "Er du sikker på at du vil slette rabattkoden {coupon}?",
    "coupon_deleted": "Rabattkode slettet",
    "edit_coupon_x": "Rediger rabattkode {code}",
    "coupon_updated": "Rabattkode oppdatert",
    "coupon_created": "Rabattkode opprettet",
    "no_code_entered": "Ingen kode oppgitt",
    "no_expiry_date": "Ingen utløpsdato",
    "generate_random_code": "Generer tilfeldig kode",
    "scheduled": "Planlagt",
    "x_off_all_products": "{discountAmount}% rabatt på alle produkter",
    "x_off_all_products_except_selected": "{discountAmount}% rabatt på alle produkter unntatt {count} utvalgte produkter",
    "x_off_x_amount_of_selected_products": "{discountAmount}% rabatt på {count} valgte produkter",
    "x_off_x_amount_of_tags": "{discountAmount}% rabatt på {count} tags",
    "cart_item_not_found": "Varen ble ikke funnet i handlekurven",
    "insufficient_stock_available": "Utilstrekkelig antall på lager",
    "desired_quantity_must_be_greater_than_0": "Ønsket antall må være større enn 0",
    "coupon_code_is_invalid": "Rabattkoden er ugyldig",
    "coupon_code_cannot_be_empty": "Rabattkoden kan ikke være tom",
    "checkout_state_not_valid_for_operation": "Ugyldig tilstand {state} for operasjon",
    "klarna_order_loading_failed": "Klarna ordre kunne ikke lastes",
    "klarna_checkout_already_completed": "Klarna ordre er allerede fullført",
    "klarna_order_update_failed": "Kunne ikke oppdatere Klarna ordre",
    "An error occurred. Please try again": "En feil oppstod. Vennligst prøv igjen",
    "coupon_code_percentage_off": "Rabattkode -:discountPercentage% (:code)",
    "coupon-code-helper-text": "Tips: koder med bokstaver, tall, bindestrek og understrek kan deles via URL og QR-kode.",
    "coupon-qr-button-disabled-tooltip": "Denne koden inneholder tegn som ikke er trygge å dele i URL-er. Bruk bokstaver, tall, bindestrek eller understrek for å aktivere QR- og URL-deling.",
    "coupon-qr-button-label": "Del rabattkode",
    "coupon-qr-copy-link": "Kopier lenke",
    "coupon-qr-copied": "Lenken er kopiert",
    "coupon-qr-download-png": "Last ned PNG",
    "coupon-qr-download-svg": "Last ned SVG",
    "coupon-qr-modal-title": "QR-kode for rabattkode",
    "discount-code-applied": "Rabattkoden :code er lagt til",
    "discount-code-not-valid": "Denne rabattkoden er ikke lenger gyldig",
    "invoice_number": "Fakturanummer",
    "internal_identifier": "Intern id",
    "cancellation": "Kansellering",
    "cancelled": "Kansellert",
    "no_items_left_to_fulfill": "Alle ordrelinjer er behandlet",
    "shipping_cant_remain_with_no_items": "Frakt kan ikke være igjen uten varer",
    "continue_shopping": "Fortsett å handle",
    "continue": "Fortsett",
    "are_you_sure_you_want_to_delete_{count}_products": "Er du sikker på at du ønsker å slette {count} produkt? | Er du sikker på at du ønsker å slette {count} produkter?",
    "maintenance_mode_info": "Vedlikeholdsmodus gjør at butikken din blir utilgjengelig for kunder. Du kan legge til et passord for å vise butikken for kunder som har passordet.",
    "compared_to": "Sammenlignet med",
    "revenue": "Omsetning",
    "profit": "Fortjeneste",
    "order_count": "Antall ordre",
    "average_order_value": "Snitt ordreverdi",
    "today": "I dag",
    "this_week": "Denne uken",
    "this_month": "Denne måneden",
    "this_year": "Dette året",
    "yesterday": "I går",
    "last_week": "Forrige uke",
    "last_month": "Forrige måned",
    "last_year": "Forrige år",
    "current_month": "Nåværende måned",
    "previous_month": "Forrige måned",
    "day": "Dag",
    "store_development": "Butikkens utvikling",
    "latest_x_unfulfilled_orders": "Siste {amount} ubehandlede ordre",
    "you_have_no_unfulfilled_orders": "Du har ingen ubehandlede ordre",
    "hi_name": "Hei, {name}",
    "hi_name!": "Hei, :Name!",
    "user_invite_text_join": "Du har blitt invitert!",
    "user_invite_text_accept": "For å godta invitasjonen og konfigurere kontoen din, klikk på knappen nedenfor:",
    "user_invite_accept": "Godta invitasjonen",
    "add_widget": "Legg til widget",
    "current_active_users": "Nåværende aktive brukere",
    "current_devices": "Nåværende enheter",
    "current_popular_pages": "Nåværende populære sider",
    "short_statistics": "Nøkkeltall",
    "remove_widget_x": "Fjerne widgeten \"{name}\"? Du kan legge den tilbake senere",
    "show_test_data": "Vis testdata",
    "remove": "Fjern",
    "remove_dates": "Fjern datoer",
    "currently_no_active_users_in_store": "Det er foreløpig ingen aktive brukere i butikken",
    "country": "Land",
    "active_users": "Aktive brukere",
    "device": "Enhet",
    "tablet": "Nettbrett",
    "desktop": "Desktop",
    "page": "Side",
    "search_engine_optimization": "Søkemotoroptimalisering",
    "tracking_code": "Sporingskode",
    "tracking_code_guide": "Se veiledning for å finne sporingskoden her",
    "property_id": "Property ID",
    "property_id_info": "Property ID-en er en unik identifikator for din Google Analytics-property. Sammen med sporingskoden er den nødvendig for at du skal kunne se Google Analytics-data direkte i butikken din. <a class='text-indigo-600 cursor-pointer' id='analytics-setup-guide'>Se oppsettveiledning</a>\n",
    "property_id_guide": "<h2>For å finne din Google Analytics property-ID:</h2>\n <ol>\n <li>Besøk Google Analytics på <a href=\"https://analytics.google.com/\" target=\"_blank\">https://analytics.google.com/</a>.</li>\n <li>Velg Admin.</li>\n <li>Trykk på Property details under Property.</li>\n </ol>\n <p>Hvis Property details viser en numerisk \"PROPERTY ID\" som \"123...\", er dette ID-en for din Google Analytics-property.</p>",
    "about_google_analytics_settings": "Google Analytics er en webanalysetjeneste levert av Google som sporer og rapporterer nettstedstrafikk. For å aktivere Google Analytics på butikken din, må du opprette en Google Analytics-konto og legge til sporingskoden her.",
    "analytics_track_sales": "Spor salg",
    "analytics_track_sales_description": "Sender kjøp, handlekurv og produktvisninger til Google Analytics som e-handelshendelser. Gjelder GA4-koder (G-…).",
    "analytics_hand_installed_purchase_warning": "Partneren «{name}» sender allerede kjøp til Google Analytics. Er salgssporing på her også, blir hvert salg telt to ganger.",
    "analytics_open_partner": "Åpne partneren",
    "analytics_tracking_code_is_extra_account": "Denne koden er allerede lagt inn som ekstra GA4-konto i hurtiginstallasjonen. Fjern den der først.",
    "add_analyst_user": "Legg til analytikerbruker",
    "add_analyst_user_info": "For at du skal kunne se live traffikk-data og rapporter fra Google Analytics direkte i nettbutikken, må du legge til en analytikerbruker i Google Analytics-kontoen din. Brukeren må ha tilgang til \"Analyst\"-rettigheter for å kunne se dataene. Nedenfor finner du e-postadressen som denne brukeren må ha.",
    "copy_to_clipboard": "Kopier til utklippstavlen",
    "email_copied_to_clipboard": "E-postadresse kopiert til utklippstavlen",
    "google_analytics_auth_error": "Vennligst sjekk at sporingskoden og property-ID-en til din Google Analytics er riktig, i tillegg til at analytiker-brukeren har blitt lagt til.",
    "go_to_analytics_page": "Gå til analytics-siden",
    "unknown_error_has_occurred_contact_support": "En ukjent feil har oppstått. Vennligst kontakt support på telefon <a href='tel:22336688' class='text-[color:var(--link-color)]'>22 33 66 88</a> eller e-post <a href='mailto:support@24nettbutikk.no' class='text-[color:var(--link-color)]'>support@24nettbutikk.no</a>",
    "latest_unfulfilled_orders_info": "De siste ubehandlede ordrene vises her. Klikk på en ordre for å se flere detaljer eller for å behandle den.",
    "comparison_charts_info": "Butikkens utvikling viser grafer av hvordan butikken din presterer denne måneden sammenlignet med forrige måned. Du kan se omsetning og 7 bestillinger.",
    "google_current_active_users_info": "Widgeten for nåværende aktive brukere viser hvor mange brukere som for øyeblikket besøker butikken din. Du kan også se hvilket land de kommer fra.",
    "google_current_devices_info": "Widgeten for nåværende enheter viser hvilke enheter brukerne bruker for å besøke butikken din akkurat nå.",
    "google_current_popular_pages_info": "Widgeten for nåværende populære sider viser hvilke sider som for øyeblikket er de mest populære i butikken din.",
    "short_statistics_info": "Widgeten for nøkkelstatistikk viser de viktigste statistikkene for butikken din. Du kan se omsetning, antall ordre, gjennomsnittlig ordreverdi og nyhetsbrevpåmeldinger.",
    "sales_report": "Salgsrapport",
    "months_by_index": {
        "1": "Januar",
        "2": "Februar",
        "3": "Mars",
        "4": "April",
        "5": "Mai",
        "6": "Juni",
        "7": "Juli",
        "8": "August",
        "9": "September",
        "10": "Oktober",
        "11": "November",
        "12": "Desember"
    },
    "month": "Måned",
    "year": "År",
    "order_status": "Ordrestatus",
    "goods_with_tax_rate": "Varer med {taxRate}% MVA",
    "net": "Netto",
    "nets_easy_checkout_name": "Nets Easy",
    "nets_easy_credentials_not_found": "Nets Easy-nøkler er ikke konfigurert.",
    "nets_easy_does_not_support_payment_refresh": "Nets Easy støtter ikke oppdatering av betaling.",
    "nets_easy_no_charge_id_for_refund": "Kan ikke refundere: ingen chargeId registrert på ordren.",
    "nets_easy_order_id_not_set": "Nets Easy betalings-ID er ikke satt.",
    "nets_easy_payment_refused_missing_shipping": "Betalingen ble avbrutt fordi ingen fraktmetode var valgt, og du har ikke blitt belastet. Velg fraktmetode og fullfør betalingen på nytt.",
    "tax": "MVA",
    "gross": "Brutto",
    "sum_all_goods": "Sum alle varer",
    "sum_shipping": "Sum frakt",
    "sum_refunds": "Sum krediteringer",
    "sum_total": "Sum total",
    "sales_report_tooltip": "I regnskapsmessig forstand registreres et salg på det tidspunktet inntektene fra en transaksjon er opptjent, noe som vanligvis skjer når en vare er levert kunden og når selgeren (du) mottar oppgjør fra kunden. <br><br> I nettbutikken definerer vi \"levert\" når du klikker på \"Send ordre\" med intensjon om å sende denne pakken til kjøper (kunden). Du vil med denne handlingen også be om betaling fra betalingstilbyder som f.eks. Vipps eller Klarna og transaksjonen er per definisjon ferdig og vil således komme med på salgsrapporten. <br><br> Ubehandlede ordrer vil således ikke komme med på salgsrapporten.",
    "good_morning": "God morgen",
    "good_forenoon": "God formiddag",
    "good_afternoon": "God ettermiddag",
    "hello": "Hei",
    "key_figures_for_period": "Nøkkeltall for perioden",
    "daily_reports": "Dagsrapporter",
    "download_csv_file": "Last ned CSV-fil",
    "back_to_themes": "Tilbake til temaer",
    "payment_methods": "Betalingsalternativer",
    "payment_method_name": "Alternativ",
    "type": "type",
    "disabled": "Deaktivert",
    "checkout": "Kasse",
    "checkout_providers": "Kasseleverandører",
    "requires_action": "Krever handling",
    "vipps_serial_number": "Serial number",
    "vipps_client_id": "Client ID",
    "vipps_client_secret": "Client secret",
    "vipps_subscription_key_auth": "Subscription key authentication",
    "vipps_subscription_key_pay": "Subscription key payment",
    "klarna_merchant_id": "Merchant ID",
    "klarna_shared_secret": "Shared secret",
    "payment_method_updated": "Betalingsmåte oppdatert",
    "selected": "valgt",
    "choose_variant_title": "Velg {name}",
    "delete_files": "Slett filer",
    "payment_reference": "Betalingsreferanse",
    "checkout_gateways_kco_description": "Komplett kasseløsning med faktura, delbetaling og kort via Klarna. Støtter både B2B og B2C. Klarna håndterer betalingsrisikoen slik at du alltid får betalt. Inkluderer salgsrapporter og analyser.",
    "checkout_gateways_nets_easy_description": "Med Nexi Nets Easy Checkout kan du tilby en rekke ulike betalingsvalg som Vipps, Klarna, Google- og ApplePay med flere. Ordrebehandlingen er integrert direkte med Nets Easy, slik at du aldri trenger å forlate ordrevinduet for å behandle ordrer.",
    "nets_easy_checkout_key": "Checkout-nøkkel",
    "nets_easy_secret_key": "Hemmelig nøkkel",
    "no_widgets_available": "Ingen widgets tilgjengelig",
    "no_widgets_available_description": "Det er ingen flere widgets som er mulig å legge til",
    "newsletter": "Nyhetsbrev",
    "register": "Registrer",
    "try_for_free": "Prøv gratis",
    "newsletter_email_already_registered": "E-postadressen er allerede registrert",
    "toggle_active": "Sett aktiv/inaktiv",
    "update_stock": "Oppdater varelager",
    "theme_settings": "Temainnstillinger",
    "theme_section_belongs_to_theme": "Tilhører temaet og er lik på alle sider. Redigeres fra forsiden som vises i butikken.",
    "theme_settings_apply_shop_wide": "Disse innstillingene tilhører temaet og gjelder hele butikken, ikke bare malen du redigerer nå. Endrer du noe her mens en A/B-test går, endres begge malene testen sammenligner.",
    "theme_editor_search_settings": "Søk i innstillinger",
    "theme_editor_search_no_results": "Ingen innstillinger passer søket",
    "theme_editor_search_opens_other_page": "Åpner en annen side i designbyggeren",
    "text_content_padding": "Luft rundt innholdet",
    "text_content_padding_description": "Slå av for å la innholdet gå helt ut til kantene, for eksempel en HTML-seksjon med egen bakgrunn. Vanlig tekst bør ha luft.",
    "theme_sliders": "Bildekaruseller",
    "social_links": "Sosiale lenker",
    "are_you_sure_you_want_to_delete_logo": "Er du sikker på at du vil slette logoen? Endringen skjer når malen blir lagret",
    "image_logo": "Bildelogo",
    "text_logo": "Tekstlogo",
    "add_new_text": "Legg til ny tekst",
    "conversion_tracking": "Konverteringssporing",
    "conversion_partners": "Konverteringspartnere",
    "conversion_partner": "Konverteringspartner",
    "events": "Hendelser",
    "event": "Hendelse",
    "add_conversion_partner": "Legg til konverteringspartner",
    "edit_conversion_partner": "Rediger konverteringspartner",
    "add_partner": "Legg til partner",
    "analytics": "Analyse",
    "necessary": "Nødvendig",
    "name_placeholder": "F.eks. Google Analytics",
    "purpose_placeholder": "F.eks. analyse av trafikken på nettstedet",
    "purpose": "Formål",
    "type(s)": "Type(r)",
    "a_description_of_what_this_partner_is_used_for": "En beskrivelse av hva denne partneren brukes til",
    "data_processor_policy": "Databehandleravtale",
    "link_to_the_partners_data_processing_agreement": "Url til partneres databehandleravtale",
    "partner_storage_duration": "Lagringsvarighet hos partner",
    "hours": "timer",
    "days": "dager",
    "weeks": "uker",
    "months": "måneder",
    "years": "år",
    "is_required": "nødvendig",
    "is_retargeting": "markedsføring",
    "is_analytics": "analyse",
    "what_is_this_partnership_used_for": "Hva brukes dette partnerskapet til?",
    "the_conversion_partner_is_required_for_the_shop_to_operate_correctly": "Konverteringspartneren er nødvendig for at butikken skal fungere riktig",
    "the_conversion_partner_is_used_for_retargeting": "Konverteringspartneren brukes til markedsføring",
    "the_conversion_partner_is_used_for_analytics": "Konverteringspartneren brukes til analyse",
    "how_long_does_the_partner_store_the_users_data": "Hvor lenge lagrer partneren brukerdata?",
    "are_you_sure_you_want_to_delete_partner": "Er du sikker på at du vil slette partneren {partner}?",
    "at_least_one_type_must_be_selected": "Minst én type må velges",
    "snippet": "Kodesnutt",
    "snippets": "Kodesnutter",
    "what_kind_of_event_should_trigger_the_snippet": "Hvilken type hendelse skal utløse kodesnutten?",
    "cart-item-quantity-updated": "Antall av vare i handlekurv ble endret",
    "cart-item-removed": "Vare fjernet fra handlekurv",
    "added-to-cart": "Vare ble lagt til i handlekurv",
    "product-viewed": "Produkt vist",
    "page-visited": "Side besøkt",
    "checkout-started": "Utsjekk startet",
    "order-placed": "Ordre ble opprettet",
    "create_new_snippet": "Opprett ny kodesnut",
    "code_that_should_be_triggered": "Kode som skal kjøres",
    "are_you_sure_you_want_to_delete_snippet": "Er du sikker på at du vil slette kodesnutten '{snippet}?'",
    "snippet_appears_to_be_invalid": "Kodesnutten ser ut til å være ugyldig",
    "snippet_appears_to_be_valid": "Kodesnutten ser ut til å være gyldig",
    "event_count": "Antall hendelser",
    "only_visible_for_you": "Kun synlig for deg",
    "internal_name": "Internt navn",
    "edit_snippet": "Rediger kodesnut",
    "knowledge_base": "Hjelpesenter",
    "duration": "Varighet",
    "add_new_cookie": "Legg til ny cookie",
    "cookies": "Cookies",
    "edit_cookie": "Rediger cookie",
    "cookie_name_placeholder": "F.eks. _ga",
    "snippet_disclaimer": "Kodesnuttene er en avansert funksjon som krever kunnskap om JavaScript og HTML. 24Nettbutikk er ikke ansvarlig for din kodesnutt. Det er ditt ansvar at kodesnutten følger gjeldende lover og regler, samt eventuelle feil som oppstår som resultat av kodesnutten.",
    "note": "Merk",
    "enable_google_analytics_in_the_store": "Aktiver Google Analytics i butikken",
    "google_analytics": "Google Analytics",
    "option_display_text": "Tekst",
    "option_display_color": "Farge",
    "option_display_image": "Bilde",
    "colour_suggested_from_other_products": "Foreslått fra andre produkter",
    "pick_color": "Velg farge",
    "remove_color": "Fjern farge",
    "remove_image": "Fjern bilde",
    "no_images_uploaded_yet": "Last opp bilder under Bilder først, så kan du velge dem her.",
    "hi_{name}": "Hei, {name}",
    "we_will_notify_you_when_the_order_is_shipped": "Vi varsler deg når ordren er sendt",
    "credit_note": "Kreditnota",
    "your_order_has_been_shipped": "Din ordre er ferdig behandlet",
    "your_order_has_been_refunded": "Din ordre har blitt kreditert",
    "your_order_has_been_cancelled": "Din ordre har blitt kansellert",
    "your_order_has_been_updated": "Din ordre har blitt oppdatert",
    "your_order_number_has_been_cancelled": "Din ordre #:number har blitt kansellert.",
    "cancelled_items": "Kansellerte varer",
    "notify_customer_of_cancellation": "varsle kunden om kansellering",
    "notify_customer_of_changes": "varsle kunden om endringer",
    "if_you_have_any_questions_reply_or_contact_us_at": "Hvis du har noen spørsmål, svar på denne e-posten eller kontakt oss på",
    "payment_operation_failed": "Kunne ikke utføre handling, kommunikasjon med betalingstilbyder feilet.",
    "reference_code": "Referansekode: :code",
    "cancellations": "Kanselleringer",
    "show_orders": "Vis ordre",
    "redirects": "Viderekoblinger",
    "create_new_redirect": "Opprett ny viderekobling",
    "redirect_from": "Viderekobling fra",
    "redirect_to": "Viderekobling til",
    "redirect_from_description": "Viderekoblingen du ønsker å sende besøkende fra. Hvis du har en gammel sti som du vil viderekoble til en ny URL, skriv inn den gamle stien her. Viderekoblingen må være en sti, ikke en full URL. Eksempel: /gammel-sti",
    "redirect_to_description": "Viderekoblingen du ønsker å sende besøkende til. Dette kan enten være en URL eller sti i nettbutikken din, eller en ekstern URL.",
    "add_redirect": "Legg til viderekobling",
    "redirect_from_must_be_a_valid_path": "Viderekobling fra må være en gyldig sti",
    "redirect_to_must_be_a_valid_path_or_url": "Viderekobling til må være en gyldig sti eller URL",
    "cannot_redirect_to_another_redirect": "Kan ikke viderekoble til en annen viderekobling",
    "edit_redirect": "Rediger viderekobling",
    "redirect_created": "Viderkobling opprettet!",
    "redirect_deleted": "Viderkobling slettet!",
    "are_you_sure_you_want_to_delete_the_redirect": "Er du sikker på at du vil slette viderekoblingen?",
    "import_csv_file": "Importer CSV-fil",
    "download_example_csv": "Last ned eksempel CSV",
    "errors": "Feil",
    "redirects_import_result": "Resultat av viderekoblingsimport",
    "redirect_csv_upload_error": "En feil oppstod under opplasting av CSV-filen. Vennligst sjekk filen og prøv igjen, eller se om filen samsvarer med eksempel-CSV.",
    "redirect_csv_upload_success": "CSV-filen ble lastet opp! Du vil snart motta en e-post med resultatene av importen. Du kan prøve å oppdatere siden for å se den oppdaterte listen over viderekoblinger.",
    "export_redirects": "Eksporter viderekoblinger",
    "edit_image": "Rediger bilde",
    "back_to_images": "Tilbake til bilder",
    "image_effects": "Bildeeffekter",
    "blur": "Uskarphet",
    "saturation": "Metning",
    "image_effect_blur_description": "Får tekst og knapp til å skille seg ut.",
    "image_effect_saturation_description": "Lavere = mer dempet. 100 % = originalbildet.",
    "use_theme_cta_colors": "Bruk tema-CTA-farger",
    "advanced_options": "Avanserte alternativer",
    "image_overlay_preview_note": "Forhåndsvisningen viser bildet i et mindre vindu. Tekststørrelse er korrekt, men forholdet mellom tekst og bilde kan se annerledes ut på den faktiske siden.",
    "display_mode": "Visningsmåte",
    "display_mode_hint": "«Enkel» lar bildet være en ren lenke. «Med innhold» lar deg legge tittel, tekst og knapp oppå bildet.",
    "overlay_device_desktop": "Desktop",
    "overlay_device_mobile": "Mobil",
    "mobile_content_override": "Eget innhold på mobil",
    "mobile_content_override_hint": "Tekst, størrelser og plassering under overstyrer desktop på små skjermer. Størrelser på mobil er faste piksler.",
    "mobile_inherits_hint": "Mobil bruker samme innhold som desktop, skalert etter bildebredden.",
    "mobile_content_mirror_hint": "Feltene under speiler desktop til du endrer noe. Endringer gjelder kun mobil, med faste pikselstørrelser.",
    "image_content_button": "Innhold",
    "phone_preview_mode_editing": "Redigering",
    "phone_preview_mode_page": "Faktisk side",
    "block_setting_section_label": "Blokkinnstilling",
    "block_height_live_hint": "Gjelder alle bildene i blokken og oppdateres med en gang.",
    "image_content_toggle": "Innhold på bildet",
    "image_content_toggle_hint": "Legg tittel, tekst og knapp oppå bildet. Lenke og alternativ tekst setter du på bilderaden i panelet.",
    "mobile_image_section": "Mobilbilde",
    "mobile_image_inherits": "Mobil bruker samme bilde som desktop.",
    "mobile_image_choose": "Bruk eget bilde på mobil",
    "mobile_image_remove": "Fjern – bruk samme som desktop",
    "image_slider_title_description": "Valgfri overskrift som vises over slideren.",
    "image_slider_title_color": "Tittelfarge",
    "image_slider_title_color_description": "Gjelder kun tittelen over slideren. Farger på tekst og knapper oppå bildene setter du i Innhold på hvert bilde.",
    "image_slider_background_color_description": "Bakgrunnen bak slideren – synlig ved vertikal luft eller når blokken ikke er i full bredde.",
    "image_slider_transition_effect": "Overgangseffekt",
    "image_slider_transition_effect_description": "Hvordan byttet mellom bildene animeres.",
    "image_slider_effect_slide": "Skyv (standard)",
    "image_slider_effect_fade": "Overtoning",
    "image_slider_effect_cube": "Kube",
    "image_slider_effect_coverflow": "Coverflow",
    "image_slider_effect_flip": "Flipp",
    "help": "Hjelp",
    "help_modal_title": "Hjelp og oversikt",
    "help_modal_subtitle": "Bli kjent med designbyggeren og blokkene du kan bruke",
    "help_first_time_tooltip": "Ny her? Trykk for å lære om designbyggeren",
    "help_more_help_question": "Fant du ikke svar på det du lurer på?",
    "help_contact_support": "Kontakt support",
    "help_save_publish_name": "Lagre og publiser",
    "help_save_publish_tagline": "Hvordan endringene dine når kundene.",
    "help_save_publish_description": "Endringer du gjør i designbyggeren er ikke synlige for kundene før du lagrer og publiserer.",
    "help_save_publish_workflow_heading": "Slik fungerer flyten",
    "help_save_publish_step_edit": "1. Du endrer noe — flytter en blokk, bytter farge, redigerer tekst.",
    "help_save_publish_step_save": "2. Endringene ligger bare i editoren (du ser dem i forhåndsvisningen, kundene ser dem ikke).",
    "help_save_publish_step_publish": "3. Du klikker «Lagre og publiser» øverst til høyre.",
    "help_save_publish_step_live": "4. Endringene er nå live — kundene ser oppdatert versjon når de besøker siden.",
    "help_save_publish_status_heading": "Utkast vs. publisert",
    "help_save_publish_status_draft": "Utkast-blokker er kun synlige i editoren — bruk det mens du jobber.",
    "help_save_publish_status_published": "Publiserte blokker er synlige for kundene (etter at du har klikket «Lagre og publiser»).",
    "help_save_publish_status_change": "Slå «Publisert» av eller på øverst i blokkens innstillinger. Blokker som er slått av, er merket «utkast» i sidemenyen.",
    "help_save_publish_buttons_heading": "Når knappene heter noe annet",
    "help_save_publish_button_not_live": "Et overstrøket øye ved knappene betyr at malen du redigerer ikke er den som brukes som standard, og da heter knappen «Lagre». En forsidemal vises ikke i butikken før den publiseres, mens produkter og kategorier som har fått malen, ser endringene med en gang.",
    "help_save_publish_button_publish_home": "«Publiser som forside» gjør forsidemalen til den besøkende ser. Forsiden du brukte, blir liggende som utkast.",
    "help_save_publish_button_use_template": "«Bruk denne malen» gjør en produkt- eller kategorimal til standardmalen for alle som ikke har fått en egen.",
    "help_save_publish_button_other_theme": "Redigerer du et tema som ikke er aktivt, lagrer «Lagre» uten at butikken endres, og «Publiser» gjør temaet til det aktive.",
    "help_save_publish_tip_draft_first": "Lag nye blokker som utkast, finpuss dem ferdig, og publiser når du er fornøyd.",
    "help_save_publish_tip_test": "Forhåndsvis alltid i mobilvisning før du publiserer.",
    "help_themes_name": "Bytte mellom temaer",
    "help_themes_tagline": "Du kan ha flere temaer og bytte mellom dem — fint for kampanjer og sesonger.",
    "help_themes_description": "Et tema er hele butikkens utseende: farger, skrift, header, footer og alle sidene med malene sine. Du kan ha flere temaer, men bare ett er aktivt i butikken om gangen. Brukes typisk til å forberede en sesongkampanje uten å forstyrre det kundene ser nå.",
    "help_themes_feature_multiple": "Ha flere temaer — ett for vanlig drift, andre for kampanjer.",
    "help_themes_feature_switch": "Åpne temaet fra Tema-menyen øverst, og trykk «Publiser» for å gjøre det aktivt.",
    "help_themes_feature_presets": "Start fra et ferdig design med «Legg til tema» i Tema-menyen — det åpner Designvarianter, med design for ulike bransjer.",
    "help_themes_feature_duplicate": "Dupliser et tema fra Tema-menyen som utgangspunkt.",
    "help_themes_usecase_seasonal": "Sesongtemaer — ett til jul, ett til sommer og vanlig drift resten av året.",
    "help_themes_usecase_campaign": "Forbered et Black Friday-tema i god tid, og publiser det når kampanjen starter.",
    "help_themes_usecase_backup": "Trygg kopi — dupliser det aktive temaet før du gjør store endringer.",
    "help_themes_gtk_only_one_live": "Bare ett tema er aktivt om gangen — det som er merket «Aktivt» i Tema-menyen. De andre er lagret, men vises ikke.",
    "help_themes_gtk_shared_settings": "Temainnstillinger, header og footer hører til temaet. Bytter du tema, bytter du alt dette samtidig.",
    "help_themes_gtk_ab_test": "Publiserer du et annet tema mens en A/B-test går, avsluttes testen. Malene den tester hører til temaet som er aktivt nå.",
    "help_themes_gtk_startup": "Med Startup-abonnementet jobber du med ett tema om gangen.",
    "help_themes_tip_duplicate_before_change": "Dupliser temaet før du gjør drastiske endringer — så har du alltid noe å gå tilbake til.",
    "help_ab_testing_name": "A/B-testing",
    "help_ab_testing_tagline": "Test to maler mot hverandre og se hvilken som selger best.",
    "help_ab_testing_description": "Med A/B-testing fordeles de besøkende på to maler, og salget måles for begge. Du kan teste forsiden, produktsidene eller kategorisidene. Variantene er helt vanlige maler som du lager og redigerer her i designbyggeren.",
    "help_ab_testing_setup_heading": "Slik setter du opp en test",
    "help_ab_testing_setup_template": "1. Lag malen du vil teste: dupliser dagens mal i «Side og mal»-velgeren og endre kopien.",
    "help_ab_testing_setup_save": "2. Lagre. Kopien vises ikke i butikken før testen starter, eller før du tar den i bruk selv.",
    "help_ab_testing_setup_start": "3. Start testen under Salg → A/B-testing, eller med «Start en A/B-test» nederst i velgeren.",
    "help_ab_testing_running_heading": "Mens testen går",
    "help_ab_testing_running_dont_edit": "La malene være. Designbyggeren varsler når malen du har åpen er med i en test — endrer du den, blir resultatet ubrukelig.",
    "help_ab_testing_running_shared": "Temainnstillinger, header og footer er felles for begge malene. Endrer du dem, endres begge.",
    "help_ab_testing_running_same_template": "Hver besøkende får samme mal hver gang, også når de kommer tilbake. En nødvendig informasjonskapsel husker valget.",
    "help_ab_testing_running_one_per_page": "Du kan ha én test i gang per sidetype.",
    "help_ab_testing_running_default_locked": "Du kan ikke bytte standardmal for sidetypen mens testen går.",
    "help_ab_testing_gtk_plan": "A/B-testing er inkludert i Premium og Premium Pluss.",
    "help_ab_testing_tip_one_change": "Test én tydelig forskjell om gangen — for eksempel hva som ligger øverst — så vet du hva som gjorde utslaget.",
    "help_menus_categories_name": "Menyer og kategorier",
    "help_menus_categories_tagline": "Hvor du faktisk konfigurerer menyene og produktkategoriene blokkene refererer til.",
    "help_menus_categories_description": "Headeren, produktblokkene og kategoriknappene henter data fra menyer og kategorier — men disse settes ikke opp her i designbyggeren. De konfigureres i admin-panelet og brukes deretter av blokkene.",
    "help_menus_categories_menus_heading": "Menyer",
    "help_menus_categories_menu_where": "Konfigurer menyer under Admin → Navigasjon → Hovedmeny og Andre menyer.",
    "help_menus_categories_menu_used_by": "Headeren henter menyen som vises i navigasjonen.",
    "help_menus_categories_menu_multiple": "Du kan ha flere menyer — f.eks. en hovedmeny og en mobilmeny.",
    "help_menus_categories_categories_heading": "Kategorier",
    "help_menus_categories_cat_where": "Konfigurer kategorier under Admin → Produkter → Kategorier.",
    "help_menus_categories_cat_used_by": "Produktgrid, produktslider og kategoriknappene henter produkter fra kategoriene dine.",
    "help_menus_categories_cat_auto": "Når du legger til nye produkter i en kategori, oppdateres alle blokker som bruker den automatisk.",
    "help_common_questions_name": "Vanlige spørsmål",
    "help_common_questions_tagline": "Raske svar på de tingene folk ofte spør om.",
    "help_common_questions_description": "Småting som ikke er feil — men som er lett å overse eller misforstå første gang.",
    "help_cq_changes_heading": "Endringene mine vises ikke",
    "help_cq_changes_not_visible": "Klikket du «Lagre og publiser»? Endringer er bare i designbyggeren før du publiserer. Står det et overstrøket øye ved knappene, redigerer du en mal som ikke vises i butikken.",
    "help_cq_draft_vs_published": "Er «Publisert» slått av på blokken? Da er den et utkast som bare vises i designbyggeren, ikke for kundene.",
    "help_cq_color_not_changing": "Endret du en farge i temainnstillingene uten at noe skjer? Sjekk om blokken har sin egen fargeinnstilling som overstyrer.",
    "help_cq_blocks_heading": "Jobbe med blokker",
    "help_cq_duplicate_block": "Hold musepekeren over en blokk i sidemenyen — en grønn dupliser-knapp dukker opp på høyre side.",
    "help_cq_delete_block": "Samme sted: en rød slette-knapp ved siden av dupliser. Slettede blokker kan ikke gjenopprettes — vær sikker.",
    "help_cq_reorder": "Endre rekkefølge ved å dra og slippe blokker opp eller ned i sidemenyen.",
    "help_cq_locked_header": "Kan du ikke velge headeren eller footeren? De er låst på produktsider, kategorisider, innholdssider og forsidemaler som ikke vises i butikken. De redigeres på forsiden som vises i butikken.",
    "help_cq_hidden_block": "Blokker med «Publisert» slått av vises ikke for kundene før du slår det på og lagrer.",
    "help_cq_media_heading": "Bilder og media",
    "help_cq_blurry_image": "Bildet er uskarpt? Last opp et større/høyere oppløsning — minst 1600 px bredt for hero-blokker.",
    "help_cq_image_formats": "Støttede formater: JPG, PNG, WebP.",
    "help_cq_image_size": "Hold filstørrelsen under 500 KB per bilde — store filer gjør siden treg.",
    "help_cq_themes_heading": "Temaer og maler",
    "help_cq_multiple_themes": "Ja, du kan ha flere temaer — bare ett er aktivt om gangen. Hver side kan i tillegg ha flere maler.",
    "help_cq_switching_themes": "Åpne temaet fra Tema-menyen øverst og trykk «Publiser». Endringen skjer med en gang.",
    "help_cq_revert_changes": "Du kan ikke automatisk «angre» tidligere endringer — derfor er det smart å duplisere temaet eller malen før du gjør store endringer.",
    "help_search_placeholder": "Søk i hjelp …",
    "help_no_results": "Ingen treff. Prøv et annet søkeord.",
    "help_section_features": "Dette kan du gjøre",
    "help_section_use_cases": "Eksempler på bruk",
    "help_section_good_to_know": "Bra å vite",
    "help_section_tips": "Tips",
    "help_category_intro": "Kom i gang",
    "help_category_essentials": "Hovedseksjoner",
    "help_category_product_page": "Produktside",
    "help_product_page_intro_name": "Slik fungerer produktsiden",
    "help_product_page_intro_tagline": "Produktsiden bygges av en produktmal — du designer malen én gang, og alle produkter som bruker den får samme oppsett.",
    "help_product_page_intro_description": "Når du redigerer produktsiden, redigerer du en produktmal — ikke ett enkelt produkt. Velg mal i «Side og mal»-velgeren øverst, og produktet du vil se den med under «Forhåndsvis med» til høyre. Innholdet (navn, pris, bilder, beskrivelse) hentes alltid fra hvert enkelt produkt.",
    "help_product_page_intro_concepts_heading": "Viktige begreper",
    "help_product_page_intro_concept_template": "En produktmal bestemmer oppsettet: hvilke elementer som vises, i hvilken rekkefølge og i hvilke soner.",
    "help_product_page_intro_concept_editing_one": "Du redigerer én mal om gangen. «Side og mal»-velgeren øverst viser hvilken — bytt mal der for å redigere en annen.",
    "help_product_page_intro_concept_preview_product": "Forhåndsvisningsproduktet under «Forhåndsvis med» er bare til visning i designbyggeren. Bytt produkt for å se hvordan malen kler ulike produkter.",
    "help_product_page_intro_concept_publish_scope": "Når du publiserer, gjelder endringene alle produkter som bruker malen — ikke bare produktet du forhåndsviser.",
    "help_concept_locked_header_footer": "Header og footer er låst her. De redigeres på forsiden som vises i butikken.",
    "help_product_page_intro_workflow_heading": "Vanlig arbeidsflyt",
    "help_product_page_intro_workflow_pick": "Velg mal i «Side og mal»-velgeren — eller lag en ny med «Opprett produktmal».",
    "help_product_page_intro_workflow_edit": "Juster produktoppsettet og innholdsblokkene, og se resultatet i forhåndsvisningen.",
    "help_product_page_intro_workflow_assign": "Tildel malen til produkter fra produktsiden i administrasjonen (feltet «Sidemal»).",
    "help_product_templates_name": "Produktmaler",
    "help_product_templates_tagline": "Lag flere oppsett for produktsider og velg mal per produkt.",
    "help_product_templates_description": "Produktmaler lar ulike produkter ha ulike sideoppsett. Standardmalen brukes av alle produkter som ikke har fått en egen mal. Maler administreres i «Side og mal»-velgeren øverst i designbyggeren.",
    "help_product_templates_feature_create": "Lag en ny mal med pluss-knappen ved siden av malvelgeren — den starter med standardoppsettet.",
    "help_product_templates_feature_duplicate": "Dupliser en eksisterende mal fra listen for å bygge videre på et oppsett du liker.",
    "help_product_templates_feature_default": "Standardmalen (markert med stjerne) gjelder alle produkter uten egen mal.",
    "help_templates_feature_make_default": "Gjør en annen mal til standard med «Bruk denne malen» øverst til høyre.",
    "help_product_templates_feature_assign": "Tildel mal per produkt: åpne produktet i administrasjonen og velg mal i «Sidemal»-boksen.",
    "help_product_templates_feature_delete": "Slett maler du ikke trenger — standardmalen kan ikke slettes.",
    "help_product_templates_usecase_campaign": "Kampanjeprodukter med eget oppsett — for eksempel relaterte produkter rett under kjøpsknappen.",
    "help_product_templates_usecase_premium": "Premiumprodukter med større bildegalleri og mer redaksjonelt innhold.",
    "help_product_templates_usecase_seasonal": "Sesongvarianter du kan bytte til uten å bygge om standardoppsettet.",
    "help_product_templates_gtk_default_fallback": "Nye produkter bruker alltid standardmalen til du aktivt velger noe annet.",
    "help_product_templates_gtk_delete_reassign": "Sletter du en mal, faller produktene som brukte den tilbake til standardmalen.",
    "help_product_templates_gtk_duplicate_independent": "En duplisert mal er helt uavhengig — endringer i originalen påvirker ikke kopien.",
    "help_product_templates_gtk_ab": "Vil du teste to produktmaler mot hverandre, kan du starte en A/B-test — se «A/B-testing».",
    "help_product_templates_tip_duplicate_first": "Skal du eksperimentere? Dupliser standardmalen først, så er det trygt å prøve seg frem.",
    "help_product_templates_tip_few": "Hold antallet maler lavt. To–tre gjennomtenkte maler er lettere å vedlikeholde enn ti nesten like.",
    "help_category_category_page": "Kategoriside",
    "help_category_page_intro_name": "Slik fungerer kategorisiden",
    "help_category_page_intro_tagline": "Ett oppsett som gjelder alle kategorisider – innstillinger i stedet for blokker.",
    "help_category_page_intro_description": "Kategorisiden bygges ikke av blokker som forsiden. Den er delt inn i regioner – tittel, verktøylinje, filtrering, produktrutenett, paginering og så videre – og hver region har sin egen innstillingsgruppe i menyen til venstre. Topp og bunn kommer fra temaets header og footer og redigeres på forsiden.",
    "help_category_page_intro_concepts_heading": "Slik henger det sammen",
    "help_category_page_intro_concept_regions": "Hver innstillingsgruppe styrer én region på siden. Klikk gruppen i menyen – eller klikk regionen direkte i forhåndsvisningen – for å åpne innstillingene.",
    "help_category_page_intro_concept_shared": "Innstillingene gjelder alle kategorier som bruker samme mal. Forhåndsvisningskategorien er bare til visning – bytt kategori for å se hvordan oppsettet kler ulikt innhold.",
    "help_category_page_intro_concept_templates": "Trenger noen kategorier et annet oppsett, lager du en kategorimal og tildeler den per kategori.",
    "help_category_page_intro_concept_header_footer": "Topp og bunn er låst her. De redigeres på forsiden som vises i butikken og følger med til alle sider.",
    "help_category_page_intro_workflow_heading": "Vanlig arbeidsflyt",
    "help_category_page_intro_workflow_pick": "Velg en kategori å forhåndsvise under «Forhåndsvis med» – søk i listen.",
    "help_category_page_intro_workflow_edit": "Klikk regionen du vil endre, juster innstillingene og se resultatet live.",
    "help_category_page_intro_workflow_publish": "Trykk «Lagre og publiser» når kategorisiden ser riktig ut. På en kategorimal som ikke er standard, heter knappen «Lagre».",
    "help_category_templates_name": "Kategorimaler",
    "help_category_templates_tagline": "Flere oppsett for kategorisider – velg mal per kategori.",
    "help_category_templates_description": "En kategorimal er et sett med kategoriside-innstillinger. Standardmalen bruker temaets egne innstillinger og gjelder alle kategorier som ikke har fått en egen mal. Navngitte maler lagrer sine egne verdier, så du kan gi for eksempel kampanjekategorier et annet oppsett uten å røre resten.",
    "help_category_templates_feature_create": "Lag en ny mal med pluss-knappen i malvelgeren – den starter som en kopi av det du redigerer nå.",
    "help_category_templates_feature_duplicate": "Dupliser en mal fra listen for å bygge videre på et oppsett du liker.",
    "help_category_templates_feature_default": "Standardmalen (markert med stjerne) gjelder alle kategorier uten egen mal og kan ikke slettes.",
    "help_category_templates_feature_assign": "Tildel mal per kategori: åpne kategorien i administrasjonen og velg mal i kategoriens innstillinger.",
    "help_category_templates_feature_delete": "Slett maler du ikke trenger. Kategorier som brukte malen går tilbake til standardmalen, og editoren forteller hvor mange det gjaldt.",
    "help_category_templates_usecase_campaign": "Kampanjekategorier med større produktkort og uendelig rulling.",
    "help_category_templates_usecase_brand": "Merkevarekategorier med bildekort for underkategoriene og roligere farger.",
    "help_category_templates_usecase_landing": "Toppkategorier som skal vise underkategoriene som kort i stedet for produkter.",
    "help_category_templates_gtk_default_reads_theme": "Den opprinnelige standardmalen har ingen egne verdier – den leser temaets innstillinger direkte. Endrer du den, endrer du temaet.",
    "help_category_templates_gtk_editing_scope": "«Side og mal»-velgeren viser hvilken mal du redigerer. Endringene gjelder alle kategorier med den malen – ikke bare den du forhåndsviser.",
    "help_category_templates_gtk_independent": "En duplisert mal er uavhengig – senere endringer i originalen påvirker ikke kopien.",
    "help_category_templates_tip_duplicate_first": "Skal du eksperimentere? Dupliser først, så er standardmalen trygg.",
    "help_category_templates_tip_few": "Hold antallet maler lavt. Noen få tydelige oppsett er lettere å vedlikeholde enn mange nesten like.",
    "help_category_regions_name": "Regionene på siden",
    "help_category_regions_tagline": "Tittel, produktrutenett, paginering, farger og innhold – én innstillingsgruppe per region.",
    "help_category_regions_description": "Siden leses fra toppen: brødsmulesti og tittel, eventuell beskrivelse, verktøylinje, filtrering og produktrutenettet med paginering under. Fargegruppen legger seg over hele flaten. Hver gruppe i menyen til venstre svarer til én av disse regionene, og valgt region får en grønn ramme i forhåndsvisningen.",
    "help_category_regions_zones_heading": "Regionene",
    "help_category_regions_zone_title": "Tittel: størrelse, justering og luft over og under kategorinavnet.",
    "help_category_regions_zone_grid": "Produktrutenett: antall produkter i bredden på desktop og mobil, avstand mellom kortene og en valgfri animasjon når de lastes inn.",
    "help_category_regions_zone_pagination": "Paginering: sidetall, «Vis flere»-knapp eller uendelig rulling som laster neste side når kunden nærmer seg bunnen.",
    "help_category_regions_zone_colors": "Farger: bakgrunn, overskrifter og tekst for kategorisiden. Med automatisk kontrast justeres tekstfargene etter bakgrunnen du velger.",
    "help_category_regions_zone_content": "Innhold: brødsmulesti, om kategoribeskrivelsen vises over eller under produktene, og hvordan underkategoriene navigeres.",
    "help_category_regions_cards_heading": "Produktkortene",
    "help_category_regions_cards_global": "Selve produktkortet – bilde, pris, merker og fargeprøver – styres av «Produktboks» under globale innstillinger, fordi de samme kortene brukes på forsiden og i søk.",
    "help_category_regions_cards_preview": "Endringer i produktboksen ser du umiddelbart i forhåndsvisningen av kategorisiden.",
    "help_category_toolbar_name": "Verktøylinje og filtre",
    "help_category_toolbar_tagline": "Standardvisning, sortering, kontrollstil og hvor filtrene ligger.",
    "help_category_toolbar_description": "Verktøylinjen ligger rett over produktene og styrer hvordan kunden ser og sorterer. Filtreringen kan ligge i et sidepanel, som en horisontal rad over produktene, i en skuff som åpnes på knapp, eller skjules helt. Innstillingene her gjelder både kategorisider og søkeresultater.",
    "help_category_toolbar_feature_view": "Standard produktvisning: rutenett eller liste når kunden kommer inn. Kunden kan bytte selv hvis veksleren er på.",
    "help_category_toolbar_feature_sorting": "Standard sortering: nyeste, navn eller pris. Manuelle kategorier følger alltid rekkefølgen du har satt i administrasjonen, så der er valget uten virkning – editoren sier fra.",
    "help_category_toolbar_feature_controls": "Kontrollstil og hvilke kontroller som vises: rutenett/liste-veksler, sortering og produktantall.",
    "help_category_toolbar_feature_layout": "Plassering av filter: sidepanel, horisontal rad, skuff eller skjult.",
    "help_category_toolbar_feature_values": "Hvor mange filterverdier og filtergrupper som vises før «Vis mer», søk i filtre, og om gruppene starter lukket.",
    "help_category_toolbar_feature_quick": "Egne filtre for «På tilbud» og «På lager», og mulighet til å feste filteret når kunden ruller.",
    "help_category_toolbar_gtk_counts": "Filterantallene viser hvor mange produkter som blir igjen med hvert valg, og oppdateres etter hvert som kunden filtrerer.",
    "help_category_toolbar_gtk_hidden": "Skjuler du filtreringen, slipper siden arbeidet med å telle filtre – det kan gi raskere sider for store kategorier.",
    "help_category_toolbar_gtk_search": "Søkeresultatsiden bruker samme verktøylinje og filterplassering.",
    "help_category_toolbar_tip_defaults": "Begynn med standardvalgene og endre én ting om gangen – forhåndsvisningen viser effekten med det samme.",
    "help_category_subcategories_name": "Underkategorier og visningsmodus",
    "help_category_subcategories_tagline": "Navigasjon til underkategoriene over produktene, eller kategorikort i stedet for produkter.",
    "help_category_subcategories_description": "En kategori kan vise produktene sine, underkategoriene sine, eller velge automatisk: har den underkategorier men ingen egne produkter, vises kategorikortene. Visningsmodus settes per kategori i administrasjonen. Uansett modus kan underkategoriene navigeres over produktene – som sidepanel, knapper, nedtrekksmeny eller bildekort.",
    "help_category_subcategories_modes_heading": "Visningsmodus",
    "help_category_subcategories_mode_auto": "Automatisk: produkter når kategorien har egne produkter, kategorikort når den bare har underkategorier.",
    "help_category_subcategories_mode_products": "Produkter: alltid produktlisten. En kategori med underkategorier kan da samle produktene fra dem.",
    "help_category_subcategories_mode_cards": "Underkategorier: alltid kategorikortene, uten produktliste.",
    "help_category_subcategories_mode_preview": "I editoren kan du tvinge begge variantene fra forhåndsvisningen, så du får stylet kortene selv om kategorien du ser på viser produkter.",
    "help_category_subcategories_groups_heading": "To innstillingsgrupper",
    "help_category_subcategories_group_image_cards": "Når kategorien viser produkter: hvordan underkategoriene navigeres – sidekolonne, knapper, rullegardin eller en rad med kategorikort.",
    "help_category_subcategories_group_category_cards": "Når kategorien viser underkategorier: rutenettet som erstatter produktene – kolonner, bildeforhold, kortstil og hover-effekt.",
    "help_category_subcategories_group_images": "Kortene ser like ut begge steder: bildetilpasning, tekstplassering og tekststil deles. Kortene bruker kategoriens eget bilde, ellers første produktbilde i kategorien, deretter fra en underkategori.",
    "help_category_preview_name": "Forhåndsvisning og valg av kategori",
    "help_category_preview_tagline": "Bytt kategori, klikk i regionene og følg med når du navigerer i forhåndsvisningen.",
    "help_category_preview_description": "Forhåndsvisningen viser én ekte kategori fra butikken. Velgeren «Forhåndsvis med» øverst til høyre søker blant kategoriene dine, og alt du endrer tegnes om uten å laste siden på nytt.",
    "help_category_preview_feature_search": "Søk etter kategori i velgeren – listen hentes mens du skriver, så store kataloger er like raske.",
    "help_category_preview_feature_click": "Pek på en region i forhåndsvisningen for en stiplet ramme, klikk for å åpne innstillingene. Valgt region får en hel ramme.",
    "help_category_preview_feature_follow": "Klikker du deg videre til en annen kategori inne i forhåndsvisningen, følger editoren med og viser innstillingene for den.",
    "help_category_preview_feature_device": "Bytt enhet i Enhet-menyen for å se desktop, nettbrett og mobil.",
    "help_category_preview_gtk_locked": "Topp og bunn kan ikke velges her – de redigeres på forsiden.",
    "help_category_preview_gtk_manual_sorting": "Forhåndsviser du en manuell kategori, er «Standard sortering» grået ut: manuelle kategorier følger rekkefølgen fra administrasjonen.",
    "help_category_preview_gtk_display_mode": "Innstillingene du ser, følger kategoriens visningsmodus. Bruk tvunget visning i forhåndsvisningen for å nå den andre varianten.",
    "help_category_preview_tip_test_both": "Test med både en stor og en liten kategori – paginering og filtre oppfører seg forskjellig.",
    "help_product_zones_name": "Soner og oppsett",
    "help_product_zones_tagline": "Produktoppsettet er delt i soner — venstre kolonne, høyre kolonne og under hovedinnholdet.",
    "help_product_zones_description": "Elementene på produktsiden ligger i tre soner. På store skjermer vises venstre og høyre kolonne side om side; på mobil stables alt i én kolonne i samme rekkefølge.",
    "help_product_zones_zones_heading": "Sonene",
    "help_product_zones_zone_left": "Venstre kolonne: bildegalleriet. Den følger med når kunden scroller, slik at bildene alltid er synlige.",
    "help_product_zones_zone_right": "Høyre kolonne: produktinfo og kjøpsdetaljer — tittel, pris, varianter, lagerstatus og kjøpsknapp.",
    "help_product_zones_zone_below": "Under hovedinnhold: elementer i full bredde under kolonnene — for eksempel produktanmeldelser.",
    "help_product_zones_arrange_heading": "Flytte og vise/skjule",
    "help_product_zones_arrange_drag": "Dra elementer i sidepanelet for å endre rekkefølgen — også mellom soner der det er tillatt.",
    "help_product_zones_arrange_visibility": "Bruk øye-ikonet for å skjule et element uten å miste innstillingene. Overstrøket betyr skjult.",
    "help_product_zones_arrange_locked": "Noen elementer er låst (hengelås) fordi siden trenger dem — for eksempel tittel, pris og kjøpsknapp.",
    "help_product_subblocks_name": "Innholdet i produktoppsettet",
    "help_product_subblocks_tagline": "Hva hvert element på produktsiden gjør — fra bildegalleri til anmeldelser.",
    "help_product_subblocks_description": "Produktoppsettet består av elementer som hver viser én del av produktet. Innholdet hentes automatisk fra produktet — her styrer du visningen.",
    "help_product_subblocks_media_heading": "Bilder og info",
    "help_product_subblocks_gallery": "Bildegalleri: produktbildene med miniatyrer. Velg visning (slider eller redaksjonelt rutenett), mobilvisning (standard, miniatyrer eller filmstripe), zoom ved peking og om bildeteksten skal vises under bildet. I fullskjerm kan kunden zoome med to fingre på mobil. Bilderekkefølgen styres på produktet i administrasjonen.",
    "help_product_subblocks_title_lead": "Produkttittel og produktingress: navnet og den korte introduksjonsteksten fra produktet.",
    "help_product_subblocks_reviews_summary": "Anmeldelsessammendrag: stjernesnittet, vises når produktet har anmeldelser.",
    "help_product_subblocks_buy_heading": "Kjøpsdetaljer",
    "help_product_subblocks_price": "Produktpris: pris, førpris og rabatt — følger kampanjene dine automatisk.",
    "help_product_subblocks_options_form": "Produktvalg og produktskjema: varianter (størrelse, farge) og eventuelle tilleggsfelt kunden fyller ut. Variantvalgene kan vises som fargeprøver eller miniatyrer, med variantpriser, lagerhint og valgfri størrelse og form.",
    "help_product_subblocks_stock": "Lagerstatus og lagervarsling: viser om varen er på lager, og lar kunden be om beskjed når den kommer tilbake.",
    "help_product_subblocks_add_to_cart_vipps": "Legg i handlekurv og Vipps Express: kjøpsknappene. Vipps-knappen vises bare når Vipps Express er aktivert.",
    "help_product_subblocks_promo_badges_payment": "Kundeklubb, trygghetsstripe og betalingsmåter: tillitselementer rundt kjøpet — vis eller skjul etter behov. Kundeklubb-boksen viser hva poengene er verdt og velkomstbonusen, og tekstene styres i Kundeklubb-appen.",
    "help_product_subblocks_below_heading": "Under hovedinnholdet",
    "help_product_subblocks_description_block": "Produktbeskrivelse: den lange beskrivelsen fra produktet, med egne avsnitt om du har flere.",
    "help_product_subblocks_related": "Relaterte produkter: viser produktene du har koblet til dette produktet. Se eget hjelpeemne.",
    "help_product_subblocks_reviews": "Produktanmeldelser: kundenes anmeldelser i full bredde nederst.",
    "help_product_related_name": "Relaterte produkter",
    "help_product_related_tagline": "Vis håndplukkede produkter på produktsiden — der du vil ha dem.",
    "help_product_related_description": "Relaterte produkter kobler du til hvert enkelt produkt i administrasjonen. Hvor de vises på siden, styres av produktmalen — for eksempel rett under kjøpsknappen eller under hovedinnholdet.",
    "help_product_related_how_heading": "Slik fungerer det",
    "help_product_related_how_connect": "Koble produkter: åpne produktet i administrasjonen og legg til relaterte produkter i «Koblede produkter»-listen.",
    "help_product_related_how_placement": "Plassering: flytt elementet «Relaterte produkter» i produktoppsettet — i høyre kolonne vises det kompakt, under hovedinnholdet i full bredde.",
    "help_product_related_how_display": "Visning: velg rutenett eller karusell, antall produkter og kolonner i elementets innstillinger.",
    "help_product_related_vs_heading": "Relaterte produkter vs. «Andre kjøpte også»",
    "help_product_related_vs_manual": "Relaterte produkter velger du selv — full kontroll over hva som anbefales.",
    "help_product_related_vs_auto": "«Andre kjøpte også» er en egen blokk som fylles automatisk basert på faktiske ordrer.",
    "help_product_related_tip_template": "Vil du ha anbefalinger rett under kjøpsknappen bare for noen produkter? Lag en egen mal med den plasseringen og tildel den til de produktene.",
    "help_product_related_tip_reciprocal": "Bruk gjensidig kobling når produktene hører naturlig sammen — da peker begge på hverandre uten dobbeltarbeid.",
    "help_product_content_blocks_name": "Innholdsblokker på produktsiden",
    "help_product_content_blocks_tagline": "Bygg ut produktmalen med blokker under produktoppsettet.",
    "help_product_content_blocks_description": "Under produktoppsettet kan du legge til vanlige innholdsblokker — bildegalleri, bildekarusell, hero-seksjoner og tekst. De hører til malen, så de vises på alle produkter som bruker den.",
    "help_product_content_blocks_feature_allowed": "Tilgjengelige blokker: bilderutenett, bildekarusell, hero med bilde og tekst, hero med bakgrunnsbilde, før- og etterbilde, FAQ, og tekstinnhold.",
    "help_product_content_blocks_feature_position": "Blokkene ligger i «Innhold»-seksjonen og kan sorteres fritt under produktoppsettet.",
    "help_product_content_blocks_feature_settings": "Hver blokk har de samme innstillingene som på forsiden — farger, bilder, lenker og tekst.",
    "help_product_content_blocks_gtk_per_template": "Innholdsblokker hører til malen, ikke produktet. Alle produkter med samme mal viser de samme blokkene.",
    "help_product_content_blocks_gtk_whitelist": "Bare innholdsblokker passer på produktsider — blokker som skjemaer og bloggutdrag hører hjemme på forsiden.",
    "help_product_content_blocks_tip_usp": "Bruk en tekstblokk til ting som gjelder alle produktene i malen — fraktinfo, garantier eller størrelsesguide.",
    "help_category_global": "Globalt",
    "help_category_hero": "Hero og bannere",
    "help_category_content": "Innholdsblokker",
    "help_category_products": "Produktblokker",
    "help_category_engagement": "Engasjement",
    "help_section_content_area_name": "Innholdsområdet",
    "help_section_content_area_tagline": "Midten av siden, der alle innholdsblokkene dine ligger.",
    "help_section_content_area_description": "Mellom headeren og footeren ligger innholdsområdet — der du bygger opp resten av siden ved å legge til, sortere og fjerne blokker. Dette er stedet for hero-bannere, produktrutenett, tekstblokker og resten av innholdet.",
    "help_section_content_area_feature_add": "Legg til blokker fra «Legg til blokk»-menyen.",
    "help_section_content_area_feature_reorder": "Dra blokker for å endre rekkefølgen.",
    "help_section_content_area_feature_draft": "Sett blokker til utkast mens du jobber — de er ikke synlige for kundene.",
    "help_section_content_area_feature_duplicate": "Dupliser en blokk hvis du vil starte fra en kopi.",
    "help_section_content_area_tip_order": "Rekkefølgen styrer hvordan kunden opplever siden — viktigste blokker først.",
    "help_section_content_area_tip_draft_first": "Lag nye blokker som utkast først. Når de er klare, publiserer du dem.",
    "help_home_templates_name": "Forsidemaler",
    "help_home_templates_tagline": "Flere versjoner av forsiden i samme tema — én vises i butikken, de andre kan du jobbe videre med eller teste.",
    "help_home_templates_description": "En forsidemal er blokkene i innholdsområdet på forsiden. Et tema kan ha flere forsidemaler, men besøkende ser bare én. De andre er merket med et overstrøket øye og vises ikke i butikken før du publiserer dem som forside eller bruker dem i en A/B-test.",
    "help_home_templates_feature_create": "Lag en ny med «Opprett forsidemal» i «Side og mal»-velgeren. Den starter som en kopi av forsiden som vises i butikken. Har du en annen forsidemal åpen, kan du kopiere den i stedet.",
    "help_home_templates_feature_manage": "Dupliser eller slett maler fra listen i velgeren. Forsiden som vises i butikken, er merket med stjerne og kan ikke slettes.",
    "help_home_templates_feature_ab": "Vil du vite hvilken forside som selger best? Start en A/B-test med lenken nederst i velgeren.",
    "help_home_templates_gtk_header_footer": "Header og footer hører til temaet og er like på alle forsidemaler. De redigeres på forsiden som vises i butikken — på de andre er de låst.",
    "help_home_templates_gtk_theme_settings": "Temainnstillinger gjelder hele butikken, ikke bare malen du har åpen.",
    "help_home_templates_gtk_ab_running": "Er malen med i en A/B-test som går, sier designbyggeren fra øverst. Endrer du den da, endrer du det testen måler.",
    "help_home_templates_tip_prepare": "Bygg en ny forside i en egen mal og publiser den når den er klar — kundene ser ingenting før det.",
    "help_global_overview_name": "Hva er globale innstillinger?",
    "help_global_overview_tagline": "Innstillinger som styrer hele nettsiden — ikke bare én blokk.",
    "help_global_overview_description": "Globale innstillinger er fundamentet i temaet ditt. Endrer du for eksempel CTA-fargen her, oppdateres alle knapper i hele butikken. Det sparer deg for å endre samme ting på 20 forskjellige steder.",
    "help_global_overview_difference_heading": "Forskjellen på globalt og per blokk",
    "help_global_overview_diff_global": "Globalt = endrer hele nettsiden samtidig. Brukes for ting som skal være konsistent: fonter, hovedfarger, knappestil.",
    "help_global_overview_diff_block": "Per blokk = bare den spesifikke blokken endres. Brukes til å variere innhold, layout og spesielle detaljer.",
    "help_global_overview_diff_when_global": "Bruk globalt for alt som skal være «den røde tråden» i designet. Bruk per-blokk for unike detaljer som hver kampanje eller seksjon trenger.",
    "help_global_overview_where_heading": "Hvor finner du innstillingene?",
    "help_global_overview_where_settings_tab": "Klikk «Temainnstillinger» under Globalt i sidemenyen.",
    "help_global_overview_where_categories": "Temainnstillinger er delt i Layout, Typografi, Farger og Mobil. Produktkortene har et eget punkt, «Produktboks», under Globalt.",
    "help_global_overview_where_scope": "Temainnstillingene gjelder hele butikken — alle sider og alle maler, ikke bare det du ser nå. Går det en A/B-test, endres begge malene den sammenligner.",
    "help_global_typography_name": "Typografi (fonter)",
    "help_global_typography_tagline": "Velg fontene som brukes på alle overskrifter og tekst i butikken.",
    "help_global_typography_description": "Fontene setter tonen for hele butikken. Du har én font for overskrifter og én for løpetekst — disse to gjelder overalt.",
    "help_global_typography_feature_heading_font": "Egen font for overskrifter.",
    "help_global_typography_feature_body_font": "Egen font for brødtekst.",
    "help_global_typography_feature_line_height": "Linjehøyde for tekst — lavere = mer kompakt.",
    "help_global_typography_feature_letter_spacing": "Bokstavavstand for overskrifter.",
    "help_global_typography_feature_transform": "Skal overskrifter være med store bokstaver?",
    "help_global_typography_tip_pairing": "En seriff-overskrift med en sans-serif brødtekst er en klassisk og trygg kombinasjon.",
    "help_global_typography_tip_readability": "Hold deg til maks to fonter — flere blir rotete.",
    "help_global_colors_name": "Farger",
    "help_global_colors_tagline": "Hovedfargene som går igjen overalt — knapper, overskrifter, lenker.",
    "help_global_colors_description": "Definerer paletten som hele butikken bruker. Endrer du CTA-fargen, oppdateres alle kjøpsknapper, lenker og fremhevinger samtidig.",
    "help_global_colors_feature_cta": "CTA-farge (Call To Action — handlingsoppfordring) med egen tekstfarge — for knapper som «Kjøp», «Legg i kurv» osv.",
    "help_global_colors_feature_headlines": "Farge på overskrifter på sidene.",
    "help_global_colors_feature_sale_price": "Egen farge på tilbudspriser.",
    "help_global_colors_feature_breadcrumbs": "Farger for brødsmuler (navigasjonen øverst på sider).",
    "help_global_colors_feature_social": "Farge på ikonene for sosiale medier i footeren og mobilmenyen — eller la dem følge tekstfargen.",
    "help_global_colors_tip_limit": "Hold deg til 2–3 hovedfarger. En CTA-farge + en aksent + nøytrale toner er nok.",
    "help_global_colors_tip_contrast": "Sjekk at CTA-fargen har god kontrast mot bakgrunnen, ellers blir den vanskelig å se.",
    "help_global_layout_name": "Layout og avrunding",
    "help_global_layout_tagline": "Hvor bred siden er og hvor mye hjørnene er avrundet.",
    "help_global_layout_description": "Styrer den globale bredden på innholdet og hvor avrundede kanter er på knapper, kort og bilder. Små endringer her gir hele butikken et nytt uttrykk.",
    "help_global_layout_feature_max_width": "Maks bredde på innholdet (1280px / 1440px / 1600px).",
    "help_global_layout_feature_border_radius": "Avrunding av hjørner — 0 = skarpt, høy verdi = veldig myk og avrundet.",
    "help_global_layout_tip_radius": "Avrunding gir butikken et moderne preg. Velg én verdi og bruk den konsekvent.",
    "help_global_product_card_name": "Produktkort-stil",
    "help_global_product_card_tagline": "Hvordan produktene presenteres i kategorier, søk og produktblokker.",
    "help_global_product_card_description": "Produktkortet er den lille «boksen» rundt hvert produkt — med bilde, navn, pris og kjøpsknapp. Innstillingene ligger under «Produktboks» i sidemenyen, og stilen gjelder alle steder produkter vises.",
    "help_global_product_card_feature_border": "Skal kortet ha en kant rundt seg eller flyte fritt på siden?",
    "help_global_product_card_feature_aspect": "Form på produktbildet (kvadrat, liggende, stående osv.).",
    "help_global_product_card_feature_fit": "Skal hele bildet vises (med kanter) eller fylle hele rammen?",
    "help_global_product_card_feature_hover": "Bytt bilde ved hover — vis produktets andre bilde når kunden peker på kortet.",
    "help_global_product_card_feature_badge": "Stil og størrelse på tilbud-merker.",
    "help_global_product_card_feature_positions": "Velg plassering av rabattmerke, merkelapper og favorittknapp.",
    "help_global_product_card_feature_text": "Vis ledetekst, fet tittel, sentrert tekst osv.",
    "help_global_product_card_feature_variants": "Vis variantvalg på kortet, med størrelse, form og plassering.",
    "help_global_product_card_tip_consistency": "Velg ett bildeformat (f.eks. kvadratisk) og last opp produktbilder i samme format — det gir det ryddigste resultatet.",
    "help_global_mobile_name": "Mobil",
    "help_global_mobile_tagline": "Innstillinger som kun gjelder på mobilskjermer.",
    "help_global_mobile_description": "Mobilen har andre regler enn desktop. Her kan du tilpasse navigasjonen og om menyen skal henge med når man scroller.",
    "help_global_mobile_feature_nav_colors": "Egne farger for mobilmenyen.",
    "help_global_mobile_feature_nav_style": "Velg mobilmeny: sidemeny som skyves inn fra venstre, eller fullskjermsoverlegg.",
    "help_global_mobile_feature_font_size": "Fontstørrelse i mobilmenyen: liten, normal eller stor.",
    "help_global_mobile_feature_contact": "Vis butikkens e-post og telefon nederst i mobilmenyen, sammen med sosiale medier.",
    "help_global_mobile_feature_sticky": "Skal menyen følge med når kunden scroller?",
    "help_global_mobile_tip_test": "Test alltid mobilvisningen — over halvparten av kundene besøker fra mobil.",
    "help_intro_title": "Velkommen til designbyggeren",
    "help_intro_tagline": "Bygg nettbutikken din ved å sette sammen ferdige blokker. Ingen koding nødvendig.",
    "help_intro_description": "Designbyggeren lar deg sette sammen sider av ferdige blokker — som hero-banner, produktrutenett, nyhetsbrev-skjema og mer. Du endrer rekkefølgen ved å dra blokker, justerer innstillingene i sidepanelet og ser resultatet i forhåndsvisningen før du publiserer.",
    "help_intro_concepts_heading": "Begreper du bør kjenne til",
    "help_intro_concept_blocks": "Blokker er byggeklossene. Hver blokk har sine egne innstillinger — farger, tekst, bilder, kolonner osv. Du legger til, fjerner og omorganiserer blokker fritt.",
    "help_intro_concept_theme_page_template": "Øverst velger du tema, side og mal. Temaet er hele butikkens utseende, siden er det du redigerer — forsiden, produktsiden, kategorisiden eller en innholdsside — og malen er oppsettet for den siden.",
    "help_intro_concept_theme": "Temainnstillinger gjelder hele butikken — farger, fonter og knappestil. Endrer du CTA-fargen, endrer alle knappene seg samtidig.",
    "help_intro_concept_preview": "Forhåndsvisningen viser hvordan siden ser ut nå. Velg mobil, nettbrett eller desktop i Enhet-menyen øverst til høyre for å sjekke ulike skjermstørrelser.",
    "help_intro_concept_publish": "Ingenting endres i butikken før du lagrer. «Lagre og publiser» sender endringene ut. Blokker med «Publisert» slått av er utkast og vises bare for deg i designbyggeren.",
    "help_intro_tips_heading": "Smarte tips",
    "help_intro_tip_drafts": "Slå av «Publisert» øverst i blokkens innstillinger mens du jobber med den. Da er den et utkast som kundene ikke ser.",
    "help_intro_tip_preview_device": "Sjekk alltid mobilvisningen før du publiserer. Tekst som ser pent ut på desktop kan bli avkortet på mobil.",
    "help_intro_tip_search": "Feltet «Søk i innstillinger» øverst (⌘K eller Ctrl K) finner en innstilling og åpner den — også når den ligger på en annen side.",
    "help_intro_tip_keyboard": "Esc lukker modaler og menyer. Du kan også klikke utenfor en modal for å lukke den.",
    "help_block_header_name": "Header",
    "help_block_header_tagline": "Logoen, menyen, søkefeltet og handlekurv-ikonet på toppen av hver side.",
    "help_block_header_description": "Headeren er noe av det første kunden ser og må kommunisere tydelig hvem du er og hva du selger. Velg blant flere varianter og styr hva som vises (søk, kontoknapp, handlekurv).",
    "help_block_header_feature_variants": "Flere ferdige varianter med ulik plassering av logo og meny.",
    "help_block_header_feature_logo": "Last opp bildelogo, eller bruk butikknavn som tekstlogo. Egen kontroll for logobredde og -høyde.",
    "help_block_header_feature_search": "Eget plassholder-tekst i søkefeltet.",
    "help_block_header_feature_sticky": "Skal headeren følge med når kunden scroller (sticky)?",
    "help_block_header_feature_colors": "Egne farger for header-bakgrunn, meny, søk og ikoner.",
    "help_block_header_tip_logo": "Bruk en PNG- eller WebP-logo med transparent bakgrunn — den ser pen ut mot enhver header-farge.",
    "help_block_header_tip_sticky": "Headeren følger med når kunden scroller — sørg for at logoen ikke er for stor.",
    "help_block_header_tip_search": "Et synlig søkefelt gjør at flere kunder fullfører kjøp — vis det hvis du har mer enn 20 produkter.",
    "help_block_header_usecase_simple": "Liten butikk med enkel meny og fokus på logo + handlekurv.",
    "help_block_header_usecase_mega": "Butikk med mange kategorier som trenger en stor (mega-)meny.",
    "help_block_header_usecase_premium": "Premium-merke som ønsker tekstlogo i stedet for grafisk logo.",
    "help_block_header_gtk_sticky": "Hvis sticky-header er aktivert, følger den med når kunden scroller — store logoer kan da ta mye plass.",
    "help_block_header_gtk_one_per_theme": "Det kan bare være én header per tema, og den er lik på alle sider. Du endrer den på forsiden som vises i butikken.",
    "help_block_header_gtk_mobile": "På mobil legger menyen seg bak en hamburger-knapp automatisk.",
    "help_section_content_area_usecase_home": "Forsiden — typisk hero, produktblokker, kampanjer og nyhetsbrev.",
    "help_section_content_area_usecase_campaign": "En egen forsidemal for kampanjer, for eksempel Black Friday, som du publiserer når kampanjen starter.",
    "help_section_content_area_usecase_seasonal": "Sesongbaserte forsidemaler med andre blokker til jul, sommer og så videre.",
    "help_section_content_area_gtk_separate_themes": "Innholdsområdet hører til forsidemalen. Har temaet flere forsidemaler, har hver sitt eget oppsett — se «Forsidemaler».",
    "help_section_content_area_gtk_draft_safe": "Utkast-blokker er trygge — de er ikke synlige for kundene før du publiserer.",
    "help_block_footer_tip_contact": "Telefonnummer i footeren bygger tillit — kunder vil vite at det finnes en ekte virksomhet bak.",
    "help_block_footer_usecase_minimal": "Minimal footer med bare logo og noen få lenker — for premium-merker.",
    "help_block_footer_usecase_multi_column": "Multi-kolonne med kundeservice, info, lenker og sosiale medier.",
    "help_block_footer_usecase_newsletter": "Footer med innebygd nyhetsbrev-skjema for å fange opp besøkende.",
    "help_block_footer_gtk_legal_required": "Personvern, salgsvilkår og angrerett må være lett tilgjengelige fra footeren — lovpålagt.",
    "help_block_footer_gtk_one_per_theme": "Det kan bare være én footer per tema, og den er lik på alle sider. Du endrer den på forsiden som vises i butikken.",
    "help_block_footer_gtk_contact_expected": "Kunder forventer å finne kontaktinfo i footeren — telefon, e-post, åpningstider.",
    "help_global_typography_gtk_loading": "Velg fonter som passer sammen — overskriftsfonten kan ha personlighet, men brødteksten må være lett å lese.",
    "help_global_typography_gtk_brand": "Fontene blir noe av det første kunden legger merke til — de skal matche merket ditt.",
    "help_global_colors_gtk_cascading": "Endrer du CTA-fargen, oppdateres ALLE knapper umiddelbart — det kan gi store visuelle endringer.",
    "help_global_colors_gtk_accessibility": "Sørg for god kontrast mellom tekst og bakgrunn — det hjelper både synssvake kunder og søkemotorer.",
    "help_global_layout_gtk_width": "1280px er trygt for de fleste butikker. 1600px gir mer luft på store skjermer, men krever nok innhold til å fylle bredden.",
    "help_global_layout_gtk_radius_buttons": "Avrunding påvirker også knappene — høy verdi gir «pille-knapper».",
    "help_global_product_card_gtk_all_pages": "Stilen brukes på kategorisider, søk, anbefalinger og alle produktblokker.",
    "help_global_product_card_gtk_image_consistency": "Hvis produktbildene har ulike størrelser, blir kortene ulike — last opp i samme format.",
    "help_global_mobile_gtk_majority": "Over 70 % av nettbutikk-trafikken kommer fra mobil — det er ofte den viktigste skjermen.",
    "help_global_mobile_gtk_test_real": "Test på en ekte telefon — forhåndsvisningen i designbyggeren viser ikke helt det samme.",
    "help_block_hero_image_text_tip_short_text": "Hold tittelen kort (3–6 ord). Lange titler blir avkortet på mobil.",
    "help_block_hero_image_text_usecase_intro": "Forteller hvem dere er og hva dere selger — første gang en kunde besøker siden.",
    "help_block_hero_image_text_usecase_campaign": "Kampanje med stort bilde av produktet og en tydelig kjøp-knapp.",
    "help_block_hero_image_text_usecase_value_prop": "Verdiløfter — «Fri frakt over 999 kr» eller «Levering på 1–2 dager».",
    "help_block_hero_image_text_gtk_mobile_stack": "På mobil legges bilde og tekst over hverandre — du kan velge rekkefølgen.",
    "help_block_hero_image_text_gtk_image_quality": "Bruk et høyoppløst bilde (minst 1600px bredt) for at det skal se skarpt ut på desktop.",
    "help_block_hero_background_tip_calm_area": "Velg bilder med et rolig parti (himmel, ensfarget bakgrunn) der teksten kan plasseres.",
    "help_block_hero_background_usecase_brand": "Livsstils- eller stemningsbilder som forteller merkets historie.",
    "help_block_hero_background_usecase_seasonal": "Sesongkampanjer med stemningsfullt bilde — jul, sommer, høst.",
    "help_block_hero_background_usecase_lifestyle": "Vis hvordan produktet brukes i en ekte situasjon, ikke bare i studio.",
    "help_block_hero_background_gtk_text_readability": "Legg et mørkt overlegg over bildet hvis teksten blir vanskelig å lese.",
    "help_block_hero_background_gtk_mobile_focal": "Bilder beskjæres ofte på mobil — sjekk at hovedmotivet ikke forsvinner.",
    "help_block_hero_background_gtk_size": "Store bakgrunnsbilder kan være tunge — komprimer før opplasting.",
    "help_block_video_hero_tip_silent": "Må videoen ha lyd for å gi mening? Slå på videokontrollene, men la budskapet også stå som tekst — de fleste ser den uten lyd.",
    "help_block_video_hero_usecase_product_demo": "Vis produktet i bruk — bevegelse fanger oppmerksomhet bedre enn bilder.",
    "help_block_video_hero_usecase_lifestyle": "Stemningsfilm av butikken, atmosfæren eller livsstilen merket representerer.",
    "help_block_video_hero_usecase_brand_story": "Korte filmer som forteller noe om merket — kvalitet, prosess, mennesker.",
    "help_block_video_hero_gtk_no_sound": "Videoen starter alltid uten lyd. Slår du på videokontrollene, kan kunden skru på lyden selv.",
    "help_block_video_hero_gtk_url_only": "Videoen ligger på YouTube eller Vimeo — du limer inn URL-en, du laster ikke opp filen.",
    "help_block_video_hero_gtk_unlisted": "Vimeo-videoer kan være skjulte (unlisted) — det fungerer fint så lenge URL-en er gyldig.",
    "help_block_campaign_bar_tip_contrast": "Velg en farge som skiller seg ut fra resten av headeren — ellers blir den oversett.",
    "help_block_campaign_bar_usecase_shipping": "«Fri frakt over 999 kr» — kommuniserer fraktløfte umiddelbart.",
    "help_block_campaign_bar_usecase_sale": "«Sommersalg — opptil 50 % rabatt» med lenke til kampanjesiden.",
    "help_block_campaign_bar_usecase_announcement": "Viktige meldinger — ferielukking, leveringstid-endring, lansering.",
    "help_block_campaign_bar_gtk_top_of_all_pages": "Vises på alle sider. Du velger plasseringen — header, hovedinnhold eller footer.",
    "help_block_campaign_bar_gtk_dismiss_remember": "Legg lenker rett i teksten — kundene kommer til kampanjesiden med ett klikk.",
    "help_block_image_grid_tip_apply_all": "«Bruk stil på alle» i bilderedigeringen kopierer farger, størrelser, plassering og knappestil til alle bildene i blokken. Tittel, tekst, knappetekst og lenker beholdes per bilde.",
    "help_block_image_grid_usecase_categories": "Vis kategoriene visuelt — kunder klikker bilder oftere enn tekstlinker.",
    "help_block_image_grid_usecase_collection": "Hele kolleksjonen — «Vårens nye kjoler», «Møbelkolleksjonen».",
    "help_block_image_grid_usecase_inspiration": "Inspirasjonsbilder — hvordan produktet ser ut i kontekst.",
    "help_block_image_grid_gtk_same_size": "Bildene blir penere hvis de har samme bildeformat (alle kvadratiske, alle stående, osv.).",
    "help_block_image_grid_gtk_overlay_readability": "Tekst over urolige bilder blir uleselig — legg et mørkt overlegg over bildet.",
    "help_block_image_grid_gtk_mobile_columns": "Sett færre kolonner på mobil enn på desktop — bildene blir for små ellers.",
    "help_block_image_slider_tip_first_seen": "Det første bildet i slideren er det eneste mange ser — sett det viktigste der.",
    "help_block_image_slider_usecase_campaigns": "Flere kampanjer som rullerer — sparer plass øverst på siden.",
    "help_block_image_slider_usecase_hero_rotation": "Alternativ til statisk hero — viser flere bilder over tid.",
    "help_block_image_slider_usecase_lookbook": "Lookbook eller fotoserie — flere bilder fra samme fotoshoot.",
    "help_block_image_slider_gtk_first_slide": "Det første bildet får mest oppmerksomhet — under 20 % av kundene ser mer enn 3 bilder i en slider.",
    "help_block_image_slider_gtk_speed": "Sett intervallet til minst 5 sekunder — kunder trenger tid til å lese.",
    "help_block_image_slider_gtk_dropoff": "Studier viser at effekten faller dramatisk med mange bilder i en slider — hold deg til 3–5.",
    "help_block_text_content_tip_personality": "Skriv som et menneske — kunder kjøper fra folk de liker, ikke roboter.",
    "help_block_text_content_usecase_about": "«Om oss»-side — historikken, verdier, teamet bak butikken.",
    "help_block_text_content_usecase_info": "Informasjonssider — frakt, retur, leveringsbetingelser.",
    "help_block_text_content_usecase_story": "Lengre fortellinger — produkthistorier, intervjuer, guider.",
    "help_block_text_content_gtk_seo_heading_levels": "Bruk H1 for hovedtittel, H2/H3 for underseksjoner — Google forstår strukturen bedre.",
    "help_block_text_content_gtk_line_length": "Tekst i smal kolonne (~60 tegn per linje) leses raskere enn full bredde.",
    "help_block_faq_tip_order_by_importance": "Sett de viktigste spørsmålene øverst — «Når kommer pakken?» før «Hvilke betalingsmetoder?».",
    "help_block_faq_usecase_shipping": "Frakt og levering — spørsmål om leveringstid, kostnad, områder.",
    "help_block_faq_usecase_sizing": "Størrelser og passform — spesielt viktig for klær og sko.",
    "help_block_faq_usecase_product_care": "Produktpleie — vask, vedlikehold, garantier.",
    "help_block_faq_gtk_seo_schema": "FAQ-blokker kan vises som rich snippets i Google-søk hvis spørsmålene er gode.",
    "help_block_faq_gtk_keep_updated": "Oppdater FAQ-en når kundeservice får samme spørsmål gjentatte ganger.",
    "help_block_featured_blog_tip_thumbnail": "Sørg for at hvert blogginnlegg har et godt hovedbilde — det vises som miniatyrbilde her.",
    "help_block_featured_blog_usecase_news": "Nyheter — produktlanseringer, kampanjer, oppdateringer.",
    "help_block_featured_blog_usecase_guides": "Guider og rådgivning — «Hvordan velge riktig størrelse», «Vedlikehold av X».",
    "help_block_featured_blog_usecase_content_marketing": "SEO-innhold — blogginnlegg som rangerer godt på Google og driver organisk trafikk.",
    "help_block_featured_blog_gtk_auto_update": "Henter automatisk de nyeste innleggene — du slipper å oppdatere blokken.",
    "help_block_featured_blog_gtk_blog_needed": "Krever at du har en aktiv blogg med innlegg — innstillingene gjøres i bloggmodulen.",
    "help_block_product_grid_tip_below_hero": "Plasser produktene rett under hero-blokken — det er der øynene faller naturlig etterpå.",
    "help_block_product_grid_usecase_category": "Vis produktene i en spesifikk kategori — «Vinterklær», «Hage og uteplass».",
    "help_block_product_grid_usecase_new_arrivals": "Lag en «Nyheter»-kategori og sortér på nyeste først.",
    "help_block_product_grid_usecase_campaign": "Lag en kampanjekategori (f.eks. «Sommertilbud») og vis den på forsiden.",
    "help_block_product_grid_gtk_card_style": "Stilen på produktkortene styres globalt under «Produktboks» i sidemenyen.",
    "help_block_product_grid_gtk_auto_update": "Innholdet oppdateres automatisk når du legger til, fjerner eller skjuler produkter i kategorien.",
    "help_block_product_grid_gtk_empty_state": "Hvis kategorien er tom, vises ingenting — blokken forsvinner praktisk talt.",
    "help_block_product_slider_tip_minimum": "Sliderne fungerer best med minst 4 produkter — færre ser tomt ut.",
    "help_block_product_slider_usecase_recommendations": "«Anbefalt for deg» eller «Kunder kjøpte også»-seksjoner.",
    "help_block_product_slider_usecase_related": "Beslektede produkter — kompletterende varer til det de ser på.",
    "help_block_product_slider_usecase_compact": "Når plassen er begrenset og du vil vise flere produkter enn et grid tillater.",
    "help_block_product_slider_gtk_swipe": "På mobil vises to kort om gangen, med en tynn linje under som viser hvor langt kunden har sveipet. Pilene vises bare på større skjermer.",
    "help_block_product_slider_gtk_hidden_products": "Skjulte og utsolgte produkter hoppes over automatisk — du trenger ikke filtrere manuelt.",
    "help_block_single_product_tip_with_hero": "Kombineres ofte med en hero-blokk over som «kontekst» — historien rundt produktet.",
    "help_block_single_product_usecase_launch": "Lansering — fremhev det nyeste produktet med et stort og eksklusivt uttrykk.",
    "help_block_single_product_usecase_signature": "Signaturprodukt — det merket er kjent for, eller bestselgeren.",
    "help_block_single_product_usecase_campaign_pair": "Kampanjeprodukt — «Ukens tilbud», «Jul-spesialen».",
    "help_block_single_product_gtk_pulls_live": "Henter pris, lager og bilder direkte fra produktet — endringer der oppdaterer her automatisk.",
    "help_block_single_product_gtk_high_res": "Brukes ofte stort — sørg for at produktbildene har høy oppløsning.",
    "help_block_category_buttons_tip_max_six": "Maks 6 knapper. Flere blir overveldende — kunden gir opp og scroller.",
    "help_block_category_buttons_usecase_main_nav": "Hovednavigasjon på forsiden — direktelenker til viktigste kategorier.",
    "help_block_category_buttons_usecase_seasonal": "Sesongkategorier — «Bursdagsgaver», «Sommersalg», «Skole-start».",
    "help_block_category_buttons_usecase_below_hero": "Like under hero-en for å lede kunden videre fra «velkommen» til kjøp.",
    "help_block_category_buttons_gtk_text_only": "Knappene viser bare kategorinavnet — ingen bilder eller ikoner. Bruk Bildegrid om du vil ha visuell kategori-navigasjon.",
    "help_block_category_buttons_gtk_scroll_mobile": "Sidelengs rulling er bra på mobil hvis du har mange kategorier — kunden sveiper.",
    "help_block_newsletter_tip_placement": "Plasser nyhetsbrevet etter at kunden har sett produkter — ikke som det første de møter.",
    "help_block_newsletter_usecase_lead_gen": "Bygge e-postliste for fremtidig markedsføring og kampanjer.",
    "help_block_newsletter_usecase_launch_list": "«Venteliste» for kommende produkter eller butikkåpning.",
    "help_block_newsletter_usecase_discount_offer": "Skaff abonnenter ved å tilby rabattkode — klassikeren «10 % rabatt på første kjøp».",
    "help_block_newsletter_gtk_subscribers_stored": "Påmeldinger samles i admin-panelet under abonnenter — derfra kan du eksportere listen.",
    "help_block_newsletter_gtk_gdpr_legal": "Husk GDPR — du må ha lov til å sende markedsføring til de som melder seg på.",
    "help_block_newsletter_gtk_value_exchange": "Folk gir bort e-posten sin når de får noe tilbake — rabatt, guide, eksklusiv tilgang.",
    "help_block_form_tip_email_notify": "Aktiver e-postvarsel — du vil ikke gå glipp av en kundehenvendelse.",
    "help_block_form_usecase_contact": "Kontaktskjema for spørsmål, klager, henvendelser.",
    "help_block_form_usecase_custom_order": "Spesialbestillinger — kunder ber om noe utenom det vanlige sortimentet.",
    "help_block_form_usecase_return": "Returforespørsel — strukturert måte å håndtere returer.",
    "help_block_form_usecase_survey": "Kundeundersøkelse — feedback på opplevelsen.",
    "help_block_form_gtk_required_email": "Sørg for å samle e-post — uten den kan du ikke svare kunden.",
    "help_block_form_gtk_short_wins": "Tre felt = 80 % fullføring. Ti felt = 20 %. Korte skjemaer gir alltid flest svar.",
    "help_block_form_gtk_thank_you_critical": "Vis en takk-melding etter innsending — uten den lurer kunden på om det fungerte.",
    "help_block_footer_name": "Footer",
    "help_block_footer_tagline": "Bunnen av siden — kontaktinfo, lenker, sosiale medier og betalingsikoner.",
    "help_block_footer_description": "Footeren er kundenes oppslagsverk når de skal finne kontakttelefonen, leveringsinfo eller åpningstider. Du har flere ferdige varianter og kan tilpasse innholdet i kolonnene.",
    "help_block_footer_feature_columns": "Flere kolonner med valgfrie lenker.",
    "help_block_footer_feature_social": "Ikoner for Instagram, Facebook, TikTok osv. Fargen velger du under Temainnstillinger → Farger.",
    "help_block_footer_feature_payment": "Vis betalingsmetodene du tilbyr.",
    "help_block_footer_feature_newsletter": "Innebygd nyhetsbrev-skjema (valgfritt).",
    "help_block_footer_feature_shape": "Footer 2 kan få en form på toppen — buet, bølge, skrå eller sagtenner — som kan legges over blokken ovenfor.",
    "help_block_footer_tip_legal": "Husk å legge inn lenker til personvern, vilkår og angrerett — det er lovpålagt.",
    "help_block_campaign_bar_name": "Kampanjelinje",
    "help_block_campaign_bar_tagline": "Tynn linje med tilbud, kampanjekoder eller viktige meldinger.",
    "help_block_campaign_bar_description": "Bruk kampanjelinjen til å rope ut tilbud eller informere om frakt. Den vises på alle sider, og du velger selv om den skal ligge i header, hovedinnhold eller footer.",
    "help_block_campaign_bar_feature_visibility": "Slå av/på uten å slette innholdet.",
    "help_block_campaign_bar_feature_link": "Opp til 3 meldinger som roterer automatisk på mobil.",
    "help_block_campaign_bar_feature_dismiss": "Egne farger for bakgrunn og tekst — gjør linjen synlig.",
    "help_block_campaign_bar_tip_short": "Hold teksten kort — én setning fungerer best.",
    "help_block_hero_image_text_name": "Bilde med tekst",
    "help_block_hero_image_text_tagline": "Stort banner med bilde på den ene siden og tekst + knapp på den andre.",
    "help_block_hero_image_text_description": "Klassisk «hero»-blokk som typisk plasseres øverst på forsiden. Du har bilde på en side, og tittel + tekst + en eller flere knapper på den andre.",
    "help_block_hero_image_text_feature_layout": "Velg om bildet skal være til venstre eller høyre.",
    "help_block_hero_image_text_feature_cta": "Stor handlingsknapp med valgfri farge.",
    "help_block_hero_image_text_feature_alignment": "Plasser tekst over, midt eller under bildet.",
    "help_block_hero_image_text_tip_first_block": "Egner seg som introblokk når du vil sette stemningen først. Selger du produkter folk allerede leter etter, kan en produktblokk øverst gi raskere kjøp.",
    "help_block_hero_background_name": "Tekst med bakgrunnsbilde",
    "help_block_hero_background_tagline": "Bakgrunnsbilde i full bredde med tekst og knapp oppå.",
    "help_block_hero_background_description": "Visuelt slagkraftig variant der bildet dekker hele blokken og teksten ligger oppå. Du kan styre hvor teksten plasseres og legge et overlegg over bildet for bedre lesbarhet.",
    "help_block_hero_background_feature_overlay": "Legg et mørkt overlegg over bildet så teksten blir lesbar.",
    "help_block_hero_background_feature_parallax": "Valgfri parallax-effekt når kunden scroller.",
    "help_block_hero_background_feature_placement": "Plasser tekst hvor som helst — øverst, midten, nederst, venstre, høyre.",
    "help_block_button_styles": "Knappen kan ha bakgrunn, ramme eller være uten ramme, med valgfritt pil- eller handlekurvikon.",
    "help_block_hero_background_tip_readability": "Velg et bilde med en rolig, ensfarget del der teksten kan ligge — eller legg et mørkt overlegg over for bedre lesbarhet.",
    "help_block_video_hero_name": "Videobanner",
    "help_block_video_hero_tagline": "Hero-banner med en YouTube- eller Vimeo-video i bakgrunnen.",
    "help_block_video_hero_description": "Som en vanlig hero, men med en video i bakgrunnen istedenfor et bilde. Du limer inn URL-en til en YouTube- eller Vimeo-video — den spilles av automatisk og i loop, uten lyd. Egner seg når du vil vise produktet eller butikken i bevegelse.",
    "help_block_video_hero_feature_autoplay": "Videoen spilles automatisk — uten lyd.",
    "help_block_video_hero_feature_loop": "Spilles i loop.",
    "help_block_video_hero_feature_overlay": "Overlegg med tittel, tekst og knapp.",
    "help_block_video_hero_feature_controls": "Valgfrie videokontroller: spill/pause, start på nytt og lyd av/på, i et hjørne du velger og i tre størrelser.",
    "help_block_video_hero_feature_height": "Velg høyde på blokken — liten, medium, stor, ekstra stor eller fullskjerm — og en egen høyde på mobil.",
    "help_block_video_hero_tip_size": "Hold videoen kort (15–30 sekunder) for at loopen ikke skal bli irriterende.",
    "help_block_image_grid_name": "Bildegrid",
    "help_block_image_grid_tagline": "Rutenett av bilder med valgfri tekst og knapp oppå hvert bilde.",
    "help_block_image_grid_description": "Bra for kategorier, kolleksjoner eller inspirasjonsbilder. Velg antall kolonner, og legg til overlegg med tekst og knapp på hvert bilde individuelt.",
    "help_block_image_grid_feature_columns": "1–6 kolonner — egen verdi for desktop og mobil.",
    "help_block_image_grid_feature_overlay": "Legg tittel, tekst og knapp på hvert bilde.",
    "help_block_image_grid_feature_link": "Hele bildet kan være en lenke.",
    "help_block_image_grid_tip_overlay": "Hold overlay-teksten kort — 2–4 ord fungerer best. Lange tekster konkurrerer med bildet om oppmerksomheten.",
    "help_block_image_slider_name": "Bildeslider",
    "help_block_image_slider_tagline": "Roterende bilder som spilles av automatisk eller manuelt.",
    "help_block_image_slider_description": "Vis flere kampanjer eller bilder uten å bruke mye plass. Du har samme muligheter for overlegg som i bildegridet, og kan styre om bildene skal roteres automatisk.",
    "help_block_image_slider_feature_autoplay": "Velg intervall mellom slidene.",
    "help_block_image_slider_feature_arrows": "Vis piler og prikker for navigering.",
    "help_block_image_slider_feature_overlay": "Overlegg med tekst, knapp og fargesjikt per bilde.",
    "help_block_carousel_second_button": "Legg til en knapp nummer to ved siden av den første — for eksempel «Handle nå» og «Les mer».",
    "help_block_image_slider_feature_effects": "Velg overgangseffekt — glidende, toning, kube, coverflow eller flip.",
    "help_block_image_slider_feature_pagination": "Fire pagineringsstiler: prikker, striper, teller eller miniatyrer.",
    "help_block_image_slider_feature_mobile_image": "Eget mobilbilde per slide — vis et stående utsnitt på små skjermer.",
    "help_block_bento_grid_name": "Bentogrid",
    "help_block_bento_grid_tagline": "Magasininspirert collage der bildene har ulik størrelse.",
    "help_block_bento_grid_description": "Et rutenett med faste layoutvarianter der noen bilder får mer plass enn andre — som en collage. Samme overleggsmuligheter som bildegrid, med tittel, tekst og knapp per bilde.",
    "help_block_bento_grid_feature_variants": "Seks layoutvarianter — blant annet stor venstre/høyre, mosaikk, hero og utstilling.",
    "help_block_bento_grid_feature_row_height": "Juster radhøyden for å gjøre hele collagen lavere eller høyere.",
    "help_block_bento_grid_feature_overlay": "Legg tittel, tekst og knapp på hvert bilde.",
    "help_block_bento_grid_feature_hover": "Hover-effekter på flisene — for eksempel zoom.",
    "help_block_bento_grid_usecase_categories": "Kategoriutstilling der hovedkategorien får den store flisen.",
    "help_block_bento_grid_usecase_campaign": "Kampanjecollage — én stor kampanje omgitt av mindre tilbud.",
    "help_block_bento_grid_usecase_lifestyle": "Livsstilsbilder i magasinstil som viser produktene i bruk.",
    "help_block_bento_grid_gtk_crop": "Bildene beskjæres automatisk for å fylle flisene — hold viktige detaljer midt i bildet.",
    "help_block_bento_grid_gtk_mobile": "På mobil ordnes flisene automatisk i to kolonner.",
    "help_block_bento_grid_gtk_image_count": "Hver variant er designet for et bestemt antall bilder (3–5) — mønsteret gjentas hvis du legger til flere.",
    "help_block_bento_grid_tip_hero_image": "Gi det beste bildet den store flisen — det er dit blikket går først.",
    "help_block_bento_grid_tip_consistent": "Bruk bilder med samme stil og fargetone — da oppleves collagen som én helhet.",
    "help_block_image_grid_slider_name": "Bildegrid-slider",
    "help_block_image_grid_slider_tagline": "Bildegrid som glir sideveis — vis flere bilder på samme plass.",
    "help_block_image_grid_slider_description": "Som bildegrid, men bildene ligger i en slider i stedet for et fast rutenett. Velg hvor mange kolonner som vises samtidig, og la kundene bla seg gjennom resten.",
    "help_block_image_grid_slider_feature_columns": "Velg antall synlige kolonner — egen verdi for desktop og mobil.",
    "help_block_image_grid_slider_feature_arrows": "Piler og prikker for navigasjon — velg stil og plassering på pilene.",
    "help_block_image_grid_slider_feature_overlay": "Legg tittel, tekst og knapp på hvert bilde.",
    "help_block_image_grid_slider_usecase_categories": "Mange kategorier på liten plass — vis noen få og la resten ligge i slideren.",
    "help_block_image_grid_slider_usecase_collections": "Kolleksjoner eller merkevarer kundene kan bla gjennom.",
    "help_block_image_grid_slider_usecase_compact": "Kompakt alternativ når bildegrid tar for mye høyde.",
    "help_block_image_grid_slider_gtk_swipe": "På mobil sveiper kundene — pilene er mest nyttige på desktop.",
    "help_block_image_grid_slider_gtk_same_size": "Bildene blir penere hvis de har samme bildeformat.",
    "help_block_image_grid_slider_tip_columns": "Legg inn flere bilder enn synlige kolonner — ellers er det ingenting å bla til.",
    "help_block_logo_slider_name": "Logoslider",
    "help_block_logo_slider_tagline": "Rullerende rekke med logoer — merkevarer, partnere eller omtaler.",
    "help_block_logo_slider_description": "Vis logoene til merkevarene du fører, samarbeidspartnere eller presseomtaler. Velg mellom jevn rulling eller sidevis blaing.",
    "help_block_logo_slider_feature_movement": "To bevegelsesstiler: jevn rulling med justerbar fart, eller sidevis blaing med autoavspilling.",
    "help_block_logo_slider_feature_per_view": "Velg hvor mange logoer som vises samtidig — egen verdi for desktop og mobil.",
    "help_block_logo_slider_feature_height": "Juster logohøyden — alle logoer vises i samme høyde.",
    "help_block_logo_slider_usecase_brands": "«Merkene vi fører» — kjente logoer bygger tillit umiddelbart.",
    "help_block_logo_slider_usecase_partners": "Samarbeidspartnere eller sertifiseringer.",
    "help_block_logo_slider_usecase_press": "«Omtalt i» — presselogoer gir troverdighet.",
    "help_block_logo_slider_gtk_same_height": "Siden alle logoer vises i samme høyde, virker brede logoer større enn kvadratiske — sjekk at rekken ser balansert ut.",
    "help_block_logo_slider_gtk_transparent": "Bruk logofiler med gjennomsiktig bakgrunn (PNG/SVG) — hvite bokser rundt logoene ser uferdig ut.",
    "help_block_logo_slider_tip_marquee": "Jevn rulling i rolig fart oppleves elegant — sett farten lavt og slå på pause ved hover.",
    "help_block_logo_slider_tip_link": "Hver logo kan lenkes — send kundene til merkevarens produktliste.",
    "help_block_before_after_name": "Før/etter-bilde",
    "help_block_before_after_tagline": "To bilder med dragbar skillelinje — vis forvandlingen.",
    "help_block_before_after_description": "Kunden drar håndtaket sideveis for å sammenligne før- og etterbildet. Perfekt når produktet gir et synlig resultat.",
    "help_block_before_after_feature_handle": "Interaktivt håndtak kunden drar — velg startposisjon for skillelinjen.",
    "help_block_before_after_feature_labels": "Egne etiketter på begge bildene — for eksempel «Før» og «Etter».",
    "help_block_before_after_feature_layout": "Velg bildeformat, og legg til tittel og tekst ved siden av bildet.",
    "help_block_before_after_usecase_results": "Synlige resultater — hudpleie, rengjøring, hårprodukter.",
    "help_block_before_after_usecase_renovation": "Oppussing og restaurering — møbler, interiør, bil.",
    "help_block_before_after_usecase_effect": "Produkteffekt — med og uten produktet.",
    "help_block_before_after_gtk_same_framing": "Bildene må ha identisk utsnitt og vinkel — bruk stativ eller samme kameraposisjon.",
    "help_block_before_after_gtk_product_page": "Blokken kan også brukes i produktside-designet — vis resultatet rett ved kjøpsknappen.",
    "help_block_before_after_tip_position": "Sett startposisjonen litt til side for midten — en synlig flik av etterbildet frister kunden til å dra.",
    "help_block_before_after_tip_honest": "Bruk ekte, uredigerte resultater — overdrevne før/etter-bilder svekker tilliten.",
    "help_block_image_slider_tip_amount": "Hold deg til 3–5 bilder — flere blir aldri sett av kundene.",
    "help_block_text_content_name": "Tekstinnhold",
    "help_block_text_content_tagline": "Fri tekst med formatering for «Om oss», informasjon eller fortellinger.",
    "help_block_text_content_description": "Fullverdig tekstredigerer for lengre innhold. Bruk overskrifter, lister, lenker og bilder. Bra for «Om oss»-side, informasjonsside eller bloggen.",
    "help_block_text_content_feature_richtext": "Overskrifter, fett/kursiv, lister, lenker.",
    "help_block_text_content_feature_alignment": "Venstre, midt eller høyre.",
    "help_block_text_content_feature_width": "Smal eller bred kolonne.",
    "help_block_text_content_feature_padding": "Slå av «Luft rundt innholdet» for å la en HTML-seksjon gå helt ut til kantene. Sammen med «Full bredde» dekker den hele skjermbredden.",
    "help_block_text_content_tip_seo": "Innholdet her er viktig for SEO — bruk relevante søkeord og overskrifter (H1/H2).",
    "help_block_faq_name": "FAQ",
    "help_block_faq_tagline": "Sammenklappbar liste over vanlige spørsmål.",
    "help_block_faq_description": "Reduserer kundesupport-spørsmål. Hvert spørsmål er sammenklappbart — kunden klikker for å utvide svaret. Spørsmålene konfigureres i admin-panelet under FAQ, og denne blokken velger hvilken FAQ-liste som skal vises.",
    "help_block_faq_feature_collapsible": "Svar utvides ved klikk.",
    "help_block_faq_feature_pick_list": "Velg hvilken FAQ-liste som vises — konfigurert separat i admin-panelet.",
    "help_block_faq_feature_title_toggle": "Vis eller skjul tittel på blokken.",
    "help_block_faq_feature_layout": "Svaret kan vises under spørsmålet eller i en skuff fra høyre, med pluss/minus- eller pil-ikon, og du velger hvilke spørsmål som starter åpne.",
    "help_block_faq_feature_width_typography": "Fullbredde eller boks, innholdsbredde, avstand over og under, og egen skriftstørrelse og tykkelse for spørsmål og svar.",
    "help_block_faq_tip_questions": "Skriv spørsmålene slik kundene faktisk stiller dem (ikke som du gjør internt).",
    "help_block_featured_blog_name": "Fremhevede blogginnlegg",
    "help_block_featured_blog_tagline": "Viser de nyeste blogginnleggene som korte oppsummeringer.",
    "help_block_featured_blog_description": "Bra for SEO og kundeengasjement. Velg antall innlegg som skal vises, og eventuelt filtrer på tags.",
    "help_block_featured_blog_feature_count": "1–12 innlegg.",
    "help_block_featured_blog_feature_tag_filter": "Vis bare innlegg med spesifikke tags.",
    "help_block_featured_blog_tip_seo": "Blogginnleggene er gull for SEO — sørg for å skrive godt og bruke relevante søkeord.",
    "help_block_product_grid_name": "Produktgrid",
    "help_block_product_grid_tagline": "Grid av produkter fra en valgt kategori.",
    "help_block_product_grid_description": "Hovedmåten å vise produkter på forsiden. Velg en kategori, antall produkter, kolonner og om utsolgte skal vises eller ikke.",
    "help_block_product_grid_feature_source": "Hent produkter fra en valgt kategori.",
    "help_block_product_grid_feature_count": "Velg antall produkter som vises.",
    "help_block_product_grid_feature_sort": "Sorter på nyeste først, eldste først eller kategoriens rekkefølge.",
    "help_block_product_grid_feature_columns": "Velg antall kolonner.",
    "help_block_product_grid_feature_out_of_stock": "Vis eller skjul utsolgte produkter.",
    "help_block_product_grid_feature_stock_status": "Vis eller skjul lagerstatus i produktkortene.",
    "help_block_product_grid_tip_category": "Kategorien oppdateres automatisk når du legger til nye produkter i den — du slipper å redigere blokken.",
    "help_block_product_slider_name": "Produktslider",
    "help_block_product_slider_tagline": "Horisontal slider med produkter, roteres med piler.",
    "help_block_product_slider_description": "Som produktrutenett, men i sliderform — sparer plass og lar deg vise flere produkter uten å fylle hele skjermen.",
    "help_block_product_slider_feature_source": "Hent produkter fra en valgt kategori (samme som produktrutenett).",
    "help_block_product_slider_feature_navigation": "Kunder navigerer manuelt med piler på desktop eller sveip på mobil.",
    "help_block_product_slider_feature_gap": "Velg avstand mellom produktkortene.",
    "help_block_product_slider_feature_stock_status": "Vis eller skjul lagerstatus i produktkortene.",
    "help_block_product_slider_tip_recommendations": "Bra for «Kunder kjøpte også» og «Anbefalt for deg»-seksjoner.",
    "help_block_single_product_name": "Enkeltprodukt",
    "help_block_single_product_tagline": "Fremhev ett spesifikt produkt med stort bilde og kjøpsknapp.",
    "help_block_single_product_description": "Når du vil sette spotlight på ett bestemt produkt — typisk en nylansering, kampanjevare eller signaturprodukt.",
    "help_block_single_product_feature_layout": "Bilde + beskrivelse + pris + kjøpsknapp.",
    "help_block_single_product_feature_promote": "Plasseres typisk midt på siden mellom andre blokker.",
    "help_block_single_product_tip_feature_product": "Bra for produktlanseringer — kombineres ofte med en hero over.",
    "help_block_category_buttons_name": "Kategorier (knapper)",
    "help_block_category_buttons_tagline": "Tekstknapper med direktelenker til kategoriene dine.",
    "help_block_category_buttons_description": "Hjelper kundene å finne frem til de viktigste kategoriene raskt. Velg hvilke kategorier som vises, knappestørrelse og om de skal brytes til neste linje eller rulle sidelengs.",
    "help_block_category_buttons_feature_categories": "Velg hvilke kategorier som skal vises som knapper.",
    "help_block_category_buttons_feature_layout": "Linjebryting (knappene fortsetter på ny linje) eller sidelengs rulling.",
    "help_block_category_buttons_feature_size": "Velg knappestørrelse: liten, medium eller stor.",
    "help_block_category_buttons_feature_styling": "Egne farger for knapp, tekst, kant og avrunding. Valgfri hover-effekt.",
    "help_block_category_buttons_tip_below_hero": "Plasseres ofte rett under hero-blokken for å lede kunden videre.",
    "help_block_newsletter_name": "Nyhetsbrevpåmelding",
    "help_block_customer_club_name": "Kundeklubb",
    "help_block_customer_club_tagline": "Verv medlemmer og vis medlemmene poengene sine.",
    "help_block_customer_club_description": "Blokken henter tallene fra kundeklubb-innstillingene: velkomstbonus, poengrate og karantenetid. Gjester og ikke-medlemmer får påmeldingsteksten og knappen, innloggede medlemmer får saldoen sin og en lenke til Min side.",
    "help_block_customer_club_feature_layouts": "Fire layouter: banner, fordelskort, steg fra innmelding til rabatt, og kalkulator med glidebryter.",
    "help_block_customer_club_feature_live_numbers": "Bonus, rate og karantene oppdateres automatisk når innstillingene endres.",
    "help_block_customer_club_feature_members": "Medlemmer ser saldo, verdi og poeng på vei i stedet for påmeldingsteksten.",
    "help_block_customer_club_usecase_home": "Høyt på forsiden for å fange nye kunder.",
    "help_block_customer_club_usecase_reminder": "Under produktseksjonene som en påminnelse før kunden går til kassen.",
    "help_block_customer_club_usecase_members": "Som fast innslag så medlemmene ser at poengene vokser.",
    "help_block_customer_club_gtk_app_required": "Blokken krever at kundeklubb-appen er kjøpt og aktiv. Skrus appen av, forsvinner blokken fra butikken.",
    "help_block_customer_club_gtk_quarantine": "Opptjente poeng låses i karantenetiden, men velkomstbonusen er tilgjengelig med en gang. Blokken sier begge deler.",
    "help_block_customer_club_gtk_consent": "Innmelding krever samtykke til markedsføring. Knappen sender kunden til klubbsiden der samtykket gis.",
    "help_block_customer_club_tip_bonus": "Sett en velkomstbonus som er verdt noe. Verdien vises ved siden av bonusfeltet i innstillingene.",
    "help_block_customer_club_tip_layout": "Bruk fordeler-layouten når du vil forklare klubben, og banneret når du bare vil ha knappen synlig.",
    "help_block_newsletter_tagline": "Få kunder til å abonnere på nyhetsbrevet ditt.",
    "help_block_newsletter_description": "Bygg din egen e-postliste. Flere varianter med ulikt design — fra et enkelt påmeldingsfelt på én linje til en seksjon i full bredde med bakgrunnsbilde.",
    "help_block_newsletter_feature_variants": "Seks ferdige varianter med ulik layout og bildevisning.",
    "help_block_newsletter_feature_content": "Egen tittel og brødtekst med rik formatering.",
    "help_block_newsletter_feature_image": "Bilde-støtte i variantene som krever det.",
    "help_block_newsletter_tip_value": "Tilby noe i bytte — 10 % rabatt på første kjøp er klassikeren.",
    "help_block_form_name": "Skjema",
    "help_block_form_tagline": "Kontaktskjema eller spørreundersøkelse.",
    "help_block_form_description": "Vis et skjema du har konfigurert i admin-panelet under Skjemaer. Selve skjemaet — felter, takk-melding og e-postvarsel — settes opp der, og denne blokken velger hvilket skjema som skal vises.",
    "help_block_form_feature_pick_form": "Velg hvilket skjema som vises (opprettes i admin under Skjemaer).",
    "help_block_form_feature_width": "Velg skjema-bredde og vertikal padding.",
    "help_block_form_feature_styling": "Egen bakgrunns- og tekstfarge for blokken.",
    "help_block_form_tip_contact": "Hold skjemaet kort — jo færre felter, jo flere svar.",
    "changes_wont_be_finalized_until_theme_saved": "Endringene lagres ikke før du lagrer i designbyggeren",
    "open_in_new_tab": "Åpne i ny fane",
    "badge_text_color": "Badge tekstfarge",
    "badge_background_color": "Badge bakgrunnsfarge",
    "discount_badge_background_color": "Rabattmerke bakgrunnsfarge",
    "discount_badge_text_color": "Rabattmerke tekstfarge",
    "discount_badge_size": {
        "label": "Rabattmerke størrelse",
        "description": "Justerer skriftstørrelsen på rabattmerket"
    },
    "badge_size": {
        "label": "Badge-størrelse",
        "description": "Justerer skriftstørrelsen på badges som «Nyhet» og «Bestselger»"
    },
    "discount_badge_shape": {
        "label": "Rabattmerke form",
        "description": "Velg formen på rabattmerket",
        "rounded": "Avrundet",
        "circle": "Sirkel",
        "starburst": "Stjerne",
        "ribbon": "Bånd",
        "tag": "Merkelapp"
    },
    "search_or_select_from_dropdown": "Søk eller velg fra nedtrekksmenyen",
    "loading": "Laster",
    "no_results": "Ingen resultater funnet",
    "campaign_bar_description": "Kampanjelinjen kan brukes til å fremme kampanjer, tilbud eller annen informasjon. Du kan legge til en tittel, en beskrivelse og en knapp som lenker til en spesifikk side i butikken din",
    "text_logo_description": "Hvis du mangler en logo, kan du lage en tekstlogo",
    "search_placeholder": "Plassholder for søkefelt",
    "search_placeholder_description": "Teksten som vises i søkefeltet før kunden begynner å skrive",
    "menu_description": "Menyer lar kundene dine navigere gjennom butikken din. Du kan legge til kategorier, produkter, sider og lenker til andre deler av butikken din. <a target='_blank' href='/admin/menus' class='text-[color:var(--link-color)]'>Du kan opprette og administrere menyer her</a>",
    "theme_block_variant_description": "Forskjellige varianter har forskjellig layout og design. Du kan velge den varianten som passer best for butikken din",
    "newsletter_signup_image_description": "Kun tilgjengelig på variant 3 og 4",
    "theme_editor_category_description": "Velg kategorien du vil hente produkter fra og vise i denne blokken. <a target='_blank' href='/admin/categories' class='text-[color:var(--link-color)]'>Du kan opprette og administrere kategorier her</a>",
    "color_of_title": "Farge på tittel",
    "replace": "Erstatt",
    "conditional_shipping_price_enabled": "Alternativ prisjustering når kjøpesummen overstiger beløp",
    "condition_modify_type": "Juster fraktkostnad",
    "replace_with_with_price": "Erstatt med pris",
    "when_order_total_exceeds": "Når ordresummen overstiger",
    "delete_image": "Slett bilde",
    "crop_image": "Beskjær bilde",
    "crop_and_save": "Beskjær og lagre",
    "image_cropped_successfully": "Bildet ble beskåret",
    "see_store": "Se butikk",
    "preview_mobile": "Forhåndsvisning mobil",
    "preview_tablet": "Forhåndsvisning nettbrett",
    "preview_desktop": "Forhåndsvisning desktop",
    "preview_product": "Forhåndsvisningsprodukt",
    "webhook_deleted": "Webhook slettet",
    "webhook_updated": "Webhook oppdatert",
    "webhook_created": "Webhook opprettet",
    "webhook_information": "Denne siden lar deg opprette webhooks, Webhooks er en effektiv måte å dele informasjon om hendelser som skjer i nettbutikken, med andre systemer.  Du kan for eksempel sende et varse til regnskapssystemet ditt når en ordre er opprettet.",
    "webhook_topics": "hendelser",
    "webhook_select_topics": "Velg hendelse",
    "existing_webhooks": "Eksisterende webhooks",
    "webhooks": "Webhooks",
    "webhook_verification_key": "Verifiseringsnøkkel",
    "order_created": "Ordre opprettet",
    "order_fulfilment_created": "Ordreforsendelse opprettet",
    "order_refund_created": "Ordre kreditert",
    "order_updated": "Ordre oppdatert",
    "order_cancelled_created": "Ordre kansellert",
    "product_created": "Produkt opprettet",
    "product_updated": "Produkt oppdatert",
    "product_deleted": "Produkt slettet",
    "please_select_at_least_one_topic": "Vennligst velg minst én hendelse",
    "copied_to_clipboard": "Kopiert til utklippstavlen",
    "webhook_verification_key_tooltip": "Verifiseringsnøkkelen brukes for å la andre systemer bekrefte at webhooken er fra 24Nettbutikk. Når du mottar en webhook, kan du bekrefte at den er fra 24Nettbutikk ved å sammenligne verifiseringsnøkkelen i webhooken med denne nøkkelen.",
    "create_new_webhook": "Opprett ny webhook",
    "updated_at": "Sist oppdatert",
    "add_webhook": "Legg til ny webhook",
    "update_webhook": "Oppdater webhook",
    "category_internal_name_placeholder": "eg. Klær / Herre / Bukser",
    "category_internal_name_description": "Valgfrit, dette er nyttig dersom du har en komplisert menystruktur, hvor flere kategorier deler samme navn, e.g: 'Klær / Herre / Bukser' vs 'Klær / Kvinne / Bukser', dette lar deg da lettere skille de to kategorien fra hverandre.",
    "category_image": "Kategoribilde",
    "category_image_description": "Vises på underkategorikort når en overordnet kategori viser underkategoriene sine.",
    "category_display_mode": "Hva denne kategorien viser",
    "category_mode_status": "Denne kategorien er satt til «{mode}».",
    "category_mode_showing_cards": "Viser kategorikort nå.",
    "category_mode_showing_products": "Viser produkter nå.",
    "category_mode_smart": "Smart kategori",
    "category_mode_change": "Endre",
    "display_mode_auto": "Automatisk",
    "display_mode_auto_description": "Viser produkter med filter dersom kategorien har egne produkter, ellers vises underkategoriene som klikkbare kategorikort.",
    "display_mode_products": "Produkter",
    "display_mode_products_description": "Viser produkter fra denne kategorien og alle underkategoriene.",
    "display_mode_subcategories": "Kategorikort",
    "display_mode_subcategories_description": "Viser underkategoriene fra denne kategorien som klikkbare kategorikort.",
    "category_new_listing_position": "Nye produkter havner",
    "new_listing_position_bottom": "Nederst",
    "new_listing_position_top": "Øverst",
    "move_to_top": "Flytt til toppen",
    "moved_to_top_of_category": "Flyttet til toppen av kategorien",
    "main_navigation": "Hovedmeny",
    "product_not_in_any_manual_categories": "Produktet er ikke i noen manuelle kategorier",
    "product_is_in_the_following_manual_categories": "Produktet er i følgende manuelle kategorier",
    "this_category_is_included_in_the_stores_main_menu": "Denne kategorien er inkludert i butikkens hovedmeny",
    "there_also_exists_{count}_smart_categories_that_are_dynamic_and_might_contain_the_product": "Det finnes {count} smart-kategori(er) som er dynamiske og kan inneholde produktet",
    "read_more": "Les mer",
    "categories_help_organize_products_into_groups_...": "Kategorier hjelper til med å organisere produkter i grupper, noe som gjør det enklere for kunder å finne det de leter etter. Et produkt som ikke er en del av noen kategori, kan fortsatt nås i butikken via søk eller direkte lenke, men vil være vanskeligere for sluttbruker å finne.",
    "add_to_category": "Tilknytt ny kategori",
    "this_category_is_not_included_in_the_stores_main_menu_and_might_not_be_visible_to_customers": "Denne kategorien er ikke inkludert i butikkens hovedmeny og er kanskje ikke synlig for kunder",
    "are_you_sure_you_want_to_remove_this_product_from_the_category": "Er du sikker på at du vil fjerne dette produktet fra kategorien?",
    "category": "Kategori",
    "add_product_to_categories": "Legg til produkt i kategorier",
    "product_added_to_x_categories": "Produkt lagt til i :count kategori|Produkt lagt til i :count kategorier",
    "menu_view": "Hovedmenyvisning",
    "table_view": "Tabellvisning",
    "from_here_you_can_view_a_table_of_all_categories_not_already_attached_to_this_product": "Herfra kan du se en tabell over alle kategorier som ikke allerede er tilknyttet dette produktet",
    "from_here_you_can_see_a_list_of_all_categories_as_listed_in_the_main_menu": "Herfra kan du se en liste over alle kategorier som er oppført i hovedmenyen",
    "smart_category_cannot_be_added": "Smart-kategorier kan ikke legges til manuelt",
    "main_menu": "Hovedmeny",
    "other_menus": "Andre menyer",
    "delete_webhook_confirmation": "Er du sikker på at du vil slette webhooken?",
    "logistics": "Logistikk",
    "logistics_providers": "Logistikkleverandører",
    "logistics_updated": "Logistikkleverandør oppdatert",
    "shipping_mapping_saved": "Fraktkobling lagret.",
    "shipping_mapping_pickup_locked_error": "Denne fraktmetoden krever hentested og er låst til riktig transportørtjeneste.",
    "shipping_provider": "Logistikkleverandør",
    "shipping_providers": "Fraktleverandører",
    "shipping_providers_desc": "Aktiver og konfigurer metoder fra hver leverandør.",
    "pricing_and_info": "Priser og info",
    "24Shipping": "24Shipping",
    "store_info_missing_fields": "Butikkinformasjonen mangler felt, vennligst sjekk \"Innstillinger / Butikkinformasjon\", og prøv igjen.",
    "edi_client_error": "En feil oppstod under kommunikasjon med EDI-klienten, vennligst prøv igjen senere.",
    "shipping_product": "Fraktprodukt",
    "label": "Etikett",
    "link": "Lenke",
    "an_error_occurred_please_try_again": "En feil oppstod, vennligst prøv igjen",
    "editing": "Redigerer",
    "close_block_settings": "Lukk blokkinnstillinger",
    "theme_header_section": "Topp",
    "theme_main_section": "Innhold",
    "theme_footer_section": "Bunn",
    "add_block": "Legg til blokk",
    "block_is_draft": "Blokken er et utkast, og vil ikke være synlig i butikken før malen er lagret",
    "block_contains_draft_images": "Blokken inneholder utkastbilder, og de vil ikke være synlige i butikken før du lagrer",
    "invalid_color_value": "Ugyldig fargeverdi {color}",
    "unknown_setting": "Ukjent innstilling",
    "invalid_setting_type": "Ugyldig innstillingstype",
    "invalid_selection": "Ugyldig valg",
    "could_not_set_custom_properties_for_media": "Kunne ikke sette egendefinerte egenskaper for media",
    "only_draft_blocks_can_be_deleted": "Kun utkast-blokker kan slettes",
    "social_media": "Sosiale medier",
    "invalid_url": "Ugyldig URL",
    "theme_screen_width_warning": "Skjermbredden din er for liten for den beste opplevelsen.",
    "partner_logos": "Partnerlogoer",
    "folder": "Mappe",
    "create_new_folder": "Opprett ny mappe",
    "no_current_folder": "Ingen gjeldende mappe",
    "no_folder": "Ingen mappe",
    "are_you_sure_you_want_to_delete_folder": "Er du sikker på at du vil slette mappen {folder}? Dette vil også slette alle filer i mappen.",
    "move_to_folder": "Flytt til mappe",
    "files_moved_to_folder": "Filer flyttet til {folder}",
    "something_went_wrong_during_move": "Noe gikk galt under flyttingen",
    "something_went_wrong_when_creating_folder": "Noe gikk galt under opprettelsen av mappen",
    "folder_created": "Mappe opprettet",
    "folder_deleted": "Mappe slettet",
    "something_went_wrong_when_deleting_folder": "Noe gikk galt under slettingen av mappen",
    "url_copied_to_clipboard": "URL kopiert til utklippstavlen",
    "showing_x_files_of_y": "Viser {count} av {total} filer",
    "showing_x_of_y": "Viser {count} av {total}",
    "add_logos": "Legg til logoer",
    "partner_logos_contains_draft_images": "Partnerlogoer inneholder utkastbilder, og de vil ikke være synlige i butikken før malen er lagret",
    "edit_category": "Rediger kategori",
    "create_category": "Opprett kategori",
    "search_product_name_or_tags": "Søk etter produktnavn eller tags",
    "edit_product": "Rediger produkt",
    "create_product": "Opprett produkt",
    "menus": "Menyer",
    "edit_menu": "Rediger meny",
    "create_menu": "Opprett meny",
    "add_menu_item": "Legg til menypunkt",
    "products_matching_smart_criteria": "Produkter som matcher smart-kriterier",
    "x_variants_selected": "{count} variant valgt | {count} varianter valgt",
    "set_new_quantity_in_stock_to_x_variants": "Sett ny lagerbeholdning til {count} variant | Sett ny lagerbeholdning til {count} varianter",
    "set_new_price_to_x_variants": "Sett ny pris til {count} variant | Sett ny pris til {count} varianter",
    "clear_all_filters": "Fjern alle filtre",
    "no_tags_exists": "Det eksisterer ingen tags",
    "manual_categories_filter_description": "Gjelder kun manuelle kategorier",
    "publish": "Publiser",
    "unpublish": "Avpubliser",
    "publish_products_action_description": "Gjør de valgte produktene synlige for kunder",
    "delete_products_action_description": "Slett de valgte produktene, dette er irreversibelt",
    "unpublish_products_action_description": "Gjør de valgte produktene usynlige for kunder",
    "add_tags": "Legg til tags",
    "add_tags_products_action_description": "Legg til tags til de valgte produktene",
    "set_page_template": "Sett sidemal",
    "set_page_template_action_description": "Tildel en sidemal til de valgte produktene",
    "set_page_template_for_x_amount_of_products": "Sett sidemal for {count} produkter",
    "set_page_template_modal_description": "Velg en sidemal for de valgte produktene. «Standard» tilbakestiller dem til temaets standardmal.",
    "set_google_category": "Sett Google-kategori",
    "set_google_category_action_description": "Tildel en Google-produktkategori til de valgte produktene",
    "set_google_category_for_x_amount_of_products": "Sett Google-kategori for {count} produkter",
    "set_google_category_modal_description": "Søk opp kategorien produktene hører hjemme i. Verdien brukes av Google Shopping-feeden.",
    "google_category": "Google-kategori",
    "without_google_category": "Produkter uten Google-kategori",
    "without_tags": "Produkter uten tagger",
    "without_categories": "Produkter uten kategori",
    "without_brand": "Produkter uten merke",
    "without_badges": "Produkter uten badges",
    "set_google_category_preview_blank": "{count} produkter mangler Google-kategori og får {category}.",
    "set_google_category_preview_existing": "{count} produkter har allerede en Google-kategori. Velg om de skal beholde den eller få den nye.",
    "set_google_category_update_all": "Oppdater alle {count}",
    "set_google_category_update_blank_only": "Oppdater kun de {count} blanke",
    "set_google_category_checking": "Sjekker de valgte produktene",
    "search_google_category": "Søk etter Google-kategori",
    "searching": "Søker",
    "add_tags_to_x_amount_of_products": "Legg til tags til {count} produkt | Legg til tags til {count} produkter",
    "add_x_tags": "Legg til {count} tag | Legg til {count} tags",
    "add_tags_modal_description": "Eventuelle produkter som allerede har de valgte taggene, vil ikke få dem lagt til igjen",
    "remove_tags": "Fjern tags",
    "remove_tags_products_action_description": "Fjern tags fra de valgte produktene",
    "remove_tags_from_x_amount_of_products": "Fjern tags fra {count} produkt | Fjern tags fra {count} produkter",
    "remove_x_tags": "Fjern {count} tag | Fjern {count} tags",
    "number_of_products": "Antall produkter",
    "are_you_sure_you_want_to_remove_tag_from_x_products": "Er du sikker på at du vil fjerne taggen fra {count} produkt? | Er du sikker på at du vil fjerne taggen fra {count} produkter?",
    "remove_tag_from_products_action_description": "Fjern taggen fra de valgte produktene",
    "products_with_tag": "Produkter med tag",
    "smart_categories_using_tag": "Smart-kategorier som bruker taggen",
    "delete_tag": "Slett tag",
    "delete_tag_modal_description": "Dette vil fjerne taggen {name} fra {count} produkt | Dette vil fjerne taggen {name} fra {count} produkter",
    "tag_deleted": "Tag slettet",
    "are_you_sure_you_want_to_delete_x_tags": "Er du sikker på at du vil slette {count} tag? | Er du sikker på at du vil slette {count} tags?",
    "attribute_values": "Verdier",
    "delete_attribute": "Slett attributt",
    "delete_attribute_modal_description": "Dette vil fjerne attributten {name} og alle verdiene fra {count} produkt. Filtrering på attributten forsvinner fra kategorisidene. | Dette vil fjerne attributten {name} og alle verdiene fra {count} produkter. Filtrering på attributten forsvinner fra kategorisidene.",
    "attribute_deleted": "Attributt slettet",
    "are_you_sure_you_want_to_delete_x_attributes": "Er du sikker på at du vil slette {count} attributt? | Er du sikker på at du vil slette {count} attributter?",
    "delete_attributes_action_description": "Slett de valgte attributtene fra alle produkter",
    "edit_attribute_name": "Endre navn på attributt",
    "edit_attribute_value_name": "Endre attributtverdi",
    "attribute_rename_consequence": "Navnet endres overalt: på {count} produkt og i kategorifiltrene. | Navnet endres overalt: på {count} produkter og i kategorifiltrene.",
    "attribute_value_name_already_in_use": "Attributten har allerede en verdi med dette navnet.",
    "products_with_attribute": "Produkter med {name}",
    "delete_attribute_value": "Slett verdi",
    "delete_attribute_value_modal_description": "Dette vil fjerne verdien {name} fra {count} produkt. | Dette vil fjerne verdien {name} fra {count} produkter.",
    "attribute_value_deleted": "Verdi slettet",
    "attribute_values_delete_note": "Attributter brukes til filtrering på kategorisider. Sletter du en verdi, fjernes den fra alle produkter som har den – og fra kategorifiltrene.",
    "all_values": "Alle verdier",
    "no_attributes_yet": "Ingen attributter ennå",
    "no_descriptions_yet": "Ingen beskrivelser ennå",
    "attributes_empty_state_description": "Attributter definerer faste egenskaper ved et produkt – som farge, størrelse eller materiale – og brukes til filtrering på kategorisidene. Du legger dem til under redigering av et produkt.",
    "badges": "Badges",
    "delete_badge": "Slett badge",
    "delete_badge_modal_description": "Dette vil fjerne badgen {name} fra {count} produkt | Dette vil fjerne badgen {name} fra {count} produkter",
    "badge_deleted": "Badge slettet",
    "delete_badges_action_description": "Slett de valgte badgene",
    "are_you_sure_you_want_to_delete_x_badges": "Er du sikker på at du vil slette {count} badge? | Er du sikker på at du vil slette {count} badges?",
    "products_with_badge": "Produkter med badge",
    "remove_badge": "fjern badge",
    "remove_badge_from_products_action_description": "Fjern badgen fra de valgte produktene",
    "are_you_sure_you_want_to_remove_badge_from_x_products": "Er du sikker på at du vil fjerne badgen fra {count} produkt? | Er du sikker på at du vil fjerne badgen fra {count} produkter?",
    "edit_menu_item": "Rediger menypunkt {name}",
    "maintenance": "Vedlikehold",
    "coupon": "Rabattkoder",
    "report": "Rapportering",
    "redirect": "Viderekoblinger",
    "permissions": {
        "users": {
            "view": "kan se brukere, informasjon om dem, og hvilke roller de har",
            "store": "kan opprette brukere, og legge til roller på brukeren",
            "update": "kan oppdatere brukere, og redigere hvilke roller de har",
            "destroy": "kan slette brukere",
            "roles": {
                "view": "kan se alle butikkens roller",
                "store": "kan opprette nye roller",
                "update": "kan oppdatere eksisterende roller",
                "destroy": "kan slette roller"
            }
        },
        "order": {
            "view": "kan se ordrer",
            "edit": "kan redigere ordrelinjer",
            "fulfill": "kan sende ordrer",
            "refund": "kan kreditere ordre"
        },
        "product": {
            "view": "kan se produkter",
            "create": "kan opprette produkter",
            "update": "kan oppdatere produkter",
            "delete": "kan slette produkter",
            "category": {
                "view": "kan se kategorier",
                "create": "kan opprette nye kategorier",
                "update": "kan oppdatere kategorier",
                "delete": "kan slette kategorier"
            }
        },
        "blog": {
            "view": "kan se blogginnlegg",
            "create": "kan opprette blogginnlegg",
            "update": "kan oppdatere blogginnlegg",
            "delete": "kan slette blogginnlegg"
        },
        "form": {
            "view": "kan se skjema",
            "create": "kan opprette skjema",
            "update": "kan redigere skjema",
            "delete": "kan slette skjema og henvendelsene deres",
            "submission": {
                "view": "kan lese henvendelser",
                "manage": "kan ta, ferdigbehandle og gjenåpne henvendelser",
                "delete": "kan slette henvendelser"
            }
        },
        "customer": {
            "view": "kan se kunder",
            "create": "kan opprette kunder",
            "update": "kan oppdatere kunder",
            "delete": "kan slette kunder"
        },
        "coupon": {
            "view": "kan se rabattkoder",
            "create": "kan opprette rabattkoder",
            "update": "kan oppdatere rabattkoder",
            "delete": "kan slette rabattkoder"
        },
        "marketing": {
            "newsletter": {
                "subscriber": {
                    "view": "kan se nyhetsbrevabonnenter",
                    "export": "kan eksportere nyhetsbrevabonnenter"
                }
            },
            "page": {
                "view": "kan se markedsføringssider",
                "create": "kan opprette markedsføringssider",
                "update": "kan redigere markedsføringssider",
                "delete": "kan slette markedsføringssider"
            },
            "review": {
                "view": "kan se anmeldelser",
                "publish": "kan publisere / avpublisere anmeldelser",
                "settings": {
                    "update": "kan oppdatere innstillinger for anmeldelser"
                }
            }
        },
        "design": {
            "update": "kan endre butikkens design",
            "menu": {
                "update": "kan redigere hovedmenyen"
            }
        },
        "report": {
            "view": "kan se rapporter",
            "sales": {
                "view": "kan se salgsrapporter",
                "export": "kan eksportere salgsrapporter"
            },
            "search": {
                "view": "kan se søkestatistikk, som populære søk og søk uten treff"
            }
        },
        "redirect": {
            "view": "kan se og eksportere omdirigeringer",
            "create": "kan opprette omdirigeringer, manuelt eller via import",
            "update": "kan oppdatere omdirigeringer, manuelt eller via import",
            "delete": "kan slette omdirigeringer"
        },
        "webhook": {
            "view": "kan se webhooks",
            "create": "kan opprette webhooks",
            "update": "kan redigere webhooks",
            "delete": "kan slette webhooks"
        },
        "app-store": {
            "install": "kan bestille & installere apper",
            "view": "Kan se installerte apper, og alle instillinger / hemmeligheter som assosiert med dem",
            "update": "kan oppdatere innstillinger i apper"
        },
        "settings": {
            "view": "kan se innstillinger",
            "shipping": {
                "edit": "kan redigere fraktinnstillinger"
            },
            "logistics": {
                "edit": "kan redigere logistikkinnstillinger"
            },
            "payment": {
                "edit": "kan redigere betalingsinnstillinger"
            },
            "store": {
                "status": {
                    "change": "kan stenge og åpen butikken (Vedlikeholdsmodus)"
                }
            },
            "invoice": {
                "edit": "Kan redigere fakturaopplysninger som 24nettbutikk benytter for å fakturere nettbutikken."
            },
            "analytics": "kan administrere analyseinstillinger (Google Analytics, Facebook Pixel, etc.)",
            "contact_info": {
                "edit": "kan redigere butikkens firmaopplysninger, som telefonnummer og e-postadresse"
            }
        },
        "category": {
            "view": "kan se kategorier",
            "create": "kan opprette kategorier",
            "update": "kan oppdatere kategorier",
            "delete": "kan slette kategorier"
        },
        "customer_group": {
            "view": "kan se kundegrupper",
            "create": "kan opprette kundegrupper",
            "update": "kan oppdatere kundegrupper",
            "delete": "kan slette kundegrupper",
            "application": {
                "manage": "kan godkjenne og avslå søknader om å bli med i en kundegruppe"
            }
        },
        "listings": {
            "view": "kan se oppføringer",
            "create": "kan opprette oppføringer",
            "update": "kan oppdatere oppføringer",
            "delete": "kan slette oppføringer"
        },
        "booking": {
            "view": "kan se bookinger",
            "create": "kan opprette bookinger",
            "update": "kan oppdatere bookinger",
            "delete": "kan slette bookinger"
        },
        "customer_club": {
            "export": "kan eksportere medlemslisten til kundeklubben"
        },
        "gift_certificate": {
            "view": "kan se utstedte gavekort",
            "manage": "kan utstede og importere gavekort"
        },
        "v1import": {
            "access": "kan bruke importverktøyet"
        },
        "accounting": {
            "transfer": "kan overføre ordre og kreditnotaer til Tripletex"
        },
        "ai": {
            "wallet": {
                "manage": "kan fylle på AI-saldoen og endre automatisk påfylling"
            }
        },
        "experiment": {
            "view": "kan se A/B-tester og resultatene deres",
            "manage": "kan opprette, starte og avslutte A/B-tester"
        }
    },
    "you_cant_edit_this_role": "Denne rollen kan ikke redigeres",
    "you_cant_delete_this_role": "Denne rollen kan ikke slettes",
    "you_cant_edit_this_user": "Denne brukeren kan ikke redigeres",
    "create_role": "Legg til rolle",
    "delete_role": "Slett rolle",
    "update_role": "Oppdater rolle",
    "payment_not_initiated": "Noe gikk galt under betalingen, prøv igjen",
    "order_already_exists": "Denne bestillingen er allerede plassert.",
    "shipping_method_not_found": "Den valgte fraktmetoden er ikke lenger tilgjengelig.",
    "total_amount_mismatch": "Betalingsbeløpet stemmer ikke med ordretotalet.",
    "roles": "Roller",
    "role": "rolle",
    "invite_user": "Inviter bruker",
    "edit_user": "Rediger bruker",
    "delete_user_confirmation": "Er du sikker på at du vil slette brukeren {name}?",
    "delete_user": "Slett bruker",
    "delete_role_confirmation": "Advarsel: Hvis du sletter en rolle, vil alle brukere som har denne rollen miste tilgang til de tilknyttede funksjonene. Er du sikker på at du vil slette denne rollen?",
    "create_api_token": "API-nøkkel",
    "add_renew_api_token_explanation": "Her kan du generere API-nøkler for å gi tilgang til tredjepartsapplikasjoner. Hvis du tror at nøkkelen din er kompromittert, kan du generere en ny nøkkel for å erstatte den gamle. Merk at denne nøkkelen er knyttet til din bruker og gir kun tredjparter tilganger som du har.",
    "personal_access_token": "Personlig tilgangsnøkkel. Nøkkelen vises kun én gang. Etter det, vil den aldri vises igjen. Kopier og oppbevar den trygt.",
    "personal_access_token_encrypted": "Nøkkelen er kryptert. Slett og opprett ny.",
    "no_personal_access_token": "Ingen personlig tilgangsnøkkel",
    "images_uploaded_successfully": "Bildene ble lastet opp",
    "images_deleted": "Bildene ble slettet",
    "image_alt_text_updated": "Bildetekst oppdatert",
    "warning_removing_your_admin_rights": "Advarsel: Hvis du fjerner dine egne administratorrettigheter, vil du ikke nødvendigvis kunne gi deg selv tilgang tilbake.",
    "changes_could_not_be_saved": "Endringene kunne ikke lagres. Prøv igjen.",
    "profile_saved_but_roles_were_not": "Profilen ble lagret, men rollene ble ikke det. Prøv igjen.",
    "warning_add_at_least_one_role": "Advarsel: Du må knytte minst en rolle til brukeren",
    "role_names": {
        "admin": "administrator",
        "accountant": "regnskapsfører",
        "writer": "skribent",
        "designer": "designer",
        "order expediter": "ordrebehandler"
    },
    "my_new_role_placeholder": "Min nye rolle",
    "multiple_sales_prices_error": "Du kan ikke ha flere salgspriser hvis én ikke har en sluttdato.",
    "edit_order_recipient": "Rediger ordremottaker",
    "order_recipient": "Ordremottaker",
    "first_name": "Fornavn",
    "last_name": "Etternavn",
    "organization_number": "Organisasjonsnummer",
    "purchase_order_number": "Referansenummer/innkjøpsordrenummer",
    "zip_code": "Postnummer",
    "zip": "Postnummer",
    "street": "Gateadresse",
    "klarna_checkout": "Klarna Checkout",
    "vipps_express": "Vipps Hurtigkasse",
    "app_store.purchase_success": "Appen ble kjøpt/installert!",
    "app_store.name": "Apps",
    "apps": "Apps",
    "my_apps": "Mine apper",
    "vipps_express_app_description": "Kunden kan betale med Vipps Hurtigkasse direkte fra produktsiden, så man slipper å gå via kassen i nettbutikken. Enklere blir det ikke!",
    "integration": "Integrasjon",
    "free": "Gratis",
    "beta": "Beta",
    "reset": "Tilbakestill",
    "frequently_asked_questions": "Ofte stilte spørsmål",
    "vipps_express_landing_order_now": "Bestill nå",
    "vipps_express_landing_why_choose_vipps_express": "Hvorfor bruke Vipps Hurtigkasse?",
    "vipps_express_landing_a_faster_way_for_your_customers_to_pay": "Det er en raskere betalingsmetode, som lett og raskt lar kundene betale, med minst mulig friksjon.",
    "vipps_express_landing_more_than_3_million_norwegians_already_have_vipps": "Mer enn 3 millioner Nordmenn brukere allerede Vipps, og de liker å betale med vipps også på nett!",
    "vipps_express_landing_faq_q_is_the_order_management_integrated": "Er ordrebehandlingen integrert?",
    "vipps_express_landing_faq_a_is_the_order_management_integrated": "Ordrebehandlingen er integrert sømløst, på lik linje med en ordinær vipps ordre, slik at du aldri trenger å forlate nettbutikken din for å behandle ordrer.",
    "vipps_express_landing_faq_q_what_is_the_expected_payment_time": "Hva er forventet utbetalingstid?",
    "vipps_express_landing_faq_a_what_is_the_expected_payment_time": "Normalt sett skjer utbetalingen fra Vipps daglig, men kan i enkelte tilfeller ta opp mot 48 timer. Det utbetales ikke i helgene.",
    "vipps_express_landing_faq_q_how_much_does_vipps_cost": "Hvor mye koster det å ha Vipps hurtigkasse?",
    "vipps_express_landing_faq_a_how_much_does_vipps_cost": "Vipps Hurtigkasse er gratis å benytte, men du betaler de ordinære vipps kostnadene (på lik linje med en ordinær vipps ordre).",
    "vipps_express_landing_faq_q_im_stuck_what_do_i_do": "Jeg står fast, hva gjør jeg?",
    "vipps_express_landing_faq_a_im_stuck_what_do_i_do": "Vi hjelper deg gjerne om du har problemer. Ta kontakt med vår gratis support på tlf. 22 33 66 88.",
    "vipps_express_landing_faq_q_can_i_use_vipps_express_without_vipps": "Kan jeg bruke Vipps Hurtigkasse uten å ha Vipps?",
    "vipps_express_landing_faq_a_can_i_use_vipps_express_without_vipps": "Nei, du må ha Vipps allerede konfigurert i nettbutikken for å kunne bestille vipps hurtigkasse.",
    "vipps_express_settings": {
        "note": "Merk",
        "vipps_credentials_must_be_defined_by_24nb": "Vipps kontoopplysninger må defineres av 24nettbutikk, om du har bestilt Vipps, men disse ikke er satt, vennligst kontakt support.",
        "the_vipps_credentials_are_shared_between_all_vipps_payment_methods": "En Vipps konto deles mellom alle Vipps betalingsmetoder, det er altså ikke mulig å ha forskjellige Vipps kontoer for Vipps Hurtigkasse og ordinær vipps."
    },
    "ie": "f.eks.",
    "unable_to_configure_vipps_express_without_vipps_credentials": "Kan ikke benytte Vipps Hurtigkasse uten Vipps først satt opp, sjekk at vipps er satt opp riktig og prøv igjen.",
    "toggle_the_app_on_or_off": "Slå appen av eller på",
    "customer_details_update_failed": "Kunne ikke oppdatere kundeinfo, kommunikasjon med betalingstilbyder feilet.",
    "header_icon_color_description": "Viser fargen på header-ikonene som signaliserer viktige varsler, som antall varer i handlekurven. Tilpass den til å matche nettbutikkens stil.",
    "header_icon_size_description": "Endrer størrelsen på header-ikonene. Gjelder for alle skjermstørrelser. ",
    "header_icon_weight_description": "Endrer tykkelsen på header-ikonene. Gjelder for alle skjermstørrelser. ",
    "sticky_header": "Fast toppmeny",
    "sticky_header_description": "Når dette valget er aktivert, vil toppmenyen i nettbutikken bli værende synlig øverst på skjermen når man scroller nedover siden.",
    "main_navigation_style": "Navigasjonsstil",
    "main_navigation_style_description": "Velg hvordan hovedmenyen vises på PC. «Rad» viser toppnivåene i en rad med megameny eller nedtrekksmeny. «Alle kategorier» legger en knapp først i menyen som åpner et panel med hele kategoritreet: toppnivåene i en liste til venstre og underkategoriene i kolonner til høyre. Passer for butikker med mange menypunkter.",
    "main_navigation_style_row": "Rad",
    "main_navigation_style_categories": "Alle kategorier",
    "header_shadow": "Skygge på header",
    "header_shadow_description": "Legger til en subtil skygge under headeren for å visuelt skille den fra sideinnholdet.",
    "header_show_account_icon": "Vis konto-ikon",
    "header_show_account_icon_description": "Viser «Min konto»-ikonet i headeren slik at kunder kan logge inn, registrere seg og se sin egen side.",
    "form_width": "Skjemabredde",
    "form_vertical_padding": "Avstand over og under skjema",
    "content_max_width": "Standard",
    "full_width": "Full bredde",
    "attributes": "Attributter",
    "add_an_attribute": "Legg til en attributt",
    "add_another_attribute": "Legg til en annen attributt",
    "attribute_value": "Attributtverdi",
    "attribute_input_info": "Lag ny ved å skrive eller velg en verdi i listen",
    "add_attribute_info": "Velg en eksisterende verdi i listen eller opprett en ny ved å skrive inn navnet på verdien. Listen inkluderer også variant-alternativer som ikke er brukt på dette produktet, da de ikke er mulig å kombinere med attributter.",
    "attributes_tooltip_text": "Attributter lar deg definere faste egenskaper ved et produkt – som farge, størrelse eller materiale – som brukes til filtrering på kategorisidene. De vises ikke på produktsiden og kan ikke velges av kundene. <br><br> Bruk attributter når produktet kun har én verdi per egenskap.<br><br>Merk: Du kan ikke legge til en attributt med et navn (som “Farge”) hvis produktet allerede bruker det navnet som et variant-alternativ. Attributtnavn må være unike per produkt og kan ikke overlappe med variantnavn.",
    "incorrect_password": "Feil passord",
    "wishlist": "Favoritter",
    "wishlist_description": "La kunden legge til produkter i en liste med favoritter, for å letter finne dem igjen under handleprosessen.",
    "wishlist_landing_let_your_customer_easily_create_a_list_of_their_favourite_products": "La kunden legge til produkter i en liste med favoritter, for å letter finne dem igjen under handleprosessen.",
    "wishlist_landing_does_it_cost_anything": "Koster det noe?",
    "wishlist_landing_no_its_free": "Nei, denne funksjonen er gratis",
    "wishlist_landing_can_the_user_share_their_favourites": "Kan brukeren dele sine favoritter?",
    "wishlist_landing_no_this_is_a_simple_list_to_allow_the_user_to_more_easily_find_and_compare_their_favourite_products": "Nei, dette er en enkel liste for å la brukeren lettere finne og sammenligne sine favorittprodukter, men inneholder ingen delingsfunksjoner, eller mulighet for å lage lister.",
    "order_now": "Bestill nå",
    "i_have_more_questions_or_feedback": "Jeg har flere spørsmål eller tilbakemeldinger",
    "we_would_love_to_talk_to_you_find_more_information_about_where_to_reach_us_here": "Vi svarer gjerne på spørsmålene dine, du finner mer informasjon om hvordan du når oss <a class='link' href='https://www.24nettbutikk.no/kontakt' target='_blank'>her.</a>",
    "feel_free_to_contact_support_at": "Ta kontakt med oss på telefon 22 33 66 88, chat via 24nettbutikk.no eller på e-post: {email}",
    "default": "Standard",
    "theme_editor_border_radius": {
        "label": "Hjørneavrunding",
        "description": "Justerer hjørneavrundingen på elementer i nettbutikken",
        "0px": "Ingen (0 px)",
        "4px": "Liten (4 px)",
        "6px": "Middels (6 px)",
        "8px": "Stor (8 px)"
    },
    "theme_editor_font_heading": {
        "label": "Skrifttype overskrifter",
        "description": "Velg skrifttypen som skal brukes på alle overskriftsnivåer. Dette avgjør hvordan side- og seksjonstitlene dine vises"
    },
    "theme_editor_font_body": {
        "label": "Skrifttype brødtekst",
        "description": "Velg skrifttypen som skal brukes for all vanlig brødtekst (avsnitt, lister, bildetekster og annet ikke-overskriftsinnhold)"
    },
    "theme_editor_body_line_height": {
        "label": "Linjeavstand brødtekst",
        "description": "Hvor mye luft det er mellom linjene i brødteksten. Påvirker lesbarheten på lengre tekster (produktbeskrivelser, blogg, FAQ)"
    },
    "theme_editor_heading_transform": {
        "label": "Tekstcase på overskrifter",
        "description": "Tving alle overskrifter til store bokstaver eller stor forbokstav. Brukes ofte i fashion- og luksus-bransjen"
    },
    "theme_editor_heading_letter_spacing": {
        "label": "Bokstavavstand på overskrifter",
        "description": "Justerer mellomrommet mellom bokstavene i overskrifter. Stram for moderne/teknisk look, vid for luksus/elegant feel"
    },
    "compact": "kompakt",
    "comfortable": "komfortabel",
    "relaxed": "luftig",
    "capitalize": "Stor Forbokstav",
    "letter_spacing_tight": "stram",
    "letter_spacing_wide": "vid",
    "letter_spacing_wider": "ekstra vid",
    "theme_editor_content_max_width": {
        "label": "Maks bredde på innholdet",
        "description": "Setter maksimal bredde på innholdsområdet i nettbutikken din. Dette påvirker hvor bredt tekst og bilder kan vises"
    },
    "change_image_on_hover": {
        "label": "Bytt bilde ved hover",
        "description": "Aktiver/deaktiver bytte til bilde nr. 2 når du holder musepekeren over produktboksen"
    },
    "theme_editor_is_full_width": {
        "label": "Fullbredde",
        "description": "Bestemmer om blokken skal strekke seg over hele skjermbredden eller holde seg innenfor innholdsbredden fra temainnstillingene"
    },
    "theme_editor_full_width_overridden_by_global": "Hele butikken er satt til full bredde i global layout, så dette valget har ingen effekt nå.",
    "theme_editor_go_to_global_layout": "endre i global layout",
    "theme_editor_stock_status_overridden_by_global": "Lagerstatus er slått av i globale innstillinger, så dette valget har ingen effekt nå.",
    "theme_editor_go_to_global_settings": "endre i globale innstillinger",
    "theme_editor_product_box_border": {
        "label": "Produktboksramme",
        "description": "Bestemmer om produktboksene skal ha en ramme rundt seg.",
        "default": "Standard",
        "thick": "Bred ramme",
        "none": "Ingen"
    },
    "hero_background_image_text": "Tekst med bakgrunnsbilde",
    "parallax_effect": "Parallax effekt",
    "overlay_active": "Overlegg",
    "overlay_active_description": "Legger en farget film over videoen for å gi bedre kontrast bak tittel, tekst eller knapp. Anbefales kun når du har innhold over videoen.",
    "product_box_border_color": "Produktboksramme farge",
    "product_box_image_hover": "Bytt bilde ved hover",
    "product_box_image_hover_description": "Bytt til produktets andre bilde når musepekeren holdes over produktkortet. Gjelder kategorisider, søk og produktlister — designblokker med egen hover-innstilling overstyrer denne.",
    "show_lead_paragraph": "Vis ingress",
    "show_lead_paragraph_description": "Vis kort beskrivelse under produktnavnet i produktbokser. Endringen vises etter at siden er lastet på nytt.",
    "show_lead_paragraph_mobile": "Vis ingress på mobil",
    "show_lead_paragraph_mobile_description": "Ingressen klippes til én linje på små skjermer. Passer best når ingressen er skrevet som en kort spesifikasjonslinje.",
    "product_box_show_stock_status": "Vis lagerstatus",
    "product_box_show_stock_status_description": "Vis lagerstatus (På lager/Ikke på lager) i produktbokser i hele butikken, inkludert kategorisider. Endringen vises etter at siden er lastet på nytt.",
    "block_show_stock_status": "Vis lagerstatus",
    "block_show_stock_status_description": "Vis lagerstatus i produktboksene i denne blokken.",
    "product_box_title_bold": "Fet produkttittel",
    "product_box_title_bold_description": "Vis produktnavn med fet skrift i produktbokser (gjelder grid, liste og små kort).",
    "product_card_density": "Tetthet på produktkort",
    "product_card_density_description": "Justerer tittel-, pris- og padding-størrelse samtidig. Kompakt passer informasjonstunge bransjer (gadgets, sport), romslig passer fashion og smykker.",
    "product_card_density_compact": "Kompakt",
    "product_card_density_standard": "Standard",
    "product_card_density_comfortable": "Romslig",
    "product_box_transparent_background": "Gjennomsiktig bakgrunn på produktboks",
    "product_box_transparent_background_description": "Fjern den hvite bakgrunnsfargen på produktboksen så den tar farge fra siden eller seksjonen under. Tekstkontrasten justeres automatisk når dette er aktivt.",
    "product_box_center_content": "Tekstjustering i produktboks",
    "product_box_center_content_description": "Juster tittel, ingress, pris og vurderinger i produktboksen",
    "product_box_align_left": "Venstrejustert",
    "product_box_align_center": "Sentrert",
    "product_card_discount_position": "Plassering av rabattmerke",
    "product_card_favorite_position": "Plassering av favorittknapp",
    "product_card_badges_position": "Plassering av merkelapper",
    "product_card_position_top_left": "Øverst til venstre",
    "product_card_position_top_right": "Øverst til høyre",
    "product_card_position_bottom_left": "Nederst til venstre",
    "product_card_position_bottom_right": "Nederst til høyre",
    "product_box_button_style": "Knappestil i produktboks",
    "product_box_button_style_description": "Velg mellom ikonknapp eller fullbredde-knapp i produktboksen. Endringen vises etter at siden er lastet på nytt.",
    "product_box_button_icon": "Ikonknapp",
    "product_box_button_full_width": "Avlang knapp",
    "show_swatches_on_cards": "Vis variantvalg på produktkort",
    "show_swatches_on_cards_description": "Når aktivert vises variantene som fargeprøver, små bilder eller tekstknapper under produkttittelen på kategorisider. Kunden ser variantens navn og bilde ved å holde musepekeren over, og går rett til varianten ved klikk.",
    "swatch_size": {
        "label": "Størrelse på variantvalg",
        "description": "Størrelse i piksler på variantvalgene på produktkortet."
    },
    "swatch_border_color": "Rammefarge på variantvalg",
    "swatch_border_width": {
        "label": "Ramme rundt variantvalg",
        "description": "Tykkelse på rammen rundt hvert variantvalg. Velg «Ingen ramme» for å skru den av.",
        "none": "Ingen ramme",
        "thin": "Tynn (1px)",
        "medium": "Medium (2px)",
        "thick": "Bred (3px)"
    },
    "swatch_placement": {
        "label": "Plassering på kortet",
        "description": "Hvor variantvalgene vises på produktkortet: under eller over tittelen, eller som et felt nederst på kortbildet. Endringen vises etter at siden er lastet på nytt.",
        "below": "Under tittelen",
        "above": "Over tittelen",
        "image": "Nederst på bildet"
    },
    "swatch_radius": {
        "label": "Form på variantvalg",
        "description": "Formen på fargeprøver, miniatyrer og tekstknapper på produktkortene.",
        "theme": "Følg temaets hjørner",
        "rounded": "Avrundet",
        "circle": "Sirkel"
    },
    "swatch_unavailable": {
        "label": "Utsolgte verdier på kort",
        "description": "Hvordan utsolgte verdier vises på produktkortene. Endringen vises etter at siden er lastet på nytt.",
        "strikethrough": "Vis med strek",
        "hide": "Skjul",
        "plain": "Vis vanlig"
    },
    "content_full_width": "Fullbredde",
    "theme_editor_image_edited_successfully": "Bilde redigert. Endringene blir synlige når du lagrer",
    "apply_overlay_to_all_images": "Bruk stil på alle",
    "apply_style_to_all_images_tooltip": "Kopier farger, størrelser, plassering og knappestil til alle bilder i blokken. Tittel, tekst, knappetekst og knappelenker beholdes per bilde.",
    "confirm_apply_style_to_all_images": "Dette kopierer stilen (farger, størrelser, plassering, knappestil) til alle andre bilder i blokken. Tittel, tekst, knappetekst og knappelenker beholdes per bilde. Vil du fortsette?",
    "theme_editor_overlay_applied_to_all": "Stilen ble brukt på alle bilder. Endringene blir synlige når du lagrer",
    "hide_all_menu_items": "Skjul alle menypunkter",
    "show_all_menu_items": "Vis alle menypunkter",
    "add_menu_item_child_tooltip": "Legg til underpunkt",
    "edit_menu_item_tooltip": "Rediger menypunkt",
    "delete_menu_item_tooltip": "Slett menypunkt",
    "disable_menu_item_tooltip": "Skjul menypunkt i butikken",
    "enable_menu_item_tooltip": "Vis menypunkt i butikken",
    "menu_depth_exceeds_three_levels_exception_message": "Meny dybde kan ikke overstige tre nivåer",
    "stock_notifications": "Lagervarslinger",
    "stock_notification": "Lagervarsling",
    "stock_notification_description_label": "Beskrivelse",
    "stock_notification_button_text": "Knapp-tekst",
    "stock_notification_description": "Vanskelig å vite hvilken produkter du skal bestille? La kundene registrere seg for varslinger når et utsolgt produkt er tilbake på lager.",
    "stock_notification_delete_confirmation": "Lagervarslingen er slettet",
    "count_of_recipients": "Antall mottakere",
    "variant_options": "Variant",
    "send_notifications": "Send varslinger",
    "stock_notification_email_greeting": "Hei 👋!",
    "stock_notification_email_message": "God nyhet! Produktet du har vist interesse for – %s – er nå tilbake på lager. 🎉 Vær rask! Det er stor etterspørsel, og vi kan ikke garantere hvor lenge det vil være tilgjengelig.",
    "stock_notification_button": "Gå til produktet",
    "stock_notification_email_farewell": "Hvis du har noen spørsmål, svar på denne e-posten eller kontakt oss på",
    "allow_stock_notifications": "Tillat lagervarslinger",
    "allow_users_to_sign_up_for_notification_when_product_comes_back_in_stock": "Tillat brukere å melde seg på varslinger når produktet kommer tilbake på lager. Dette vil legge til et skjema på produktsiden som lar brukere melde seg på.",
    "stock_notification_already_subscribed": "Du vil motta en e-post når produktet er tilbake på lager",
    "stock_notification_subscription_success": "Du vil motta en e-post når produktet er tilbake på lager",
    "stock_notification_back_in_stock": "Tilbake på lager",
    "stock_notification_success_sent": "Varslinger sendt",
    "stock_notification_error_sent": "Noe gikk galt under sending av varslinger. Kontakt support.",
    "stock_notification_view_subscribers": "Se påmeldte",
    "stock_notification_subscribers_title": "Påmeldte – {product}",
    "stock_notification_back_to_report": "Tilbake til lagervarslinger",
    "stock_notification_variant_buyable": "Kan kjøpes nå",
    "stock_notification_variant_sold_out": "Kan ikke kjøpes ennå",
    "stock_notification_waiting_count": "{count} venter på varsel",
    "stock_notification_open_product": "Åpne produktet",
    "stock_notification_subscriber_email": "E-post",
    "stock_notification_subscriber_customer": "Kunde",
    "stock_notification_subscriber_phone": "Telefon",
    "stock_notification_subscribed_at": "Påmeldt",
    "stock_notification_view_customer": "Se kunden",
    "stock_notification_guest": "Gjest",
    "stock_notification_no_subscribers": "Ingen venter på varsel for denne varianten akkurat nå.",
    "stock_notification_send_confirm_title": "Sende varslinger nå?",
    "stock_notification_send_confirm_text": "Alle på lista ({count}) får en e-post om at varen er tilbake på lager. Utsendingen kan ikke angres.",
    "stock_notification_send_disabled_hint": "Fjern markeringen for å sende til alle som venter.",
    "stock_notification_remove_subscribers": "Fjern fra lista",
    "stock_notification_remove_subscribers_description": "Uten å sende e-post",
    "stock_notification_remove_confirm_title": "Fjerne {count} fra lista?",
    "stock_notification_remove_confirm_text": "De får ingen e-post om at varen er tilbake på lager. Påmeldingen kan ikke gjenopprettes.",
    "stock_notification_subscribers_removed": "Fjernet fra lista",
    "new_product": "Nytt produkt",
    "create_new": "Opprett ny",
    "copy": "Kopier",
    "copy_this_product": "Kopier dette produktet",
    "copy_product": "Kopier produkt",
    "product_copy": {
        "title": "Kopier produkt",
        "description": "Kopier produktet til et helt nytt produkt, og rediger det nye produktet med samme egenskaper som det eksisterende produktet",
        "copyable_lead_paragraph": "Ingress",
        "copyable_descriptions": "Produktbeskrivelse/faner",
        "copyable_categories": "Kategorier",
        "copyable_variants": "Varianter og alternativer",
        "copyable_attributes": "Attributter",
        "copyable_price": "Priser",
        "copyable_offers": "Tilbudspriser",
        "copyable_images": "Bilder",
        "copyable_tags": "Tags",
        "copyable_stock": "Varelager",
        "copyable_stock_notifications": "Lagervarsling",
        "copyable_shipping": "Frakt",
        "copyable_google_product_category": "Google produktklassifikasjon",
        "copyable_meta_title_and_description": "Søkemotoroptimalisering",
        "offers_disabled": "Pris må være huket av for at tilbudsprisene skal kunne kopieres"
    },
    "product_copy_exception_message": "Kopiering av produktet mislyktes",
    "product_copy_success_message": "Produktet ble kopiert",
    "nothing_is_broken_but_i_have_some_feedback": "Alt fungerer, men jeg har noen tilbakemeldinger",
    "something_is_not_working": "Noe fungerer ikke",
    "product-box-image-object-fit": "Passform produktbilder",
    "contain": "Begrens",
    "cover": "Dekk",
    "product-box-image-aspect-ratio": "Produktbildeformat",
    "product_box_image_fit_title": "Hvordan vises produktbildet?",
    "product_box_image_fit_description": "Velg om hele bildet skal være synlig, eller om bildet skal fylle hele rammen (og eventuelt beskjæres).",
    "product_box_image_fit_contain": "Vis hele bildet",
    "product_box_image_fit_cover": "Fyll hele rammen",
    "product_box_image_shape_title": "Form på produktbildet",
    "product_box_image_shape_description": "Bestemmer formen på bildeområdet i produktkortet. Velg det som passer best til produktbildene dine.",
    "product_box_aspect_square": "Kvadrat (1:1)",
    "product_box_aspect_landscape": "Liggende (4:3)",
    "product_box_aspect_landscape_wide": "Bredt liggende (3:2)",
    "product_box_aspect_widescreen": "Widescreen (16:9)",
    "product_box_aspect_portrait": "Stående (3:4)",
    "product_box_aspect_portrait_tall": "Høyt stående (9:16)",
    "title_of_list": "Tittel på liste",
    "you_also_need_this": "Dette trenger du også",
    "related_products_placement_moved_description": "Plasseringen av relaterte produkter konfigureres nå i produktsidens designredigerer.",
    "related_products_placement_moved_description_short": "Plassering settes per mal i designbyggeren, på produktsiden.",
    "related_products_placement_moved_cta": "Åpne designredigerer",
    "grid": "Rutenett",
    "slider": "Slider",
    "drag_between_zones_hint": "Dra mellom høyre kolonne og full bredde",
    "both_ways": "Begge veier",
    "product_connections": "Tilknyttede produkter",
    "product_connections_description": "<p>Tilknyttede produkter lar deg vise en skreddersydd liste med varer på produktsiden.</p><br><ul><li><strong>Tittel:</strong> Du bestemmer hva listen skal hete, for eksempel “Du trenger også disse”.</li><li><strong>Plassering:</strong> Velg hvor på produktsiden listen skal vises.</li><li><strong>Produkter:</strong> Hvilke produkter som skal vises i listen. Du kan dra og slippe for å sette rekkefølge.</li></ul>",
    "product_connections_reciprocal_description": "<p>Huk av “Begge veier” dersom du vil at det valgte produktet automatisk knyttes til dette produktet.</p><br><p>Hvis det valgte produktet ikke har noen liste fra før, opprettes den med samme tittel og plassering som dette produktet sin.</p>",
    "no_products_connected": "Ingen produkter tilknyttet",
    "connection_list_max_listings_exceeded": "Du kan maksimalt koble til :max produkter. Fjern noen for å kunne lagre.",
    "connection_list_limit_reached": "Grensen på {max} tilknyttede produkter er nådd. Fjern noen for å legge til flere.",
    "connection_list_title_required": "Listen må ha en tittel før du kan lagre de tilknyttede produktene.",
    "connection_list_title_too_short": "Tittelen på listen må være minst :min tegn.",
    "connection_list_title_required_hint": "Tittelen vises over listen på produktsiden, og må fylles ut når du har lagt til produkter.",
    "listing_picker_remaining_slots": "Du kan velge {count} til",
    "listing_picker_limit_reached": "Du kan ikke velge flere. Fjern noen fra listen for å legge til flere.",
    "connection_list_remove_reciprocal_modal": {
        "title": "Bekreft fjerning",
        "description": "<strong>«{reciprocalProductName}»</strong> er for øyeblikket gjensidig tilknyttet <strong>«{currentProductName}»</strong>.<br><br>Ønsker du:<ul class='list-disc pl-3'> <li>Bare fjerne «{reciprocalProductName}» fra denne listen</li><li>Eller også fjerne «{currentProductName}» fra «{reciprocalProductName}» sin tilknytningsliste?</li></ul>",
        "remove_single": "Fjern fra denne listen",
        "remove_both": "Fjern fra begge lister"
    },
    "add_filter": "Legg til filter",
    "connect_to_a_product": "Knytt til et produkt",
    "connect_to_a_product_action_description": "Knytt de valgte produktene til et annet produkt",
    "product_connection_action_modal": {
        "connecting_x_amount_to_product_y": "Tilknytter {n} produkt til produktet {productName} | Tilknytter {n} produkter til produktet {productName}",
        "existing_connection_list": "Vi fant allerede en liste med tilknyttede produkter på {productName}. <br> De produktene du har markert, vil bli lagt til denne listen. <br> Hvis du ønsker å endre tittelen og plasseringen til denne listen, kan du gjøre det over. <br> Merk: vi har allerede forhåndsutfylt tittel og plasseringen med de verdiene som er i den eksisterende listen."
    },
    "products_were_connected": "Produktene ble tilknyttet!",
    "product_bulk_connection_catch_all_exception_message": "Noe gikk galt under tilknytning av produkter",
    "product_bulk_connection_too_few_products_exception_message": "Du må velge minst to produkter å tilknytte",
    "connect_products_to_each_other": "Tilknytt hverandre",
    "connect_many_to_many_action_description": "Knytt de valgte produktene til hverandre, slik at de vises i hverandres lister med tilknyttede produkter",
    "overwrite_product_list_data": {
        "label": "Overskriv eventuell allerede eksisterende listers tittel og plassering",
        "description": "Når denne er aktivert, vil tittel og plassering på alle allerede opprettede tilknyttede produktlister bli overskrevet med de nye verdiene du angir. Hvis en eller flere av produktene ikke har en liste, vil de få opprettet en ny liste med de verdiene du angir."
    },
    "product_connections_app_description": "Lag tilpassede lister med produkter – bestem tittel og plassering, velg én- eller toveis-koblinger for automatisk speiling, og vis dem direkte på produktsiden",
    "report_a_bug": "Rapporter en feil",
    "send": "Send",
    "required": "påkrevd",
    "describe_the_bug": "Beskriv feilen",
    "give_feedback": "Gi tilbakemelding",
    "your_feedback": "Din tilbakemelding",
    "add_a_screenshot": "Legg til skjermbilde",
    "remove_screenshot": "Fjern skjermbilde",
    "google_analytics_disabled": "Google Analytics er ikke aktivert",
    "location": "Lagerplassering",
    "hide": "Skjul",
    "search_for_products": "Søk etter produkter",
    "search_query": "Søkeord",
    "question": "Spørsmål",
    "answer": "Svar",
    "faq": "FAQ",
    "faqs": "FAQer",
    "add_faq": "Legg til FAQ",
    "edit_faq": "Rediger FAQ",
    "delete_faq": "Slett FAQ",
    "are_you_sure_delete_faq": "Er du sikker på at du vil slette FAQ?",
    "faq_answer_layout": "Visning av svar",
    "faq_answer_layout_description": "«Skuff fra høyre» åpner svaret i et panel som glir inn fra siden i stedet for under spørsmålet.",
    "faq_answer_layout_accordion": "Under spørsmålet",
    "faq_answer_layout_drawer": "Skuff fra høyre",
    "faq_is_full_width_description": "Bestemmer om fargeflaten skal strekke seg over hele skjermbredden eller ligge som en boks innenfor innholdsbredden fra temainnstillingene.",
    "faq_content_width": "Innholdsbredde",
    "faq_vertical_padding": "Avstand over og under",
    "faq_question_size": "Skriftstørrelse spørsmål",
    "faq_question_weight": "Teksttykkelse spørsmål",
    "faq_answer_size": "Skriftstørrelse svar",
    "option_button_background_color": "Bakgrunnsfarge knapper",
    "option_button_text_color": "Tekstfarge knapper",
    "option_button_colors_description": "Gjelder uvalgte knapper. Den valgte knappen følger temaets farger for handlingsknapper.",
    "accordion_initial_state": "Faner som starter åpne",
    "accordion_initial_state_first": "Kun første",
    "accordion_initial_state_all": "Alle",
    "accordion_initial_state_none": "Ingen",
    "accordion_icon_style": "Ikon",
    "accordion_icon_style_plus_minus": "Pluss og minus",
    "accordion_icon_style_chevron": "Pil opp/ned",
    "faq_description": "Vis en FAQ-side på forsiden av nettbutikken",
    "faq_answer_created": "Svar opprettet",
    "faq_answer_deleted": "Svar slettet",
    "faq_app_description": "FAQ-sider lar deg gi svar på vanlige spørsmål, noe som kan redusere antall henvendelser til kundeservice.",
    "faq_why_use_description": "Faq-sider.",
    "faq_description_first": "FAQ-sider kan redusere antall henvendelser til kundeservice ved å gi klare og tilgjengelige svar på vanlige spørsmål.",
    "faq_description_second": "FAQ-sider kan vises på forsiden av nettbutikken, samt legges til som menypunkter i menyene rundt omkring i nettbutikken.",
    "faq_is_now_installed": "FAQ er nå aktivert og klar til bruk!",
    "click_here_to_begin": "Trykk her for å begynne",
    "original_order_total": "Opprinnelig ordrebeløp",
    "view_order_(sincos)": "Se ordre hos betalingsleverandør (sincos)",
    "preposition_from": "fra",
    "preposition_of": "av",
    "quantity_will_be_restocked": "{quantity} produkt(er) vil bli lagt tilbake på lager",
    "sort_products_by": "Vis produktene i denne rekkefølgen",
    "latest_first": "nyeste først",
    "oldest_first": "eldste først",
    "category_order": "kategoriens rekkefølge",
    "lowest_price_first": "laveste pris først",
    "highest_price_first": "høyeste pris først",
    "alphabetical_a_to_z": "alfabetisk (A–Å)",
    "shuffle_products": "Vis i tilfeldig rekkefølge",
    "shuffle_products_description": "Produktene stokkes på nytt ved hvert besøk. Sorteringen bestemmer hvilke produkter som vises.",
    "show_out_of_stock": "Inkluder produkter som er utsolgt",
    "otherwise_show_products_in_stock_or_not_tracking_stock_or_that_allow_backorder": "Ellers vises kun produkter som er på lager, som ikke sporer lagerbeholdning, eller som tillater bestilling på restordre",
    "are_you_sure_you_want_to_publish_{count}_products": "Er du sikker på at du vil publisere {count} produkt og gjøre det synlig i butikken? | Er du sikker på at du vil publisere {count} produkter og gjøre dem synlige i butikken?",
    "are_you_sure_you_want_to_unpublish_{count}_products": "Er du sikker på at du vil avpublisere {count} produkt og gjøre det usynlig i butikken? | Er du sikker på at du vil avpublisere {count} produkter og gjøre dem usynlige i butikken?",
    "cost_per_unit": "Innkjøpspris eks. MVA",
    "remove_selection": "Fjern valgte",
    "export_fulfilled_orders": "Eksporter effektuerte ordrer (CSV)",
    "export_fulfilled_order_lines": "Eksporter effektuerte ordrelinjer (CSV)",
    "export_products": "Eksporter produkter",
    "export_products_action_description": "Eksporter produkter og varianter i CSV-format",
    "recheck_hs_codes": "Kontroller HS-koder",
    "recheck_hs_codes_action_description": "Sammenlign lagrede HS-koder for de valgte produktene med et nytt AI-forslag",
    "export_unfulfilled_orders": "Eksporter ueffektuerte ordrer (CSV)",
    "export_unfulfilled_order_lines": "Eksporter ueffektuerte ordrelinjer (CSV)",
    "item_:name_changed_:changes": "På linje \":name\" ble :changes",
    "unit_price_from_:old_to_:new": "enhetspris ble endret fra :old til :new",
    "order_total_changed_from_:old_to_:new.": "Total ordresum ble endret fra :old til :new.",
    "shipping_was_cancelled": "fraktprisen ble kansellert",
    ":count_items_were_cancelled_:items": ":count vare(r) ble kansellert, (:items).",
    ":count_items_were_cancelled_including_shipping_:items": ":count varer(s) ble kanselert (:items), i tillegg til fraktprisen.",
    ":count_items_were_cancelled_returning_stock_:items": ":count vare(r) ble kansellert (:items), og varelageret på disse varene ble tilbakestilt.",
    ":count_items_were_cancelled_including_shipping_returning_stock_:items": ":count vare(r) ble kansellert (:items), varelageret tilbakestilt, fraktprisen ble også kansellert.",
    "order_was_placed_by_:name_totaling_:total": "Bestillingen ble gjennomført av :name, med en totalsum på :total",
    "canceling_a_total_of_:sum": "Totalt ble :sum kansellert",
    "_was_changed_from_:from_to_:to": " ble endret fra :from til :to",
    "shipped_with": "sendt med",
    "the_customer_was_notified": "kunden ble varslet",
    "fulfillment_:fulfillmentId_was_made": "Forsendelse :fulfillmentId ble opprettet",
    "refund_:refundId_was_made": "Kreditering :refundId ble opprettet",
    "fulfillment_was_made": "Forsendelse ble utført",
    "order_was_placed": "Ordre ble opprettet",
    "order_recipient_was_updated": "Ordremottaker ble oppdatert",
    "customer_requested_cancellation": "Kunden ba om kansellering",
    "customer_requested_credit_or_return": "Kunden ba om kreditering / retur",
    "customer_:email_submitted_request_from_mypage": "Kunde :email sendte forespørselen fra «Min side».",
    "customer_cancellation_request_subject": "Forespørsel om kansellering registrert",
    "customer_credit_request_subject": "Forespørsel om kreditering registrert",
    "merchant_cancellation_request_subject": "Kunde har bedt om kansellering — bestilling #:orderId",
    "merchant_credit_request_subject": "Kunde har bedt om kreditering — bestilling #:orderId",
    "customer_cancellation_request_body": "Hei! Din forespørsel om kansellering er nå registrert og vil bli behandlet så snart som mulig. En bekreftelse på registreringen er sendt til din e-postadresse.",
    "customer_credit_request_body": "Vi har registrert ditt ønske om å returnere ett eller flere produkter.\n\nDu har mottatt en e-post med informasjon om hvordan du returnerer varene. I samme e-post finner du også angrerettskjemaet, som må fylles ut og legges ved de returnerte varene.\n\nVi anbefaler at du leser våre salgsbetingelser og returvilkår før du sender varene i retur.",
    "read_our_terms_and_return_policy": "Les våre salgsbetingelser og returvilkår",
    "merchant_cancellation_request_body": "Kunde :customerName (:customerEmail) har bedt om kansellering av bestilling #:orderId via «Min side». Vennligst behandle forespørselen i administrasjonsgrensesnittet.",
    "merchant_credit_request_body": "Kunde :customerName (:customerEmail) har bedt om kreditering / retur av bestilling #:orderId via «Min side». Bestillingen er sendt — vent på retur før kreditering.",
    "hi": "Hei",
    "item": "Vare",
    "requested_items": "Forespurte varer",
    "contact_us_at": "Har du spørsmål? Kontakt oss på",
    "unknown_order_item": "Ukjent ordrelinje.",
    "item_already_fully_requested": "Alle eksemplarer av «:title» er allerede forespurt.",
    "item_quantity_exceeds_remaining": "Du kan maksimalt be om :remaining av «:title».",
    "please_select_at_least_one_item": "Du må velge minst én vare for å sende forespørselen.",
    "order_items_were_cancelled": "Ordrelinjer ble kansellert",
    "order_items_were_updated": "Ordrelinjer ble endret",
    "orders_with_customer_details": "Ordrer med kundeopplysninger",
    "order_lines": "Ordrelinjer",
    "items_were_restocked": "varene ble lagt tilbake på lager",
    "refund_was_made": "Kreditering ble opprettet",
    "gift_certificate_payment_refunded": "Gavekortbeløp tilbakeført",
    "gift_certificate_payment_refunded_:amount_to_:code": ":amount tilbakeført til gavekort :code",
    "gift_certificate_coverage_released": "Gavekort tilbakeført",
    "gift_certificate_coverage_released_:amount_to_:code": ":amount tilbakeført til gavekort :code",
    "reason": "Årsak",
    "shipping_price_was_updated": "Fraktprisen ble oppdatert",
    "pickup_point_was_updated": "Hentested oppdatert",
    "pickup_point_was_set_to_:point": "Hentested satt til :point",
    "pickup_point_was_auto_assigned": "Hentested tildelt automatisk",
    "pickup_point_was_auto_assigned_to_:point": "Nærmeste hentested ble tildelt automatisk: :point",
    "shipping_price_was_updated_from_:old_to_:new": "Fraktprisen ble endret fra :old til :new",
    ":name(:email)_wrote": ":name (:email) skrev kommentar:",
    "comment_was_added": "Kommentar ble lagt til",
    "changes_made": "Endringer gjort: ",
    "quantity_from_:old_to_:new": "Antall ble endret fra :old til :new",
    "select_country": "Select country",
    "no_access_to_this_page": "You do not have access to this page",
    "customer.edit": "Rediger kundekonto",
    "customer.accountNumber": "Kundekontonummer",
    "customer.account": "Kundekonto",
    "customer.billing.first_name": "Fornavn",
    "customer.billing.last_name": "Etternavn",
    "customer.billing.company": "Firma",
    "customer.billing.street": "Gateadresse",
    "customer.billing.postal_code": "Postnummer",
    "customer.billing.city": "Poststed",
    "customer.billing.country": "Land",
    "customer.billing.email": "E-postadresse",
    "customer.billing.phone_number": "Telefon",
    "customer.billing.company_name": "Firmanavn",
    "customer.billing.organization_number": "Organisasjonsnummer",
    "customer.billing.company_project": "Prosjekt",
    "customer.billing.company_department": "Avdeling",
    "customer.shipping.first_name": "Fornavn",
    "customer.shipping.last_name": "Etternavn",
    "customer.shipping.company": "Firma",
    "customer.shipping.street": "Gateadresse",
    "customer.shipping.postal_code": "Postnummer",
    "customer.shipping.city": "Poststed",
    "customer.shipping.country": "Land",
    "customer.shipping.email": "E-postadresse",
    "customer.shipping.phone_number": "Telefon",
    "customer.shipping.company_name": "Firmanavn",
    "customer.shipping.organization_number": "Organisasjonsnummer",
    "customer.shipping.company_project": "Prosjekt",
    "customer.shipping.company_department": "Avdeling",
    "customer.customers_active_address": "Kundens aktive adresse",
    "customer.is_the_customer_a_business": "Er kunden en bedrift?",
    "customer.uses_shipping_address": "Benytter kunden egen fraktadresse?",
    "customer.shipping_address": "Fraktadresse",
    "customer.customer_type": "Kundetype",
    "customer.number": "Kundenummer",
    "customer.customer_created": "Kunden ble opprettet",
    "customer.customer_updated": "Kunden ble oppdatert",
    "customer.customer_deleted": "Kunden ble slettet",
    "customer.are_you_sure_you_want_to_delete_this_customer": "Er du sikker på at du ønsker å slette denne kundekontoen?",
    "customer.select_country": "Velg land",
    "customer.impersonate_customer_tooltip": "Ved å klikker her vil du bli logget inn i butikken som denne kunden, du vil se butikken slik de gjør.",
    "admin_login_failed": "Innlogging mislyktes",
    "admin_password_reset_link_sent": "Passord reset e-post sendt, sjekk inboksen din.",
    "admin_password_reset_link_failed": "Passord reset e-post kunne ikke sendes. Dette er vanligvis fordi du har forsøkt flere ganger på kort tid, Vennligst prøv igjen om noen minutter.",
    "admin_password_reset_success": "Ditt passord ble oppdatert, du kan nå logge inn med nytt passord.",
    "admin_password_reset_failed": "Dit passord kunne ikke endres, dette er vanligvis fordi du har forsøkt flere ganger på kort tid, Vennligst prøv igjen om noen minutter.",
    "reset_your_password": "Endre passordet ditt",
    "you_recently_requested_to_reset_your_account_password": "Du har nylig bedt om å få endret passordet ditt",
    "if_you_ignore_this_message_your_password_will_not_be_changed": "Dersom du ingorerer denne meldingem, vil passordet ikke endres.",
    "click_here_to_reset_your_password": "Klikk her for å tilbakestille passordet ditt",
    "if_you_didnt_request_a_password_reset": "Om du ikke har bedt om å få tilbakestilt passordet, ",
    "please_contact_us": "vennligst gi oss beskjed",
    "please_verify_your_email": "Vennlist bekreft e-posten din",
    "verify_email_address": "Bekreft e-postadresse",
    "welcome_to_our_store": "Velkommen til :storeName 👋",
    "youve_created_an_account_in_our_store": "Du har opprettet en konto i butikken vår. ",
    "verification_email_info_text": "Siste steg før du kan benyttet kontoen din, er å bekrefte e-postadressen din.",
    "password_reset_mail": "Tilbakestill passord",
    "note_about_passwords": "Opplysning om passord.",
    "when_you_have_created_the_customer_on_behalf_of_the_user_they_must_select_their_own_password_using_the_lost_password_functionality": "Når du har opprettet kontoen for kunden, må kunden selv velge sitt eget passord før kontoen kan brukes, dette gjør de ved å benytte seg av glemt passord funksjonen.",
    "you_recently_requested_to_reset_your_storename_account_password": "Noen har nylig etterspurt en reset av passord på kontoen din hos :storeName, dersom dette ikke var deg, kan du se bort fra denne e-posten.",
    "this_will_be_the_customers_default_address_when_creating_new_orders": "Dette blir standard-addressen når brukeren gjør nye kjøp i butikken",
    "it_will_not_change_the_address_on_existing_orders": "Adressen på eksisterende ordre vil ikke endres",
    "customer_has_no_account": "Kunden har ingen konto",
    "a_customer_account_with_this_email_address_already_exists": "En kundekonto med denne e-postadressen finnes allerede",
    "account_details": "Kontoopplysninger",
    "order_history": "Ordrehistorikk",
    "key_figures": "Nøkkeltall",
    "no": "nei",
    "yes": "ja",
    "has_created_account": "har opprettet konto",
    "has_account": "Har konto",
    "click_here_to_show_orders": "Klikk her for å vise ordrene",
    "has_the_customer_registered_for_an_account_in_the_store_or_have_they_just_completed_a_purchase_without_doing_so": "Har kunden registrert en konto i butikken, eller har hen bare gjennomført et kjøp uten å gjøre det?",
    "Billing-/_Shipping_address": "Faktura-/ Leveringsadresse",
    "first_order_placed": "Første ordre plassert",
    "last_order_placed": "Siste ordre plassert",
    "total_income": "Total inntekt",
    "total_ordered": "Total bestilt",
    "total_cancelled": "Total kansellert",
    "total_refunded": "Total kreditert",
    "if_multiple_names_appear_here_that_means_that_the_same_customer_(identified_via_email)_has_ordered_with_multiple_names": "Dersom flere navn dukker opp i denne lista, så betyr det at den samme kunden (identifisert med den samme e-postadressen), har handlet under flere forskjellige navn.",
    "key_figures_income_tooltip": "Inntekten som kommer fra denne kunden, etter at kanselleringer og krediteringer er trukket fra.",
    "key_figures_ordered_tooltip": "Summen som denne kunden har bestilt fra butikken, men her er ikke krediteringer og kanselleringer trukket fra.",
    "no_acces_to_this_page": "Du har ikke tilgang til denne siden",
    "vipps_login_no_user_found": "Det ser ikke ut til at du har en bruker fra tidligere, vennligst registrer deg.",
    "vipps_login": "Vipps login",
    "vipps_login_description": "Glem brukernavn og passord, Vipps login lar brukerene i butikken din enkelt logge seg inn med Vipps kontoen sin. Med over 11 millioner brukere i norden blir det enklere for mange!",
    "vipps_login_does_it_cost_anything": "Koster dette noe?",
    "vipps_login_no_its_free": "Nei, denne funksjonen er gratis, denne funksjonen er i utgangspunktet ikke gratis i Vipps, men gjennom 24Nettbutikk's samarbeid med vipps får du denne uten ekstra kostnad. :)",
    "vipps_login_does_it_require_the_store_to_have_vipps_as_a_payment_method": "Kreves det at Nettbutikken benytter Vipps som betalingsmetode for å bruke Vipps login?",
    "company_type": "Firmatype",
    "company_product_category": "Produktkategori",
    "desired_domain": "Ønsket domene",
    "billing_interval": "Betalingsintervall",
    "bought_by": "Kjøpt av",
    "not_shipped": "Ikke sendt",
    "date_bought": "Kjøpt",
    "customer_number": "Kundenr.",
    "name/company": "Navn/firma",
    "date_shipped": "Dato sendt",
    "stock_notification_landing_header_text": "Lagervarsling – vinn tilbake kundene når varen er tilbake",
    "stock_notification_subheading": "Utsolgte produkter trenger ikke bety tapte salg. Med Lagervarsling kan kundene dine enkelt melde seg på en liste og bli varslet så snart varen er tilbake på lager.",
    "stock_notification_how_it_works_1": "<strong>Enkel påmelding</strong> – kundene registrerer seg direkte på produktsiden om varen er utsolgt.",
    "stock_notification_how_it_works_2": "Lagervarslingen aktiveres også om du selger flere varianter av produktet. For eksempel vil lagervarslingen dukke opp om kunden velger en størrelse du er utsolgt for.",
    "stock_notification_how_it_works_3": "<strong>Full kontroll</strong> – du velger selv hvilke produkter som skal ha lagervarslingsfunksjon.",
    "stock_notification_how_it_works_4": "<strong>Oversikt i admin-panelet</strong> – se hvem som venter på varene, og hvor stor interessen er.",
    "stock_notification_how_it_works_5": "<strong>Velg hvem du skal varsle</strong> – send e-post til alle på listen, eller kun til utvalgte kunder.",
    "stock_notification_question_1": "Finnes det noen rapport som viser hvem og hvor mange som har registrert seg for varslinger?",
    "stock_notification_answer_1": "Ja, under \"Rapporter\" så \"Lagervarslinger\" finner du en rapport som viser alle registrerte brukere, og hvor mange som har registrert seg for varslinger på hvert produkt.",
    "mailmojo_connection_success": "Mailmojo-kontoen din er nå koblet til nettbutikken!",
    "mailmojo_connection_failed": "Kunne ikke koble til Mailmojo-kontoen din. Vennligst prøv igjen, eller kontakt support hvis problemet vedvarer.",
    "mailmojo_configure_settings_label": "Trykk her for å koble nettbutikken din til Mailmojo-konto.",
    "mailmojo_configure_settings_button": "Koble til Mailmojo",
    "mailmojo": "Mailmojo",
    "mailmojo_description": "Med Mailmojo kan du enkelt sende ut nyhetsbrev og e-postkampanjer til kundene dine.",
    "mailmojo_landing_header_text": "Mailmojo – enkelt nyhetsbrev rett fra nettbutikken din Vil du holde kontakten med kundene dine, bygge lojalitet og selge mer? Med Mailmojo kan du sende profesjonelle nyhetsbrev direkte til kundene dine – integrert med nettbutikken din. Mailmojo er et norsk verktøy som gjør det lekende lett å lykkes med nyhetsbrev og SMS. Enten du vil gjøre alt selv eller få hjelp fra eksperter .",
    "mailmojo_why_choose": "Hvorfor velge Mailmojo?",
    "mailmojo_why_choose_1": "<strong>Enkelt å bruke</strong> – du trenger ingen teknisk kunnskap for å lage flotte nyhetsbrev.",
    "mailmojo_why_choose_2": "<strong>Moderne maler</strong> – tilpass designet slik at nyhetsbrevene passer din merkevare.",
    "mailmojo_why_choose_3": "<strong>Full innsikt</strong> – se hvem som åpner, klikker og kjøper, så du kan tilpasse innholdet ditt",
    "mailmojo_why_choose_4": "<strong>GDPR-tilpasset</strong> – bygget og driftet i Norge, med personvern og sikkerhet i fokus.",
    "mailmojo_why_choose_5": "<strong>Automatisk integrasjon</strong> – hent kundedata og e-postadresser rett fra nettbutikken din.",
    "mailmojo_advantages": "Fordeler for din nettbutikk",
    "mailmojo_advantage_1": "Som kunde hos 24Nettbutikk får du også rabatt hos Mailmojo",
    "mailmojo_advantage_2": "Hold kontakten med kundene dine og bygg lojale relasjoner.",
    "mailmojo_advantage_3": "Øk salget ved å markedsføre kampanjer, nyheter og tilbud direkte i innboksen.",
    "mailmojo_advantage_4": "Bruk innsikt og statistikk til å forbedre markedsføringen din over tid.",
    "mailmojo_punchline": "Med Mailmojo får du et kraftig, men enkelt verktøy for e-postmarkedsføring – på norsk, for norske nettbutikker.",
    "mailmojo_question_1": "Trenger jeg en egen konto hos Mailmojo for å bruke denne appen?",
    "mailmojo_answer_1": "Ja, men som 24nettbutikk kunde mottar du en 25% rabatt på alle årlige mailmojo abonnement!",
    "mailmojo_question_2": "Hvordan bruker jeg denne app-en?",
    "mailmojo_answer_2": "Åpne denne siden, og følg instruksene, om noe er uklart, ta gjerne kontakt med oss på support.",
    "as_a_customer_you_get_discounted_mailmojo": "Som kunde av 24Nettbutikk får du fast rabatt på 25% på alle årlige abonnement hos Mailmojo.",
    "mailmojo_feature_free_up_to_50_recipients": "Gratis inntil 50 aktive mottakere",
    "mailmojo_feature_unlimited_sends": "Ubegrenset antall e-post-utsendelser per måned.",
    "mailmojo_feature_servers_in_norway": "Dine data trygt lagret på servere i Norge.",
    "mailmojo_feature_top_delivery_quality": "Leveringskvalitet i toppklasse.",
    "mailmojo_feature_popups_and_signup_forms": "Popups og påmeldingsskjemaer.",
    "mailmojo_feature_design_templates": "30+ proffe designmaler inkludert.",
    "mailmojo_feature_flexible_automation": "Fleksibel automatisering av utsendelser.",
    "mailmojo_feature_norwegian_support": "Fri, norsk support på e-post og chat.",
    "mailmojo_feature_personal_advisor": "For deg med over 4 000 kontakter: Tett oppfølging og veiledning fra din egen rådgiver som vil hjelpe deg å lykkes med e-postmarkedsføring, til en verdi av 9 000 kroner.",
    "mailmojo_calculate_price_over_50": "Beregn prisen for deg med over 50 aktive mottakere",
    "mailmojo_whats_included": "Hva er inkludert?",
    "google_shopping": "Google Shopping",
    "google_shopping_description": "Legg produktene deres i Google Merchant Center, slik at de kan vises i Google Shopping. Dette er en enkel måte å øke synligheten og salget av produktene dine på.",
    "google_shopping_landing_header_text": "Denne appen tillater deg å koble nettbutikken din til Google Merchant Center, slik at du kan vise produktene dine i Google Shopping.",
    "google_shopping_question_1": "Trenger jeg å manuelt beskrive hvert produkt for å bruke Google Shopping?",
    "google_shopping_answer_1": "Ja, inne på hvert produkt så kan man sette opp en Google produktbeskrivelse, som vil bli brukt i Google Shopping. Dette er et krav fra Google.",
    "enable_the_google_shopping_feed_and_enable_google_taxonomy_data_on_products": "Aktiver Google Shopping-feeden på /google-shopping-feed, og legg til mulighet for Google produktklassifikasjon på produktene dine i admin",
    "new_contact_us_message": "Ny melding fra kontaktskjema",
    "name_of_the_sender": "Navn på avsender",
    "email_of_the_sender": "E-post til avsender",
    "message": "Melding",
    "contact_form": "Kontaktskjema",
    "select_shortcode": "Velg dynamisk innhold",
    "q_what_are_shortcodes": "Hva er dynamisk innhold?",
    "a_what_are_shortcodes": "dynamisk innhold (eller shortcodes på engelsk) er små koder du kan sette inn i tekstfelt for å vise dynamisk innhold eller spesielle funksjoner, som for eksempel skjemaer, produktkaruseller eller andre interaktive elementer. De gjør det enkelt å legge til avansert funksjonalitet uten å måtte skrive egen kode.",
    "shortcode_editor_disclaimer": "dynamisk innhold vil kun vises som en liten tekstsnutt i selve editoren, men vil bli omgjort til dynamisk innhold på selve siden.",
    "dynamic_content": "Dynamisk innhold",
    "insert_dynamic_content": "Sett inn dynamisk innhold",
    "create_form": "Opprett skjema",
    "forms": "Skjema",
    "this_is_only_a_simplified_preview_of_the_form_and_might_not_reflect_its_design_shape_or_colors_when_used": "Dette er en forenklet forhåndsvisning av feltene i skjemaet ditt, forhåndsvisningen trenger ikke matche med designet, fasongen eller fargene, når skjemaet faktisk vises i butikken din.",
    "back_to_appstore": "Tilbake til Apps",
    "back_to_app": "Tilbake til Appen",
    "form": "Skjema",
    "fields": "Felt",
    "add_field": "Legg til felt",
    "email_on_submit": "Send e-post hit ved innsending",
    "email_on_submit_description": "Alle innsendinger blir uansett lagret i nettbutikken, og kan sees fra disse sidene, men du kan om du ønsker får nettbutikken til å videresende henvendelsene til en e-postadresse.",
    "submit_button_text": "Tekst på knappen",
    "submission_thank_you_text": "Tekst som vises til brukeren etter innsending",
    "select_type": "Velg type",
    "select-multiple_form_description": "Velg en eller flere",
    "select-one_form_description": "Velg en",
    "text_form_description": "Kort tekst",
    "textarea_form_description": "Lengre tekst",
    "number_form_description": "Nummer",
    "boolean_form_description": "Ja/Nei",
    "email_form_description": "E-postadresse",
    "phone_form_description": "Telefonnummer",
    "date_form_description": "Dato",
    "datetime_form_description": "Tid og Dato",
    "half_width": "Halv bredde",
    "half_width_fields_pair_up": "To halv bredde-felt etter hverandre legger seg side ved side.",
    "help_text": "Hjelpetekst",
    "field": "Felt",
    "duplicate_field": "Dupliser felt",
    "shown_below_the_field": "Vises under feltet. Valgfri.",
    "remove_the_field": "Fjern feltet",
    "the_form_needs_a_title": "Skjemaet må ha en tittel før det kan lagres",
    "the_field_x_needs_options": "Feltet «{name}» må ha minst ett alternativ",
    "all_fields_need_a_label": "Alle felt må ha en etikett",
    "click_a_field_type_to_add_it_to_the_form": "Klikk på en felttype til venstre for å legge den til i skjemaet",
    "form_canvas_note": "Slik ser skjemaet ut for kunden — klikk på et felt for å redigere det",
    "add_option": "Legg til alternativ",
    "options": "Alternativer",
    "unique_id": "Unik id",
    "no_fields_in_form": "Skjemaet innholder ingen felt.",
    "edit_field": "Rediger felt",
    "edit_form": "Rediger skjema",
    "submissions": "Henvendelser",
    "submission": "Henvendelse",
    "is_this_field_required_for_the_user_to_be_able_to_submit_the_form": "Er dette feltet påkrevd for at brukeren skal kunne sende inn skjemaet?",
    "the_field_must_have_at_least_one_option": "Feltet \":field\" må ha minst ett alternativ",
    "view_form_submissions": "Se henvendelser via skjemaet",
    "delete_form_and_submissions": "Slett skjemaet, og alle dets henvendelser",
    "all_options_must_have_value_and_label": "Alle alternativer må ha både verdi og etikett",
    "please_add_at_least_one_option": "Vennligst legg til minst ett alternativ",
    "handled_by": "Håndteres av",
    "assigned_to_you": "Henvendelsen håndteres av deg.",
    "assign_submission": "Sett meg som håndtør av denne henvendelsen",
    "view_submission": "Se henvendelsen",
    "submission_unassigned": "Håndtør av henvendelsen tømt",
    "unassign_submission": "Fjern håndtør av henvendelsen",
    "latest_submission": "Siste henvendelse",
    "submission_inbox_count": "{count} henvendelse | {count} henvendelser",
    "submission_inbox_last_7_days": "{count} siste 7 dager",
    "submission_inbox_state_all": "Alle",
    "submission_inbox_state_unhandled": "Ikke tildelt",
    "submission_inbox_state_mine": "Mine",
    "submission_inbox_search_placeholder": "Søk i navn, e-post og tekst",
    "submission_inbox_sort_label": "Sortering",
    "submission_inbox_sort_newest": "Nyeste først",
    "submission_inbox_sort_oldest": "Eldste først",
    "submission_inbox_sort_unhandled_first": "Ikke tildelte først",
    "submission_inbox_sort_sender": "Avsender A–Å",
    "submission_inbox_show_more": "Vis flere ({count} til)",
    "submission_inbox_empty_title": "Ingen henvendelser ennå",
    "submission_inbox_no_matches": "Ingen henvendelser passer søket",
    "submission_inbox_reset_filters": "Nullstill søk og filter",
    "submission_inbox_select_prompt": "Velg en henvendelse i lista",
    "submission_inbox_anonymous": "Uten navn",
    "submission_inbox_you": "Deg",
    "submission_inbox_handled_by_you": "Du håndterer denne",
    "submission_inbox_handled_by": "Håndteres av {name}",
    "submission_inbox_take": "Ta saken",
    "submission_inbox_take_over": "Ta over",
    "submission_inbox_release": "Slipp saken",
    "submission_inbox_reply": "Svar på e-post",
    "submission_inbox_reply_subject": "Re: {form}",
    "submission_inbox_copy_email": "Kopier e-postadressen",
    "submission_inbox_copied": "Kopiert",
    "submission_inbox_received": "Mottatt {date}",
    "submission_inbox_date_at_time": "{date} kl. {time}",
    "submission_inbox_related": "Andre henvendelser fra samme avsender ({count})",
    "submission_inbox_state_unread": "Ulest",
    "submission_inbox_unread_count": "{count} ulest | {count} uleste",
    "submission_inbox_sort_unread_first": "Uleste først",
    "submission_inbox_mark_read": "Merk som lest",
    "submission_inbox_mark_unread": "Merk som ulest",
    "forms_inbox_all_caught_up": "Ingen uleste eller ubehandlede henvendelser",
    "forms_latest_submission": "Siste {time}",
    "forms_product_form_hint": "Fylles ut på produktsiden",
    "forms_inbox_show_all_forms": "Vis alle skjema",
    "forms_inbox_empty_text": "Når noen sender inn et skjema, dukker henvendelsen opp her.",
    "forms_card_more_actions": "Flere valg",
    "forms_delete_form": "Slett skjema",
    "forms_show_all": "Vis alle {count} skjema",
    "forms_show_fewer": "Vis færre",
    "submission_inbox_state_open": "Ubehandlet",
    "submission_inbox_state_done": "Behandlet",
    "submission_inbox_open_count": "{count} ubehandlet",
    "submission_inbox_complete": "Merk som ferdig",
    "submission_inbox_reopen": "Gjenåpne",
    "submission_inbox_completed_by": "Ferdigbehandlet av {name}",
    "submission_inbox_completed": "Ferdigbehandlet",
    "submission_inbox_done_short": "Ferdig",
    "submission_inbox_more_actions": "Flere valg",
    "submission_inbox_delete": "Slett henvendelse",
    "submission_inbox_delete_name": "henvendelsen fra {name}",
    "submission_inbox_select_all": "Velg alle {count}",
    "submission_inbox_select_row": "Velg henvendelsen fra {name}",
    "x_submissions_selected": "{count} henvendelse markert | {count} henvendelser markert",
    "bulk_group_status": "status",
    "bulk_group_handling": "tildeling",
    "submission_bulk_assign": "Ta sakene",
    "submission_bulk_unassign": "Fjern tildeling",
    "submission_bulk_delete": "Slett henvendelser",
    "submission_completed": "Henvendelsen er markert som ferdigbehandlet.",
    "submission_reopened": "Henvendelsen er åpnet igjen.",
    "submissions_updated": ":count henvendelse oppdatert|:count henvendelser oppdatert",
    "submissions_deleted": ":count henvendelse slettet|:count henvendelser slettet",
    "duplicate_option_values_are_not_allowed_within_the_same_input": "Alternativer kan ikke ha samme id eller etikett",
    "invalid_email": "Invalid email",
    "submission_created": "Henvendelse sendt!",
    "invalid_phone_number": "Ugyldig telefonnummer",
    "invalid_option": "Ugyldig alternativ",
    "options_are_only_supported_for_select_input_fields": "Alternativer støttes kun for valg-felt",
    "purchase_the_app_to_enable_more_forms": "Kjøp skjemabygger app-en for å bruke flere skjema",
    "purchase_the_form_builder_to_enable_this_feature": "Kjøp skjemabygger app-en for å bruke denne funksjonen",
    "if_you_purchase_the_form_builder_you_can_have_multiple_forms_and_edit_them": "Dersom du kjøper skjemabygger app-en kan butikken ha så mange skjema dere ønsker, og dere kan legge til akkurat de feltene dere ønsker",
    "did_you_know": "Visste du at",
    "read_more_here": "<a href=\"{url}\" target=\"_blank\">Les mer her</a>",
    "no_submissions_yet": "Ingen henvendelser enda",
    "form_builder_app_name": "Skjemabygger",
    "form_builder_app_short_description": "Samle enkelt inn informasjon fra kundene dine med kontaktskjemaer og produktskjemaer.",
    "form_builder_app_default_features": "Som standard kan du bruke et enkelt kontaktskjema for å motta meldinger og henvendelser direkte i admin-panelet, med valgfrie e-postvarsler.",
    "form_builder_app_upgrade_title": "Oppgrader for å låse opp avanserte funksjoner:",
    "form_builder_app_upgrade_features": "Lag ubegrenset antall tilpassede skjemaer for alle formål—kontakt, tilbakemelding, registrering, produktspesifikk informasjon og mer.",
    "form_builder_app_field_types": "Legg til ulike felttyper:",
    "form_builder_app_field_type_short_text": "Kort tekst",
    "form_builder_app_field_type_long_text": "Lang tekst",
    "form_builder_app_field_type_select_one": "Velg én",
    "form_builder_app_field_type_select_multiple": "Velg flere",
    "form_builder_app_field_type_email": "E-post",
    "form_builder_app_field_type_phone": "Telefon",
    "form_builder_app_field_type_number": "Nummer",
    "form_builder_app_field_type_boolean": "Ja/Nei (avkrysningsboks)",
    "form_builder_app_field_type_date": "Dato",
    "form_builder_app_field_type_datetime": "Tid og dato",
    "form_builder_app_customize_forms": "Tilpass hvert skjema etter dine forretningsbehov.",
    "form_builder_app_manage_submissions": "Se og administrer alle innsendelser i admin-panelet.",
    "form_builder_app_email_forwarding": "Send innsendelser til hvilken som helst e-postadresse du ønsker.",
    "form_builder_app_product_forms": "Knytt skjemaer til produkter for å samle inn tilpasset informasjon som graveringstekst, hilsener eller mål – lagret sammen med ordren.",
    "form_builder_app_cta": "Gi nettbutikken din fleksible skjemaer og sømløs datainnsamling. Oppgrader nå for å låse opp hele potensialet til skjemabyggeren!",
    "form_builder_app_pricing_info": "Skjemabyggeren er <strong>gratis</strong> for alle planer unntatt <strong>startup</strong>. Hvis du har Startup-planen, koster appen <strong>{price} pr. måned</strong>.",
    "plan": "Plan",
    "price_per_month": "Pris per måned",
    "upgrade_your_plan_to_get_app_and_other_apps_for_free": "Oppgrader planen din for å få {app} og andre apper gratis.",
    "pricing": "Priser",
    "can_i_use_forms_without_buying_the_app": "Kan jeg bruke skjemaer uten å kjøpe appen?",
    "yes_but_you_can_have_one_one_form_active_and_will_have_restricted_functionality": "Ja! Men du kan kun ha ett skjema aktivt, og vil ha begrenset funksjonalitet.",
    "select...": "Velg ...",
    "num.sold": "Ant. solgt",
    "hero_image_text": "Bilde med tekst",
    "hero_image_text_content_order": "Rekkefølge på innhold",
    "hero_image_text_content_order_description": "Bestem rekkefølgen på bilde og tekst i blokken",
    "hero_image_text_content_order_option_1": "Bilde / tekst",
    "hero_image_text_content_order_option_2": "Tekst / bilde",
    "updated": "Oppdatert",
    "select_form": "Velg skjema",
    "start_up": "StartUp",
    "premium": "Premium",
    "premium_pluss": "Premium Pluss",
    "subscriptions": "Abonnementer",
    "subscription": "Abonnement",
    "monthly": "Månedlig",
    "per_month": "Per måned",
    "popular": "Populær",
    "please_set_contact_email": "For å fortsette, må du legge inn en e-postadresse. Legg inn e-postadresse her, og prøv igjen.",
    "stripe": {
        "set_default_payment_method_tooltip": "Trykk her for å velge dette som standard betalingsmetode",
        "delete_payment_method_tooltip": "Slett betalingsmetode",
        "no_card_attached": "For å kjøpe noe må du legge inn et kort. Legg inn kortet deres her."
    },
    "no_stripe_customer_found": "Ingen kunde funnet. Kontakt support for å få hjelp med dette.",
    "error_occurred_updating_stripe_customer_source": "Vi fikk en feilmelding når vi prøvde å oppdatere betalingsmetoden din. Vennligst prøv igjen senere, eller kontakt support.",
    "cant_remove_the_last_card_please_register_another_first": "Kan ikke fjerne siste betalingskort, vennligst registrert et nytt først.",
    "customer_source_updated": "Kortet er nå oppdatert",
    "vipps_app_name": "Navnet du ønsker å vise i Vipps-appen",
    "days_left_of_your_trial": "Dager igjen av prøveperioden",
    "order_your_24estore": "Bestill din 24nettbutikk",
    "please_fill_the_fields_below": "Fyll ut feltene nedenfor",
    "company_information": "Bedriftsinformasjon",
    "select_your_company_from_the_list_below": "Velg ditt firma fra listen",
    "organization_number_does_not_appear_to_be_valid": "Organisasjonsnummeret du har oppgitt, ser ikke ut til å være gyldig",
    "help_us_find_your_company_information": "Hjelp oss hente opplysninger om ditt firma",
    "fields_marked_with_asterisk_required": "felt merket med stjerne er obligatoriske",
    "all_required_fields_are_filled": "All obligatoriske felt er fylt",
    "please_fill_all_required_fields": "Vennligst fyll ut alle nødvendige felt",
    "information_pre_filled": "Vi har forsøkt å forhåndsfylle disse feltene basert på det vi vet om dere. Disse opplysningen brukes når 24nettbutikk skal får kontakt med dere. Vennligst kontroller, og rett eventuelle feil.",
    "enter_your_contact_details": "Oppgi kontaktopplysninger",
    "lookup_by_organization_number": "Søk etter organisasjonsnummer",
    "lookup_by_company_name": "Søk etter firmanavn",
    "manual_entry": "Oppgi manuelt",
    "search_for_your_company_by_name": "Hjelp oss finne firmaet ditt",
    "company_search_help_text": "Du behøver ikke skrive inn hele firmanavnet, begynn med de første par bokstavene, deretter dukker en liste opp.",
    "enter_company_name": "Skriv firmanavn",
    "enter_9_digit_organization_number_for_automatic_lookup": "Oppgi ditt organisasjonsnummer (9 siffer) for automatisk innhenting av opplysninger",
    "organization_number_must_be_9_digits": "Organisasjonsnummer må bestå av 9 siffer",
    "enter_organization_number": "Skriv organisasjonsnummer",
    "organization_number_help_text": "Organisasjonunmmeret som representerer din bedrift i brønnøysundregisteret, består alltid av 9 siffer.",
    "enter_company_information_manually": "Oppgi bedriftsinformasjon manuelt",
    "business_configuration": "Opplysninger om nettbutikken",
    "organization_form": "Selskapsform",
    "please_enter_valid_email": "Vennligst oppgi en gyldig e-postadresse",
    "i_accept_the": "Jeg aksepterer",
    "terms_and_conditions": "Vilkår og betingelser",
    "completed": "Fullført",
    "incomplete": "Ikke fullført",
    "comment": "Kommentar",
    "i.e.": "f. eks",
    "select_organization_form": "Velg selskapsform",
    "terms_of_service": "Kjøpsbetingelsene",
    "privacy_policy": "Personvernerklæringen",
    "please_fill_all_required_fields_above": "Vennligst fyll alle obligatoriske felt over",
    "postal_code_must_be_4_digits": "Postnummer må bestå av 4 siffer",
    "no_companies_found_for_search_term": "Fant ingen firma som matcher søket ditt.",
    "try_different_search_term_or_use_manual_entry": "Sjekk om du har skrevet riktig, eller benytt søk med organisasjonsnummer, eller oppgi manuelt istede.",
    "loading_company_details": "Søker etter firma, vennligst vent",
    "home&garden": "Hjem og hage",
    "leisure_sports_&_hobbies": "Fritid, sport og hobby",
    "health_&_beauty": "Helse og skjønnhet",
    "childrens_products": "Barneprodukter",
    "clothing_&_shoes": "Klær og sko",
    "jewelry_&_accessories": "Smykker og tilbehør",
    "automotive_supplies_parts_&_accessories": "Bilrekvisita, bildeler og annet til kjøretøy",
    "electronics": "Elektronikk",
    "food_&_drink": "Mat og drikke",
    "digital_products_events_&_tickets": "Digitale produkter, arrangementer og billetter",
    "other": "Annet",
    "semi_annually": "Halvårlig",
    "semi-annually": "Halvårlig",
    "thank_you_for_using_24estore": "Takk for at du benytter deg av 24nettbutikk!",
    "here_is_what_happens_now": "Dette skjer videre:",
    "price_pr_month": "Månedspris",
    "read_more_about_our_plans_here": "Les mer om våre abonnement her",
    "please_note_that_startup_requires_you_to_register_a_payment_card": "Vær oppmerksom på at dersom Startup, eller Premium med månedlig betaling velges, så kreves det at et betalingskort (kredit eller debit) blir registrert i butikken, før du kan ta den i bruk.",
    "finish_order": "Fullfør bestilling",
    "licensing": "Abonnement",
    "your_license_has_been_upgraded": "Abonnementet ditt har blitt oppgradert",
    "your_store_is_now_ordered": "Butikken din er nå bestilt!",
    "in_order_to_start_using_your_store_we_need_to_onboard_you_with_our_payment_provider": "For å la kundene dine benytte butikken, må vi nå bestille tilgang til våre betalingspartner",
    "theme_presets": {
        "title": "Forhåndsinnstillinger",
        "description": "Se hvordan butikken din kan se ut med andre varianter av header og footer, og ulike temainnstillinger. Du ser kun en forhåndsvisning, og endringene trer ikke i kraft før du lagrer.",
        "industries": {
            "fashion": "Mote",
            "sport": "Sport",
            "gadgets": "Teknologi",
            "jewelry": "Smykker",
            "beauty": "Skjønnhet",
            "home": "Hjem",
            "toys": "Leker"
        },
        "industry_descriptions": {
            "fashion": "Designet for klesbutikker, motemerker og tilbehør. Store hero-bilder og rene produktraster lar plaggene få oppmerksomheten.",
            "sport": "For sportsmerker, treningsutstyr og friluftsliv. Sterke kontraster og dynamiske komposisjoner formidler energi og prestasjon.",
            "gadgets": "For forbrukerelektronikk og smart hjem. Ren produktfotografering og tydelig spesifikasjons-fokus.",
            "jewelry": "For smykker og klokker. Makro-bilder og forfinet typografi lar hvert stykke skinne.",
            "beauty": "For skjønnhet, hudpleie og parfyme. Lyset, fargene og typografien fremhever pleieritualer i et eksklusivt uttrykk.",
            "home": "For interiør, møbler og bolig. Vignetter av stylet rom gir kunden inspirasjon — produktene plasseres i kontekst.",
            "toys": "For leke- og barnebutikker. Varme farger og bilder av barn i lek formidler trygghet og glede."
        },
        "presets": {
            "fashion": {
                "name": "Klassisk",
                "description": "Tidløst utgangspunkt for moteforretninger — bygg videre i din egen retning."
            },
            "sport": {
                "name": "Klassisk",
                "description": "Tidløst utgangspunkt for sportsbutikker — bygg videre i din egen retning."
            },
            "gadgets": {
                "name": "Klassisk",
                "description": "Tidløst utgangspunkt for teknologibutikker — bygg videre i din egen retning."
            },
            "jewelry": {
                "name": "Klassisk",
                "description": "Tidløst utgangspunkt for smykkebutikker — bygg videre i din egen retning."
            },
            "beauty": {
                "name": "Klassisk",
                "description": "Tidløst utgangspunkt for skjønnhetsbutikker — bygg videre i din egen retning."
            },
            "home": {
                "name": "Klassisk",
                "description": "Tidløst utgangspunkt for interiør- og hjembutikker — bygg videre i din egen retning."
            },
            "toys": {
                "name": "Klassisk",
                "description": "Tidløst utgangspunkt for leke- og barnebutikker — bygg videre i din egen retning."
            }
        },
        "no_preset": "Ingen design",
        "no_preset_description": "Start med et helt blankt tema, og bygg opp designet ditt helt fra bunnen av",
        "you_have_decided_to_start_with_no_preset": "Du har valgt å starte med ingen forhåndslaget design"
    },
    "theme_description": {
        "glow": "Glow er et moderne, stilrent tema som gir nettbutikken din et friskt og profesjonelt preg. Med tilpasningsmuligheter for produktoppsett, funksjonsmoduler, kampanjebannere og innhold kan du skreddersy handleopplevelsen på en responsiv layout som fremhever produktene dine"
    },
    "menu_item_font_size": "Skriftstørrelse på menypunkt",
    "extra_small": "Ekstra liten",
    "small": "Liten",
    "normal": "Normal",
    "large": "Stor",
    "thin": "Tynn",
    "bold": "Tykk",
    "extra_large": "Ekstra stor",
    "menu_item_font_weight": "Skriftvekt på menypunkt",
    "font_weight": "Teksttykkelse",
    "font_weight_light": "Tynn",
    "font_weight_normal": "Normal",
    "font_weight_medium": "Medium",
    "font_weight_semibold": "Halvfet",
    "font_weight_bold": "Fet",
    "block_status_description": "Når slått på, er blokken synlig for kundene. Når slått av, er den kun synlig for deg mens du redigerer malen",
    "interval": "Intervall",
    "theme_editor_slider_interval_description": "Dette er tiden i sekunder mellom hvert bilde. Standard er 5 sekunder",
    "show_arrows": "Vis piler",
    "theme_editor_show_arrows_description": "Bestemmer om pilene for å navigere mellom bildene skal vises eller ikke. Piler vil kun vises dersom det er mer enn ett bilde i slideren",
    "slider_content_glide": "Innholdet glir etter",
    "slider_content_glide_description": "Tittel, tekst og knapp glir på plass i eget tempo når bildet bytter.",
    "slider_autoplay": "Automatisk bildebytte",
    "slider_autoplay_description": "Bytter bilde automatisk. Avslått lar kunden bla selv med piler, prikker eller sveip.",
    "show_arrows_mobile": "Vis piler på mobil",
    "show_arrows_mobile_description": "Slå av for å skjule pilene på små skjermer – kundene kan fortsatt sveipe.",
    "show_dots": "Vis prikker",
    "pagination_style": "Prikke-stil",
    "pagination_style_description": "Hvordan slide-indikatoren vises nederst på bildet.",
    "pagination_style_dots": "Prikker",
    "pagination_style_bars": "Streker",
    "pagination_style_fraction": "Teller (1 / 5)",
    "pagination_style_thumbnails": "Miniatyrbilder",
    "theme_editor_show_dots_description": "Bestemmer om prikkene for å navigere mellom bildene skal vises eller ikke. Prikker vil kun vises dersom det er mer enn ett bilde i slideren",
    "image_aspect_ratio": "Bildeforhold",
    "image_aspect_ratio_description": "Tvinger alle bildene til samme høyde-breddeforhold med kantcropping. Nyttig når bildene som lastes opp har ulike størrelser.",
    "image_aspect_native": "Behold original",
    "arrow_position": "Pilplassering",
    "arrow_position_inside": "Inni",
    "arrow_position_outside": "Utenfor",
    "arrow_position_above": "Over",
    "arrow_position_below": "Under",
    "arrow_style": "Pilstil",
    "arrow_style_round": "Rund",
    "arrow_style_square": "Firkantet",
    "arrow_style_minimal": "Minimal",
    "see_demo": "Se demo",
    "theme_preset_selector_modal": {
        "step_welcome": {
            "title": "Gratulerer med ny nettbutikk!",
            "subtitle": "Din 14 dagers prøveperiode starter nå.",
            "description": "Her er viktig informasjon om din nye nettbutikk. Vennligst lagre denne informasjonen slik at du kan gå tilbake til innholdet senere.",
            "store_url": "Adressen til din nettbutikk:",
            "store_username": "Ditt brukernavn:",
            "store_password_text": "Passordet er det du valgte da du opprettet nettbutikken.",
            "button_text": "La oss komme i gang!"
        },
        "step_select": {
            "title": "Velkommen til din 24Nettbutikk!",
            "subtitle": "Velg et design som passer til din butikk",
            "description": "Vi har laget flere profesjonelle designvarianter, tilpasset ulike bransjer og produktkategorier. Velg den varianten som ligger nærmest din stil. Husk at du kan endre variant, tilpasse farger, fonter og oppsett senere.",
            "select_preset_text": "Trykk på det designet du liker best, så setter vi opp butikken din med dette som utgangspunkt"
        },
        "step_confirm": {
            "you_have_selected_this_preset": "Du har valgt følgende variant",
            "select_another_preset": "Velg en annen variant",
            "confirm_preset": "Gå videre med valgt variant",
            "design_editor_description": "Med designbyggeren har du full kontroll over utseendet på butikken din – uten å måtte kunne kode.",
            "list_of_features": ["Endre <strong>farger, fonter, header og footer</strong> slik at de matcher din merkevare.", "Bygg opp sidene dine med de elementene du ønsker - fleksibelt og enkelt.", "Juster detaljer eller bytt hele uttrykket på noen få klikk."],
            "this_gives_you_a_professional_store": "Dette gir deg en profesjonell nettbutikk som både ser unik ut og gir kundene dine en bedre handleopplevelse.",
            "design_editor_location": "Designbyggeren finner du under menypunktet «Design»."
        },
        "step_thank_you": {
            "title": "Gratulerer med ny nettbutikk",
            "congratulations": "Gratulerer med å ha valgt ditt første design!",
            "next_steps": "Nå er neste steg å fylle butikken med produkter og gjøre den klar for salg.",
            "tutorial_info": "<p>Vi anbefaler at du følger sjekklisten som viser deg hva du bør gjøre, og i hvilken rekkefølge dette bør gjøres. Her vil du også få hjelp i form av korte hjelpevideoer som tar deg gjennom en steg-for steg forklaring.<br><br />Husk også at du kan klikke på valget “Hjelpesenter” i menyen til venstre og klikke deg inn på våre <a href='https://support.24nettbutikk.no/knowledge' target='_blank' class='link'>supportsider</a> for veiledninger og hjelp med de ulike valgene.<br /><br />Husk også at vi i 24Nettbutikk-teamet står klare til å hjelpe deg på telefon, e-post eller chat, om du står fast 😊</p>"
        }
    },
    "design_builder": "Designbygger",
    "design_variants": "Designvarianter",
    "edit_active_design": "Rediger aktivt design",
    "see_demo_store": "Se demobutikk",
    "see_in_design_builder": "Se i designbygger",
    "design_variants_hero_title": "Mange ferdige design å velge mellom",
    "design_variants_hero_description": "Vi har laget design for alle slags butikker — klær, sport, smykker, hjem og mye mer. Prøv så mange du vil før du bestemmer deg, og endre alt etterpå slik du vil ha det.",
    "design_variants_info": {
        "preview_description": "Utforsk tilgjengelige maler for butikken din. Besøk en demobutikk for å se hver mal i bruk, og legg til de du ønsker å bruke.",
        "note_title": "Hva inneholder en mal?",
        "note_description": "Innhold du selv har lagt til — bildeslidere, produkter osv. — er uavhengig av malen og vil ikke bli påvirket. Hver mal definerer:",
        "list_global_settings": "Globale innstillinger — Farge, font, hjørneavrunding m.m.",
        "list_header": "Header — Plassering av logo og søkefelt",
        "list_footer": "Footer — Plassering av firmainformasjon, partnerlogoer m.m."
    },
    "product_search_log": "Søkehistorikk",
    "product_searches": "Søkehistorikk",
    "see_products": "Se produkter",
    "query": "Søkeord",
    "count": "Antall",
    "searched_at": "Søkt på",
    "search_with_no_matches": "Søk uten treff",
    "no_matches": "Ingen treff",
    "button": "Knapp",
    "text_alignment": "Tekstjustering",
    "placement": "Plassering",
    "left": "Venstre",
    "center": "Midten",
    "center_title": "Sentrer tittel",
    "right": "Høyre",
    "top": "Topp",
    "bottom": "Bunn",
    "color": "Farge",
    "size": "Størrelse",
    "button_text": "Tekst på knapp",
    "outlined": "Uthevet",
    "shadow": "Skygge",
    "opacity": "Opasitet",
    "overlay_color": "Overlegg-farge",
    "URL": "URL",
    "simple": "Enkel",
    "image_alt_text_description": "Bildetekst er en kort beskrivelse av bildet. Den gjør bildet lettere å forstå for søkemotorer og blir lest opp av skjermlesere",
    "theme_block_image_simple_mode_description": "Bruk Enkel-modus når du kun trenger et bilde med en valgfri lenke",
    "button_url_overrides_image_link": "Overstyrer bildelenken. Står feltet tomt, bruker knappen lenken fra Lenke-seksjonen.",
    "second_button": "Knapp nummer to",
    "second_button_description": "La teksten stå tom for å vise bare én knapp. Nummer to står til høyre for den første.",
    "button_style": "Knappestil",
    "button_style_filled": "Med bakgrunn",
    "button_style_outlined": "Med ramme",
    "button_style_plain": "Uten ramme",
    "button_style_inverted": "Tekstfargen som bakgrunn",
    "button_icon": "Ikon bak teksten",
    "button_icon_arrow": "Pil",
    "button_icon_cart": "Handlekurv",
    "theme_block_image_content_link_description": "Gjør hele bildet klikkbart. Legger du til en knapp i innholdet, er det knappen som bærer lenken — med knappens egen URL hvis den er satt.",
    "theme_block_image_content_mode_description": "Bruk Innholds-modus for å legge til overlegg på bildet, som tittel, tekst og en knapp med lenke",
    "vertical_placement": "Vertikal plassering",
    "horizontal_placement": "Horisontal plassering",
    "vertical_placement_slider_description": "0 er øverst, 50 er midtstilt og 100 er nederst.",
    "horizontal_placement_slider_description": "0 er helt til venstre, 50 er midtstilt og 100 er helt til høyre.",
    "help_articles": "Hjelpeartikler",
    "tutorial_videos": "Hjelpevideoer",
    "see_all_tutorial_videos_here": "Se alle hjelpevideoer her",
    "item_is_a_menu_item_delete_warning": "<strong>{name}</strong> er et menypunkt. Hvis du sletter dette elementet, blir det fjernet fra alle menyer der det er brukt, sammen med eventuelle undermenypunkter.",
    "are_you_sure": "Er du sikker?",
    "step_by_step_support_guides": "Steg-for-steg supportartikkel",
    "next": "Neste",
    "start_tour": "Start veiledning",
    "skip_tour": "Hopp over veiledning",
    "tours": {
        "initial": {
            "step_one": {
                "title": "Produktkategorier",
                "description": "Vi anbefaler at du først oppretter produktkategoriene dine og knytter disse til hovedmenyen. Hjelpevideoene under vil vise deg hvordan.",
                "link_one_text": "Sammenhengen mellom produkter, kategorier og menyer",
                "link_two_text": "Slik bygger du en produktkategori",
                "link_three_text": "Slik knytter du produktkategorier til Hovedmenyen"
            },
            "step_two": {
                "title": "Produkter",
                "description": "Opprett produkter og knytt så disse til produktkategoriene. Hjelpevideoene vil vise deg hvordan.",
                "link_one_text": "Slik legger du til produkter og knytter disse til produktkategorier",
                "link_two_text": "Legg til egenskaper (attributter) til produktene"
            }
        }
    },
    "tour_done_button_text": "Ferdig",
    "you_cant_disable_maintenance_mode_without_an_active_license": "Du kan ikke åpne butikken, uten å først å ha inngått en lisensavtale.",
    "included_for_free_with": "Inkludert gratis med",
    "available_for_plans": "Tilgjengelig for kjøp med",
    "startup": "Startup",
    "all_prices_are_pr_month_and_excluding_vat": "Alle prisene er oppgitt pr. måned, og ekskl. mva.",
    "cant_order_apps_without_first_owning_a_license": "Du kan ikke kjøpe apps før du har valgt en lisens til nettbutikken",
    "app_requires_license": "Denne appen krever {licenses}.",
    "app_not_buyable_with_current_license": "Denne appen er ikke tilgjengelig på din nåværende lisens.",
    "connected_products_heading": "Tilknyttede produkter – øk mersalget i nettbutikken din",
    "connected_products_sub_heading": "Tilknyttede produkter lar deg vise en skreddersydd liste med varer på produktsiden.\nDette gjør det enkelt for kundene å oppdage flere produkter de kanskje vil  like! Med tilknyttede produkter kan du vise en skreddersydd liste med anbefalte varer direkte på produktsiden.",
    "connected_products_how_it_works_1": "<strong>Din egen tittel</strong> – kall listen det du vil, f.eks. “Du trenger også disse” eller “Andre farger du vil like”.",
    "connected_products_how_it_works_2": "<strong>Velg plassering</strong> – vis listen under produktinnhold, under kjøpsknappen – eller kun som bilder for å fremheve alternativer.",
    "connected_products_how_it_works_3": "<strong>Full kontroll</strong> – bestem selv hvilke produkter som skal vises, og dra-og-slipp for å sette rekkefølgen.",
    "why_use_connected_products": "Hvorfor aktivere tilknyttede produkter?",
    "connected_products_why_use_1": "<strong>Øk mersalget</strong> – foreslå komplementære varer eller alternative varianter.",
    "connected_products_why_use_2": "<strong>Bedre handleopplevelse</strong> – kundene får inspirasjon og hjelp til å finne riktige produkter.",
    "connected_products_why_use_3": "<strong>Mer kontroll</strong> – du bestemmer hvilke produkter som skal fremheves, akkurat slik du ønsker.",
    "connected_products_upsell": "Med tilknyttede produkter gir du kundene flere grunner til å handle – og øker verdien av hvert kjøp.",
    "google_shopping_heading": "Google Shopping – nå kundene når de leter etter deg",
    "google_shopping_sub_heading": "Vil du at produktene dine skal vises rett foran kundene når de søker på Google? Med vår integrasjon mot Google Shopping kan du enkelt få nettbutikken din til å dukke opp i Googles produktannonser – akkurat der potensielle kunder er klare til å handle.",
    "q_what_is_google_shopping": "Hva er Google Shopping?",
    "a_what_is_google_shopping": "Google Shopping er en tjeneste fra Google som lar brukere søke etter, sammenligne og klikke seg til dine produkter direkte via Googles plattform. Produktene dine vises med bilde, pris og butikkens navn – noe som gir en tydelig og attraktiv presentasjon rett i søkeresultatene.",
    "why_use_google_shopping": "Hvorfor bruke Google Shopping?",
    "why_use_google_shopping_1": "<strong>Treff kjøpsklare kunder</strong> – nå ut til folk som aktivt leter etter produktene du selger.",
    "why_use_google_shopping_2": "<strong>Øk synligheten</strong> – produktene dine vises med bilder og priser på Google-søk.",
    "why_use_google_shopping_3": "<strong>Flere salg</strong> – kunder kan klikke seg rett inn i butikken din fra Google.",
    "why_use_google_shopping_4": "<strong>Automatisk oppdatering</strong> – integrasjonen sørger for at produktinformasjonen din alltid er oppdatert.\n",
    "simple_integration_with_24estore": "Enkel integrasjon med 24Nettbutikk",
    "with_our_google_shopping_integration_everything_is_prepared_for_you": "Med vår Google Shopping-app er alt satt opp for deg:",
    "google_shopping_prepared_1": "Koble dine produktene sømløst til Google Shopping.",
    "google_shopping_prepared_2": "Pris, lagerstatus og produktinformasjon oppdateres automatisk.",
    "google_shopping_prepared_3": "Du slipper tungt teknisk arbeid – vi gjør jobben enkel og oversiktlig.",
    "form_builder_heading": "Skjemabygger – samle inn verdifull informasjon enkelt og effektivt",
    "form_builder_sub_heading": "Vil du ha bedre kontroll på kundehenvendelser og data? Med Skjemabygger kan du lage profesjonelle skjemaer som passer dine behov – fra enkle kontaktskjemaer til produktskjemaer som samler inn tilpasset informasjon ved kjøp.",
    "get_started_with_the_standard_functions": "Dette er inkludert for alle butikker",
    "form_builder_function_1": "<strong>Enkelt kontaktskjema</strong> – motta meldinger og henvendelser direkte i admin-panelet.",
    "form_builder_function_2": "<strong>E-postvarsler</strong> – få beskjed når noen sender inn et skjema.",
    "form_builder_function_3": "<strong>Full oversikt</strong> – se og administrer alle innsendelser på ett sted.",
    "form_builder_function_4": "<strong>Fleksibel videresending</strong> – send innsendelser til hvilken som helst e-postadresse du ønsker.",
    "this_is_what_you_get": "Dette får du ved kjøp av app-en",
    "form_builder_what_you_get_1": "<strong>Ubegrenset antall skjemaer</strong> – lag skjema for kontakt, tilbakemeldinger, registreringer, kampanjer og mye mer.",
    "form_builder_what_you_get_2": "<strong>Tilpass hvert skjema</strong> – skreddersy utseende og innhold etter forretningsbehov.\n",
    "form_builder_what_you_get_3": "<strong>Mange felttyper</strong>  – velg mellom:\nkort/ lang tekst,\navkrysningsbokser,\n e-post,\ntelefon,\ntall,\ndato,\ntid,\nm.m.\n",
    "form_builder_what_you_get_4": "<strong>Sømløs datainnsamling</strong> – gjør det enkelt for kundene å gi deg den informasjonen du trenger.",
    "form_builder_what_you_get_5": "<strong>Produktskjemaer</strong> – knytt skjemaer til produkter for å samle inn detaljer som gravering, hilsener eller spesialmål. Data lagres med ordren, og du kan legge til en tilleggskostnad for tjenesten.",
    "form_builder_why_use": "Hvorfor bruke Skjemabygger?",
    "form_builder_why_use_1": "Gjør butikken mer profesjonell og brukervennlig.",
    "form_builder_why_use_2": "Samle inn leads, tilbakemeldinger og registreringer uten ekstra systemer.",
    "form_builder_why_use_3": "Få bedre innsikt i kundene dine og bruk data til å ta smartere beslutninger.",
    "form_builder_sub_text": "Med Skjemabygger får du fleksibilitet, oversikt og en enklere hverdag – direkte integrert i nettbutikken din.",
    "faq_heading": "FAQ – gi kundene svarene før de spør",
    "faq_sub_heading": "FAQ – gi kundene svarene før de spør \nMed FAQ-appen kan du enkelt lage en oversiktlig spørsmål-og-svar-seksjon i nettbutikken din. Det gir kundene rask tilgang til den informasjonen de lurer på – uten at de trenger å kontakte deg.",
    "advantages_with_faq": "Fordeler med FAQ",
    "advantages_with_faq_1": "<strong>Mindre kundeservice</strong> – færre henvendelser fordi kundene finner svarene selv.",
    "advantages_with_faq_2": "<strong>Bedre kjøpsopplevelse</strong> – når kundene får raske svar, er de mer tilbøyelige til å fullføre kjøpet.",
    "advantages_with_faq_3": "<strong>Fleksibel plassering</strong> – legg FAQ direkte på forsiden, på produktsider eller som menypunkt i butikken din.",
    "faq_sub_text": "Med FAQ blir butikken din mer profesjonell, kundene dine mer fornøyde – og du sparer tid på support.",
    "wishlist_headline": "La kundene lagre produktene de elsker",
    "wishlist_subline": "Gjør det enkelt for kundene dine å komme tilbake og fullføre kjøpet! Med Favoritter kan de klikke på hjertet ved produktet og legge varen til i sin egen favorittliste.",
    "this_allows_customers_to": "Dette gir kundene muligheten til å:",
    "this_allows_customers_to_1": "<strong>Planlegge kjøp</strong> – lagre produktene de liker, og handle senere.",
    "this_allows_customers_to_2": "<strong>Finne tilbake</strong> – slippe å lete på nytt etter varer de allerede har vist interesse for.",
    "this_allows_customers_to_3": "<strong>Kjøpe mer</strong> – en favorittliste gjør det lettere å legge flere produkter i handlekurven.",
    "why_use_wishlist": "Hvorfor aktivere Favoritter?",
    "why_use_wishlist_1": "Øker sannsynligheten for at kundene kommer tilbake.",
    "why_use_wishlist_2": "Skaper en bedre handleopplevelse med mer kontroll og inspirasjon.",
    "why_use_wishlist_3": "Bidrar til økt salg når kundene enkelt kan hente opp listen sin og legge varer i handlekurven.",
    "wishlist_closer": "Med favoritter bygger du altså lojalitet og gjør kundereisen smidigere – noe både du og kundene dine tjener på.",
    "vipps_express_headline": "Vipps Hurtigkasse – raskeste vei til flere salg",
    "vipps_express_subline": "Gjør kjøpsopplevelsen enklere for kundene dine – og øk salget! Med Vipps Hurtigkasse kan kundene betale med Vipps på bare noen få klikk, enten direkte fra produktsiden eller i handlekurven.",
    "advantages_with_vipps_express": "Fordeler med Vipps Hurtigkasse",
    "advantages_with_vipps_express_1": "<strong>Superrask betaling</strong> – den enkleste og raskeste måten å ta betalt på i nettbutikken din.",
    "advantages_with_vipps_express_2": "<strong>Reduser forlatte handlekurver</strong> – kortere betalingsprosess betyr flere gjennomførte kjøp.",
    "advantages_with_vipps_express_3": "<strong>Høyere konvertering</strong> – våre kunder opplever rekordhøy konvertering med Vipps Hurtigkasse, spesielt for de som har en relativ lav gjennomsnittlig ordreverdi.",
    "advantages_with_vipps_express_4": "<strong>Sømløs ordrebehandling</strong> – håndteres på samme måte som ordinære Vipps-ordrer, direkte i nettbutikkens ordrebehandling.",
    "advantages_with_vipps_express_5": "<strong>Ingen ekstra kostnader</strong> – transaksjonsprisen er den samme som for ordinære Vipps-ordrer <a class='link' href='https://www.24nettbutikk.no/priser' target='_blank'>(se priser her).</a>",
    "can_i_use_vipps_express_without_vipps_q": "Kan jeg bruke Vipps Hurtigkasse uten å ha Vipps?",
    "can_i_use_vipps_express_without_vipps_a": "Nei, du må ha Vipps allerede konfigurert i nettbutikken for å kunne bestille vipps hurtigkasse.",
    "how_much_does_it_cost_to_use_vipps_express_q": "Hvor mye koster det å ha Vipps hurtigkasse?",
    "how_much_does_it_cost_to_use_vipps_express_a": "Vipps Hurtigkasse er gratis å benytte, men du betaler de ordinære Vipps kostnadene (på lik linje med en ordinær Vipps ordre).",
    "vipps_express_tagline": "Med Vipps Hurtigkasse får du flere salg, mer fornøyde kunder – og en enda enklere hverdag i nettbutikken din.",
    "product_tags_tooltip": "Bruk produkt-tags for å plassere produkter i smartkategorier. Eksempel: \"Dame\" og \"Sko\" gjør at en damesko automatisk vises i begge kategorier (hvis de er opprettet med disse kriteriene)",
    "product_badges_tooltip": "Badges er små etiketter som vises på produktbildet i produktlister. Eksempel: \"Ryddesalg\" eller \"Miljøvennlig\"",
    "active_shipping_methods": "Aktive fraktmetoder",
    "what_is_24_shipping_desc": "Som kunde hos 24Nettbutikk får du eksklusiv tilgang til 24Shipping – en komplett fraktavtale som gir deg stordriftsfordeler og profesjonell logistikk fra første dag.",
    "what_is_24_shipping_desc_2": "Med 24Shipping får du tilgang til våre stordriftsrabatter – og sparer 10–60 % på frakt allerede fra første pakke.",
    "what_is_24_shipping_1": "<strong>10–60 % rabatt fra første pakke</strong> hos Norges største fraktleverandører: <strong>Posten Bring og PostNord.</strong>",
    "what_is_24_shipping_2": "<strong>Sømløst integrert i ordrebehandlingen</strong> – bestill frakt direkte fra ordrevinduet.",
    "what_is_24_shipping_3": "<strong>Automatisk printing av etiketter og pakksedler.</strong>",
    "what_is_24_shipping_4": "<strong>Alle leveringsalternativer</strong> – postkasse, pakkeboks, hentested eller hjemlevering.",
    "24_shipping_is_included_for_free_in_your_license_and_you_only_pay_for_the_shipments_you_make": "Resultat? Du sparer tid, penger og får en proff fraktløsning som gir kundene dine den leveringsopplevelsen de forventer.",
    "incident_form_24_shipping": "Avviksskjema 24Shipping",
    "currently_using": "Nåværende kort",
    "use_this_card": "Benytt dette",
    "cards": "Betalingskort",
    "card": "Betalingskort",
    "footer_font_size": "Footer tekststørrelse",
    "card_registered": "Betalingskort registrert",
    "to_use_the_appstore_we_need_to_have_a_payment_card_on_file": "For å kjøpe apps trenger vi et registrert betalingskort.",
    "to_use_24shipping_we_need_to_have_a_payment_card_on_file": "For å kunne bestille frakt med 24Shipping trenger vi et registrert betalingskort.",
    "how_are_card_details_saved_q": "Hvordan håndteres mine kortopplysninger?",
    "how_are_card_details_saved_a": "Betalingskort lagres ikke i nettbutikken, og håndteres istede via vår betalingspartner <a class=\"link\" href=\"https://stripe.com\" target=\"_blank\">stripe</a>.",
    "how_can_i_cancel_an_app_q": "Hvordan kan jeg kansellere en app ?",
    "how_can_i_cancel_an_app_a": "Du kan når som helst kansellere en app, ved å ta kontakt med support hos 24Nettbutikk.",
    "how_the_appstore_works": "Hvordan fungerer app-butikken?",
    "add_card_here": "Legg til kort her",
    "what_is_24shipping_q": "Hva er 24Shipping?",
    "what_is_24shipping_a": "Fraktdealen som vi har kalt 24Shipping, er utviklet for å gi deg som kunde av 24Nettbutikk stordriftsfordeler for kjøp av frakt fra Norges største fraktleverandører Posten Bring og PostNord, les mer om denne <a class=\"link\" href=\"https://www.24nettbutikk.no/24shipping\" target=_\"blank\">her</a>.",
    "i_dont_want_to_use_24_shipping_how_can_i_hide_this_q": "Jeg ønsker ikke å benytte 24Shipping, hvordan skjuler jeg dette vinduet i fremtiden?",
    "i_dont_want_to_use_24_shipping_how_can_i_hide_this_a": "For å skjule dette vinduet, deaktiver 24Shipping under logistikk <a class=\"link\" href=\"/admin/logistics\">her.</a>",
    "gap_between_images": "Avstand mellom bilder",
    "image_mode": "Bildemodus",
    "url": "URL",
    "hover_effect": "Hover-effekt",
    "hover_effect_description": "Velg hvordan bildene skal reagere når brukeren holder markøren over dem",
    "hover_effect_scale": "Forstørres",
    "hover_effect_shadow": "Skygge",
    "hover_effect_blur": "Uskarphet",
    "hover_effect_grayscale": "Gråtoner",
    "blog": "Blogg",
    "blog_app_description": "Del enkelt nyttig innhold gjennom en blogg direkte i nettbutikken. Perfekt for nyheter, guider og inspirasjon som kan styrke merkevaren og øke engasjementet.",
    "blog_app_headline": "Blogg – del innhold som engasjerer kundene dine",
    "blog_app_sub_heading": "Med blogg-appen kan du enkelt publisere artikler, guider og nyheter direkte i nettbutikken din. Gi kundene dine nyttig innhold som bygger tillit, inspirasjon og øker salget.",
    "blog_app_advantages": "Fordeler med blogg",
    "blog_app_advantage_1": "<strong>Styrk merkevaren</strong> – del kunnskap og historier som viser din ekspertise.",
    "blog_app_advantage_2": "<strong>Bedre synlighet</strong> – blogginnlegg kan bidra til bedre rangering i søkemotorer.",
    "blog_app_advantage_3": "<strong>Engasjer kundene</strong> – gi kundene verdifullt innhold som gjør at de kommer tilbake oftere.",
    "blog_app_closer": "Med blogg-appen blir nettbutikken din mer enn bare et sted å handle – den blir en kilde til inspirasjon og kunnskap for kundene dine.",
    "blog_posts": "Blogginnlegg",
    "blog_post": "Blogginnlegg",
    "add_blog_post": "Legg til blogginnlegg",
    "create_blog_post": "Opprett blogginnlegg",
    "create_blog_posts": "Opprett blogginnlegg",
    "edit_blog_post": "Rediger blogginnlegg",
    "blog_index_page": "Blogg hovedside",
    "unpublished": "Upublisert",
    "date_published": "Publiseringsdato",
    "show_image_in_post": "Vis bilde i innlegget",
    "blog_name": "Bloggnavn",
    "blog_name_description": "Navnet på bloggen slik det vises i nettbutikken. Dette kan være \"Blogg\", \"Nyheter\" eller noe annet som passer din butikk.",
    "blog_description": "Bloggbeskrivelse",
    "blog_description_description": "En kort beskrivelse av bloggen som vises under bloggnavnet i nettbutikken.",
    "blog_settings": "Blogginnstillinger",
    "blog_post_image": "blogginnlegg bildet",
    "see_blog_in_store": "Se blogg i butikken",
    "blog_post_tags_description": "Bruk blogg-tags for å kategorisere innleggene dine. Eksempel: \"Nyheter\", \"Guider\" eller \"Inspirasjon\". Disse brukes også for å vise relaterte innlegg inne på blogginnlegget.",
    "blog_post_image_description": "Dette bildet vises som forsidebilde på bloggoversikten. Du kan også velge å vise det øverst i selve blogginnlegget.",
    "other_shipping_methods": "Andre fraktmetoder",
    "upload_a_favicon_for_your_store": "Last opp en favicon for butikken din. Ikonet må være av filtype PNG og må ha en størrelse på 16x16, 32x32 eller 64x64 piksler. Ikonet kan ikke ha større filstørrelse enn 128 kB. Merk at endringer på favicon ikke blir synlig før senest 30 minutter etter endringen.",
    "favicon_updated": "Favicon oppdatert",
    "favicon_deleted": "Favicon slettet",
    "payment_onboarding_text": "Bestilling av betalingsalternativer er tilgjengelig for kunder med aktivt 24Next abonnement.",
    "payment_click_here_to_onboard_saas": "Trykk her for å komme i gang.",
    "payment_order": "Bestill",
    "vipps_continue": "Fortsett hos Vipps",
    "vipps_reorder": "Bestill på nytt",
    "vipps_trial_disabled_hint": "Du kan bestille Vipps når butikken har et aktivt abonnement.",
    "vipps_state_submitted": "Innsendt – til behandling hos Vipps",
    "vipps_state_completed": "Godkjent! Sjekk e-posten fra Vipps og videresend API-nøklene til oss, så aktiverer vi Vipps.",
    "customer.first_name.required": "Fornavn er påkrevd.",
    "customer.first_name.string": "Fornavn må være en tekst.",
    "customer.first_name.max": "Fornavn kan ikke være lengre enn 255 tegn.",
    "customer.last_name.required": "Etternavn er påkrevd.",
    "customer.last_name.string": "Etternavn må være en tekst.",
    "customer.last_name.max": "Etternavn kan ikke være lengre enn 255 tegn.",
    "customer.customer_type.required": "Kundetype er påkrevd.",
    "customer.customer_type.string": "Kundetype må være en tekst.",
    "customer.customer_type.in": "Kundetype må være enten privatkunde eller bedrift.",
    "customer.company_name.required_if": "Firmanavn er påkrevd for bedrifter.",
    "customer.company_name.string": "Firmanavn må være en tekst.",
    "customer.company_name.max": "Firmanavn kan ikke være lengre enn 255 tegn.",
    "customer.company_vat_number.required_if": "Organisasjonsnummer er påkrevd for bedrifter.",
    "customer.company_vat_number.string": "Organisasjonsnummer må være en tekst.",
    "customer.company_vat_number.max": "Organisasjonsnummer kan ikke være lengre enn 255 tegn.",
    "customer.company_department.string": "Avdeling må være en tekst.",
    "customer.company_department.max": "Avdeling kan ikke være lengre enn 255 tegn.",
    "customer.company_project.string": "Prosjekt må være en tekst.",
    "customer.company_project.max": "Prosjekt kan ikke være lengre enn 255 tegn.",
    "customer.email.required": "E-postadresse er påkrevd.",
    "customer.email.string": "E-postadresse må være en tekst.",
    "customer.email.email": "E-postadressen må være gyldig.",
    "customer.email.max": "E-postadresse kan ikke være lengre enn 255 tegn.",
    "customer.email.unique": "E-postadressen er allerede registrert.",
    "customer.password.required": "Passord er påkrevd.",
    "customer.password.string": "Passord må være en tekst.",
    "customer.password.min": "Passordet må være minst 8 tegn.",
    "customer.password.confirmed": "Passordene stemmer ikke overens.",
    "manage_attributes_action_description": "Administrer produktattributter. Enten ved å opprette nye eller fjerne eksisterende",
    "manage_attributes_to_x_amount_of_products": "Administrer attributter for 1 produkt | Administrer attributter for {count} produkter",
    "attributes_that_will_be_added": "Attributter som vil bli lagt til",
    "manage_attributes_modal_description": "Administrer produktattributter for de valgte produktene. Bruk «Legg til» for å tilknytte nye attributter, eller «Fjern» for å fjerne eksisterende.",
    "you_have_already_added_this_attribute": "Du har allerede lagt til denne attributten",
    "check_shipping_methods": "Hent fraktmåter",
    "create_shipment": "Opprett forsendelse",
    "internal_reference": "Intern referanse",
    "logistics_provider": "Logistikkleverandør",
    "manual_shipment_description": "Herfra kan du manuelt booke en forsendelse",
    "manual_shipments": "Manuelle forsendelser",
    "select_shipping_method": "Velg fraktmåte",
    "fill_form_to_get_shipping_methods": "Fyll ut skjema for å hente tilgjengelige fraktmåter",
    "recipient": "Mottaker",
    "package": "Pakke",
    "last_x_days": "Siste {days} dager",
    "search_by_recipient_name": "Søk etter mottakernavn...",
    "no_shipments_yet": "Ingen forsendelser er opprettet ennå",
    "view_label": "Vis",
    "print": "Skriv ut",
    "in gram": "i gram",
    "in cm": "i cm",
    "pickup_points": "Hentepunkter",
    "pickup_point": "Hentepunkt",
    "requested_delivery_date": "Ønsket leveringsdag",
    "requested_delivery_booking_notice": "Kunden har valgt levering {delivery}. Datoen sendes med i bookingen når produktet er Pakke levert hjem (5600).",
    "url_to_label": "Etikett",
    "link_to_label": "Etikett",
    "dimensions": "Dimensjoner",
    "choose_pickup_point": "Velg hentepunkt",
    "manual_shipment_created_successfully": "Manuell forsendelse opprettet",
    "could_not_book_manual_shipment": "Kunne ikke opprette manuell forsendelse. Vennligst prøv igjen eller kontakt kundeservice",
    "no_shipping_methods_found": "Fant ingen fraktmåter for oppgitt adresse, dimensjoner og vekt.",
    "could_not_book_shipment": "Kunne ikke booke forsendelse. Vennligst prøv igjen eller kontakt kundeservice",
    "product_pricing_has_variants_description": "Produktet har produktvarianter. Du kan angi én pris for alle i feltet under, eller sette egne priser i tabellen <a class='text-[color:var(--link-color)]' href='#variants-table'>Produktvarianter</a>.",
    "hide_form": "Skjul skjema",
    "new_start_date_overlaps_with_an_existing_period": "Startdatoen overlapper med en eksisterende periode",
    "discounted_price_cannot_be_0": "Den rabatterte prisen kan ikke være 0",
    "discount_price_cannot_be_higher_than_original_price": "Den rabatterte prisen kan ikke være høyere enn originalprisen",
    "start_date_is_required": "Startdato er påkrevd",
    "end_date_is_required": "Sluttdato er påkrevd",
    "end_date_cannot_be_before_start_date": "Sluttdato kan ikke være før startdato",
    "mobile_navigation_background_color": "Mobilmeny bakgrunnsfarge",
    "mobile_navigation_text_color": "Mobilmeny tekstfarge",
    "mobile_navigation_style": "Mobilnavigasjonsstil",
    "mobile_navigation_style_description": "Velg mellom en sidemeny eller fullskjermsoverlegg for mobilmenyen",
    "mobile_navigation_style_drawer": "Sidemeny (skyv fra venstre)",
    "mobile_navigation_style_overlay": "Fullskjermsoverlegg",
    "mobile_navigation_font_size": "Fontstørrelse i mobilmenyen",
    "mobile_navigation_font_size_description": "Skalerer teksten i mobilmenyen, både sidemenyen og fullskjermsoverlegget",
    "mobile_navigation_font_size_small": "Liten",
    "mobile_navigation_font_size_normal": "Normal",
    "mobile_navigation_font_size_large": "Stor",
    "mobile_navigation_show_contact": "Vis kontaktinfo i mobilmenyen",
    "mobile_navigation_show_contact_description": "Viser e-post og telefon fra butikkinformasjonen nederst i mobilmenyen, sammen med sosiale medier",
    "mobile_sticky_menu": "Sticky mobilmeny",
    "mobile_sticky_menu_description": "Vis en fast navigasjonslinje nederst på skjermen på mobil",
    "store_id_copied_to_clipboard": "Butikk-ID kopiert til utklippstavlen",
    "from_here_you_can_book_a_manual_shipment": "Herfra kan du manuelt booke en forsendelse via 24Shipping",
    "book_manual_shipment": "Book manuell forsendelse",
    "fulfillment_items_required": "Varer som skal sendes er påkrevd",
    "fulfillment_items_must_be_array": "Varer som skal sendes må være en liste",
    "fulfillment_carrier_required_with_tracking": "Fraktselskap er påkrevd når sporingsnummer er oppgitt",
    "fulfillment_carrier_must_be_string": "Fraktselskap må være tekst",
    "fulfillment_tracking_number_required_with_carrier": "Sporingsnummer er påkrevd når fraktselskap er oppgitt",
    "fulfillment_tracking_number_must_be_string": "Sporingsnummer må være tekst",
    "fulfillment_tracking_url_must_be_valid": "Sporings-URL må være gyldig",
    "fulfillment_notify_customer_required": "Varsling av kunde er påkrevd",
    "fulfillment_notify_customer_must_be_boolean": "Varsling av kunde må være ja/nei",
    "fulfillment_logistics_provider_required": "Logistikkleverandør er påkrevd",
    "fulfillment_logistics_provider_must_be_string": "Logistikkleverandør må være tekst",
    "fulfillment_logistics_provider_not_found": "Logistikkleverandør ble ikke funnet",
    "fulfillment_product_required_for_provider": "Produkt er påkrevd for denne leverandøren",
    "fulfillment_product_must_be_string": "Produkt må være tekst",
    "fulfillment_dimensions_must_be_array": "Dimensjoner må være en liste",
    "fulfillment_dimensions_required_for_provider": "Dimensjoner er påkrevd for denne leverandøren",
    "fulfillment_dimensions_length_required": "Lengde er påkrevd",
    "fulfillment_dimensions_length_must_be_numeric": "Lengde må være et tall",
    "fulfillment_dimensions_width_required": "Bredde er påkrevd",
    "fulfillment_dimensions_width_must_be_numeric": "Bredde må være et tall",
    "fulfillment_dimensions_height_required": "Høyde er påkrevd",
    "fulfillment_dimensions_height_must_be_numeric": "Høyde må være et tall",
    "fulfillment_dimensions_weight_required": "Vekt er påkrevd",
    "fulfillment_dimensions_weight_must_be_numeric": "Vekt må være et tall",
    "fulfillment_pickup_point_required": "Denne fraktmetoden krever hentested. Velg et hentested før du fullfører.",
    "could_not_refresh_widgets": "Kunne ikke legge til ønsket widget. Prøv å last siden på nytt.",
    "(disconnected)": "(Frakoblet)",
    "payment_method_was_updated": "Betalingsmetode ble endret",
    "payment_method_was_updated_from:from_to_:to": "Betalingsmetode ble endret fra :from til :to",
    "are_you_sure_you_want_to_disconnect_this_order_from_its_current_payment_gateway": "Er du helt sikker på at du ønsker å koble denne ordren fra sin nåværende betalingsleverandør?",
    "manage_prices_for_x_amount_of_products": "Administrer priser for 1 produkt | Administrer priser for {count} produkter",
    "manage_prices_modal_description": "Administrer priser for de valgte produktene. Du kan sette en ny pris for alle produktene, eller justere prisene med et fast beløp eller en prosentandel. Du kan også sette og fjerne tilbudspriser.",
    "base_prices": "Grunnpriser",
    "base_price": "Grunnpris",
    "sales_prices": "Tilbudspriser",
    "sales_price": "Tilbudspris",
    "manage_prices_product_preview_description": "Dette er en forhåndsvisning av hvordan prisene vil se ut for produktet eller variantene etter at endringene lagres. Hvis du fjerner avhukingen ved et produkt eller en variant, vil det ikke bli oppdatert og beholdes uendret.",
    "managing": "Administrerer",
    "action": "Handling",
    "adjust_type": "Justeringstype",
    "current_sale": "Nåværende tilbud",
    "current_sale_description": "Fjern den nåværende tilbudsprisen for produkt eller variantene",
    "current_stock": "Nåværende beholdning",
    "scheduled_sales": "Planlagte tilbud",
    "scheduled_sales_description": "Fjern planlagte tilbud for produkt eller variantene",
    "all_sales": "Alle tilbud",
    "all_sales_description": "Fjern både nåværende og planlagte tilbud for produkt eller variantene",
    "add_sale": "Legg til tilbud",
    "remove_sale": "Fjern tilbud",
    "adjust_by_amount": "Justere med beløp",
    "adjust_by_percentage": "Justere med prosentandel",
    "increase_price_by_percentage": "Øk pris med {value}%",
    "decrease_price_by_percentage": "Reduser pris med {value}%",
    "increase_price_by_amount": "Øk pris med {value}",
    "decrease_price_by_amount": "Reduser pris med {value}",
    "replace_price_with_amount": "Erstatt pris med {value}",
    "increase": "Øk",
    "decrease": "Reduser",
    "prices": "Priser",
    "manage_prices_action_description": "Du kan sette en ny pris for valgte produkter, eller sette og fjerne tilbudspriser",
    "add_sales_price_by_percentage": "Gi {value} % rabatt fra grunnprisen",
    "add_sales_price_by_amount": "Gi {value} rabatt fra grunnprisen",
    "add_sales_price_fixed": "Sett fast tilbudspris på {value}",
    "fixed": "Fast pris",
    "fixed_sale_price_including_vat": "Fast tilbudspris (inkl. MVA)",
    "overwrite_existing_sales_prices": "Overskriv eksisterende tilbudspriser",
    "sales_price_exceeds_base_price": "Tilbudsprisen overstiger eller er lik grunnprisen.",
    "remove_sales_price_option": "Fjern {option}",
    "base_price_will_exceed_current_sales_price": "Kan ikke justere grunnprisen fordi den vil overstige den nåværende tilbudsprisen.",
    "conflicting_sales_prices": "Vil ikke oppdatere. Det finnes motstridende tilbudspriser i det angitte datointervallet.",
    "sales_price_zero_or_less": "Vil ikke oppdatere fordi den resulterende tilbudsprisen er null eller lavere.",
    "original_price": "Originalpris",
    "new_price": "Ny pris",
    "current_price": "Nåværende pris",
    "one_active_sale_will_be_removed": "Ett aktivt tilbud vil bli fjernet",
    "x_scheduled_sales_will_be_removed": "Ett planlagt tilbud vil bli fjernet | {count} planlagte tilbud vil bli fjernet",
    "no_current_sale_to_remove": "Ingen nåværende tilbud å fjerne",
    "no_scheduled_sales_to_remove": "Ingen planlagte tilbud å fjerne",
    "amount": "Beløp",
    "amount_excluding_vat": "Beløp ekskl. mva.",
    "amount_including_vat": "Beløp inkl. mva.",
    "are_you_sure_you_want_to_apply_these_price_changes_to_the_selected_products": "Er du sikker på at du vil bruke disse prisendringene på de valgte produktene/variantene?",
    "will_not_be_updated": "Vil ikke bli oppdatert",
    "sales_price_percentage_modification_example": "Med en justering på {percentage}%, så vil for eksempel et produkt med en grunnpris på {originalPriceExample} kr få en tilbudspris på {salesPricePercentageModificationExample} kr",
    "sales_price_amount_modification_example": "Med en justering på {amount} kr, så vil for eksempel et produkt med en grunnpris på {originalPriceExample} kr få en tilbudspris på {salesPriceAmountModificationExample} kr",
    "add_theme": "Legg til tema",
    "add_theme_x": "Legg til temaet {name}",
    "theme_x_added": "Temaet {name} er lagt til",
    "go_to_theme": "Gå til temaet",
    "theme_added_description": "Temaet er lagt til i butikken din. Nå kan du gå til designbyggeren og tilpasse det slik du vil.",
    "theme": "Tema",
    "save_and_publish": "Lagre og publiser",
    "add_new_theme": "Legg til nytt tema",
    "publish_theme_modal_title": "Publiser tema",
    "publish_theme_modal_description": "Er du sikker på at du vil publisere dette temaet? Da blir det butikkens aktive tema",
    "theme_saved_and_published_successfully": "Temaet er lagret og publisert",
    "checklist": {
        "steps": {
            "add_company_information": {
                "label": "Legg til basisinformasjon om butikken din",
                "description": "Adresse, kontaktinfo og organisasjonsnummer.",
                "help_text": "Norske myndigheter krever at butikker viser organisasjonsnummer, adresse og kontaktinfo. Det er også med på å bygge tillit hos kundene som vil sjekke hvem de kjøper fra.",
                "bullets": ["Organisasjonsnummer og firmanavn", "Postadresse og kontakt-e-post"],
                "cta_label": "Gå til innstillinger"
            },
            "change_design": {
                "label": "Legg til logo og jobb med design av butikken",
                "description": "Gi butikken din et profesjonelt uttrykk som bygger tillit og ditt brand.",
                "help_text": "Et godt førsteinntrykk gjør det lettere for kundene å stole på deg og handle. I designeren kan du laste opp logo, justere farger og typografi, og forhåndsvise butikken før du publiserer.",
                "bullets": ["Last opp logo (PNG anbefales)", "Velg farger som matcher merkevaren din", "Forhåndsvis på desktop og mobil"],
                "cta_label": "Åpne designer"
            },
            "add_category": {
                "label": "Legg til en produktkategori",
                "description": "Organiser produktene dine i kategorier slik at kundene finner frem.",
                "help_text": "Kategorier hjelper kundene å navigere i butikken. Med tydelig struktur finner kundene raskere det de leter etter, noe som typisk gir flere salg.",
                "bullets": ["Lag overordnede kategorier først (f.eks. «Klær», «Sko»)", "Plasser produkter i flere kategorier hvis det passer", "Kan legges til i hovedmenyen — se videoen over for hvordan"],
                "cta_label": "Lag kategori"
            }
        }
    },
    "duplicate_theme": "Dupliser tema",
    "duplicate_theme_x": "Dupliser temaet {name}",
    "theme_duplicated": "Temaet er duplisert",
    "duplicate": "Dupliser",
    "delete_theme": "Slett tema",
    "theme_deleted": "Temaet er slettet",
    "vertical_padding": "Avstand over og under bilder",
    "edit_internal_name": "Rediger internt navn",
    "edit_internal_name_of_x": "Rediger internt navn til {name}",
    "theme_deleted_successfully": "Temaet er slettet",
    "cannot_delete_active_theme": "Du kan ikke slette det aktive temaet",
    "are_you_sure_you_want_to_delete_theme_x": "Er du sikker på at du vil slette temaet {name}?",
    "get_started": "Kom i gang",
    "theme_limit_reached_error": "Du har nådd grensen for antall temaer i butikken din. Slett et tema før du legger til et nytt.",
    "theme_limit_reached_notification": "Grensen for antall temaer er nådd",
    "startup_can_only_work_on_one_theme": "Startup-abonnementet lar deg jobbe med ett tema om gangen",
    "startup_order_warning_heading": "Funksjoner du har brukt blir deaktivert",
    "startup_order_warning_intro": "Med StartUp mister du tilgang til disse funksjonene du har brukt i prøveperioden:",
    "startup_order_warning_addon_note": "Kan kjøpes som tillegg for {price} per måned eks. mva.",
    "startup_order_warning_usage_form_builder": "Du har opprettet {count} skjema | Du har opprettet {count} skjemaer",
    "startup_order_warning_usage_faq": "{count} FAQ-oppføring opprettet | {count} FAQ-oppføringer opprettet",
    "startup_order_warning_usage_product_reviews": "{count} produktomtale mottatt | {count} produktomtaler mottatt",
    "startup_order_warning_usage_stock_notification": "{count} kunde venter på lagervarsel | {count} kunder venter på lagervarsel",
    "startup_order_warning_usage_product_connections": "{count} produktkobling opprettet | {count} produktkoblinger opprettet",
    "startup_order_warning_usage_themes": "Du har {count} temaer — kun temaet som er aktivt når du bestiller, forblir tilgjengelig",
    "startup_order_warning_themes_hint": "Sørg for at temaet du vil beholde, er aktivt før du fullfører bestillingen.",
    "upgrade_plan": "Oppgrader abonnement",
    "unsaved_changes_warning": "Du har ulagrede endringer. Er du sikker på at du vil forlate siden?",
    "order_webshop": "Bestill nettbutikk",
    "create_manual_shipment": "Opprett manuell forsendelse",
    "store_documents": "Ordredokumenter",
    "invoice": "Faktura",
    "invoice_payment_shipping_email_note": "Kunden betaler med egenfaktura, så fakturaen legges ikke ved e-posten om forsendelsen. Du finner den under Faktura på ordren når forsendelsen er opprettet.",
    "invoice_payment_method_note": "Kunder som betaler med egenfaktura får ikke fakturaen vår i e-posten om forsendelsen. Du finner den under Faktura på ordren hvis du vil sende den selv.",
    "invoice_due_days": "Betalingsfrist (dager)",
    "invoice_due_days_hint": "Antall dager kunden har på å betale. Vises som forfallsdato på fakturaen.",
    "invoice_account_number": "Kontonummer",
    "invoice_account_number_hint": "Kontoen kunden skal betale til. Vises på fakturaen.",
    "invoice_account_number_missing": "Mangler kontonummer",
    "invoice_account_number_missing_hint": "Fyll inn kontonummeret kunden skal betale til, så det står på fakturaen.",
    "picklist": "Plukkliste",
    "picklist_columns_settings": "Velg kolonner og tilpass navn",
    "pickCheckboxName": "Avhukingsboks om varen er hentet",
    "packCheckboxName": "Avhukingsboks om varen er pakket",
    "product_name_with_variants": "Produktnavn",
    "make_brand": "Merke",
    "b2c": "Privat",
    "b2b": "Bedrift",
    "checkout_gateways_spennd_description": "Moderne og fleksibel kasse med Vipps Login for rask identifisering. Støtter Vipps, Visa, Mastercard og Klarna i Vipps-appen. Du velger selv rekkefølge og synlighet på betalingsalternativene.",
    "use_checkout": "Benytt som standard",
    "order_payment_methods": "Bestill betalingsalternativer her",
    "checkout_updated_successfully": "Kassen er oppdatert",
    "only_one_checkout_at_a_time": "Merk: Kun en kasse kan være aktiv samtidig.",
    "checkout_description_paragraph_1": "En kasseleverandør er motoren som håndterer betalingene dine. Betalingsalternativer er metodene kundene dine bruker til å betale. Én kasseleverandør kan tilby flere betalingsalternativer og samme betalingsalternativ kan finnes hos flere leverandører.",
    "checkout_description_paragraph_2": "Forskjellene ligger i hva du betaler i transaksjonspris (% av omsetningen), hvor mange dager du må vente for å få oppgjøret (oppgjørstid) og hvilke betalingsalternativer kasseleverandøren tilbyr.",
    "available_providers": "Tilgjengelige leverandører",
    "contact_qliro_to_order": "Kontakt Qliro for bestilling",
    "contact_nets_to_order": "Opprett Nets Easy",
    "go_to_nets_portal": "Gå til Nets-portalen",
    "demo_mode": "Demo",
    "demo_mode_description": "Kasseløsningen kjører mot sandkasse-miljøet — ingen ekte transaksjoner.",
    "compare_checkout_providers": "Sammenlign kasseleverandører",
    "payment_options": "Betalingsalternativer",
    "settlement_model": "Oppgjørsmodell",
    "settlement_multiple": "Flere utbetalinger",
    "settlement_single": "Én samlet utbetaling",
    "price_level": "Prisnivå",
    "price_level_low": "Lav",
    "price_level_medium": "Middels",
    "transaction_prices": "Transaksjonspriser",
    "view_prices": "Se priser",
    "settlement_time": "Oppgjørstid",
    "b2c_b2b": "B2C / B2B",
    "best_for": "Best for",
    "best_for_kco": "Fleksible oppgjør",
    "best_for_spennd": "Kombinert B2C og B2B",
    "best_for_qliro": "Samlet utbetaling",
    "best_for_nets_easy": "Integrert ordrebehandling",
    "best_for_vipps": "Enkel løsning",
    "best_for_demo": "Ny leverandør (test)",
    "checkout_gateways_demo_description": "En ny betalingsleverandør med direkte utbetaling og lave gebyrer. Støtter de vanligste betalingsmetodene og gir rask oppgjørstid.",
    "coming_soon": "Kommer snart",
    "vipps_standalone_description": "Vipps som egen kasseløsning med Vipps og Klarna.",
    "show_more": "Vis mer",
    "view_payment_options": "Endre betalingsalternativer",
    "hide_payment_options": "Skjul betalingsalternativer",
    "show_less": "Vis mindre",
    "included": "Inkludert",
    "registration_form_title": "Bestillingsskjema for Kustom Checkout",
    "registration_form_description": "For at du skal kunne ta imot betaling fra dine kunder, må betalingsleverandøren (Kustom) gjennomføre en godkjenning av nettbutikken din. Søknadsprosessen er enkel og tar kun noen få minutter å gjennomføre. Når den er godkjent, kan du begynne å ta imot betalinger i nettbutikken din.",
    "norway": "Norge",
    "business_information": "Bedriftsinformasjon",
    "organization_name": "Organisasjonsnavn",
    "organization_is_registered": "Organisasjonen er registrert",
    "subject_to_vat": "Underlagt MVA",
    "organization_category": "Organisasjonskategori",
    "choose_category": "Velg kategori",
    "support_email": "Support e-post",
    "support_phone": "Support telefon",
    "stakeholder_information": "Interessent / Eier / Hovedaksjonær",
    "person": "Person",
    "date_of_birth": "Fødselsdato",
    "owner": "Eier",
    "material_influencer": "Materiell påvirker",
    "street_address": "Gateadresse",
    "region": "Region/Fylke",
    "political_exposed_person": "Politisk utsatt person",
    "pep_role": "Politisk utsatt persons rolle",
    "pep_relationship": "Relasjon til politisk utsatt person",
    "add_person": "Legg til flere personer",
    "bank_account_information": "Bankkonto informasjon",
    "currency_code": "Valutakode",
    "nok": "NOK",
    "account_holder": "Kontoinnehaver (navn)",
    "iban_number": "IBAN-nummer",
    "iban_help_text": "Fyll inn Deres IBAN-NUMMER. Dette nummeret finner du eksempelvis fra kontoutskriten fra banken Deres, samt i Deres nettbank. Eksempel på IBAN-NUMMER er NO71 4482 0550 045",
    "You must accept the terms and conditions.": "Du må godta vilkårene og betingelsene.",
    "form_submitted_successfully": "Bestillingen er registrert, du vil bli kontaktet fortløpende",
    "kustom_accept_terms": "Jeg godtar",
    "kustom_terms_link_text": "vilkårene og betingelsene",
    "pep_head_of_state": "Statsoverhode",
    "pep_head_of_gov": "Statsleder",
    "pep_executive_gov_member": "Høytstående regeringsmedlem",
    "pep_deputy_minister": "Viseminister",
    "pep_parliament_member": "Parlamentleder",
    "pep_supreme_court_judge": "Høyesterettsdommer",
    "pep_const_court_judge": "Lagmannsrettdommer",
    "pep_auditing_auth_officer": "Revisjonsvirker",
    "pep_central_bank_boards_membr": "Sentralbankstyremedlem",
    "pep_ambassador": "Ambassadør",
    "pep_international_org_leader": "Internasjonall bedriftsleder",
    "pep_armed_forces_officer": "Militærleder",
    "pep_state_owned_enterprise_bodies_member": "Statseid bedriftsleder",
    "pep_relationship_close_associate": "Nær sammarbeidspartner/assistent",
    "pep_relationship_spouse": "Ektefelle",
    "pep_relationship_partner": "Partner",
    "pep_relationship_children": "Barn",
    "pep_relationship_children_spouses_or_partners": "Barn, ektefelle eller partner",
    "category_automotive_products": "Automotive Products",
    "category_automotive_parts_and_accessories": "Automotive Parts & Accessories",
    "category_wheels_and_tires": "Wheels & Tires",
    "category_children_products": "Children Products",
    "category_children_clothes_and_nurturing_products": "Children Clothes & Nurturing products",
    "category_children_toys": "Children toys",
    "category_diversified_children_products": "Diversified children products",
    "category_clothing_and_shoes": "Clothing & Shoes",
    "category_adult_shoes_and_clothing": "Adult Shoes & Clothing",
    "category_general_shoes_and_clothing": "General Shoes & Clothing",
    "category_underwear": "Underwear",
    "category_youthful_shoes_and_clothing": "Youthful Shoes & Clothing",
    "category_electronics": "Electronics",
    "category_car_electronics": "Car electronics",
    "category_diversified_electronics": "Diversified electronics",
    "category_electronic_equipment_and_related_accessories": "Electronic equipment & Related accessories",
    "category_household_electronics": "Household electronics (whitegoods/appliances)",
    "category_office_machines_and_related_accessories": "Office machines & Related accessories (excl. computers)",
    "category_book_and_magazines": "Books & Magazines",
    "category_diversified_entertainment": "Diversified entertainment",
    "category_music_and_movies": "Music & Movies",
    "category_video_games_and_related_accessories": "Video Games & Related accessories",
    "category_erotic_materials": "Erotic Materials",
    "category_diversified_erotic_material": "Diversified erotic material",
    "category_erotic_clothing_and_accessories": "Erotic Clothing & Accessories",
    "category_sex_toys": "Sex toys",
    "category_food_and_beverage": "Food & Beverage",
    "category_candy": "Candy",
    "category_tobacco": "Tobacco",
    "category_wine_beer_and_liquor": "Wine, Beer & Liquor",
    "category_health_and_beauty": "Health & Beauty",
    "category_body_and_hair_care": "Body & Hair Care",
    "category_cosmetics": "Cosmetics",
    "category_dietary_supplements": "Dietary supplements",
    "category_diversified_health_and_beauty_products": "Diversified Health & Beauty products",
    "category_fragrances": "Fragrances",
    "category_personal_care_and_body_improvement": "Personal care & Body improvement",
    "category_pharmaceutical_products": "Pharmaceutical products",
    "category_prescription_optics": "Prescription optics",
    "category_home_and_garden": "Home & Garden",
    "category_cleaning_and_sanitary": "Cleaning & Sanitary",
    "category_decoration_and_art": "Decoration & Art",
    "category_diversified_home_and_garden_products": "Diversified Home & Garden products",
    "category_furniture": "Furniture",
    "category_kitchenware": "Kitchenware",
    "category_pet_supplies": "Pet supplies",
    "category_plants_and_flowers": "Plants & Flowers",
    "category_safety_products": "Safety products",
    "category_tools_and_home_improvement": "Tools & Home improvement",
    "category_intangible_products": "Intangible products",
    "category_dating_services": "Dating services",
    "category_digital_services": "Digital services",
    "category_education": "Education",
    "category_event_tickets": "Event tickets",
    "category_marketplaces": "Marketplaces",
    "category_other_services": "Other services",
    "category_travel_services": "Travel services",
    "category_jewelry_and_accessories": "Jewelry & Accessories",
    "category_bags_and_wallets": "Bags & Wallets",
    "category_diversified_jewelry_and_accessories": "Diversified Jewelry & Accessories",
    "category_jewelry_and_watches": "Jewelry & Watches",
    "category_non_prescription_sunglasses_and_lenses": "Non-prescription sunglasses and lenses",
    "category_leisure_sport_and_hobby": "Leisure, Sport & Hobby",
    "category_collectibles": "Collectibles",
    "category_concept_stores_and_miscellaneous": "Concept stores & Miscellaneous",
    "category_costumes_and_party_supplies": "Costumes & Party supplies",
    "category_hobby_articles": "Hobby articles",
    "category_musical_instruments_and_equipment": "Musical Instruments & Equipment",
    "category_prints_and_photos": "Prints & Photos",
    "category_sports_gear_and_outdoor": "Sports gear & Outdoor",
    "email_text": "Ekstra tekst som vises på e-post til kunde etter kjøp. F.eks. informasjon om hvordan de skal betale for ordren.",
    "receipt_page_text": "Ekstra tekst som vises på kvitteringssiden etter kjøp. F.eks. informasjon om hvordan de skal betale for ordren.",
    "email_text_label": "Ekstra tekst på e-post",
    "receipt_page_text_label": "Ekstra tekst på kvitteringssiden",
    "shipping_max_weight": "maksvekt",
    "shipping_max_weight_help": "Fraktmetoden skjules i kassen når kurvens totale vekt er over denne grensen. La stå tom eller 0 for ingen grense.",
    "shipping_order_confirmation_text": "Ekstra tekst som vises i ordrebekreftelsen på e-post, basert på valgt fraktmetode. F.eks. hentested og åpningstider.",
    "shipping_fulfillment_text": "Ekstra tekst som vises i e-posten når ordren er klar eller sendt, basert på valgt fraktmetode. F.eks. at kunden tar med ordrenummeret ved henting.",
    "customer_invalid_data": "Ugyldig kundedata.",
    "customer_type_must_be_string": "Kundetype må være en tekst.",
    "customer_first_name_must_be_string": "Fornavn må være en tekst.",
    "customer_last_name_must_be_string": "Etternavn må være en tekst.",
    "customer_email_must_be_valid": "E-post må være en gyldig e-postadresse.",
    "customer_phone_must_be_string": "Telefonnummer må være en tekst.",
    "delivery_address_invalid_data": "Ugyldig leveringsadresse data.",
    "delivery_address_street_must_be_string": "Leveringsadresse gate må være en tekst.",
    "delivery_address_postal_code_must_be_numeric": "Leveringsadresse postnummer må være numerisk.",
    "delivery_address_postal_code_must_be_4_digits": "Leveringsadresse postnummer må være 4 siffer.",
    "delivery_address_city_must_be_string": "Leveringsadresse by må være en tekst.",
    "delivery_address_country_must_be_string": "Leveringsadresse land må være en tekst.",
    "shipping_method_identifier_must_be_string": "Fraktmetode identifikator må være en tekst.",
    "pickup_point_invalid_data": "Ugyldig hentepunkt data.",
    "pickup_point_city_must_be_string": "Hentepunkt by må være en tekst.",
    "pickup_point_identifier_must_be_string": "Hentepunkt identifikator må være en tekst.",
    "pickup_point_name_must_be_string": "Hentepunkt navn må være en tekst.",
    "pickup_point_postal_code_must_be_string": "Hentepunkt postnummer må være en tekst.",
    "pickup_point_street_must_be_string": "Hentepunkt gate må være en tekst.",
    "payment_invalid_data": "Ugyldig betalingsdata.",
    "payment_selected_identifier_must_be_string": "Valgt betalingsidentifikator må være en tekst.",
    "promo_code_must_be_string": "Rabattkode må være en tekst.",
    "promo_code_does_not_exist": "Rabattkoden finnes ikke.",
    "insight": "innsikt",
    "insights": "innsikt",
    "payment_method_distribution": "Betalingsmåter",
    "payment_method_distribution_comparison": "Sammenlignet Betalingsmåter",
    "shipping_method_distribution": "Fraktmåter",
    "shipping_method_distribution_comparison": "Sammenlignet fraktmåter",
    "orders_per_day": "Order per dag",
    "compare_orders_per_day": "Sammenlignet ordre per dag",
    "profit_per_day": "Profit per dag",
    "compare_profit_per_day": "Sammenlignet profitt per dag",
    "revenue_per_day": "Omsetning per dag",
    "cost_of_goods_sold": "Varekostnad",
    "cogs_per_day": "Kostnad solgte varer per dag",
    "profit_margin": "Fortjenestemargin",
    "total_revenue": "Total omsetning",
    "customer_type_distribution": "Kundetype fordeling",
    "shipping_per_day": "Kostnad frakt per dag",
    "number_of_orders": "Antall ordre",
    "gross_income": "Bruttoinntekt",
    "profitability_percentage": "Dekningsbidrag",
    "db": "DB %",
    "january": "Januar",
    "february": "Februar",
    "march": "Mars",
    "april": "April",
    "may": "Mai",
    "june": "Juni",
    "july": "Juli",
    "august": "August",
    "september": "September",
    "october": "Oktober",
    "november": "November",
    "december": "Desember",
    "same_month_last_year": "Samme måned forrige år",
    "compare_period": "Sammenlign periode",
    "compare_last_month": "Sammenlign forrige måned",
    "compare_last_year": "Sammenlign forrige år",
    "period": "Sammenlignet med",
    "product_revenue": "Produktomsetning",
    "preorder_text": "Forhåndsvisningstekst",
    "preorder_text_description": "Tekst som vises på produktet når det er tilgjengelig for forhåndsbestilling",
    "preorder_text_placeholder": "Forventet på lager",
    "date_expected_in_stock": "Forventet dato på lager",
    "date_expected_in_stock_description": "Angi en dato for når utsolgte produkter med \"Tillat restordre\" aktivert forventes på lager. Merk: Dette vil sette status på produktet som \"Forhåndsbestilling\" når produktet er utsolgt.",
    "qty_expected": "Forventet antall",
    "qty_expected_description": "Antall varer som forventes tilbake på lager på den angitte datoen.",
    "date_and_qty_expected_set_per_variant": "Forventet dato og antall settes per produktvariant i tabellen Produktvarianter.",
    "more": "Mer",
    "empty": "Tøm",
    "do_you_want_to_manage_the_offer_period": "Vil du styre tilbudsperioden?",
    "if_turned_off_the_offer_starts_today": "Hvis av, starter tilbudet i dag og har ingen sluttdato",
    "show": "Vis",
    "no_options_available": "Ingen alternativer tilgjengelig",
    "type_to_add_option": "Skriv for å begynne å opprette et alternativ",
    "variant_price_discrepancy_warning": "Én eller flere varianter har en annen pris enn de øvrige. Hvis du legger inn en ny pris i feltet under, vil denne gjelde for alle varianter",
    "all_variants": "Alle varianter",
    "product_is_on_sale": "Produktet er på tilbud",
    "send_email_to_customer": "Send e-post til kunde",
    ":name(:email)_sent_email_to_customer": ":name (:email) sendte e-post til kunde:",
    "subject": "Emne",
    "body": "Innhold",
    "customer_message_description": "<strong>Fra e-post:</strong> :fromEmail<br><strong>Til e-post:</strong> :toEmail<br><strong>Emne:</strong> :subject<br><br><strong>Innhold:</strong><br> :body :attachments",
    "email_sent": "E-post sendt",
    "send_email": "Send e-post",
    "order_confirmation": "Ordrebekreftelse",
    "cancellation_form": "Angrerettsskjema",
    "attachments": "Vedlegg",
    "refund": "Kreditering",
    "xledger_headline": "Xledger regnskap",
    "xledger_description": "Integrasjonen overfører ordredata sømløst mellom din 24Nettbutikk og regnskapssystemet.",
    "third_party_app_text_1": "Om integrasjonen",
    "third_party_app_text_2": "Integrasjonen henter ut ordredata fra butikken din og importerer dem i regnskapssystemet. Det kan settes opp forskjellig levering av ordrene basert på betalingsmåte, for eksempel om de betalte ordrene skal bokføres mens andre skal faktureres.",
    "third_party_app_text_3": "Vi samarbeider med den norske integrasjonspartneren iizy for å levere denne løsningen. iizy har bred erfaring og støtter mer enn 250 ulike systemer.",
    "third_party_app_text_4": "Utforsk alle tilgjengelige integrasjoner og se gjeldende priser her.",
    "third_party_app_text_5": "Hvem passer integrasjonen for?",
    "third_party_app_text_6": "Denne integrasjonen passer for alle som i dag har nettbutikken sin i 24Nettbutikk og ønsker en sømløs overføring av ordredata til sitt regnskapssystem.",
    "third_party_app_text_7": "Hva koster integrasjonen?",
    "third_party_app_text_8": "Som kunde hos 24Nettbutikk betaler du fast pris for hver integrasjon. Se prisliste hos iizy",
    "third_party_app_text_9": "Bestilling",
    "third_party_app_text_10": "Klikk for bestilling",
    "third_party_app_text_11": "For å sette opp en kobling mellom din 24Nettbutikk og regnskapsprogrammet trenger du en API-nøkkel – denne gir systemene tilgang til å overføre ordredata automatisk.",
    "third_party_app_text_12": "Slik generer du API nøkkel",
    "documentation": "Dokumentasjon",
    "here": "her",
    "zirius_headline": "Zirius regnskap",
    "zirius_description": "Integrasjonen overfører ordredata sømløst mellom din 24Nettbutikk og regnskapssystemet.",
    "visma_business_nxt_headline": "Visma Business NXT regnskap",
    "visma_business_nxt_description": "Integrasjonen overfører ordredata sømløst mellom din 24Nettbutikk og regnskapssystemet.",
    "vismaeaccounting_headline": "Visma eAccounting  regnskap",
    "vismaeaccounting_description": "Integrasjonen overfører ordredata sømløst mellom din 24Nettbutikk og regnskapssystemet.",
    "visma_headline": "Visma regnskap",
    "visma_description": "Integrasjonen overfører ordredata sømløst mellom din 24Nettbutikk og regnskapssystemet.",
    "unimicro_headline": "Unimicro regnskap",
    "unimicro_description": "Integrasjonen overfører ordredata sømløst mellom din 24Nettbutikk og regnskapssystemet.",
    "sparebank1regnskap_headline": "SpareBank 1  regnskap",
    "sparebank1regnskap_description": "Integrasjonen overfører ordredata sømløst mellom din 24Nettbutikk og regnskapssystemet.",
    "systima_headline": "Systima regnskap",
    "systima_description": "Integrasjonen overfører ordredata sømløst mellom din 24Nettbutikk og regnskapssystemet.",
    "poweroffice_headline": "PowerOffice regnskap",
    "poweroffice_description": "Integrasjonen overfører ordredata sømløst mellom din 24Nettbutikk og regnskapssystemet.",
    "duett_headline": "Duett regnskap",
    "duett_description": "Integrasjonen overfører ordredata sømløst mellom din 24Nettbutikk og regnskapssystemet.",
    "dnbregnskap_headline": "DNB regnskap",
    "dnbregnskap_description": "Integrasjonen overfører ordredata sømløst mellom din 24Nettbutikk og regnskapssystemet.",
    "conta_headline": "Conta regnskap",
    "conta_description": "Integrasjonen overfører ordredata sømløst mellom din 24Nettbutikk og regnskapssystemet.",
    "twentyfoursevenoffice_headline": "Finago regnskap",
    "twentyfoursevenoffice_description": "Integrasjonen overfører ordredata sømløst mellom din 24Nettbutikk og Finago regnskapssystemet.",
    "tripletex_iizy_headline": "Tripletex regnskap",
    "tripletex_iizy_description": "Integrasjonen overfører ordredata sømløst mellom din 24Nettbutikk og regnskapssystemet.",
    "fiken_iizy_headline": "Fiken regnskap",
    "fiken_iizy_description": "Integrasjonen overfører ordredata sømløst mellom din 24Nettbutikk og regnskapssystemet.",
    "elfsight_instagramslider_app_text_2": "En Instagram-visning i nettbutikken gjør butikken mer levende og troverdig ved å vise ekte og oppdatert innhold. Den hjelper kundene å se produktene i bruk, skaper inspirasjon og kan gjøre det enklere å ta en kjøpsbeslutning. Samtidig kobler den sosiale medier tettere til nettbutikken, styrker merkevaren og kan bidra til både økt engasjement og høyere konvertering.",
    "elfsight_instagramslider_app_text_6": "Dette passer best for nettbutikker som ønsker å bygge tillit, vise produkter visuelt og skape en sterkere merkevare. Det er særlig relevant for butikker innen mote, interiør, skjønnhet, sport og livsstil, men også for bedrifter som bruker Instagram aktivt til inspirasjon, kundebilder eller lanseringer.",
    "instagram_slider_headline": "Instagram bildekarusell",
    "instagram_slider_description": "Vis dine Instagram bilder i en karusell eller grid på forsiden.",
    "instagram_description": "Vis dine Instagram bilder i en karusell eller grid på forsiden.",
    "socials": "Sosiale medier",
    "youtube_description": "Vis dine Youtube videoer i en karusell eller grid på forsiden.",
    "youtube_feed_headline": "Youtube feed",
    "youtube_feed_description": "Vis frem YouTube-guidene og produktvideoene dine for å øke synligheten, holde seerne engasjert og gjøre innholdet ditt til en sterkere drivkraft for leads og salg.",
    "elfsight_youtubefeed_app_text_2": "Et YouTube-galleri i nettbutikken din gjør det enkelt å bruke video som et effektivt salgsverktøy der kundene faktisk tar kjøpsbeslutningen. Video gir liv til produktene dine på en måte bilder og tekst alene ikke kan, ved å vise funksjon, kvalitet og bruk i praksis. Når kundene kan se guider, demonstrasjoner og anmeldelser direkte i nettbutikken, bygger du raskere tillit og reduserer usikkerhet før kjøp. Samtidig holder du besøkende lenger på siden, noe som øker engasjementet og sannsynligheten for konvertering. Et YouTube-galleri lar deg gjenbruke eksisterende videoinnhold og forvandle det til en aktiv salgsdriver som styrker både merkevaren din, kundereisen og omsetningen.",
    "elfsight_youtubefeed_app_text_6": "Dette passer best for nettbutikker som ønsker å bygge tillit, vise produkter visuelt og skape en sterkere merkevare. Det er særlig relevant for butikker innen mote, interiør, skjønnhet, sport og livsstil, men også for bedrifter som bruker Youtube aktivt til inspirasjon, kundevideoer, referanser eller eller guider.",
    "tiktok_description": "Vis dine TikTok innlegg i en karusell eller grid på forsiden.",
    "tiktok_feed_headline": "TikTok feed",
    "elfsight_tiktok_app_text_2": "En TikTok-feed er viktig fordi den lar merkevaren din møte kundene på en måte som føles naturlig, autentisk og relevant i dagens digitale landskap. Videoene fanger raskt oppmerksomheten og kommuniserer budskapet ditt på få sekunder, noe som passer perfekt med hvordan brukere konsumerer innhold i dag. Ved å vise en TikTok-feed kan du fremheve personlighet, trender og ekte kundemøter, noe som styrker tillit og gjør merkevaren mer menneskelig. Samtidig skaper levende og underholdende innhold høyere engasjement, holder besøkende lenger på siden og øker sjansen for at de deler innholdet videre. En aktiv TikTok-feed signaliserer også at merkevaren er oppdatert og i takt med markedet, noe som kan være avgjørende for å skille seg ut og bygge en sterk relasjon til både nye og eksisterende kunder.",
    "tiktok_feed_description": "Presenter TikTok-klipp, korte videoer og viralt innhold for å øke engasjementet og vise frem merkevaren din på en dynamisk, trendbevisst og underholdende måte.",
    "elfsight_tiktok_app_text_6": "Dette passer spesielt godt for visuelle nettsteder og nettbutikker der produkter, stil og inspirasjon er viktig for kjøpsbeslutningen. Typiske eksempler er nettbutikker innen mote og klær, interiør og møbler, skjønnhet og kosmetikk, sport og friluft, smykker og accessories samt kunst, design og livsstilsprodukter. Det egner seg også godt for merkevarenettsteder, kampanjesider og nettbutikker som bygger på historiefortelling, kundebilder eller brukergenerert innhold, og for virksomheter som allerede er aktive på Instagram og ønsker å knytte sosiale medier tettere til salgsopplevelsen.",
    "googlereviews_description": "Vis dine Google anmeldelser på forsiden av din nettbutikk.",
    "googlereviews_headline": "Google Reviews",
    "elfsight_googlereviews_app_text_2": "Vis frem kundeanmeldelser fra Google for å bygge tillit og hjelpe besøkende med å vurdere servicekvalitet, bedriftens omdømme og den totale kundeopplevelsen før de velger deg.",
    "elfsight_googlereviews_app_text_6": "Google Reviews passer spesielt godt for nettbutikker fordi kundene ikke har mulighet til å se, ta på eller oppleve produktene fysisk før kjøp. Anmeldelser fra ekte kunder fungerer derfor som et viktig tillitssignal som reduserer usikkerhet og senker terskelen for å handle. Når en nettbutikk viser frem Google Reviews, får potensielle kjøpere innsikt i leveringstid, kundeservice, produktkvalitet og den totale handleopplevelsen. Dette gjør det enklere å ta en trygg kjøpsbeslutning og øker sannsynligheten for konvertering. Samtidig styrker Google Reviews nettbutikkens troverdighet og synlighet i søk, noe som bidrar til både mer trafikk og høyere salg.",
    "order_license_before_ordering_apps": "Du må ha et aktivt 24Next abonnement før du kan bestille apps.",
    "third_party_app_customer_information": "Appen legges til manuelt av vårt supportteam så snart som mulig. Dersom vi har spørsmål rundt oppsettet av appen i butikken din, tar vi kontakt med deg.",
    "third_party_app_already_owned": "Du er allerede eier av denne appen",
    "theme_block_is_new_description": "Blokken er ny og vil automatisk bli synlig når malen publiseres, med mindre publisering er slått av for blokken",
    "edit_internal_name_of_block": "Rediger internt navn til blokk",
    "24_shipping_price_desc": "Med 24Shipping får du tilgang til markedets beste fraktpriser hos Bring og PostNord – allerede fra første sending. Rabattene gjelder uavhengig av volum og er basert på hvilken plan du har: StartUp, Premium eller Premium Pluss.Viktig! Har du høyt volum? Ta gjerne kontakt med oss – så skreddersyr vi en løsning som passer dine behov best.",
    "customer_text_label_placeholder": "Trykk på t-skjorte",
    "extra_cost": "Tilleggspris for dette valget",
    "customer_text": "Fritekstfelt",
    "customer_text_description": "Gir kunden mulighet til å legge inn egen tekst som trykk eller gravering på produktet, for eksempel på en t-skjorte",
    "field_heading": "Overskrift til feltet",
    "form_type": "Skjematype",
    "form_type_description": "Kontaktskjema brukes til generelle henvendelser, mens produktskjema samler inn produktspesifikk informasjon og lagrer den sammen med ordren",
    "contact": "Kontakt",
    "product_form": "Produktskjema",
    "product_contact_form": "Kontaktskjema",
    "product_contact_form_admin_title": "Kontaktskjema på produktsiden",
    "product_contact_form_admin_description": "Velg et kontaktskjema som kundene kan sende inn fra dette produktet. Produktnavnet følger med henvendelsen. Skjemaet vises bare på produkter der det er valgt her, og sub-blokken «Kontaktskjema» må være slått på i produktsidemalen i designeditoren.",
    "product_contact_form_tooltip_text": "Lar kunder sende en henvendelse direkte fra produktsiden, uten å legge produktet i handlekurven.<br><br>Produktnavnet legges automatisk inn i innsendingen, slik at du ser hvilket produkt henvendelsen gjelder både i e-posten og under Skjemaer → Innsendinger.",
    "create_contact_form_link": "Opprett et kontaktskjema",
    "product_contact_form_app": "Kontaktskjema på produkter",
    "product_contact_form_app_description": "La kundene sende en henvendelse rett fra produktsiden. Du velger hvilke produkter som skal ha skjema, og produktnavnet følger automatisk med henvendelsen.",
    "product_contact_form_app_heading": "Kontaktskjema på produkter – få henvendelser om akkurat det produktet",
    "product_contact_form_app_sub_heading": "Noen produkter trenger en samtale før kjøpet: prisforespørsler, spesialmål, tilpasninger eller store bestillinger. Med denne appen legger du et kontaktskjema på nettopp de produktene, og kunden slipper å forklare hvilket produkt det gjelder.",
    "product_contact_form_app_how_it_works_1": "Lag et kontaktskjema i skjemabyggeren, eller bruk et du allerede har.",
    "product_contact_form_app_how_it_works_2": "Velg skjemaet på hvert produkt som skal ha det, under «Kontaktskjema på produktsiden» i produktredigeringen.",
    "product_contact_form_app_how_it_works_3": "Slå på sub-blokken «Kontaktskjema» i produktsidemalen i designeditoren, og bestem om skjemaet skal være synlig eller ligge bak en knapp.",
    "product_contact_form_app_how_it_works_4": "Hver henvendelse lagres under Skjemaer → Innsendinger og sendes på e-post, med produktnavnet som første linje.",
    "product_contact_form_app_how_it_works_5": "Appen er gratis og inkludert med Skjemabygger. Bestill den og slå den på under appens innstillinger, så vises boksen i produktredigeringen og sub-blokken i designeditoren.",
    "product_contact_form_app_requires_form_builder": "Krever at appen Skjemabygger er aktiv, siden skjemaene lages der. Bryteren for denne appen kan slås på først når Skjemabygger er på.",
    "product_contact_form_display_style": "Visning",
    "product_contact_form_display_always": "Alltid synlig",
    "product_contact_form_display_collapsible": "Bak en knapp",
    "product_contact_form_button_label": "Knappetekst",
    "product_contact_form_button_label_description": "Teksten på knappen som åpner skjemaet.",
    "no_form": "Ingen skjema",
    "invalid_value_for": "Ugyldig verdi for :name",
    "product_form_must_be_completed": "Dette produktet krever at du fyller ut et skjema. Gå til produktsiden for å fullføre kjøpet.",
    "(and :count more error)": "(og :count feil til)",
    "(and :count more errors)": "(og :count feil til)",
    "buyable_not_available": "Produktet er ikke tilgjengelig for kjøp",
    "buyable_id_and_type_not_valid": "Produktet kunne ikke legges i handlekurven",
    "product_form_tooltip_text": "Produktskjema lar deg samle inn tilpasset informasjon fra kunder når de legger et produkt i handlekurven – som graveringstekst, hilsener eller spesialmål.<br><br>Skjemafeltene vises på produktsiden, og innsendt data lagres sammen med ordren.<br><br>Du kan også sette en tilleggskostnad som legges til produktprisen når et skjema er knyttet til produktet.",
    "additional_cost": "Tilleggskostnad",
    "additional_cost_placeholder": "0,00",
    "additional_cost_help": "Tilleggskostnad som legges til produktprisen når dette skjemaet er valgt",
    "create_product_form_link": "Opprett et produktskjema",
    "b2b_app_description": "Aktiver B2B-utsjekk og vis priser ekskl. mva for bedriftskunder",
    "b2b_app_headline": "B2B for bedriftskunder",
    "b2b_app_subline": "Gi bedriftskunder mulighet til å handle med organisasjonsnummer og se priser ekskl. mva.",
    "b2b_app_advantages_heading": "Fordeler med B2B",
    "b2b_app_advantage_1": "Vis priser ekskl. mva for bedriftskunder",
    "b2b_app_advantage_2": "Egne felt for organisasjonsnummer, prosjekt og avdeling i kassen",
    "b2b_app_advantage_3": "La kunder velge om de er privat- eller bedriftskunde",
    "b2b_app_advantage_4": "Sett bedrift som standard kundetype for B2B-fokuserte butikker",
    "b2b_enabled": "Aktiver B2B",
    "b2b_enabled_description": "Aktiverer B2B-utsjekk og mulighet for priser ekskl. mva",
    "b2b_is_b2b_by_default": "B2B som standard",
    "b2b_is_b2b_by_default_description": "Nye besøkende ser priser ekskl. mva og behandles som bedriftskunder som standard",
    "b2b_show_customer_type_modal": "Vis kundetype-modal",
    "b2b_show_customer_type_modal_description": "Vis en modal som spør kunden om de er bedrift eller privatkunde ved første besøk",
    "b2b_customer_type_question": "Hva slags kunde er du?",
    "b2b_customer_type_description": "Bedriftskunder får priser vist ekskl. mva",
    "b2b_private_customer": "Privatkunde",
    "b2b_business_customer": "Bedriftskunde",
    "b2b_requires_compatible_checkout": "B2B krever minst én betalingsmåte aktivert for :checkout",
    "b2b_checkout_default": "Standard utsjekk for B2B",
    "b2b_checkout_default_description": "Velg hvilken utsjekk som skal brukes for B2B-kunder",
    "b2b_checkout_checkout_gateways_spennd": "Spennd",
    "b2b_checkout_checkout_gateways_kco": "Kustom Checkout",
    "b2b_checkout_checkout_gateways_qliro": "Qliro Checkout",
    "b2b_checkout_checkout_gateways_nets_easy": "Nets Easy",
    "b2b_checkout_settings": "B2B-innstillinger",
    "validation.organization_number_invalid": "Ugyldig organisasjonsnummer",
    "validation.phone_invalid": "Ugyldig telefonnummer",
    "validation.phone_required": "Telefonnummer er påkrevd",
    "validation.company_name_required": "Firmanavn er påkrevd",
    "validation.organization_number_required": "Organisasjonsnummer er påkrevd",
    "filtering": "Filtrering",
    "filtering_description": "filtre vises på kategori- og søkesider, og lar kundene snevre inn produkter etter egenskaper som størrelse, farge eller prisklasse. Filtergrupper genereres automatisk fra produktalternativer (varianter) og attributter. Sorteringen er global og gjelder for alle sider der produkter kan filtreres. Dra og slipp for å endre rekkefølgen.",
    "filtering_sale_filter_row": "På tilbud",
    "filtering_stock_filter_row": "På lager",
    "filtering_theme_managed_badge": "Designbygger",
    "filtering_theme_managed_note": "Slås av og på i designbyggeren under Kategoriside → Filtrering",
    "filtering_design_builder_hint": "Plassering og utseende på filtreringen styrer du i designbyggeren.",
    "open_design_builder": "Åpne designbyggeren",
    "category_filters_admin_hint": "Hvilke filtre som vises, og rekkefølgen på dem, styrer du på Filtrering-siden under Produkter.",
    "open_filtering_page": "Åpne Filtrering",
    "filtering_empty_state_title": "Ingen filtergrupper ennå",
    "filtering_empty_state_description": "Filtergrupper opprettes automatisk fra produktalternativer og attributter. Legg til alternativer (som Størrelse eller Farge) eller attributter på produktene dine, så dukker de opp her.",
    "filtering_go_to_products": "Gå til produkter",
    "filtering_source_option": "Variant",
    "filtering_source_attribute": "Attributt",
    "filtering_source_both": "Variant + Attributt",
    "filter_visibility": "Filtersynlighet",
    "filter_visibility_description": "Velg hvilke filtre som skal vises på kategori- og søkesider i nettbutikken.",
    "price_filter": "Prisfilter",
    "facet_filters": "Filtergrupper",
    "inherit": "Arv",
    "filter_visibility_inherit_description": "\"Arv\" bruker den globale standardinnstillingen. Du kan endre standardene under",
    "filter_visibility_global_link": "filtrering",
    "unsaved_changes": "du har ulagrede endringer",
    "updating_preview": "Oppdaterer forhåndsvisning ...",
    "reset_to_default": "Tilbakestill",
    "pi_column_gap": "Avstand mellom kolonner",
    "pi_sub_block_spacing": "Avstand mellom elementer",
    "pi_vertical_padding": "Avstand over og under",
    "unsaved_changes_confirm": "Du har ulagrede endringer. Er du sikker på at du vil forlate siden?",
    "expand_all": "utvid alle",
    "collapse_all": "skjul alle",
    "group": "gruppe",
    "groups": "grupper",
    "value": "verdi",
    "values": "verdier",
    "search_blocks": "Søk etter blokker",
    "no_blocks_found": "Ingen blokker funnet",
    "block_category_products": "Produkter",
    "block_category_media": "Media",
    "block_category_content": "Innhold",
    "block_category_marketing": "Markedsføring",
    "block_description_product_grid": "Vis produkter i et rutenett",
    "block_description_product_slider": "Vis produkter i en horisontal glidebryter",
    "block_description_single_product": "Fremhev et enkelt produkt med detaljer",
    "block_description_image_grid": "Vis bilder i et rutenett",
    "block_description_bento_grid": "Vis bilder i et asymmetrisk bento-rutenett",
    "block_description_image_grid_slider": "Vis flere bilder i en horisontal glidebryter",
    "block_description_image_slider": "Vis bilder i en horisontal glidebryter",
    "block_description_before_after_image": "Sammenlign to bilder med en drabar slider — kunden drar for å avsløre etter-bildet",
    "before_image": "Før-bilde",
    "after_image": "Etter-bilde",
    "before_label": "Før-tekst",
    "after_label": "Etter-tekst",
    "initial_slider_position": "Start-posisjon for slider",
    "initial_slider_position_description": "Hvor slider-håndtaket står når siden lastes (0 = helt til venstre, 100 = helt til høyre).",
    "block_description_hero_image_text": "Stort bilde med tekstoverlegg",
    "block_description_hero_background_image_text": "Fullbredde bakgrunnsbilde med tekst",
    "block_description_text_content": "Seksjon med rikt tekstinnhold",
    "block_description_faq": "Ofte stilte spørsmål med utvidbare svar",
    "block_description_form": "Tilpassbart kontakt- eller henvendelsesskjema",
    "block_description_campaign_bar": "Reklamebanner for kampanjer og tilbud",
    "block_description_newsletter_signup": "E-postregistrering for nyhetsbrev",
    "customer_club_block": "Kundeklubb",
    "block_description_customer_club": "Verv medlemmer til kundeklubben med velkomstbonus og poengrate, og vis medlemmene saldoen sin.",
    "customer_club_block_layout_banner": "Banner",
    "customer_club_block_layout_benefits": "Fordeler",
    "customer_club_block_layout_steps": "Slik fungerer det",
    "customer_club_block_layout_calculator": "Kalkulator",
    "customer_club_block_calculator_max": "Kalkulatorens maksbeløp (kr)",
    "customer_club_block_calculator_max_description": "Øvre grense på glidebryteren. Startverdien blir en femtedel av dette.",
    "customer_club_block_layout_description": "Banner er én flate med tekst og knapp. Fordeler viser tre kort. Slik fungerer det viser stegene fra innmelding til rabatt. Kalkulator lar kunden dra et beløp og se poeng og verdi.",
    "customer_club_block_show_bonus": "Vis velkomstbonus",
    "customer_club_block_show_bonus_description": "Vises bare for ikke-medlemmer, og bare når velkomstbonusen i kundeklubb-innstillingene er over null.",
    "customer_club_block_show_rate": "Vis poengrate",
    "customer_club_block_show_rate_description": "Gjelder banner-layouten. Fordeler-layouten viser alltid raten i kortene.",
    "customer_club_block_member_title": "Tittel for medlemmer",
    "customer_club_block_member_title_description": "Vises til innloggede medlemmer sammen med saldoen deres.",
    "customer_club_block_member_button_text": "Knappetekst for medlemmer",
    "customer_club_block_button_style_description": "«Med bakgrunn» bruker temaets knappefarge. På en mørk flate passer ofte «Tekstfargen som bakgrunn» eller «Med ramme» bedre.",
    "block_description_category_buttons": "Vis kategorier som klikkbare knapper",
    "block_description_featured_blog_posts": "Vis fremhevede blogginnlegg i en slider",
    "featured_blog_posts": "Fremhevede blogginnlegg",
    "featured_blog_posts_select_tag": "Velg en tagg for å filtrere blogginnlegg. La stå tom for å vise de nyeste.",
    "blog_tag": "Bloggtag",
    "number_of_posts": "Antall innlegg",
    "show_date": "Vis dato",
    "show_tags": "Vis tagger",
    "block_title_color": "Blokkens tittelfarge",
    "some_variants_have_different_prices": "Noen varianter har forskjellige priser",
    "global": "globalt",
    "search_for_menu": "Søk etter meny",
    "confirm_delete_campaign_text": "Er du sikker på at du vil slette kampanjeteksten?",
    "unsupported_file_type": "Ustøttet filtype",
    "file_too_large": "Filen {name} er for stor, maks filstørrelse er {size}MB",
    "theme_block_media_too_large": "Bildet er for stort. Maks filstørrelse er :size MB.",
    "theme_block_media_required": "Ingen fil ble mottatt. Velg en fil og prøv igjen.",
    "uploaded_file_too_large_for_server": "Filen er for stor til å lastes opp. Bruk en mindre fil.",
    "block_duplicated": "Blokk duplisert",
    "fullscreen_preview": "Fullskjermvisning",
    "exit_fullscreen": "Avslutt fullskjerm",
    "dark_mode": "Mørk modus",
    "light_mode": "Lys modus",
    "video_hero": "Videobanner",
    "background_video": "Bakgrunnsvideo",
    "video_url": "Video-URL",
    "video_controls": "Videokontroller",
    "video_show_controls": "Vis videokontroller",
    "video_show_controls_description": "Legger spill/pause, start på nytt og lyd av/på oppå videoen. Videoen starter fortsatt av seg selv uten lyd.",
    "block_height_mobile": "Høyde på mobil",
    "follow_desktop": "Følg desktop",
    "video_controls_placement": "Plassering av kontrollene",
    "video_controls_size": "Størrelse på kontrollene",
    "bottom_right": "Nede til høyre",
    "bottom_left": "Nede til venstre",
    "top_right": "Oppe til høyre",
    "top_left": "Oppe til venstre",
    "video_play": "Spill av video",
    "video_pause": "Sett video på pause",
    "video_restart": "Start videoen på nytt",
    "video_mute": "Slå av lyden",
    "video_unmute": "Slå på lyden",
    "video_url_description": "Lim inn en YouTube- eller Vimeo-lenke, for eksempel https://www.youtube.com/watch?v=…, https://youtu.be/… eller https://vimeo.com/…. Videoen spilles av automatisk, uten lyd og i loop.",
    "video_url_youtube_detected": "YouTube-video gjenkjent",
    "video_url_vimeo_detected": "Vimeo-video gjenkjent",
    "video_url_unrecognized": "URL-en ble ikke gjenkjent. Støttede tjenester er YouTube og Vimeo.",
    "title_color": "Tittelfarge",
    "title_size": "Tittelstørrelse",
    "text_size": "Tekststørrelse",
    "button_text_color": "Knappetekstfarge",
    "button_size": "Knappestørrelse",
    "button_background_color": "Knappebakgrunnsfarge",
    "button_border_radius": "Avrunding på knapp",
    "category_buttons": "Kategorier (knapper)",
    "category_buttons_select_categories": "Velg kategorier som skal vises som knapper",
    "gap_between_buttons": "Avstand mellom knapper",
    "scale": "Forstørr",
    "underline": "Understrek",
    "fill": "Lysere",
    "button_layout": "Knappevisning",
    "wrap": "Bryt linje",
    "scroll": "Horisontal scroll",
    "video": "Video",
    "overlay": "Overlegg",
    "medium": "Medium",
    "full_screen": "Fullskjerm",
    "block_height": "Høyde",
    "video_hero_app_description": "Legg til en fullbredde videohero-seksjon i nettbutikken for et engasjerende, filmatisk førsteinntrykk.",
    "video_hero_heading": "Video Hero – fang besøkende fra første sekund",
    "video_hero_sub_heading": "Med Video Hero-appen kan du legge til en slående fullbredde bakgrunnsvideo-seksjon på forsiden av butikken din. Legg tekst, knapper og handlingsoppfordringer oppå videoen for å lede besøkende akkurat dit du vil.",
    "advantages_with_video_hero": "Fordeler med Video Hero",
    "advantages_with_video_hero_1": "<strong>Umiddelbar oppmerksomhet</strong> – en bevegelig hero-seksjon fanger besøkendes oppmerksomhet langt mer effektivt enn et statisk bilde.",
    "advantages_with_video_hero_2": "<strong>Sterkere merkevarebygging</strong> – vis frem produktene, historien eller kampanjen din på en filmatisk måte som bygger tillit.",
    "advantages_with_video_hero_3": "<strong>Fullt tilpassbar</strong> – kontroller tekst, farger, knappestiler, overlegg og plassering direkte fra temaeditoren.",
    "video_hero_sub_text": "Med Video Hero skiller nettbutikken din seg ut, engasjerer besøkende og driver flere konverteringer.",
    "video_hero_file_limit": "Støttede formater: MP4 og WebM. Maks filstørrelse: 30 MB.",
    "show_contact_phone_number": "Vis telefonnummer for kontakt",
    "footer_block_show_phone_number_description": "Velg om telefonnummeret for kontakt skal være synlig",
    "show_contact_email": "Vis e-post",
    "footer_block_show_email_description": "Velg om kontakt-e-postadressen skal være synlig",
    "show_contact_address": "Vis adresse",
    "footer_block_show_address_description": "Velg om butikkens adresse skal være synlig",
    "show_org_number": "Vis org.nummer",
    "footer_block_show_org_number_description": "Velg om organisasjonsnummeret skal være synlig",
    "footer_section_order": "Innholdsrekkefølge",
    "footer_section_order_description": "Dra for å endre rekkefølgen på innholdet i footeren.",
    "footer_menu_order_description": "Dra for å endre rekkefølgen på menyene i footeren.",
    "footer_section_company": "Firmainformasjon",
    "footer_section_contact": "Kontaktinformasjon",
    "footer_section_newsletter": "Nyhetsbrev",
    "footer_top_shape": "Form på topp",
    "footer_top_shape_description": "Dekorativ form på toppen av footeren. Gjelder kun variant 2.",
    "footer_top_shape_dip": "Buet",
    "footer_top_shape_wave": "Bølge",
    "footer_top_shape_diagonal": "Skrå",
    "footer_top_shape_sawtooth": "Sagtenner",
    "footer_top_shape_overlap": "Legg formen over blokken ovenfor",
    "footer_top_shape_overlap_description": "Slått på: formen skjærer inn i bunnen av blokken ovenfor, slik at footeren glir over i blokkens bakgrunnsfarge. Sørg for at blokken ovenfor har nok luft i bunnen. Slått av: et mellomrom med sidens bakgrunnsfarge vises før formen.",
    "footer_top_gap_color": "Farge over formen",
    "footer_top_gap_color_description": "Fargen på feltet mellom blokken ovenfor og formen. Sidens bakgrunn er hvit, så hvit gir samme utseende som før.",
    "footer_variant_1": "Variant 1",
    "footer_variant_2": "Variant 2",
    "footer_variant_3": "Variant 3",
    "footer_variant_4": "Variant 4",
    "footer_variant_5": "Variant 5",
    "footer_variant_6": "Variant 6",
    "header_variant_1": "Variant 1",
    "header_variant_2": "Variant 2",
    "header_variant_3": "Variant 3",
    "header_variant_4": "Variant 4",
    "header_variant_5": "Variant 5",
    "header_variant_6": "Variant 6",
    "including_unfulfilled_orders": "Inkluderer ubehandlede ordre",
    "ship_without_edi": "Send uten EDI",
    "license_page_order_title": "Bestill din 24Nettbutikk",
    "license_page_grow_title": "Nettbutikken som vokser med deg",
    "license_page_subtitle": "Komplett plattform med markedets beste fraktavtaler, kjente betalingsløsninger og gratis norsk support.",
    "license_page_social_proof": "Brukt av over 1 000 norske nettbutikker",
    "license_page_no_startup_costs": "Ingen oppstartskostnader",
    "license_page_free_support": "Gratis norsk support",
    "license_page_no_commitment": "Ingen bindingstid",
    "license_page_six_month_commitment": "6 måneders binding",
    "license_page_best_price": "beste pris",
    "license_page_startup_credit_card_note": "For startup kreves det at du registrerer et betalingskort.",
    "license_page_startup_desc": "Perfekt for deg som vil komme raskt i gang med en profesjonell nettbutikk.",
    "license_page_premium_desc": "Norges mest populære nettbutikkpakke — alt du trenger for å vokse, med bedre priser og kraftige salgsverktøy.",
    "license_page_premium_pluss_desc": "For ambisiøse nettbutikker som vil ha alt — de laveste prisene, de fleste apper og personlig oppfølging.",
    "license_page_most_chosen": "Mest valgt",
    "license_page_current_plan": "Din nåværende plan",
    "license_page_get_started": "Kom i gang",
    "license_page_choose_premium": "Velg Premium",
    "license_page_choose_premium_pluss": "Velg Premium Pluss",
    "license_page_upgrade_to_premium": "Oppgrader til Premium",
    "license_page_upgrade_to_premium_pluss": "Oppgrader til Premium Pluss",
    "license_page_see_all_features": "Se alle funksjoner",
    "license_page_included_apps": "Apper inkludert:",
    "license_page_all_from_startup_plus": "Alt du får i Startup, pluss:",
    "license_page_all_from_premium_plus": "Alt du får i Premium, pluss:",
    "license_page_3x_more_products": "3x flere produkter",
    "license_page_up_to_products": "opptil {count}",
    "license_page_lower_klarna_price": "Lavere Kustom-pris",
    "license_page_lower_shipping": "Lavere fraktpriser",
    "license_page_via_24shipping": "via 24Shipping",
    "license_page_marketing_tools": "Markedsføringsverktøy",
    "license_page_upsell_crosssell": "for oppsalg og mersalg",
    "license_page_b2b": "B2B-salg",
    "license_page_b2b_desc": "egne priser og innlogging for bedriftskunder",
    "license_page_unlimited_products": "Ubegrenset antall produkter",
    "license_page_lowest_klarna": "Laveste Kustom-pris",
    "license_page_best_shipping": "Våre beste fraktpriser",
    "license_page_all_apps_included": "De fleste apper inkludert i prisen",
    "license_page_no_extra_cost": "våre beste priser",
    "license_page_priority_support": "Prioritert support",
    "license_page_faster_response": "raskere svar",
    "license_page_personal_designer": "Personlig webdesigner",
    "license_page_designer_desc": "tilpasser butikken din",
    "license_page_24shipping": "24Shipping — ferdig fraktavtale med Bring og PostNord",
    "license_page_vipps_klarna": "Betaling med Vipps og Klarna",
    "license_page_up_to_2000_products": "Opptil 2 000 produkter",
    "license_page_unlimited_orders": "Ubegrenset antall ordre",
    "license_page_ssl": "SSL-sertifikat (Rating A+)",
    "license_page_design_builder": "Moderne designbygger — tilpass butikken din uten kode",
    "license_page_seo": "SEO-optimalisering",
    "license_page_label_printer_discount": "50% rabatt på etikettskriver",
    "license_page_free_norwegian_support": "Gratis norsk support",
    "app_store_featured": "Anbefalte apper",
    "app_store_included_with": "Inkludert med {app}",
    "included_with_app": "Inkludert med",
    "app_requires_app_active": "Denne appen krever at {app} er aktiv.",
    "app_dependency_not_active": "{app} er ikke aktiv. Slå den på først, så kan denne appen slås på.",
    "app_store_included": "Inkludert",
    "app_store_requires_upgrade": "Krever høyere lisens",
    "app_store_from_price": "fra {price} kr/mnd",
    "app_store_installed": "Installert",
    "app_store_see_more": "Se mer",
    "app_store_all": "Alle",
    "app_store_price_filter": "Pris",
    "app_store_free": "Gratis",
    "app_store_third_party": "Tredjepart",
    "app_store_related": "Relaterte apper",
    "app_store_not_included_trial": "Ikke inkludert i prøveperioden",
    "app_store_search": "Søk etter apper...",
    "app_store_prices_your_plan": "Din plan",
    "app_store_prices_you_get_apps": "Med {plan} får du {count} flere apper inkludert enn på {currentPlan}",
    "app_store_prices_you_save_hint": "Beløpet er hva de {count} appene koster kjøpt hver for seg som tillegg på {currentPlan}. Du sparer bare på de appene du faktisk bruker.",
    "app_store_prices_you_pay_today": "Du betaler for disse tilleggsappene i dag: {names}",
    "app_store_prices_trial_chip": "Prøveperiode",
    "app_store_prices_trial_banner_body": "Butikken har appene som følger med {plan} så lenge prøveperioden varer. Prisene under gjelder fra du velger et abonnement.",
    "app_store_prices_trial_choose_plan": "Velg abonnement",
    "app_store_prices_apps_included": "apper inkludert",
    "app_store_prices_see_plan": "Les mer om {plan}",
    "app_store_prices_third_party_heading": "{count} tredjepartsapper",
    "app_store_prices_top_plan": "Du har planen med flest apper inkludert",
    "app_store_prices_third_party_note": "Tredjepartsapper prises og faktureres av leverandøren, ikke av oss. Apper med pris i tabellen over faktureres av oss.",
    "app_store_prices_not_included_filter": "Ikke inkludert",
    "app_store_prices_difference": "{amount}/mnd mer enn {currentPlan}",
    "app_store_prices_not_available": "Ikke tilgjengelig",
    "app_store_prices_no_add_ons": "Du betaler ikke for noen tilleggsapper i dag",
    "app_store_prices_net_saving": "Bytter du, betaler du totalt {amount}/mnd mindre enn i dag",
    "app_store_prices_net_even": "Bytter du, betaler du like mye totalt og får {count} flere apper",
    "app_store_prices_already_yours": "Du betaler for denne appen som tillegg i dag",
    "app_store_prices_default_sort": "Tilbakestill sortering",
    "app_store_prices_compare": "Sammenlign priser",
    "app_store_prices_recommended": "Vi anbefaler",
    "app_store_prices_show_more_apps": "+{count} til",
    "app_store_prices_show_fewer_apps": "Vis færre",
    "app_store_prices_paid_today_short": "Betaler du for i dag",
    "app_store_prices_included_in_all_plans": "Inkludert i alle planer",
    "app_store_prices_you_save": "Du sparer",
    "app_store_prices_you_save_sub": "på de {count} appene kjøpt hver for seg på {currentPlan}",
    "app_store_prices_heading": "Apper og priser per plan",
    "app_store_prices_intro": "Her ser du hvilke apper som er inkludert i planen din, hvilke som blir inkludert på en høyere plan, og hva hver app koster som tillegg.",
    "app_store_prices_with_commitment": "med halvårlig binding",
    "app_store_prices_license_price_note": "Lisensprisene er oppgitt per måned med halvårlig binding.",
    "user_invited_success_message": "Den du inviterte har nå mottatt en e-post med instruksjoner for å fullføre registreringen.",
    "postnord": "PostNord",
    "postnord_app_description": "Denne appen styrer nettbutikkens tilgang til din PostNord-konto for fraktberegninger.",
    "postnord_landing_description": "Gjør det enkelt å tilby PostNord-levering i nettbutikken din, sømløst integrert direkte i kassen.",
    "postnord_app_description_1": "Med PostNord-integrasjonen kan kundene dine velge trygg og rask levering rett i kassen.",
    "postnord_app_description_2": "Gi nettbutikken din et profesjonelt preg med PostNord som fraktalternativ ved utsjekk.",
    "client_id": "Klient-ID",
    "client_id_description": "Klient ID benyttes i enkelte av PostNords systemer for å identifisere nettbutikken din",
    "client_secret": "Client Secret (Klient hemmelighet)",
    "client_secret_description": "Klient hemmelighet benyttes sammen med klient ID for å autentisere nettbutikken din i PostNords systemer",
    "postnord_heading": "PostNord",
    "postnord_sub_heading_1": "Du bruker denne appen om du har din egen fraktavtale med PostNord. Merk at vi leverer PostNord via vår egen fraktdeal - 24Shipping som allerede ligger klar til bruk, og som mest sannsynlig gir deg bedre priser enn hva du kan oppnå med en direkteavtale med PostNord.",
    "postnord_sub_heading_2": "Merk at du må ha integrasjon mot en TA-partner om du ønsker automatisk utskrift av adresseetiketter.",
    "postnord_sub_heading_3": "Aktiver PostNord sine fraktalternativer her",
    "postnord_sub_heading_4": "Med PostNord får du en av Nordens mest pålitelige og fleksible logistikkpartnere – rett inn i nettbutikken din.",
    "why_use_postnord": "Hvorfor velge PostNord?",
    "why_use_postnord_1": "<strong>Dekker hele Norden</strong> – leverer til både privatpersoner og bedrifter.",
    "why_use_postnord_2": "<strong>Fleksible leveringsalternativer</strong> – hjemlevering, utleveringssted eller pakkebokser.",
    "why_use_postnord_3": "<strong>Pålitelig sporing</strong> – kundene kan følge forsendelsen fra butikk til levering.",
    "why_use_postnord_4": "<strong>Sterk på B2B og B2C</strong> – skalerer uansett om du sender små pakker eller store volumer.",
    "important": "Viktig",
    "postnord_customer_id": "Kundenummer (Kunde ID)",
    "postnord_customer_id_description": "Kundenummeret du har hos PostNord",
    "helthjem_helthjem": "HeltHjem",
    "helthjem_helthjem_app_description": "Integrer nettbutikken din med HeltHjem for sømløs frakt og levering.",
    "helthjem_helthjem_landing_description": "Koble nettbutikken din til HeltHjem for å effektivisere fraktprosessen og tilby kundene dine pålitelige leveringsalternativer.",
    "helthjem_helthjem_app_description_1": "Administrer forsendelsene dine enkelt direkte fra nettbutikken din.",
    "helthjem_helthjem_app_description_2": "Gi kundene dine fleksible leveringsalternativer gjennom HeltHjem sitt omfattende nettverk.",
    "helthjem_shop_id": "Shop ID",
    "helthjem_shop_id_description": "Din unike identifikator for nettbutikken i HeltHjem sitt system",
    "helthjem_transport_solution_id": "Transport Solution ID",
    "helthjem_transport_solution_id_description": "IDen til transportløsningen du ønsker å bruke for forsendelsene dine",
    "helthjem_client_id": "Client ID",
    "helthjem_client_id_description": "Client ID brukes i tredjepartssystemer for å identifisere nettbutikken din",
    "helthjem_client_secret": "Client Secret",
    "helthjem_client_secret_description": "Client Secret brukes sammen med Klient ID for å autentisere nettbutikken din med tredjepartssystemer",
    "helthjem_invalid_credentials": "Kunne ikke koble til HeltHjem. Vennligst kontroller at Shop ID, Client ID og Client Secret er riktige.",
    "helthjem_heading": "HeltHjem",
    "helthjem_sub_heading_1": "Med <strong>Helthjem-integrasjonen</strong> gjør du det enkelt for kundene dine å få varene levert direkte hjem – raskt, trygt og fleksibelt. Helthjem leverer til hele Norge, også tidlig om morgenen, og har et av markedets mest brukervennlige leveringsalternativer.",
    "helthjem_sub_heading_2": "Merk at du må ha integrasjon mot en TA-partner om du ønsker automatisk utskrift av adresseetiketter.\n",
    "why_use_helthjem": "Hvorfor velge HeltHjem?",
    "why_use_helthjem_1": "<strong>Rask levering</strong> – ofte over natten, slik at kunden får pakken sin allerede neste morgen.",
    "why_use_helthjem_2": "<strong>Direkte i postkassen eller på dørmatten</strong> – kundene slipper å dra til utleveringssted.",
    "why_use_helthjem_3": "<strong>Levering på døren</strong> – også tidlig morgen</strong> – pakken ligger klar når kunden våkner.",
    "why_use_helthjem_4": "<strong>Dekker hele Norge</strong> – fra by til bygd, med høy leveringsgrad.",
    "helthjem_pricing_notice_title": "Priser må settes manuelt",
    "helthjem_pricing_notice_body": "HeltHjem beregner ikke fraktpriser automatisk basert på vekt eller dimensjoner. Du må selv sette pris på hver fraktmetode under <strong>Frakt</strong>-innstillingene etter at appen er aktivert.",
    "shipping_method_requires_configuration_1": "Denne fraktmåten krever konfigurasjon.",
    "shipping_method_requires_configuration_2": "Gå til apps",
    "shipping_method_requires_configuration_3": "for å aktivere og konfigurere denne fraktmåten.",
    "checkout_gateways_qliro_description": "Nordisk kasseløsning med faktura, delbetaling og kort. Qliro håndterer betalingsflyt og kredittrisiko. Betalingsmåtene administreres av Qliro — kontakt dem for endringer.",
    "edit_credentials": "Rediger nøkler",
    "credentials_updated": "Nøkler oppdatert",
    "credentials_already_saved_placeholder": "•••••••• (lagret — la stå tomt for å beholde)",
    "credentials_currently_saved": "lagret",
    "checkout_gateway_does_not_support_credential_editing": "Denne kassen har ingen nøkler å redigere.",
    "qliro_api_key": "API-nøkkel",
    "qliro_api_secret": "API-hemmelighet",
    "qliro_no_shipping_method_selected": "Ingen fraktmåter tilgjengelig. Kontakt oss for hjelp.",
    "qliro_checkout_newsletter_text": "Vær den første til å få informasjon om våre produkter og kampanjer",
    "no_data_for_period": "Ingen data for valgt periode",
    "missing_name": "Mangler navn",
    "deleted_product_with_id": "Slettet produkt (ID {id})",
    "no_checkout_or_payment_methods_configured": "Ingen kasse er ferdig konfigurert. Kunder vil ikke kunne fullføre kjøp.",
    "go_to_payment_settings": "Gå til betalingsinnstillinger",
    "spennd_enabled_without_payment_methods": "Spennd er aktivert, men har ingen betalingsmetoder slått på. Aktiver minst én betalingsmetode for at Spennd skal fungere.",
    "attribute_name_already_in_use": "Navnet er allerede i bruk som et variant-alternativ eller en attributt.",
    "option_name_already_in_use": "Navnet er allerede i bruk som en attributt eller et variant-alternativ.",
    "attribute_name_cannot_be_same_as_option_name": "En attributt kan ikke ha samme navn som et variant-alternativ.",
    "dashboard.vs_yesterday": "vs. i går",
    "dashboard.vs_last_week": "vs. forrige uke",
    "dashboard.vs_last_month": "vs. forrige måned",
    "dashboard.vs_last_year": "vs. i fjor",
    "dashboard.period_today": "I dag",
    "dashboard.period_this_week": "Denne uken",
    "dashboard.period_this_month": "Denne måneden",
    "dashboard.period_this_year": "I år",
    "dashboard.section_kpis": "Finansielle nøkkeltall",
    "dashboard.section_operational": "Operasjonelt",
    "dashboard.section_financial": "Finansiell analyse",
    "dashboard.section_products": "Produkt og salg",
    "dashboard.section_customers": "Kunder",
    "dashboard.section_logistics": "Drift og logistikk",
    "dashboard.section_search": "Søk",
    "dashboard.monthly_status": "Månedsstatus",
    "dashboard.monthly_status_tooltip": "Salg hittil denne måneden vs. samme periode forrige måned",
    "dashboard.this_month_so_far": "Denne måneden hittil",
    "dashboard.same_period_last_month": "Samme periode forrige mnd",
    "dashboard.n_orders": "1 ordre | {count} ordrer",
    "dashboard.no_sales_this_month": "Ingen salg denne måneden",
    "dashboard.sales_data_after_first_order": "Ingen ordrer er registrert denne måneden.",
    "dashboard.sales_distribution": "Salgsfordeling",
    "dashboard.sales_distribution_tooltip": "Salg fordelt per ukedag eller tidspunkt på døgnet, basert på siste 90 dager.",
    "dashboard.weekday": "Ukedag",
    "dashboard.time_of_day": "Tidspunkt",
    "dashboard.avg_revenue": "Gjennomsnittlig omsetning",
    "dashboard.not_enough_data": "Ikke nok data",
    "dashboard.sales_distribution_empty": "Ingen ordrer er registrert i perioden.",
    "dashboard.refunds": "Refusjoner",
    "dashboard.refunds_tooltip": "Refunderte og kansellerte ordrer",
    "dashboard.refunded": "Refundert",
    "dashboard.cancelled": "Kansellert",
    "dashboard.total_lost": "Totalt tapt",
    "dashboard.loss_rate": "Tapsrate",
    "dashboard.no_refunds": "Ingen refusjoner",
    "dashboard.no_refunds_in_period": "Ingen refusjoner eller kanselleringer i perioden.",
    "dashboard.top_products": "Bestselgende produkter",
    "dashboard.top_products_tooltip": "Produkter med høyest salg",
    "dashboard.quantity": "Antall",
    "dashboard.amount": "Beløp",
    "dashboard.no_sales_data": "Ingen salgsdata",
    "dashboard.product_data_after_first_sale": "Ingen produkter er solgt i perioden.",
    "dashboard.top_refunded": "Mest refunderte",
    "dashboard.top_refunded_tooltip": "Produkter med høy refusjonsrate kan indikere kvalitetsproblemer, feil produktbeskrivelse eller størrelsesavvik.",
    "dashboard.product": "Produkt",
    "dashboard.return_pct": "Retur %",
    "dashboard.no_refunded_products": "Ingen refunderte produkter",
    "dashboard.no_refunded_in_period": "Ingen produkter er refundert i perioden.",
    "dashboard.low_stock": "Lavt lagernivå",
    "dashboard.low_stock_tooltip": "Viser de 20 produktene med under 30 dagers lagerbeholdning igjen, basert på salg de siste 3 månedene.",
    "dashboard.sku": "SKU",
    "dashboard.in_stock": "På lager",
    "dashboard.days_remaining": "Dager igjen",
    "dashboard.n_days": "1 dag | {count} dager",
    "dashboard.no_stock_alerts": "Ingen lagervarsler",
    "dashboard.all_products_sufficient_stock": "Alle produkter har tilstrekkelig lagerbeholdning.",
    "dashboard.pending_orders": "Ubehandlede ordrer",
    "dashboard.pending_orders_tooltip": "Ordrer som venter på behandling",
    "dashboard.date": "Dato",
    "dashboard.customer": "Kunde",
    "dashboard.total": "Total",
    "dashboard.no_pending_orders": "Ingen ubehandlede ordrer",
    "dashboard.all_orders_processed": "Alle ordrer er behandlet.",
    "dashboard.unmoderated_reviews": "Kundeanmeldelser",
    "dashboard.unmoderated_reviews_tooltip": "Anmeldelser som venter på godkjenning",
    "dashboard.activate_in_app_store": "Aktiver i App Store",
    "dashboard.no_unmoderated_reviews": "Ingen umodererte anmeldelser",
    "dashboard.all_reviews_approved": "Alle anmeldelser er godkjent.",
    "dashboard.new_vs_returning": "Nye vs returnerende",
    "dashboard.new_vs_returning_tooltip": "Fordeling nye og gjentakende kunder",
    "dashboard.new": "Nye",
    "dashboard.returning": "Returnerende",
    "dashboard.returning_lc": "returnerende",
    "dashboard.n_customers": "1 kunde | {count} kunder",
    "dashboard.total_customers": "Totalt kunder",
    "dashboard.no_customer_data": "Ingen kundedata",
    "dashboard.customer_data_after_first_sale": "Ingen kunder er registrert i perioden.",
    "dashboard.clv_title": "Gjenkjøp og CLV",
    "dashboard.clv_tooltip": "CLV (Customer Lifetime Value) er det totale beløpet en kunde har handlet for siden første ordre. Gjenkjøpsrate viser andelen kunder som har bestilt mer enn én gang.",
    "dashboard.club_members": "Kundeklubb",
    "dashboard.club_members_tooltip": "Aktive medlemmer i kundeklubben, hvor mange som meldte seg inn i perioden, andelen av privatkundene som er medlemmer, og poeng som er utestående.",
    "dashboard.club_active_members": "Aktive medlemmer",
    "dashboard.club_share_of_customers": "Andel av kundene",
    "dashboard.club_pending_points": "Poeng på vei",
    "dashboard.club_available_points": "Tilgjengelige poeng",
    "dashboard.club_points_worth": "verdt {value}",
    "dashboard.club_see_members": "Se medlemmer",
    "dashboard.club_no_members": "Ingen medlemmer ennå",
    "dashboard.club_no_members_description": "Medlemmene dukker opp her når kundene melder seg inn.",
    "dashboard.all_time": "All-time",
    "dashboard.avg_clv": "Snitt CLV",
    "dashboard.repurchase_rate": "Gjenkjøpsrate",
    "dashboard.avg_orders_per_customer": "Snitt ordrer / kunde",
    "dashboard.order_status": "Ordrestatus",
    "dashboard.order_status_tooltip": "Fordeling av ordrestatuser",
    "dashboard.n_requires_action": "1 krever handling | {count} krever handling",
    "dashboard.pending": "Venter",
    "dashboard.partial": "Delvis",
    "dashboard.fulfilled": "Fullført",
    "dashboard.totalt": "totalt",
    "dashboard.no_orders": "Ingen ordrer",
    "dashboard.order_status_empty": "Ingen ordrer er registrert ennå.",
    "dashboard.processing_time": "Behandlingstid",
    "dashboard.processing_time_tooltip": "Gjennomsnittlig tid fra ordre til fullført",
    "dashboard.avg_processing_time": "Gjennomsnittlig behandlingstid",
    "dashboard.fastest": "Raskest",
    "dashboard.slowest": "Tregeste",
    "dashboard.hour_suffix": "t",
    "dashboard.under_24h": "Under 24t",
    "dashboard.no_fulfilled_orders": "Ingen fullførte ordrer",
    "dashboard.processing_time_empty": "Ingen ordrer er fullført i perioden.",
    "dashboard.shipping_methods": "Fraktmetoder",
    "dashboard.shipping_methods_tooltip": "Fordeling av fraktmetoder",
    "dashboard.no_shipping_data": "Ingen fraktdata",
    "dashboard.shipping_methods_empty": "Ingen ordrer med frakt i perioden.",
    "dashboard.payment_methods": "Betalingsmetoder",
    "dashboard.payment_methods_tooltip": "Fordeling av betalingsmetoder",
    "dashboard.no_payment_data": "Ingen betalingsdata",
    "dashboard.payment_methods_empty": "Ingen ordrer med betaling i perioden.",
    "dashboard.popular_searches": "Populære søk",
    "dashboard.popular_searches_tooltip": "De mest populære søkene i perioden",
    "dashboard.search_term": "Søkeord",
    "dashboard.searches": "Søk",
    "dashboard.with_results": "Med treff",
    "dashboard.no_searches_yet": "Ingen søk registrert enda",
    "dashboard.search_data_empty": "Ingen søk er registrert ennå.",
    "dashboard.no_results": "ingen treff",
    "dashboard.zero_result_searches": "Søk uten treff",
    "dashboard.zero_result_searches_tooltip": "Søk som ikke ga noen resultater",
    "dashboard.no_zero_result_searches": "Ingen søk uten treff",
    "dashboard.all_searches_had_results": "Alle søk i perioden ga resultater.",
    "dashboard.total_sales": "Total salg",
    "dashboard.total_sales_tooltip": "Samlet salg i perioden",
    "dashboard.no_sales_yet": "Ingen salg enda",
    "dashboard.sales_after_first_order": "Ingen salg er registrert i perioden.",
    "dashboard.order_count": "Antall ordrer",
    "dashboard.order_count_tooltip": "Antall bestillinger i valgt periode",
    "dashboard.no_orders_yet": "Ingen ordrer enda",
    "dashboard.order_count_empty": "Ordretall vises her etter første bestilling.",
    "dashboard.avg_order_value": "Snitt ordreverdi",
    "dashboard.avg_order_value_tooltip": "Gjennomsnittlig ordreverdi (AOV)",
    "dashboard.no_data": "Ingen data",
    "dashboard.avg_order_value_empty": "Ingen ordrer er registrert i perioden.",
    "dashboard.units_sold": "Solgte varer",
    "dashboard.units_sold_tooltip": "Totalt antall solgte enheter",
    "dashboard.no_units_sold": "Ingen solgte varer",
    "dashboard.units_sold_empty": "Antall solgte enheter vises her.",
    "dashboard.newsletter": "Nyhetsbrev",
    "dashboard.newsletter_tooltip": "Antall aktive abonnenter",
    "dashboard.no_subscribers": "Ingen abonnenter",
    "dashboard.newsletter_empty": "Abonnenter vises når noen melder seg på.",
    "dashboard.total_subscribers": "totalt abonnenter",
    "dashboard.n_new": "+{count} nye",
    "dashboard.test_data": "Testdata",
    "dashboard.test_data_active": "Testdata er aktivert.",
    "dashboard.test_data_description": "Widgetene viser eksempeldata — ikke ekte butikkdata.",
    "dashboard.reset": "Tilbakestill",
    "dashboard.done": "Ferdig",
    "dashboard.customize": "Tilpass",
    "dashboard.show": "Vis",
    "dashboard.n_orders_suffix": "1 ordre | {count} ordrer",
    "criteria_cannot_be_empty": "Kriterier kan ikke være tomme",
    "susoft_app_name": "Susoft POS",
    "susoft_app_description": "Synkroniser lagerbeholdning mellom Susoft POS og nettbutikken. Hold lageret oppdatert på tvers av alle salgskanaler.",
    "susoft_shop_url_key": "Butikk URL-nøkkel",
    "susoft_shop_url_key_description": "Din Susoft butikk URL-nøkkel (f.eks. 'minsuperbutikk'). Finnes i GlobalOne Web UI eller din Susoft nettbutikk-URL.",
    "susoft_login": "Brukernavn",
    "susoft_login_description": "Din Susoft API-innlogging (e-post eller brukernavn).",
    "susoft_password": "Passord",
    "susoft_password_description": "Ditt Susoft API-passord.",
    "susoft_landing_headline": "Susoft POS-integrasjon",
    "susoft_landing_description": "Koble Susoft POS-systemet ditt til nettbutikken for automatisk synkronisering av lagerbeholdning. Når et salg skjer i kassen, oppdateres nettbutikkens lager umiddelbart — og omvendt.",
    "susoft_product_mapping": "Produktkartlegging",
    "susoft_register_webhooks": "Registrer webhooks",
    "susoft_search_products": "Søk produkter i nettbutikk...",
    "susoft_no_products_found": "Ingen produkter funnet i Susoft.",
    "susoft_mapped": "Koblet",
    "susoft_unmapped": "Ikke koblet",
    "susoft_auto_matched": "Auto-koblet",
    "susoft_save_mappings": "Lagre koblinger",
    "susoft_sync_queued": "Lagersynkronisering er satt i kø og kjører i bakgrunnen.",
    "susoft_push_all_queued": "Nettbutikkens lager er sendt til Susoft.",
    "susoft_sync_pos_to_store": "POS → Nettbutikk",
    "susoft_sync_store_to_pos": "Nettbutikk → POS",
    "susoft_landing_features_title": "Funksjoner",
    "susoft_landing_feature_1": "<strong>Automatisk lagersynkronisering</strong> — når et salg skjer i kassen, oppdateres nettbutikkens lager umiddelbart.",
    "susoft_landing_feature_2": "<strong>Toveis synkronisering</strong> — lagerendringer i nettbutikken sendes automatisk tilbake til Susoft.",
    "susoft_landing_feature_3": "<strong>Produktkobling</strong> — koble POS-produkter til nettbutikkvarianter via strekkode, med smart automatisk kobling.",
    "susoft_landing_feature_4": "<strong>Full lageravstemming</strong> — synkroniser all produktbeholdning fra Susoft med ett klikk når som helst.",
    "susoft_landing_how_it_works_title": "Hvordan fungerer det?",
    "susoft_landing_how_it_works_description": "Integrasjonen kobler seg til Susoft POS-systemet via deres API. Etter at du har lagt inn påloggingsinformasjon og koblet produkter, holdes lagerbeholdningen synkronisert gjennom webhooks. Når Susoft varsler om en endring, oppdaterer vi nettbutikken — og når lageret endres i nettbutikken, sender vi det tilbake til Susoft.",
    "susoft_landing_requirements_title": "Hva trenger jeg?",
    "susoft_landing_requirements_description": "Du trenger en aktiv Susoft-konto med API-tilgang. Du trenger din butikk URL-nøkkel, innloggings-epost og passord for å konfigurere integrasjonen.",
    "susoft_invalid_credentials": "Kunne ikke koble til Susoft. Vennligst sjekk din butikk URL-nøkkel, brukernavn og passord.",
    "susoft_hidden": "Skjult",
    "susoft_show_hidden": "Vis skjulte",
    "susoft_hidden_products": "Skjulte produkter",
    "susoft_unhide": "Vis igjen",
    "susoft_hide": "Skjul",
    "susoft_unsaved": "Ulagret",
    "susoft_refresh_products": "Hent fra Susoft",
    "susoft_products_refreshed": "Produktlisten er oppdatert fra Susoft.",
    "susoft_search_susoft_products": "Søk i Susoft-produkter...",
    "susoft_filter_all": "Alle",
    "susoft_filter_mapped": "Koblet",
    "susoft_filter_unmapped": "Ikke koblet",
    "susoft_susoft_product": "Susoft-produkt",
    "susoft_barcode": "Strekkode (GTIN)",
    "susoft_stock": "Lager Susoft",
    "susoft_store_stock": "Lager nettbutikk",
    "susoft_stock_mismatch": "Avvik i lager",
    "susoft_update_stock": "Oppdater",
    "susoft_push_stock_to_susoft": "Oppdater lager i Susoft",
    "susoft_set_to": "Sett til {value}",
    "susoft_vanaheim_product": "Produkt i nettbutikk",
    "susoft_status": "Status",
    "susoft_no_hidden_products": "Ingen skjulte produkter.",
    "susoft_show_help": "Vis hjelp",
    "susoft_help_intro": "Denne siden kobler Susoft POS-produkter til nettbutikkens produktvarianter. Bruk filterknappene for å bytte mellom koblede og ukoblede produkter.",
    "susoft_help_search": "Bruk <strong>søkefeltet i hver rad</strong> for å finne det riktige nettbutikkproduktet etter navn, SKU eller GTIN.",
    "susoft_help_auto_match": "Produkter med en <strong>strekkode som matcher en variant-GTIN</strong> blir automatisk koblet.",
    "susoft_help_hide": "Bruk <strong>skjul-knappen</strong> (øye-ikon) for å skjule irrelevante Susoft-produkter. Se og vis dem igjen via \"Vis skjulte\"-knappen.",
    "susoft_help_sync_pos_to_store": "Bruk <strong>POS → Nettbutikk</strong> for å oppdatere nettbutikkens lager for alle koblede produkter med gjeldende lagerverdier fra Susoft.",
    "susoft_help_sync_store_to_pos": "Bruk <strong>Nettbutikk → POS</strong> for å sende nettbutikkens lager for alle koblede produkter til Susoft.",
    "susoft_help_refresh": "Bruk <strong>Hent fra Susoft</strong> for å oppdatere den lokale listen med produkter fra Susoft sitt API. Dette henter kun produktdata og endrer ingen koblinger.",
    "susoft_help_save": "Klikk <strong>Lagre koblinger</strong> når du er ferdig. Koblede produkter synkroniserer lager begge veier.",
    "susoft_per_page": "Per side",
    "susoft_product_hidden": ":count produkt skjult.|:count produkter skjult.",
    "susoft_product_unhidden": ":count produkt vist igjen.|:count produkter vist igjen.",
    "susoft_pos": "Susoft POS",
    "point_of_sale": "POS",
    "printer_format_label": "Etikett",
    "printer_format_document": "Dokument",
    "default_label_printer": "Standard etikettskriver",
    "default_document_printer": "Standard dokumentskriver",
    "printer_format_description": "Etiketter skrives ut ved booking. Dokumenter (ordrebekreftelse, leveringsbekreftelse, angrefrist-skjema) skrives ut som A4.",
    "auto_print_at_booking": "Auto-utskrift ved booking",
    "auto_print_label": "Etikett",
    "auto_print_order_confirmation": "Ordrebekreftelse",
    "auto_print_delivery_confirmation": "Leveringsbekreftelse",
    "auto_print_cancellation_form": "Angrefrist-skjema",
    "only_owner_can_delete_printer": "Kun eieren kan slette denne skriveren",
    "only_owner_can_edit_printer": "Kun eieren kan redigere denne skriveren",
    "username": "Brukernavn",
    "format": "Format",
    "shared": "Delt",
    "try_again": "Prøv igjen",
    "smartprint.stepper.account": "Konto",
    "smartprint.stepper.install": "Installer",
    "smartprint.stepper.connection": "Tilkobling",
    "smartprint.setup_title": "SmartPrint-oppsett",
    "smartprint.create_account.heading": "Kom i gang med SmartPrint",
    "smartprint.create_account.intro": "SmartPrint kobler nettbutikken til skriverne dine. Du trenger en konto og klientprogramvare installert på maskinen din.",
    "smartprint.create_account.tip_label": "Tips:",
    "smartprint.create_account.tip_body": "Gjør dette på maskinen som er koblet til skriverne du vil bruke.",
    "smartprint.create_account.error": "Kunne ikke opprette konto. Prøv igjen.",
    "smartprint.create_account.creating": "Oppretter...",
    "smartprint.create_account.submit": "Opprett SmartPrint-konto",
    "smartprint.create_account.switch_to_email": "Jeg vil legge til en e-post-skriver i stedet",
    "smartprint.install_client.heading": "Installer SmartPrint-klienten",
    "smartprint.install_client.intro": "Last ned og installer klienten på maskinen du vil skrive ut fra. Logg inn med brukernavn og passord under.",
    "smartprint.install_client.download_exe": "Last ned .exe",
    "smartprint.install_client.download_dmg": "Last ned .dmg",
    "smartprint.install_client.credentials": "Innloggingsinformasjon",
    "smartprint.install_client.confirm": "Jeg har installert klienten",
    "smartprint.install_client.modal_title": "Installer klient på ny maskin",
    "smartprint.install_client.modal_error": "Kunne ikke hente innloggingsinformasjon. Prøv igjen senere.",
    "smartprint.wait.connecting_heading": "Venter på tilkobling...",
    "smartprint.wait.connecting_body": "Åpne SmartPrint-klienten og logg inn. Denne dialogen oppdateres automatisk.",
    "smartprint.wait.timeout_heading": "Klarte ikke å oppdage maskinen",
    "smartprint.wait.timeout_body": "Sjekk at SmartPrint-klienten kjører og at du er logget inn.",
    "add_printer.edit_title": "Rediger skriver",
    "add_printer.add_title": "Legg til skriver",
    "add_printer.type_smartprint": "SmartPrint (fysisk skriver)",
    "add_printer.type_smartprint_trial_help": "Tilgjengelig med betalt abonnement",
    "add_printer.type_smartprint_help": "Skriv ut via tilkoblet skriver",
    "add_printer.type_email_help": "Send dokument til e-postadresse",
    "add_printer.name_placeholder": "f.eks. Lagerskriver",
    "add_printer.physical_printer_label": "Fysisk skriver",
    "add_printer.choose_printer_placeholder": "Velg skriver...",
    "add_printer.email_placeholder": "navn@eksempel.no",
    "add_printer.shared_label": "Del med andre brukere",
    "add_printer.shared_help": "Andre brukere på denne butikken kan bruke skriveren.",
    "add_printer.shared_smartprint_warning": "Maskinen din må være på nett og koblet til skriveren hver gang du skriver ut.",
    "add_printer.checking": "Sjekker...",
    "delete_printer.title": "Slett skriver",
    "delete_printer.confirm": "Er du sikker? Skriveren fjernes permanent.",
    "delete_printer.default_warning_label": "OBS:",
    "delete_printer.default_warning_body": "Denne skriveren er satt som standard — standardvalget fjernes når du sletter.",
    "printer_list.install_on_new_machine": "+ Installer klient på ny maskin",
    "printer_list.col_attachment": "Tilknytning",
    "printer_list.not_connected": "Ikke koblet",
    "printer_list.empty": "Ingen skrivere er lagt til ennå.",
    "printer_list.settings_load_error": "Kunne ikke laste innstillinger fra 24Shipping. Prøv igjen om et øyeblikk.",
    "printer_settings.user_only_note": "Disse innstillingene gjelder kun for din bruker.",
    "printer_settings.shared_printer_warning": "Maskinen som deler skriveren må være på nett og koblet til skriveren hver gang du skriver ut.",
    "printer_settings.no_printer_option": "Ingen",
    "printer_settings.shared_suffix": "(delt)",
    "printer_settings.save": "Lagre innstillinger",
    "printers_page_title": "Innstillinger — Logistikk",
    "picklist_intro": "Plukklisten brukes ved klargjøring av ordrer, og finnes på hver enkelt ordre under ubehandlede ordrelinjer.",
    "manual_shipment.fill_form_first": "Fyll ut skjema over for å hente tilgjengelig fraktmåter.",
    "partial_fulfillment_not_supported": "På grunn av begrensninger hos denne ordrens betalingsleverandør, er det ikke mulig å deleffektuere.",
    "add_discount_rules": "Legg til rabattregler",
    "add_rules": "Legg til regler",
    "add_x_rules_with_y_percent": "Legg til {count} regler med {percent} % rabatt",
    "added": "Lagt til",
    "bulk_change_discount_description": "Endre rabatt for {count} valgte regler.",
    "bulk_delete_rules_confirmation": "Er du sikker på at du vil slette {count} valgte regler? Produktene vil falle tilbake til gruppens standardrabatt.",
    "change_discount": "Endre rabatt",
    "clear_all": "Fjern alle",
    "create_group": "Opprett gruppe",
    "customer_group": "Kundegruppe",
    "customer_group_created": "Kundegruppen ble opprettet",
    "customer_group_deleted": "Kundegruppen ble slettet",
    "customer_group_updated": "Kundegruppen ble oppdatert",
    "internal_note": "Interne notater",
    "internal_note_placeholder": "Notater om denne kunden, kun synlig for ansatte…",
    "internal_note_help": "Kun synlig for deg og andre ansatte. Kunden ser aldri dette.",
    "member_added": "Kunde lagt til i gruppen",
    "member_removed": "Kunde fjernet fra gruppen",
    "discount_rule_saved": "Rabattregel lagret",
    "discount_rule_deleted": "Rabattregel slettet",
    "customer_groups_subtitle": "Administrer kundegrupper og rabatter",
    "total_groups": "Totalt grupper",
    "active_groups": "Aktive grupper",
    "total_members": "Totalt medlemmer",
    "open": "åpne",
    "search_members_placeholder": "Søk etter navn, e-post eller selskap …",
    "remove_member": "Fjern medlem",
    "remove_member_confirmation": "Er du sikker på at du vil fjerne {customer} fra gruppen?",
    "no_members_match_search": "Ingen medlemmer matcher søket.",
    "add_customers": "Legg til kunder",
    "add_customers_description": "Søk etter kunder å legge til i denne gruppen.",
    "no_customers_match_search": "Ingen kunder matcher søket.",
    "no_customers_available": "Ingen tilgjengelige kunder å legge til.",
    "add_discount_rules_description": "Velg produkter som skal få denne rabatten i gruppen.",
    "no_products_selected_yet": "Ingen produkter valgt ennå.",
    "how_discounts_work": "Slik fungerer rabattene",
    "discounts_with_default_explanation": "Alle produkter i denne gruppen får en standardrabatt på <strong>{percent} %</strong>. Legg til en regel her hvis et bestemt produkt skal ha en annen rabatt — regelen overstyrer standarden for de produktene.",
    "discounts_without_default_explanation": "Denne gruppen har ingen standardrabatt. Legg til regler her for å gi rabatt på spesifikke produkter — eller sett en standardrabatt på <strong>Generelt</strong>-fanen for å rabattere hele utvalget.",
    "rule_overrides_default": "Denne regelen overstyrer standardrabatten for produktene du velger.",
    "default_discount": "Standardrabatt",
    "default_discount_help": "Rabatten som gjelder for alle produkter med mindre en produktspesifikk regel overstyrer.",
    "default_discount_override_help": "Denne rabatten gjelder for alle produkter. Du kan overstyre denne per produkt under Rabattregler.",
    "delete_customer_group": "Slett kundegruppe",
    "delete_discount_rule": "Slett rabattregel",
    "delete_group": "Slett gruppe",
    "delete_group_confirmation": "Er du sikker på at du vil slette kundegruppen \"{name}\"? Alle medlemmer vil miste sine grupperabatter.",
    "delete_rule": "Slett regel",
    "delete_rule_confirmation": "Er du sikker på at du vil slette regelen for \"{product}\"? Produktet vil falle tilbake til standardrabatten på {defaultDiscount} %.",
    "delete_selected": "Slett valgte",
    "delete_selected_rules": "Slett valgte regler",
    "description_help": "En intern beskrivelse for å identifisere denne gruppen.",
    "discount_rules": "Rabattregler",
    "group_name": "Gruppenavn",
    "group_name_help": "Navnet vises for kunder som er medlem av gruppen.",
    "group_name_placeholder": "F.eks. Grossister, VIP-kunder",
    "inactive_group_help": "Inaktive grupper gir ingen rabatter til medlemmene.",
    "internal_description": "Intern beskrivelse",
    "members_count_label": "kunder i denne gruppen.",
    "new_customer_group": "Ny kundegruppe",
    "new_discount": "Ny rabatt",
    "no_customer_groups": "Ingen kundegrupper opprettet ennå.",
    "no_discount_rules": "Ingen produktspesifikke rabattregler.",
    "no_members": "Ingen kunder er lagt til i denne gruppen.",
    "no_products_found": "Ingen produkter funnet.",
    "percent_on_all_products": "% på alle produkter",
    "product_specific_rules_info": "produktspesifikke regler overstyrer den generelle rabatten på",
    "products_found": "produkter funnet",
    "search_customer_placeholder": "Søk etter kunde — navn, e-post eller firma...",
    "search_product_name_or_sku": "Søk etter produktnavn, SKU eller tag...",
    "search_rules_placeholder": "Søk i regler — produktnavn eller SKU...",
    "search_to_find_products": "Søk for å finne produkter",
    "select_all_x_results": "Velg alle {count} treff",
    "scroll_for_more": "til — scroll for flere",
    "transfer_customer_group": "Flytt kunde til ny gruppe",
    "transfer_customer_group_confirmation": "{customer} er allerede medlem av gruppen \"{from}\". Vil du flytte kunden til \"{to}\"? Kunden vil bli fjernet fra \"{from}\".",
    "transfer_customer": "Flytt kunde",
    "add_x_rules": "Legg til {count} regler",
    "set_discount_percent_required": "Angi en rabattprosent før du legger til regler.",
    "customer_groups_app_headline": "Kundegrupper",
    "customer_groups_app_description": "Gi grupper av kunder automatiske rabatter, for eksempel grossister, VIP-kunder eller partnere.",
    "customer_groups_app_sub_heading": "Definer grupper av kunder og gi dem automatiske rabatter. Nyttig for grossister, VIP-er, partnere eller andre segmenter som skal se andre priser.",
    "customer_groups_app_advantages": "Fordeler med kundegrupper",
    "customer_groups_app_advantage_1": "Sett en standardrabatt som gjelder for alle produkter for medlemmer av gruppen",
    "customer_groups_app_advantage_2": "Overstyr standarden per produkt med rabattregler for enkeltprodukter",
    "customer_groups_app_advantage_3": "Innloggede medlemmer ser sin gruppepris på kategori-, produkt- og kassesider",
    "customer_groups_app_advantage_4": "Gruppemedlemskap lagres på ordren, slik at historisk prising bevares",
    "customer_groups_app_closer": "Aktiver kundegrupper for å segmentere kundene dine og belønne lojalitet.",
    "get_started_heading": "Slik kommer du i gang",
    "basic_information": "Grunninformasjon",
    "basic_information_description": "Navn og beskrivelse vises i admin og på medlemslisten.",
    "default_discount_section_description": "Gjelder for alle produkter i gruppen — kan overstyres med regler per produkt.",
    "group_status_description": "Inaktive grupper får ikke rabatter eller medlemmer.",
    "applications_section": "Søknader",
    "applications_section_description": "Lar kunder be om å bli med i gruppen — du godkjenner manuelt.",
    "customer_groups_get_started_step_1": "Opprett en kundegruppe og sett en standardrabatt — for eksempel 15 % for grossister.",
    "customer_groups_get_started_step_2": "Legg til kunder i gruppen fra kundebasen din.",
    "customer_groups_get_started_step_3": "Overstyr enkeltprodukter med spesifikke rabattregler hvis du trenger det.",
    "manage_customer_groups": "Administrer kundegrupper",
    "from_price": "Fra",
    "not_configured": "Ikke konfigurert",
    "shipping_mode_flat": "Fast pris",
    "shipping_mode_weight": "Etter vekt",
    "shipping_mode_zone": "Etter sone",
    "shipping_mode_matrix": "Vekt + sone",
    "shipping_mode_description_flat": "En enkelt pris brukes for alle kurver.",
    "shipping_mode_description_weight": "Prisen bestemmes av kurvens totale vekt. Kurver utenfor definerte vektintervaller vil ikke få denne fraktmetoden.",
    "shipping_mode_description_zone": "Prisen bestemmes av leveringssonen (postnummer). Kurver med postnummer utenfor sonene vil ikke få denne fraktmetoden.",
    "shipping_mode_description_matrix": "Prisen bestemmes av kombinasjonen av kurvens vekt og leveringssone.",
    "pricing_rules_card_title": "Prisregler",
    "pricing_rules_card_description": "Varierende pris basert på vekt og/eller leveringssone.",
    "custom_shipping.flat_price_required": "Fast pris er påkrevd",
    "custom_shipping.flat_price_forbidden_with_tables": "Fast pris kan ikke brukes sammen med vekt- eller sonetabeller",
    "custom_shipping.weight_range_from_gt_to": "Fra-vekt må være lavere eller lik til-vekt",
    "custom_shipping.overlapping_weight_ranges": "Vektintervaller overlapper",
    "custom_shipping.range_from_gt_to": "Fra-postnummer må være lavere eller likt til-postnummer",
    "custom_shipping.overlapping_ranges": "Postnummerintervaller overlapper",
    "custom_shipping.duplicate_zone_name": "Sonenavn må være unike",
    "custom_shipping.missing_price_row": "Alle kombinasjoner av vektklasse og sone må ha en pris",
    "custom_shipping.duplicate_price_row": "Samme pris-kombinasjon er angitt to ganger",
    "custom_shipping.confirm_delete": "Er du sikker på at du vil slette denne fraktmetoden?",
    "new_custom_shipping_method": "Ny egendefinert fraktmetode",
    "edit_custom_shipping_method": "Rediger egendefinert fraktmetode",
    "flat_price": "Fast pris",
    "weight_tiers": "Vektklasser",
    "weight_tier": "Vektklasse",
    "add_weight_tier": "Legg til vektklasse",
    "no_weight_tiers_yet": "Ingen vektklasser lagt til",
    "from_weight": "Fra",
    "to_weight": "Til",
    "zones": "Soner",
    "add_zone": "Legg til sone",
    "no_zones_yet": "Ingen soner lagt til",
    "zone_name_placeholder": "Sonenavn (f.eks. Nord-Norge)",
    "from_zip": "Fra postnr",
    "to_zip": "Til postnr",
    "remove_range": "Fjern intervall",
    "remove_zone": "Fjern sone",
    "add_range": "Legg til intervall",
    "price_grid": "Prisrutenett",
    "unnamed_zone": "(uten navn)",
    "stock_history": "Lagerhistorikk",
    "stock_log": "Lagerlogg",
    "no_stock_history": "Ingen lagerhistorikk",
    "no_stock_changes": "Ingen lagerendringer",
    "added_to_stock": "Lagt til på lager",
    "removed_from_stock": "Fjernet fra lager",
    "total_stock": "Totalt på lager",
    "locations": "Lokasjoner",
    "active_variants": "Aktive varianter",
    "no_stock_registered": "Ingen lager registrert",
    "entry": "Oppføring",
    "entries": "Oppføringer",
    "main_variant": "Hovedvariant",
    "all_sources": "Alle kilder",
    "source": "Kilde",
    "actor": "Utført av",
    "by": "Av",
    "showing": "Viser",
    "seconds_ago": "sekunder siden",
    "minutes_ago": "minutter siden",
    "hours_ago": "timer siden",
    "days_ago": "dager siden",
    "weeks_ago": "uker siden",
    "source_admin": "Admin",
    "source_order": "Ordre",
    "source_refund": "Refundering",
    "source_cancellation": "Kansellering",
    "source_susoft": "Susoft",
    "source_migration": "Migrering",
    "source_backfill": "Auto-fyll",
    "source_trial_purge": "Prøvetid avsluttet",
    "stock_change": "Endring",
    "history_for": "Historikk for",
    "shelf": "Lagerplassering",
    "bin": "Lagerplassering",
    "assigned_location": "Tildelt lagerplassering",
    "create_shelf": "Opprett lagerplassering",
    "search_or_create_stock_location": "Søk eller opprett lagerplassering",
    "clear": "Fjern",
    "source_transfer": "Overføring",
    "no_stock_location_set": "Ingen lagerplassering satt",
    "warehouse": "Varelager",
    "search_or_create_warehouse": "Søk eller opprett varelager",
    "enable_product_locations": "Aktiver lagerplasseringer",
    "enable_product_locations_description": "Tilordne lagerplasseringer til produkter for å vite hvor de er fysisk lagret.",
    "enable_product_warehouses": "Aktiver flere varelagre",
    "enable_product_warehouses_description": "Bruk flere varelagre i tillegg til standardvarelageret.",
    "warehouses_app_required": "Krever Varelager-appen.",
    "warehouses_app_description": "Administrer flere varelagre for å spore lagerbeholdning på tvers av lokasjoner.",
    "bulk_picking": "Bulk-plukking",
    "bulk_picking_app_description": "Plukk mange ordrer i én operasjon: samle alle varer, ta dem til pakkebordet, og sorter og pakk per ordre.",
    "bulk_picking_method": "Plukkemetode",
    "bulk_picking_method_description": "Velg hvordan butikken plukker og pakker bulk-ordrer.",
    "bulk_picking_method_pakkestasjon": "Pakkestasjon",
    "bulk_picking_method_trillevogn": "Trillevogn",
    "bulk_picking_method_legacy": "Lister og etiketter (klassisk)",
    "bulk_picking_method_label": "Plukkemetode",
    "bulk_picking_method_fit_label": "Passer når",
    "bulk_picking_method_pakkestasjon_desc": "Plukk alle varer samlet i én runde, ta dem til pakkebordet, og sorter og pakk per ordre der.",
    "bulk_picking_method_pakkestasjon_fit": "mange ordrer har de samme produktene, og du har et pakkebord. Færrest turer inn til lageret.",
    "bulk_picking_method_trillevogn_desc": "Trill en vogn med én kurv per ordre. Plukk i én runde og legg hver vare rett i riktig kurv/eske — ingen sortering etterpå.",
    "bulk_picking_method_trillevogn_fit": "ordrene er ulike, og du vil plukke mobilt i én runde.",
    "bulk_picking_method_legacy_title": "Effektuer + skriv ut lister",
    "bulk_picking_method_legacy_tag": "Eldre metode",
    "bulk_picking_method_coming_soon": "Kommer snart",
    "bulk_picking_beta_free_title": "Gratis under beta",
    "bulk_picking_beta_free_body": "Appen er gratis for alle butikker mens den er i beta. Prisen kan endre seg når betaen er over.",
    "bulk_picking_method_legacy_desc": "Effektuer ordrene, skriv ut lister og etiketter, og plukk/pakk manuelt — som i den gamle løsningen.",
    "bulk_picking_method_legacy_fit": "Overgangsmetode. Bytt til pakkestasjon eller trillevogn når du er klar.",
    "bulk_send_orders": "Send ordrer",
    "bulk_send_orders_description": "Effektuer de valgte ordrene, bestill frakt og skriv ut lister og etiketter.",
    "bulk_print_pick_lists": "Skriv ut plukklister",
    "bulk_print_pick_lists_description": "Hent plukklister for de valgte ordrene uten å sende dem.",
    "bulk_print_title": "Skriv ut plukklister",
    "bulk_print_body": "{count} ordre er valgt. Ordrer som allerede er sendt eller kansellert, tas ikke med. | {count} ordrer er valgt. Ordrer som allerede er sendt eller kansellert, tas ikke med.",
    "bulk_print_nothing_left": "Ingen av de valgte ordrene har noe igjen å plukke.",
    "bulk_print_not_reserved": "Ingenting sendes eller reserveres. Listene viser det som gjenstår å sende på hver ordre nå.",
    "bulk_send_title": "Send ordrer",
    "bulk_send_booked_not_captured": "Frakten ble booket, og etiketten kan være skrevet ut, men betalingen feilet. Ordren er ikke sendt.",
    "bulk_send_row_booked": "Booket, ikke sendt",
    "bulk_send_row_booked_detail": "Booket hos {carrier}, sporingsnr. {tracking}",
    "bulk_send_paused_title": "Sendingen er satt på pause ved ordre #{order}",
    "bulk_send_paused_body": "Frakten ble booket hos {carrier} (sporingsnr. {tracking}), men ordren ble ikke sendt.",
    "bulk_send_paused_cause": "Betalingen feilet: {cause}",
    "bulk_send_printed_likely": "Skriveren har trolig skrevet ut dette for ordren: {things}. Ta det ut av bunken før du fortsetter, så utskriftene ikke kommer i utakt med ordrene.",
    "bulk_send_printed_maybe": "Skriveren kan ha skrevet ut dette for ordren: {things}. Sjekk bunken og ta det ut før du fortsetter, så utskriftene ikke kommer i utakt med ordrene.",
    "bulk_send_printed_unknown": "Skriveren kan ha skrevet ut etiketten og dokumentene for denne ordren. Sjekk bunken og ta dem ut før du fortsetter, så utskriftene ikke kommer i utakt med ordrene.",
    "bulk_send_printed_nothing": "Ingenting ble skrevet ut for denne ordren.",
    "bulk_send_continue": "Fortsett med resten",
    "bulk_send_stop_here": "Stopp her",
    "bulk_send_summary_booked": "Booket, ikke sendt",
    "bulk_send_orders_count": "{count} ordre | {count} ordrer",
    "bulk_send_progress": "{done} av {total} behandlet",
    "bulk_send_done_title": "{count} ordre sendt | {count} ordrer sendt",
    "bulk_send_units": "{count} vare | {count} varer",
    "bulk_send_summary_sent": "Sendt",
    "bulk_send_summary_failed": "Kunne ikke sendes",
    "bulk_send_summary_skipped": "Hoppet over",
    "bulk_send_too_many_orders": "Send maks :max ordrer om gangen. Velg færre og prøv igjen.",
    "bulk_send_checking": "Sjekker de valgte ordrene …",
    "bulk_send_ready": "{count} ordre kan sendes | {count} ordrer kan sendes",
    "bulk_send_skipped_heading": "{count} ordre blir hoppet over | {count} ordrer blir hoppet over",
    "bulk_send_carrier_hint": "Frakt bestilles etter fraktkoblingen for hver fraktmåte, og alle gjenstående varer på ordren effektueres.",
    "bulk_send_start": "Send {count} ordre | Send {count} ordrer",
    "bulk_send_row_waiting": "Venter",
    "bulk_send_row_sending": "Sender …",
    "bulk_send_row_sent": "Sendt",
    "bulk_send_row_failed": "Kunne ikke sendes",
    "bulk_send_retry": "Prøv på nytt",
    "bulk_send_view_label": "Se etikett",
    "bulk_send_print_hint": "Plukk og pakk fra listene. Transportører som skriver ut selv, som 24Shipping, har allerede sendt etikettene til skriveren.",
    "bulk_send_print_pick_list": "Samlet plukkliste",
    "bulk_send_print_packing_slips": "Plukkliste per ordre",
    "bulk_send_print_labels": "Etiketter",
    "bulk_send_close_while_sending": "Sendingen stopper hvis du lukker nå. Ordrer som allerede er sendt, forblir sendt.",
    "bulk_send_skip_not_found": "Fant ikke ordren",
    "bulk_send_skip_not_open": "Allerede sendt eller kansellert",
    "bulk_send_skip_locked": "Låst til en plukke-batch",
    "bulk_send_skip_shipping": "Fraktmåten mangler fraktkobling",
    "bulk_send_already_in_progress": "Ordren sendes allerede.",
    "bulk_send_order_number": "Ordre #:order",
    "bulk_send_labels_not_merged": "Disse etikettene kunne ikke legges i filen. Skriv dem ut fra ordresiden:",
    "bulk_send_nothing_to_print": "Ingen dokumenter å skrive ut.",
    "bulk_picking_feedback_title": "Passer ingen av flytene helt?",
    "bulk_picking_feedback_body": "Vi utvider gjerne med flere måter å håndtere det på. Fortell oss hvordan butikken din plukker og pakker — har dere et behov ingen av arbeidsmåtene dekker, ser vi på om vi kan bygge en flyt som passer.",
    "bulk_picking_auto_print_only_pakkestasjon": "Gjelder kun pakkestasjon-metoden.",
    "bulk_picking_auto_print_picklist": "Skriv ut plukkeliste automatisk",
    "bulk_picking_auto_print_picklist_description": "Send plukkelisten til skriver når en batch startes. (Krever Smartprint dokumentskriver, og 24shipping som logistikkleverandør på ordren.)",
    "bulk_picking_lock_guard": "Beskytt låste ordrer",
    "bulk_picking_lock_guard_description": "Blokker endringer på ordrer som er låst til en aktiv plukke-batch, til de frigjøres. Anbefalt når flere ansatte plukker samtidig.",
    "bulk_picking_order_locked_guard": "Ordre #:order er låst til aktiv batch #B-:batch (:admin). Frigjør den fra batchen først.",
    "bulk_picking_order_locked_banner": "Låst til aktiv batch #B-{batch} ({admin}) — frigjør for å redigere.",
    "stock_shortage_banner": "Ordren er oversolgt. Lageret viser negativt antall for disse varene:",
    "stock_shortage_line": "{name}: bestilt {requested}, mangler {shortfall}",
    "bulk_picking_landing_header_text": "Plukk mange ordrer samtidig",
    "bulk_picking_subheading": "Plukk og pakk mange ordrer i én operasjon — med metoden som passer butikken din.",
    "bulk_picking_how_it_works_1": "Velg ordrene du vil plukke, og start en batch.",
    "bulk_picking_how_it_works_2": "Få én samlet plukkeliste sortert etter lagerlokasjon.",
    "bulk_picking_how_it_works_3": "Sorter og pakk per ordre på pakkestasjonen.",
    "bulk_picking_get_started_heading": "Kom i gang",
    "bulk_picking_get_started_step_1": "Installer appen og velg plukkemetode.",
    "bulk_picking_get_started_step_2": "Gå til ordrelisten og velg «Start bulk-plukking».",
    "bulk_picking_get_started_step_3": "Plukk, pakk og fullfør ordrene.",
    "bulk_picking_features_heading": "Høydepunkter",
    "bulk_picking_feature_methods_title": "Flere plukkemetoder",
    "bulk_picking_feature_methods_body": "Pakkestasjon og klassiske lister er klare nå. Trillevogn kommer.",
    "bulk_picking_feature_bulk_title": "Oppfyll flere ordrer samtidig",
    "bulk_picking_feature_bulk_body": "Plukk, pakk og send mange ordrer i én operasjon — ikke én om gangen.",
    "bulk_picking_feature_location_title": "Sortert etter lagerplass",
    "bulk_picking_feature_location_body": "Legg til valgfri lagerplass på produktene, så grupperes plukklisten etter lokasjon — færre turer i lageret.",
    "bulk_picking_feature_lock_title": "Valgfri ordrelåsing",
    "bulk_picking_feature_lock_body": "Lås ordrene i en batch mens de plukkes, så to ansatte ikke tar samme ordre.",
    "bulk_picking_how_it_works_heading": "Slik fungerer pakkestasjon",
    "bulk_picking_setup_title": "Kom i gang",
    "bulk_picking_setup_done_title": "Alt klart",
    "bulk_picking_setup_step_method": "Velg plukkemetode",
    "bulk_picking_setup_step_mapping": "Koble fraktmetoder til transportørtjeneste",
    "bulk_picking_setup_step_printer": "Koble til en skriver",
    "bulk_picking_setup_step_printer_hint": "Anbefalt for automatisk utskrift av etiketter.",
    "bulk_picking_setup_configure": "Sett opp",
    "bulk_picking_setup_change": "Endre",
    "bulk_picking_setup_recommended": "Anbefalt",
    "warehouses_landing_header_text": "Spor lagerbeholdning på tvers av flere varelagre",
    "warehouses_subheading": "Bruk Varelager-appen for å administrere flere fysiske varelagre og holde orden på hvor produktene dine er lagret.",
    "warehouses_how_it_works_1": "Opprett flere varelagre og tilordne dem til produktvariantene dine.",
    "warehouses_how_it_works_2": "Spor lagerbeholdning per varelager og lagerplassering.",
    "warehouses_how_it_works_3": "Få en samlet oversikt over hvor lagervarene dine er.",
    "warehouses_how_it_works_4": "Aktiver eller deaktiver bruken av flere varelagre når som helst fra innstillingene.",
    "warehouses_get_started_heading": "Slik kommer du i gang",
    "warehouses_get_started_step_1": "Appen er allerede inkludert i lisensen din – ingen kjøp nødvendig.",
    "warehouses_get_started_step_2": "Legg til varelagre og lokasjoner under Innstillinger.",
    "warehouses_get_started_step_3": "Tilordne produkter og varianter til varelagre og hyller.",
    "warehouses": "Varelagre",
    "stock_locations": "Lagerplasseringer",
    "stock_location_warehouse_no_parent": "Et varelager kan ikke ha en overordnet plassering.",
    "stock_location_shelf_requires_warehouse_parent": "Hyller må ligge under et varelager.",
    "stock_location_bin_requires_shelf_parent": "Kasser må ligge under en hylle.",
    "stock_location_invalid_parent": "Ugyldig overordnet plassering for denne typen.",
    "default_warehouse": "Standard-varelager",
    "set_as_default": "Sett som standard",
    "features": "Funksjoner",
    "add_warehouse": "Legg til varelager",
    "add_location": "Legg til lagerplassering",
    "no_warehouses_yet": "Ingen varelagre ennå.",
    "stock_settings_description": "Konfigurer hvordan lager spores i butikken din.",
    "stock_features_description": "Skru på funksjoner for lagerplasseringer og flere varelagre.",
    "warehouses_description": "Fysiske lokasjoner der varer oppbevares.",
    "stock_locations_description": "Hyller, kasser eller områder innenfor et varelager.",
    "warehouse_name": "Varelagernavn",
    "location_name": "Lagerplasseringsnavn",
    "new_stock_location_name": "Nytt lagerplasseringsnavn",
    "no_stock_locations_yet": "Ingen lagerplasseringer ennå.",
    "rename_location": "Gi lagerplasseringen nytt navn",
    "confirm_delete_location": "Slett lagerplasseringen?",
    "new_warehouse_name": "Nytt varelagernavn",
    "rename": "Endre navn",
    "rename_warehouse": "Gi varelageret nytt navn",
    "confirm_delete_warehouse": "Slett varelageret? Dette kan ikke angres.",
    "confirm_delete_warehouse_with_locations": "Dette varelageret har {count} lagerplasseringer. Sletting fjerner også alle lagerplasseringene og deres lagerbeholdning. Fortsette?",
    "n_locations": "{count} lagerplasseringer",
    "welcome_flow.page_title": "Velkommen",
    "welcome_flow.trial_badge": "{total}-dagers gratis prøveperiode · Dag {day} av {total}",
    "welcome_flow.trial_badge_short": "Dag {day} av {total}",
    "welcome_flow.step_counter": "Steg {current} av {total}",
    "welcome_flow.continue": "Fortsett",
    "welcome_flow.back": "Tilbake",
    "welcome_flow.go_to_store": "Gå til butikken",
    "welcome_flow.steps.name.title": "Navn på butikken",
    "welcome_flow.steps.about.title": "Om butikken din",
    "welcome_flow.steps.theme.title": "Velg utgangspunkt",
    "welcome_flow.step1.heading_with_name": "Velkommen til 24Nettbutikk, {name}!",
    "welcome_flow.step1.heading": "Velkommen til 24Nettbutikk!",
    "welcome_flow.step1.intro": "La oss starte med navnet på butikken din. Etterpå stiller vi noen korte spørsmål for å bli bedre kjent — det tar under ett minutt.",
    "welcome_flow.step1.label": "Butikkens navn",
    "welcome_flow.step2.heading": "La oss bli litt kjent",
    "welcome_flow.step2.sub": "Tre korte spørsmål, så er vi nesten i mål.",
    "welcome_flow.step2.industry": "Hvilken bransje tilhører du?",
    "welcome_flow.step2.pos": "Trenger du integrasjon mot kassesystem (POS)?",
    "welcome_flow.step2.pos_name": "Hvilket kassesystem?",
    "welcome_flow.step2.pos_name_placeholder": "f.eks. Zettle, Susoft PCKasse",
    "welcome_flow.step2.contact": "Vil du at vi kontakter deg på telefon for en uforpliktende prat?",
    "welcome_flow.step2.phone": "Telefonnummer",
    "welcome_flow.step2.phone_placeholder": "+47 900 00 000",
    "welcome_flow.step3.heading": "Velg et utgangspunkt",
    "welcome_flow.step3.sub": "Et ferdig oppsett du kan tilpasse videre.",
    "welcome_flow.step3.suggestion_banner": "Basert på bransjen du valgte ({industry}), har vi foreslått {theme}-temaet. Du kan velge et annet i listen nedenfor.",
    "welcome_flow.step3.suggested_badge": "Foreslått",
    "welcome_flow.step3.selected_label": "Valgt: {theme}",
    "welcome_flow.industry.clothes": "Klær og mote",
    "welcome_flow.industry.home": "Hjem og interiør",
    "welcome_flow.industry.food": "Mat og drikke",
    "welcome_flow.industry.beauty": "Skjønnhet og velvære",
    "welcome_flow.industry.sport": "Sport og fritid",
    "welcome_flow.industry.kids": "Barn og baby",
    "welcome_flow.industry.other": "Annet",
    "welcome_flow.pos.no": "Nei",
    "welcome_flow.pos.yes": "Ja",
    "welcome_flow.pos.maybe": "Kanskje senere",
    "welcome_flow.contact.yes": "Ja, gjerne",
    "welcome_flow.contact.email": "Bare send meg en e-post",
    "welcome_flow.contact.no": "Nei takk",
    "first_product_wizard.page_title": "Opprett ditt første produkt",
    "first_product_wizard.step_name_placeholder": "For eksempel «Økologisk bomullsgenser»",
    "first_product_wizard.name_min_chars": "Minst 3 tegn.",
    "first_product_wizard.simplified_note_title": "Legg til ditt første produkt – enkelt og raskt",
    "first_product_wizard.simplified_note_body": "Her viser vi bare det viktigste du trenger for å opprette ditt første produkt og komme videre til testbestillingen. Du kan legge til varianter, SEO, frakt og andre innstillinger senere fra produktsiden.",
    "first_product_wizard.full_form_prompt": "Vil du heller fylle ut alt nå?",
    "first_product_wizard.use_full_form": "Gå til full produktregistrering",
    "first_product_wizard.lead_paragraph_placeholder": "Kort salgsargument, vises over beskrivelsen.",
    "first_product_wizard.description_label": "Beskrivelse",
    "first_product_wizard.description_placeholder": "Fortell om materialer, størrelse, bruk, osv.",
    "first_product_wizard.step_shipping_subtitle": "Velg pakketype så frakten beregnes riktig. Du kan justere senere.",
    "first_product_wizard.step_images_subtitle": "Et godt bilde selger bedre enn en god tekst.",
    "first_product_wizard.step_description_subtitle": "En kort ingress og en beskrivelse hjelper kundene å bestemme seg.",
    "first_product_wizard.step_pricing_subtitle": "Du kan endre prisen når som helst.",
    "first_product_wizard.package_preset_group_label": "Pakketype",
    "first_product_wizard.package_preset.letter.label": "Brev",
    "first_product_wizard.package_preset.letter.summary": "200 g · 25×15×2 cm",
    "first_product_wizard.package_preset.small.label": "Småpakke",
    "first_product_wizard.package_preset.small.summary": "500 g · 25×20×10 cm",
    "first_product_wizard.package_preset.medium.label": "Pakke",
    "first_product_wizard.package_preset.medium.summary": "2 kg · 40×30×20 cm",
    "first_product_wizard.package_preset.large.label": "Stor pakke",
    "first_product_wizard.package_preset.large.summary": "5 kg · 50×40×30 cm",
    "first_product_wizard.package_preset.custom.label": "Tilpasset",
    "first_product_wizard.package_preset.custom.summary": "Skriv inn vekt og mål selv.",
    "first_product_wizard.package_preset.weight_label": "Vekt",
    "first_product_wizard.package_preset.length_label": "Lengde",
    "first_product_wizard.package_preset.width_label": "Bredde",
    "first_product_wizard.package_preset.height_label": "Høyde",
    "first_product_wizard.step_variants_title": "Har produktet varianter?",
    "first_product_wizard.step_variants_subtitle": "For eksempel ulike størrelser eller farger. Du kan alltid legge til varianter senere.",
    "first_product_wizard.variants_no_desc": "Ett enkelt produkt",
    "first_product_wizard.variants_yes_desc": "Flere varianter",
    "first_product_wizard.variants_explanation": "Legg til én linje per valg kunden skal ta (f.eks. «Størrelse» med verdiene «S», «M», «L»). Vi lager alle kombinasjoner automatisk.",
    "first_product_wizard.option_name_label": "Navn på valg",
    "first_product_wizard.option_name_placeholder": "F.eks. Størrelse, Farge, Materiale",
    "first_product_wizard.add_value_placeholder": "Legg til verdi, f.eks. Medium",
    "first_product_wizard.add_value_button": "Legg til",
    "first_product_wizard.add_option": "Legg til enda et valg",
    "first_product_wizard.remove_option": "Fjern valg",
    "first_product_wizard.remove_value": "Fjern verdi",
    "first_product_wizard.all_variants_same_price": "Alle variantene har samme pris",
    "first_product_wizard.variants_preview_count": "Varianter ({count})",
    "first_product_wizard.variant_price_placeholder": "Pris",
    "first_product_wizard.variant_stock_placeholder": "Lager",
    "first_product_wizard.too_many_variants_hint": "Du har mange varianter — du kan sette priser og lager for hver enkelt senere i produktet.",
    "first_product_wizard.upload_instruction": "Klikk eller dra bildene hit",
    "first_product_wizard.upload_drop_here": "Slipp bildene her",
    "first_product_wizard.upload_formats": "JPG, PNG eller WebP.",
    "first_product_wizard.image_remove": "Fjern bilde",
    "first_product_wizard.publish_visible_title": "Produktet blir synlig i butikken din",
    "first_product_wizard.publish_visible_desc": "Du bruker det til en testbestilling i neste del av oppsettet. Du kan skjule produktet når som helst fra produktsiden.",
    "first_product_wizard.create_product": "Opprett produkt",
    "first_product_wizard.continue": "Fortsett",
    "first_product_wizard.create_failed": "Noe gikk galt. Prøv igjen.",
    "first_product_wizard.image_upload_failed": "Kunne ikke laste opp bilder. Produktet ble opprettet uten bilder.",
    "first_product_wizard.success_flash": "Ditt første produkt er opprettet!",
    "first_product_wizard.preview_hide": "Skjul forhåndsvisning",
    "first_product_wizard.preview_show": "Vis forhåndsvisning",
    "first_product_wizard.preview_label": "Forhåndsvisning",
    "first_product_wizard.preview_close": "Lukk",
    "first_product_wizard.preview_mobile_button": "Forhåndsvis",
    "first_product_wizard.preview_image_placeholder": "Bilde vises her",
    "first_product_wizard.preview_name_placeholder": "Produktnavn",
    "first_product_wizard.preview_price_placeholder": "Pris settes på neste steg",
    "trial_dashboard.eyebrow": "Kom i gang · {done} av {total} fullført",
    "trial_dashboard.heading": "Tre ting å gjøre først.",
    "trial_dashboard.sub": "Velg det som føles enklest. Alt lagres underveis — du kan stoppe når som helst.",
    "trial_dashboard.trial_label": "Prøveperiode",
    "trial_dashboard.trial_day_progress": "Dag {day} av {total} · {left} dager igjen",
    "trial_dashboard.card_name.title": "Butikken har navn",
    "trial_dashboard.card_name.desc_with_name": "{name} — du kan endre dette når som helst.",
    "trial_dashboard.card_name.desc_no_name": "Du kan endre navnet når som helst.",
    "trial_dashboard.card_name.time": "Ferdig",
    "trial_dashboard.card_product.title": "Legg til ditt første produkt",
    "trial_dashboard.card_product.desc": "Legg til et produkt i butikken din og gjør det klart for salg.",
    "trial_dashboard.card_product.time": "⏱ ~2 min",
    "trial_dashboard.card_test_order.default.title": "Legg inn en testbestilling",
    "trial_dashboard.card_test_order.default.desc": "Kjøp produktet ditt fra din egen butikk. Se hele reisen — fra kurv til kvittering — før kunder gjør det.",
    "trial_dashboard.card_test_order.default.time": "⏱ ~2 min",
    "trial_dashboard.card_test_order.fulfill.title": "Fullfør testbestillingen",
    "trial_dashboard.card_test_order.fulfill.desc": "Ordren ligger og venter. Bekreft den og opprett en fraktetikett — nøyaktig slik du gjør det med ekte kundeordrer.",
    "trial_dashboard.card_test_order.fulfill.time": "⏱ ~1 min",
    "trial_dashboard.card_test_order.needs_product_hint": "Legg til et produkt først for å kunne legge inn en testbestilling.",
    "trial_dashboard.footer.title": "Litt mer å sette opp før butikken er klar for kunder.",
    "trial_dashboard.footer.see_full_checklist": "Se full sjekkliste →",
    "trial_dashboard.remaining.completed": "Ferdig",
    "trial_dashboard.remaining.sub": "Fullfør stegene for å åpne butikken din for kunder.",
    "trial_dashboard.checklist.heading": "Kom i gang med din 24Nettbutikk",
    "trial_dashboard.checklist.sub": "Følg stegene nedenfor for å sette opp butikken din. Når du fullfører et steg, blir det markert som utført.",
    "trial_dashboard.checklist.progress_label": "fullført",
    "trial_dashboard.checklist.encouragement_title": "Du er på god vei!",
    "trial_dashboard.checklist.encouragement_body": "Fullfør stegene og få butikken din klar til lansering.",
    "trial_dashboard.checklist.done": "Utført",
    "trial_dashboard.checklist.not_done": "Ikke utført",
    "trial_dashboard.checklist.tips_label": "Tips!",
    "trial_dashboard.checklist.tips_body": "Du kan når som helst komme tilbake hit for å se fremdriften din.",
    "trial_dashboard.checklist.hide": "Skjul oversikten",
    "trial_dashboard.checklist.hide_hint": "Du finner alltid sjekklisten i toppmenyen.",
    "trial_checklist_drawer.restore_cards": "Vis oversikten på dashbordet igjen",
    "trial_dashboard.remaining.details": "Mer om stegene",
    "trial_dashboard.remaining.start": "Start",
    "trial_dashboard.skip_three_things": "Hopp over",
    "trial_checklist_chip.label": "Sjekkliste",
    "trial_checklist_chip.aria": "Åpne sjekkliste · {done} av {total} fullført",
    "trial_checklist_drawer.heading": "Full sjekkliste",
    "trial_checklist_drawer.sub": "Alt du bør sette opp før du åpner butikken for kunder.",
    "trial_checklist_drawer.progress": "{done} av {total} fullført",
    "trial_checklist_drawer.section_get_started": "Kom i gang",
    "trial_checklist_drawer.section_prepare_store": "Klargjør butikken",
    "trial_checklist_drawer.help_prefix": "Trenger du hjelp?",
    "trial_checklist_drawer.help_link": "Hjelpesenteret",
    "trial_checklist_drawer.close": "Lukk sjekkliste",
    "trial_checklist_drawer.expand": "Vis mer",
    "trial_checklist_drawer.collapse": "Skjul",
    "trial_checklist_drawer.completed_badge": "Fullført",
    "trial_checklist_drawer.video_play": "Spill av video",
    "trial_checklist_drawer.cta_view": "Vis",
    "trial_checklist_drawer.cta_step_name": "Gå til innstillinger",
    "trial_checklist_drawer.cta_step_product": "Start produktveiviseren",
    "trial_checklist_drawer.cta_step_test_order_default": "Start testbestilling",
    "trial_checklist_drawer.cta_step_test_order_fulfill": "Fullfør ordren",
    "trial_checklist_drawer.cta_step_test_order_done": "Vis ordrer",
    "trial_checklist_drawer.cta_step_test_order_needs_product": "Lag et produkt først",
    "trial_dashboard.card_name.help_text": "Butikknavnet vises i kassen, på fakturaer og i søkeresultater. Du kan endre det når som helst fra innstillingene.",
    "trial_dashboard.card_name.bullets.0": "Vises i hodet på butikken",
    "trial_dashboard.card_name.bullets.1": "Brukes i e-postkvitteringer og fakturaer",
    "trial_dashboard.card_name.bullets.2": "Kan endres når som helst",
    "trial_dashboard.card_product.help_text": "Det første produktet ditt setter standarden for resten. Vi har laget en forenklet flyt så du raskt får noe å selge — du kan finjustere alt fra produktsiden senere.",
    "trial_dashboard.card_product.bullets.0": "Bilder, navn og pris er det viktigste",
    "trial_dashboard.card_product.bullets.1": "Du kan legge til varianter (størrelse, farge) senere",
    "trial_dashboard.card_product.bullets.2": "Sett MVA-sats riktig fra start",
    "trial_dashboard.card_test_order.default.help_text": "Test selve kjøpsopplevelsen før kundene gjør det. Du kjøper produktet ditt fra din egen butikk og ser hele reisen — fra produktside til kvittering.",
    "trial_dashboard.card_test_order.default.bullets.0": "Ingen ekte penger trekkes — vi simulerer betaling",
    "trial_dashboard.card_test_order.default.bullets.1": "Du ser hva kundene faktisk møter",
    "trial_dashboard.card_test_order.default.bullets.2": "Etter handelen kan du fullføre ordren som om det var en ekte kunde",
    "trial_dashboard.card_test_order.fulfill.help_text": "Ordren ligger og venter på fulfillment. Bekreft den, lag en fraktetikett og se hvordan en ekte kundeordre håndteres — fra start til pakke i posten.",
    "trial_dashboard.card_test_order.fulfill.bullets.0": "Bekreft ordreinformasjonen",
    "trial_dashboard.card_test_order.fulfill.bullets.1": "Velg fraktmetode og lag etikett",
    "trial_dashboard.card_test_order.fulfill.bullets.2": "Marker som sendt",
    "onboarding_survey.title": "Før vi begynner - La oss bli litt mer kjent",
    "onboarding_survey.intro": "Vi stiller noen korte spørsmål så vi kan tilpasse 24Nettbutikk til dine behov. Tar under to minutter.",
    "onboarding_survey.submit": "Fullfør",
    "onboarding_survey.skip_link": "Hopp over spørsmålene",
    "onboarding_survey.situation.question": "Hva beskriver best din situasjon?",
    "onboarding_survey.situation.options.already_has_store": "Jeg driver allerede en nettbutikk",
    "onboarding_survey.situation.options.physical_store": "Jeg driver fysisk butikk og vil starte nettbutikk",
    "onboarding_survey.situation.options.starting_idea": "Jeg er i oppstartsfasen med en idé",
    "onboarding_survey.situation.options.exploring": "Jeg tester / utforsker muligheter",
    "onboarding_survey.current_platform.question": "Hvilken plattform bruker du i dag?",
    "onboarding_survey.current_platform.options.shopify": "Shopify",
    "onboarding_survey.current_platform.options.mystore": "Mystore",
    "onboarding_survey.current_platform.options.woocommerce": "WooCommerce",
    "onboarding_survey.current_platform.options.magento": "Magento",
    "onboarding_survey.current_platform.options.wix": "Wix",
    "onboarding_survey.current_platform.options.quickbutik": "Quickbutik",
    "onboarding_survey.current_platform.options.other": "Annen",
    "onboarding_survey.timeline.question": "Hvor langt har du kommet i prosessen?",
    "onboarding_survey.timeline.options.within_1_month": "Klar til å starte innen 1 måned",
    "onboarding_survey.timeline.options.within_3_months": "Planlegger oppstart innen 3 måneder",
    "onboarding_survey.timeline.options.uncertain": "Usikker på tidspunkt",
    "onboarding_survey.timeline.options.idea_stage": "Kun på idéstadiet",
    "onboarding_survey.industry.question": "Hvilken bransje tilhører du?",
    "onboarding_survey.industry.options.klaer_og_mote": "Klær og mote",
    "onboarding_survey.industry.options.sport_og_fritid": "Sport og fritid",
    "onboarding_survey.industry.options.elektronikk": "Elektronikk",
    "onboarding_survey.industry.options.mat_og_drikke": "Mat og drikke",
    "onboarding_survey.industry.options.hjem_og_interior": "Hjem og interiør",
    "onboarding_survey.industry.options.barn_og_baby": "Barn og baby",
    "onboarding_survey.industry.options.smykker_og_klokker": "Smykker og klokker",
    "onboarding_survey.industry.options.kosmetikk_og_skjonnhet": "Kosmetikk og skjønnhet",
    "onboarding_survey.industry.options.boker_og_media": "Bøker og media",
    "onboarding_survey.industry.options.haandverk_og_kunst": "Håndverk og kunst",
    "onboarding_survey.industry.options.dyr_og_dyrepleie": "Dyr og dyrepleie",
    "onboarding_survey.industry.options.hobby_og_spill": "Hobby og spill",
    "onboarding_survey.industry.options.helse_og_velvaere": "Helse og velvære",
    "onboarding_survey.industry.options.bil_og_mc": "Bil og MC",
    "onboarding_survey.industry.options.bygg_og_hage": "Bygg og hage",
    "onboarding_survey.industry.options.tjenester": "Tjenester",
    "onboarding_survey.industry.options.digitale_produkter": "Digitale produkter",
    "onboarding_survey.industry.options.annet": "Annet",
    "onboarding_survey.selling_what.question": "Hva skal du selge? (velg flere hvis aktuelt)",
    "onboarding_survey.selling_what.options.physical": "Fysiske produkter",
    "onboarding_survey.selling_what.options.digital": "Digitale produkter",
    "onboarding_survey.selling_what.options.services": "Tjenester",
    "onboarding_survey.selling_what.options.subscription": "Abonnement",
    "onboarding_survey.selling_where.question": "Hvor planlegger du å selge?",
    "onboarding_survey.selling_where.options.norway_only": "Kun i Norge",
    "onboarding_survey.selling_where.options.norway_plus_international": "Norge + Internasjonalt",
    "onboarding_survey.needs_pos.question": "Trenger du integrasjon mot kassasystem (POS)?",
    "onboarding_survey.needs_pos.options.no": "Nei",
    "onboarding_survey.needs_pos.options.yes": "Ja",
    "onboarding_survey.pos_name.question": "Hvilket POS bruker du? (f.eks. Zettle, Susoft PCKasse)",
    "onboarding_survey.important_features.question": "Hvilke funksjoner er viktigst for deg? (velg flere)",
    "onboarding_survey.important_features.options.seo": "Søkemotoroptimalisering (SEO)",
    "onboarding_survey.important_features.options.b2b": "B2B / bedriftskunder",
    "onboarding_survey.important_features.options.multilingual": "Flere språk",
    "onboarding_survey.important_features.options.multicurrency": "Flere valutaer",
    "onboarding_survey.important_features.options.subscription": "Abonnement",
    "onboarding_survey.important_features.options.advanced_shipping": "Avanserte fraktregler",
    "onboarding_survey.important_features.options.discounts": "Rabatter og kampanjer",
    "onboarding_survey.important_features.options.pos": "POS — fysisk kasseløsning",
    "onboarding_survey.platform_priorities.question": "Hva er viktigst når du velger nettbutikkplattform? (velg maks 3)",
    "onboarding_survey.platform_priorities.options.price": "Pris",
    "onboarding_survey.platform_priorities.options.simplicity": "Enkelhet",
    "onboarding_survey.platform_priorities.options.integrations": "Integrasjoner",
    "onboarding_survey.platform_priorities.options.design": "Design",
    "onboarding_survey.platform_priorities.options.seo": "SEO",
    "onboarding_survey.platform_priorities.options.automation": "Automatisering",
    "onboarding_survey.platform_priorities.options.scaling": "Skalering",
    "onboarding_survey.platform_priorities.options.pos": "POS",
    "onboarding_survey.platform_priorities.options.free_support": "Gratis support",
    "onboarding_survey.platform_priorities.options.international": "Salg til utlandet",
    "onboarding_survey.expected_revenue.question": "Hvor mye forventer du å omsette for første år?",
    "onboarding_survey.expected_revenue.options.under_100k": "Under 100 000 kr",
    "onboarding_survey.expected_revenue.options.100k_500k": "100 000 – 500 000 kr",
    "onboarding_survey.expected_revenue.options.500k_1m": "500 000 – 1 mill kr",
    "onboarding_survey.expected_revenue.options.over_1m": "Over 1 mill kr",
    "onboarding_survey.wants_sales_call.question": "Vil du at vi kontakter deg på telefon for en uforpliktende prat?",
    "onboarding_survey.wants_sales_call.options.yes": "Ja",
    "onboarding_survey.wants_sales_call.options.no": "Nei",
    "onboarding_survey.phone.question": "Telefonnummer",
    "MyBring Booking": "MyBring Booking",
    "mybring_uid_label": "MyBring UID (e-post)",
    "logistra_enabled": "Aktiver Logistra",
    "logistra_enabled_description": "Når aktivert kan Logistra brukes til å booke forsendelser ved ordrebehandling.",
    "sincos_shipping_enabled": "Aktiver 24Shipping",
    "sincos_shipping_enabled_description": "Når aktivert kan 24Shipping brukes til å booke forsendelser ved ordrebehandling.",
    "sincos_shipping_app_headline": "Fraktetiketter uten egne transportøravtaler",
    "sincos_shipping_app_body": "Aktiver appen og book forsendelser med Posten og PostNord direkte fra ordrebehandlingen — uten egne transportøravtaler.",
    "mybring_booking_enabled": "Aktiver MyBring Booking",
    "mybring_booking_enabled_description": "Når aktivert kan MyBring brukes til å booke forsendelser ved ordrebehandling.",
    "mybring_uid_description": "E-postadressen som er registrert som API-bruker i MyBring-kontoen din.",
    "mybring_api_key_description": "API-nøkkelen din fra mybring.com. La den maskerte verdien stå for å beholde gjeldende nøkkel.",
    "mybring_default_customer_number_description": "Forhåndsvalgt kunde ved booking. Tilgjengelig når gyldige API-detaljer er lagret.",
    "mybring_app_headline": "Book Bring-forsendelser med din egen avtale",
    "mybring_app_body": "Koble til MyBring-kontoen din og book fraktetiketter direkte fra ordrebehandlingen med dine egne Bring-priser.",
    "mybring_api_key_label": "MyBring API Key",
    "default_customer_number": "Standard kundenummer",
    "select_customer_number": "Velg kundenummer...",
    "select_bring_product": "Velg Bring-produkt...",
    "select_shipping_product": "Velg fraktprodukt...",
    "mybring_credentials_validation_failed": "Kunne ikke koble til MyBring. Sjekk at UID og API Key er korrekte.",
    "unknown_customer_number": "Ukjent kundenummer.",
    "only_norwegian_customers": "Vis kun norske kontoer",
    "only_norwegian_customers_help": "Når aktiv vises kun MyBring-kontoer registrert i Norge. Slå av for å vise kontoer fra alle land.",
    "open_options": "Åpne valg",
    "logistics_description_sincos_shipping": "Komplett fraktavtale som gir deg stordriftsfordeler og profesjonell logistikk fra første dag.",
    "logistics_description_mybring_booking": "Bestill fraktlapper direkte hos Bring med din egen MyBring-konto.",
    "shipping_mapping_title": "Fraktkobling",
    "shipping_mapping_intro": "Koble hver fraktmetode til en transportørtjeneste, eller merk den som manuell.",
    "shipping_mapping_info_title": "Hva er fraktkobling?",
    "shipping_mapping_info_body": "Fraktkobling styrer hvilken transportørtjeneste som brukes automatisk når du behandler ordrer i bulk (bulk-plukking). Kunden velger en fraktmetode i kassen (for eksempel Standard eller Hentested); koblingen bestemmer hvilken tjeneste den bookes med, så du slipper å velge per ordre. Behandler du ordrer enkeltvis, velger du transportør selv der.",
    "shipping_mapping_info_hint": "I bulk-flyten sendes fraktmetoder uten kobling manuelt uten etikett. Metoder som krever hentested er låst til riktig transportør. Har vi et forslag, vises det under feltet – trykk Bruk for å ta det i bruk.",
    "shipping_mapping_method": "Fraktmetode",
    "shipping_mapping_target": "Kobling",
    "shipping_mapping_not_configured": "Ikke konfigurert",
    "shipping_mapping_manual_option": "Manuell — ingen etikett",
    "shipping_mapping_product": "Tjeneste",
    "shipping_mapping_unmapped_badge": "Mangler kobling",
    "shipping_mapping_auto_default": "Sendes med egen transportør som standard — overstyr ved behov",
    "shipping_mapping_unknown_provider": "Ukjent transportør.",
    "shipping_mapping_unknown_product": "Ukjent tjeneste for valgt transportør.",
    "shipping_mapping_recommended_unsaved": "Anbefalt — ikke lagret",
    "shipping_mapping_recommended_label": "Anbefalt:",
    "shipping_mapping_use": "Bruk",
    "shipping_mapping_summary_unmapped": "{unmapped} av {total} fraktmetoder mangler kobling",
    "shipping_mapping_summary_all_mapped": "Alle fraktmetoder er koblet",
    "shipping_mapping_filter_all": "Alle",
    "shipping_mapping_locked_badge": "Låst",
    "shipping_mapping_apply_all": "Bruk alle forslag",
    "shipping_mapping_save_failed": "Kunne ikke lagre — prøv igjen.",
    "shipping_mapping_manual_no_label_hint": "Sendes uten etikett",
    "shipping_mapping_select_target_first": "Velg kobling først",
    "shipping_mapping_other_group": "Annet",
    "shipping_mapping_provider_disabled": "Transportøren er deaktivert — aktiver den i App Store eller velg en annen.",
    "select_logistics_provider": "Velg logistikkleverandør...",
    "select_logistics_product": "Velg fraktprodukt...",
    "shipping_methods_fetched": "{count} fraktmåter funnet — velg en nedenfor",
    "app_disable_confirm_title": "Bekreft deaktivering",
    "app_disable_confirm_button": "Deaktiver og lagre",
    "app_disable_mapped_warning": "{1}:count fraktmetode er koblet til :name og vil stå uten kobling til appen aktiveres igjen — eller du kan koble den til en annen transportør under Fraktkobling.|[2,*]:count fraktmetoder er koblet til :name og vil stå uten kobling til appen aktiveres igjen — eller du kan koble dem til en annen transportør under Fraktkobling.",
    "shipping_mapping_pickup_locked": "Krever hentested — låst til riktig transportør",
    "shipping_mapping_link": "Fraktkobling",
    "pickup_at_store": "Hent i butikk",
    "printers": "Skrivere",
    "mybring_not_configured": "MyBring er ikke tilgjengelig for denne ordren.",
    "discard_changes": "Forkast endringer",
    "discard_unsaved_changes_question": "Forkast alle endringer som ikke er lagret?",
    "save_failed_some_items_have_errors": "Lagring feilet — noen punkter har feil",
    "only_top_level_menu_items_can_be_mega_menus": "Kun menypunkter på øverste nivå kan settes som megameny",
    "menu_save_item_not_found": "Menypunktet finnes ikke i denne menyen",
    "menu_save_unknown_temp_id": "Et nytt menypunkt refererte til et annet som ikke ble opprettet",
    "menu_save_circular_temp_id_reference": "Sirkulær referanse mellom nye menypunkter",
    "menu_is_empty": "Menyen er tom",
    "add_first_menu_item_hint": "Legg til ditt første menypunkt for å komme i gang",
    "click_to_edit_name": "Klikk for å endre navn",
    "right_column": "Høyre kolonne",
    "home": "Hjem",
    "create_template": "Opprett mal",
    "delete_template": "Slett mal",
    "template_name": "Malnavn",
    "confirm_delete_template": "Er du sikker på at du vil slette denne malen? Produkter som bruker den vil automatisk gå tilbake til standardmalen.",
    "confirm_delete_category_template": "Er du sikker på at du vil slette denne malen? Kategorier som bruker den går automatisk tilbake til standardmalen.",
    "template_deleted": "Malen ble slettet",
    "categories_now_use_default_template": "{0} Ingen kategorier brukte malen|{1} 1 kategori bruker nå standardmalen|[2,*] :count kategorier bruker nå standardmalen",
    "product_page_template": "Produktsidemal",
    "page_template": "Sidemal",
    "others_also_bought": "Andre kjøpte også",
    "product_title": "Produkttittel",
    "product_lead_paragraph": "Produktingress",
    "product_price": "Produktpris",
    "payment_methods_title_description": "Valgfri tekst som vises over logoene, f.eks. \"Rask og trygg betaling med:\".",
    "payment_methods_logos": "Logoer",
    "payment_methods_logos_description": "Velg hvilke betalingsmåte-logoer som skal vises på produktsiden.",
    "product_options": "Produktvalg",
    "stock_status": "Lagerstatus",
    "add_to_cart": "Legg i handlekurv",
    "product_description": "Produktbeskrivelse",
    "related_products": "Relaterte produkter",
    "column_ratio": "Kolonneforhold",
    "image_gallery": "Bildegalleri",
    "sticky_left_column": "Fest venstre kolonne",
    "sticky_left_column_description": "Venstre kolonne følger med ved scrolling. Nyttig når høyrekolonnen er lengre enn galleriet.",
    "sticky_right_column": "Fest høyre kolonne",
    "sticky_right_column_description": "Høyre kolonne følger med ved scrolling. Nyttig når galleriet er høyere enn produktinnholdet (feks rutenett med mange bilder).",
    "gallery_thumbnail_position": "Miniatyrbildeposisjon",
    "gallery_grid_columns": "Antall kolonner i rutenettet",
    "gallery_grid_columns_description": "Kun når miniatyrbildeposisjon er satt til Rutenett.",
    "gallery_display_style": "Visning",
    "gallery_display_style_description": "Slider viser ett bilde om gangen. Redaksjonelt rutenett viser hovedbildet i full bredde og resten i et 2-kolonners oppsett der hvert tredje bilde får full bredde (kun på PC — mobil beholder slideren). Produkter med bare ett bilde bruker slideren.",
    "gallery_display_slider": "Slider",
    "gallery_display_editorial_grid": "Redaksjonelt rutenett",
    "gallery_mobile_style": "Mobilvisning",
    "gallery_mobile_style_description": "Gjelder kun mobil. Standard viser ett bilde om gangen med teller. Miniatyrbilder legger en rad med små bilder under. Filmstripe viser kanten av neste bilde med en tynn fremdriftslinje under.",
    "gallery_mobile_style_standard": "Standard",
    "gallery_mobile_style_thumbnails": "Miniatyrbilder",
    "gallery_mobile_style_filmstrip": "Filmstripe",
    "gallery_hover_zoom": "Zoom ved peking",
    "gallery_hover_zoom_description": "Forstørr hovedbildet når kunden holder musepekeren over det (kun på PC). Klikk åpner fortsatt fullskjerm.",
    "gallery_aspect_ratio": "Bildeforhold på hovedbildet",
    "gallery_aspect_ratio_description": "Velg et fast forhold for å minimere whitespace. Naturlig bruker bildets egen proporsjon i slideren og 16:9 for hovedbildet i rutenettet.",
    "gallery_aspect_natural": "Naturlig",
    "gallery_image_fill": "Fyll hele bilderammen",
    "gallery_image_fill_description": "Bildet fyller hele rammen og beskjærer ytterkantene ved behov. Avslått beholder hele bildet med whitespace rundt.",
    "gallery_show_image_text": "Vis bildetekst",
    "gallery_show_image_text_description": "Vis teksten fra feltet Bildetekst under produktbildet. Bilder uten bildetekst vises som før.",
    "gallery_image_text_filename_fallback": "Bruk filnavn når bildetekst mangler",
    "gallery_image_text_filename_fallback_description": "Bilder uten bildetekst viser filnavnet sitt, uten filendelse.",
    "gallery_image_text_alignment": "Justering av bildetekst",
    "gallery_image_text_alignment_description": "Gjelder teksten under bildet, i både slider og rutenett.",
    "gallery_image_text_align_left": "Venstre",
    "gallery_image_text_align_center": "Midtstilt",
    "gallery_image_text_align_right": "Høyre",
    "gallery_show_thumbnails": "Vis miniatyrbilder",
    "gallery_show_thumbnails_description": "Skjul for å bare vise hovedbildet. Nyttig om produktet kun har ett bilde eller om du vil ha et renere uttrykk.",
    "sticky_gallery": "Fest bildegalleri",
    "sticky_gallery_description": "Bildegalleriet følger med ved scrolling",
    "heading_tag": "Overskriftsnivå",
    "show_sale_badge": "Vis salgsmerke",
    "show_discount_badge": "Vis rabattmerke",
    "show_discount_badge_description": "Vis prosentvis rabatt som et merke i hjørnet av hovedbildet når produktet er på salg.",
    "display_style": "Visningsstil",
    "product_options_display_style_description": "Om verdiene vises som tekst, farger eller bilder styres av valget på hvert alternativ under Varianter på produktet i admin. Her velger du bare utformingen av knappene.",
    "product_options_size": "Størrelse på knapper",
    "product_options_size_s": "Små",
    "product_options_size_m": "Middels",
    "product_options_size_l": "Store",
    "product_options_size_xl": "Ekstra store",
    "product_options_swatch_shape": "Form på variantvalg",
    "product_options_swatch_shape_theme": "Følg temaets hjørner",
    "product_options_swatch_shape_rounded": "Avrundet",
    "product_options_swatch_shape_circle": "Sirkel",
    "product_options_show_selected_value": "Vis valgt verdi i etiketten",
    "product_options_show_selected_value_description": "Viser valgt verdi ved siden av alternativnavnet, f.eks. «Farge: Hvit». Gjelder alternativer med farge- eller bildevisning.",
    "clear_variant_image_on_x_variants": "Fjern galleribildet fra {count} produktvarianter",
    "clear_variant_image_explanation": "Uten galleribilde blir galleriet stående på hovedbildet når kunden velger produktvarianten.",
    "set_variant_image": "Sett galleribilde",
    "set_variant_image_action_description": "Velg bildet galleriet viser når kunden velger disse produktvariantene",
    "clear_variant_image_action_description": "Fjern galleribildet fra de valgte produktvariantene",
    "adjust_stock_variants_action_description": "Øk eller reduser lagerantallet for de valgte variantene",
    "toggle_active_variants_action_description": "Aktiver eller deaktiver de valgte variantene",
    "variant_bulk_hint": "Huk av produktvarianter, eller velg dem etter alternativ, for å sette galleribilde, lager eller status på flere samtidig.",
    "set_variant_image_on_x_variants": "Sett galleribilde på {count} produktvarianter",
    "variant_image_clear": "Fjern galleribildet",
    "image_used_by_gallery_only": "Kun i galleriet",
    "main_image": "Hovedbilde",
    "show_all_images": "Vis alle bildene",
    "show_fewer_images": "Vis færre bilder",
    "images_reorder_hint": "Dra for å endre rekkefølge – det første bildet er hovedbildet.",
    "product_options_show_variant_prices": "Vis variantpris",
    "product_options_show_variant_prices_description": "Viser variantens pris ved hver verdi i nedtrekksliste, skuff og rader i full bredde. Med flere alternativer vises prisen først når de andre valgene er gjort, siden prisen tilhører varianten.",
    "product_options_low_stock_hint": "Lavt lager-hint",
    "product_options_low_stock_hint_description": "Viser «Kun X igjen» under variantvalgene når valgt variant har færre enn grensen på lager. Gjelder produkter med lagerstyring uten restordre.",
    "product_options_low_stock_off": "Av",
    "product_options_low_stock_3": "Under 3",
    "product_options_low_stock_5": "Under 5",
    "product_options_low_stock_10": "Under 10",
    "product_options_unavailable_values": "Utsolgte verdier",
    "product_options_unavailable_strikethrough": "Vis med strek",
    "product_options_unavailable_hide": "Skjul",
    "show_quantity_selector": "Vis antallsvelger",
    "buy_button_text": "Tekst på kjøpsknapp",
    "preorder_button_text": "Tekst på forhåndsbestillingsknapp",
    "club_promo": "Kundeklubb-boks",
    "club_promo_bg_color": "Bakgrunnsfarge",
    "club_promo_text_color": "Tekstfarge",
    "club_promo_icon": "Ikon",
    "club_promo_icon_star": "Stjerne",
    "club_promo_icon_gift": "Gave",
    "club_promo_icon_sparkles": "Glitter",
    "club_promo_icon_heart": "Hjerte",
    "club_promo_icon_badge": "Merke",
    "club_promo_icon_none": "Ingen",
    "vipps_express_button": "Vipps Express-knapp",
    "vipps_express_button_width": "Bredde",
    "club_promo_texts_in_app_settings": "Aktivering og tekster styres i Kundeklubb-appens innstillinger",
    "customer_club_design_moved_to_theme_editor": "Farger og ikon styres i theme-editoren på ClubPromo-blokken.",
    "open_theme_editor": "Åpne theme-editoren",
    "reviews_per_page": "Anmeldelser per side",
    "reviews_list_loading": "Innlasting",
    "reviews_list_loading_description": "Rullefelt viser alle anmeldelsene i en boks med egen rulling, som i dag. «Vis flere»-knapp viser et antall om gangen og laster flere ved klikk.",
    "reviews_list_loading_scroll": "Rullefelt",
    "reviews_list_loading_button": "«Vis flere»-knapp",
    "reviews_per_page_description": "Antall anmeldelser som vises før «Vis flere»-knappen.",
    "reviews_density": "Tetthet",
    "reviews_density_normal": "Normal",
    "reviews_density_compact": "Kompakt",
    "reviews_clickable_histogram": "Klikkbart histogram",
    "reviews_clickable_histogram_description": "Kunden kan klikke på en stjernerad for å bare se anmeldelser med den vurderingen.",
    "reviews_slides_per_view": "Kort per visning på PC",
    "reviews_show_histogram": "Vis histogram",
    "reviews_show_histogram_description": "Viser fordelingen av stjerner ved siden av overskriften.",
    "reviews_autoplay": "Autoplay",
    "reviews_show_pagination": "Vis prikker",
    "reviews_show_pagination_description": "Navigasjonsprikkene under kortene.",
    "reviews_autoplay_description": "Karusellen blar videre av seg selv hvert femte sekund og stopper når musen er over.",
    "reviews_heading": "Overskrift",
    "reviews_sort_order": "Sortering",
    "reviews_sort_newest": "Nyeste først",
    "reviews_sort_highest": "Høyest vurdering først",
    "reviews_sort_lowest": "Lavest vurdering først",
    "reviews_show_verified_badge": "Vis «Verifisert kjøp»",
    "reviews_show_verified_badge_description": "Merker anmeldelser som er skrevet etter et kjøp i butikken.",
    "reviews_hide_empty": "Skjul anmeldelser uten tekst",
    "reviews_hide_empty_description": "Anmeldelser som bare har stjerner telles fortsatt i snittet, men vises ikke i listen.",
    "reviews_date_format": "Datoformat",
    "reviews_date_format_date": "Dato",
    "reviews_date_format_relative": "Relativ («2 uker siden»)",
    "reviews_star_color": "Stjernefarge",
    "reviews_summary_show_count": "Vis antall anmeldelser",
    "reviews_summary_show_count_description": "Avslått viser bare stjernene og snittvurderingen.",
    "no_settings": "Ingen innstillinger",
    "template": "Mal",
    "select_product": "Velg produkt",
    "select_category": "Velg kategori",
    "search_categories": "Søk etter kategorier",
    "product_templates": "Produktmaler",
    "product_template": "Produktmal",
    "product_template_hint": "Nytt: Lag flere produktmaler og velg mal per produkt",
    "show_me": "Vis meg",
    "preview_short": "Forhåndsvis",
    "theme_editor_zone_left_column": "Venstre kolonne",
    "theme_editor_zone_right_column": "Høyre kolonne",
    "theme_editor_zone_full_width": "Under hovedinnhold",
    "page_template_description": "Velg hvilken sidemal som skal brukes for dette produktet.",
    "font_size": "Skriftstørrelse",
    "alignment": "Justering",
    "show_savings": "Vis besparelse",
    "show_savings_description": "Vis hvor mye kunden sparer når produktet er på salg",
    "show_stock_status": "Vis lagerstatus",
    "show_stock_status_description": "Vis lagerstatus til høyre for prisen. Vises kun på produkter med lagerbehandling aktivert.",
    "show_product_badges": "Vis badger",
    "show_product_badges_description": "Vis produktets badger over tittelen.",
    "trust_badges": "Trygghetsstripe",
    "trust_badges_title_size": "Skriftstørrelse tittel",
    "trust_badges_subtitle_size": "Skriftstørrelse undertittel",
    "trust_badges_item_1_enabled": "Vis element 1",
    "trust_badges_item_1_icon": "Ikon 1",
    "trust_badges_item_1_title": "Tittel 1",
    "trust_badges_item_1_subtitle": "Undertittel 1",
    "trust_badges_item_2_enabled": "Vis element 2",
    "trust_badges_item_2_icon": "Ikon 2",
    "trust_badges_item_2_title": "Tittel 2",
    "trust_badges_item_2_subtitle": "Undertittel 2",
    "trust_badges_item_3_enabled": "Vis element 3",
    "trust_badges_item_3_icon": "Ikon 3",
    "trust_badges_item_3_title": "Tittel 3",
    "trust_badges_item_3_subtitle": "Undertittel 3",
    "trust_badges_icon_truck": "Lastebil",
    "trust_badges_icon_return": "Retur",
    "trust_badges_icon_shield": "Skjold",
    "trust_badges_icon_card": "Betalingskort",
    "trust_badges_icon_clock": "Klokke",
    "trust_badges_icon_badge": "Merke",
    "trust_badges_icon_chat": "Snakkeboble",
    "trust_badges_icon_gift": "Gave",
    "trust_badges_icon_lock": "Hengelås",
    "trust_badges_icon_heart": "Hjerte",
    "trust_badges_icon_sparkles": "Glitter",
    "orientation": "Retning",
    "horizontal": "Horisontal",
    "vertical": "Vertikal",
    "reviews_summary": "Anmeldelsessammendrag",
    "reviews_summary_show_count": "Vis antall anmeldelser",
    "reviews_summary_link_to_reviews": "Klikk ruller til anmeldelser",
    "reviews_summary_link_to_reviews_description": "Når brukeren klikker på antallet, rulles siden ned til anmeldelse-seksjonen.",
    "below": "Under",
    "accordion": "Trekkspill",
    "tabs": "Faner",
    "inline": "Innebygd",
    "pills": "Knapper",
    "pills_full_width": "Fullbredde knapper",
    "dropdown": "Nedtrekksmeny",
    "drawer": "Sidemeny",
    "product_layout_background_color_description": "Bestemmer bakgrunnsfargen for hele produktsiden.",
    "auto_text_contrast": "Auto-juster tekstfarger",
    "auto_text_contrast_description": "Tekstfarger justeres automatisk basert på bakgrunnsfargen for god lesbarhet. Slå av for å velge fargene selv.",
    "auto_contrast_controls_color": "Auto-juster tekstfarger er på og styrer denne fargen.",
    "heading_color": "Overskriftsfarge",
    "heading_color_description": "Brukes på produkttittel, pris og andre fremtredende tekstelementer.",
    "text_color_description": "Brukes på brødtekst, ingress og produktbeskrivelse.",
    "muted_text_color": "Sekundær tekstfarge",
    "muted_text_color_description": "Brukes på mindre fremtredende tekst som «ekskl. mva» og hjelpetekster.",
    "duplicate_template": "Dupliser mal",
    "copy_of": "Kopi av",
    "front_page": "Forside",
    "product_page": "Produktside",
    "category_page": "Kategoriside",
    "page_content": "sideinnhold",
    "block_description_page_content": "Teksten fra siden i Sider-admin. Flytt den blant de andre blokkene.",
    "content_pages": "Innholdssider",
    "content_page_label": "Side",
    "edit_page_text": "Rediger tekst",
    "search_pages": "Søk i sider",
    "no_pages_found": "Ingen sider matcher søket",
    "no_content_pages_yet": "Butikken har ingen innholdssider ennå.",
    "create_page_in_admin": "Opprett side under Innhold",
    "page_content_edit_hint": "Teksten redigeres i Sider-admin. Her styrer du bare plassering og utseende.",
    "page_design_button": "Design siden",
    "page_design_editor_hint": "Teksten vises som blokken «Sideinnhold» i designbyggeren. Der kan du legge bilder, FAQ, skjema og andre blokker rundt teksten og flytte den dit du vil, kun for denne siden.",
    "page_open_design_editor": "Åpne i designbyggeren",
    "pages_index_design_hint": "Her skriver du teksten på sidene. Hvordan hver side ser ut, designer du under Innholdssider i designbyggeren.",
    "pages_open_design_editor": "Åpne designbyggeren",
    "designed": "Designet",
    "help_category_content_page": "Innholdssider",
    "help_content_page_intro_name": "Slik fungerer innholdssider",
    "help_content_page_intro_tagline": "Sidene lages og skrives i Sider-admin. Her bestemmer du hvordan hver side ser ut, med blokker rundt teksten.",
    "help_content_page_intro_description": "Velg siden du vil jobbe med under Innholdssider i «Side og mal»-velgeren øverst. Teksten fra Sider-admin vises som blokken «Sideinnhold», som du kan flytte fritt. Legg til bilder, FAQ, skjema og andre blokker over eller under.",
    "help_content_page_intro_concepts_heading": "Viktige begreper",
    "help_content_page_intro_concept_text_block": "«Sideinnhold» er teksten fra Sider-admin. Den kan flyttes, men ikke slettes, og selve teksten redigeres fortsatt i Sider-admin.",
    "help_content_page_intro_concept_per_page": "Hver side har sitt eget oppsett. Blokker du legger på én side, påvirker ingen andre sider.",
    "help_content_page_intro_concept_fallback": "En side du aldri har åpnet her vises som før, med teksten alene.",
    "help_content_page_intro_concept_blocks": "Blokkvelgeren viser innholds- og mediablokker. Produktblokker hører til forsiden.",
    "help_content_page_intro_workflow_heading": "Vanlig arbeidsflyt",
    "help_content_page_intro_workflow_pick": "Åpne «Side og mal»-velgeren, velg Innholdssider og «Åpne innholdssidene». Søk i sider når butikken har mange. Sider du har designet, er merket «Designet».",
    "help_content_page_intro_workflow_arrange": "Dra «Sideinnhold» dit du vil ha den, og legg til blokker over og under.",
    "help_content_page_intro_workflow_edit_text": "Trenger du å endre teksten, bruk lenken «Rediger tekst» som åpner siden i Sider-admin.",
    "help_content_page_intro_workflow_save": "Trykk «Lagre og publiser». Bare siden du står på blir endret.",
    "category_page_settings_intro": "Én global visning som gjelder alle kategorisider og søkeresultater.",
    "category_page_title": "Tittel",
    "category_page_filters": "Filtrering",
    "category_page_grid": "Produktrutenett",
    "category_page_pagination": "Paginering",
    "category_pagination_style": "Paginering",
    "category_pagination_style_description": "«Sidetall» viser nummererte sider med en 25/50/100-velger for kunden. «Vis flere»-knapp lar kunden hente neste side med et klikk. «Uendelig scroll» laster flere produkter automatisk når kunden scroller.",
    "category_pagination_style_pages": "Sidetall (med 25/50/100-velger)",
    "category_pagination_style_load_more": "«Vis flere»-knapp",
    "category_pagination_style_infinite": "Uendelig scroll",
    "category_page_colors": "Farger",
    "category_align_left": "Venstre",
    "category_align_center": "Midtstilt",
    "category_show_title": "Vis kategoritittel",
    "category_show_title_description": "Overskriften øverst på kategorisiden. Beskrivelsen vises uansett, og styres av «Plassering av beskrivelse».",
    "category_title_hidden_hint": "Slå på «Vis kategoritittel» for å endre denne.",
    "category_title_align": "Tittel-justering",
    "category_title_spacing": "Luft over/under tittel",
    "category_title_spacing_normal": "Normal",
    "category_title_spacing_roomy": "Luftig",
    "category_title_spacing_spacious": "Ekstra luftig",
    "category_heading_size": "Tittelstørrelse",
    "category_heading_size_small": "Liten",
    "category_heading_size_medium": "Middels",
    "category_heading_size_large": "Stor",
    "category_filter_values_visible": "Filterverdier før «Vis mer»",
    "category_filter_values_visible_description": "Hvor mange verdier som vises i en filtergruppe før en «Vis mer»-knapp dukker opp.",
    "category_filter_values_visible_all": "Alle",
    "category_filter_group_limit": "Filtergrupper før «Vis flere»",
    "category_filter_group_limit_description": "Hvor mange filtergrupper som vises i sidekolonnen før en «Vis flere filtre»-knapp dukker opp. Grupper med aktive valg vises alltid.",
    "category_filter_groups_collapsed": "Start med lukkede filtergrupper",
    "category_filter_groups_collapsed_description": "Alle filtergruppene i filterpanelet er lukket når kunden åpner kategorien. Underkategori-listen påvirkes ikke.",
    "category_filter_toggle_all": "Vis «Åpne/lukk alle filtre»-knapp",
    "category_filter_toggle_all_description": "Knapp øverst i filterpanelet som åpner eller lukker alle filtergruppene samtidig.",
    "category_filter_search": "Søk i filtre",
    "category_filter_search_description": "Viser søkefelt i filterpanelet: ett øverst som søker på tvers av alle filtergruppene, og ett inne i grupper med mange verdier. Feltene dukker først opp når det er flere enn ti filtergrupper, eller flere enn ti verdier i en gruppe. Gjelder alle filterplasseringer unntatt den horisontale raden.",
    "category_show_sale_filter": "Vis «På tilbud»-filter",
    "category_show_sale_filter_description": "Gir kundene en avkrysningsboks i filteret som viser kun produkter med rabatt.",
    "category_control_style": "Kontrollstil",
    "category_control_style_description": "Utseendet på sortering, filterpiller og andre kontroller på kategorisiden.",
    "category_control_style_border": "Ramme",
    "category_control_style_underline": "Understrek",
    "category_control_style_ghost": "Ingen ramme",
    "category_show_stock_filter": "Vis «På lager»-filter",
    "category_show_stock_filter_description": "Gir kundene en avkrysningsboks i filteret som viser kun produkter på lager.",
    "category_filter_sticky": "Fest filter ved scroll",
    "category_filter_sticky_description": "Filter-sidekolonnen følger med når kunden scroller. Gjelder kun sidekolonne-visning på desktop.",
    "category_filter_sticky_sidebar_only": "Gjelder bare når filteret vises i sidekolonne. Velg «Sidekolonne» under Plassering av filter for å bruke denne.",
    "category_filter_setting_panel_only": "Gjelder bare når filteret vises i sidekolonne eller sidemeny. Velg «Sidekolonne» eller «Filtrering i sidemeny» under Plassering av filter for å bruke denne.",
    "category_filter_setting_layout_hidden": "Filteret er skjult, så dette valget har ingen virkning. Velg en annen plassering under Plassering av filter for å bruke det.",
    "category_section_spacing": "Avstand rundt produktene",
    "category_card_animation": "Animasjon ved innlasting",
    "category_card_animation_description": "Produktkort toner mykt inn når de scrolles inn i visning (der nettleseren støtter det).",
    "category_card_animation_none": "Ingen",
    "category_card_animation_fade": "Ton inn ved scroll",
    "category_page_toolbar": "Verktøylinje",
    "category_page_content": "Innhold",
    "category_template": "Kategorimal",
    "category_template_description": "Hvilken kategoriside-design denne kategorien bruker. Maler opprettes og redigeres i designbyggeren under Kategoriside.",
    "category_page_category_cards": "Underkategorier",
    "category_cards_when_products": "Når kategorien viser produkter",
    "category_cards_when_subcategories": "Når kategorien viser underkategorier",
    "category_cards_appearance": "Slik ser kortene ut",
    "category_cards_when_products_inactive": "Kategorien i forhåndsvisningen viser underkategorier, så navigasjonen her vises ikke på den. Andre kategorier i butikken bruker den.",
    "category_cards_when_subcategories_inactive": "Kategorien i forhåndsvisningen viser produkter, så rutenettet vises ikke på den. Andre kategorier i butikken bruker det.",
    "subcategory_nav_disabled_hint": "Gjelder bare når navigasjonen står på «Kategorikort øverst».",
    "subcategory_image_fit_title": "Hvordan vises bildet?",
    "subcategory_text_size": "Tekststørrelse",
    "subcategory_columns_mobile": "Kort i bredden – mobil",
    "subcategory_grid_gap": "Luft mellom kortene",
    "subcategory_card_style": "Kortstil",
    "subcategory_card_style_plain": "Ren",
    "subcategory_card_style_border": "Ramme",
    "subcategory_text_weight": "Teksttykkelse",
    "subcategory_text_align": "Tekstjustering",
    "subcategory_text_uppercase": "Store bokstaver",
    "text_position": "Tekstplassering",
    "text_position_below": "Under bildet",
    "text_position_overlay": "På bildet",
    "category_group_products_only_notice": "Kategorien i forhåndsvisningen viser kategorikort, ikke produkter. Innstillingene her gjelder kategorisider som viser produkter. Hva en kategori viser, styres av «Hva denne kategorien viser» i kategoriens innstillinger.",
    "category_preview_force_cards": "Forhåndsvis kategorikort likevel",
    "category_preview_force_products": "Forhåndsvis produktvisning likevel",
    "category_preview_forced_cards_notice": "Forhåndsvisningen er tvunget til å vise kategorikort.",
    "category_preview_forced_products_notice": "Forhåndsvisningen er tvunget til å vise produktvisningen.",
    "category_preview_force_reset": "Tilbakestill",
    "category_preview_drawer_notice": "Filtermenyen vises bare når kunden åpner den, og knapper er slått av i forhåndsvisningen. Åpne den herfra for å se innstillingene.",
    "category_preview_open_drawer": "Åpne filtermenyen i forhåndsvisningen",
    "category_preview_close_drawer": "Lukk filtermenyen",
    "category_preview_dropdown_notice": "Nedtrekksmenyen for underkategorier vises bare når kunden åpner den. Åpne den herfra for å se den i forhåndsvisningen.",
    "category_preview_open_dropdown": "Åpne nedtrekksmenyen i forhåndsvisningen",
    "category_preview_close_dropdown": "Lukk nedtrekksmenyen",
    "display_mode_design_editor_hint": "Utseendet på kategorikortene tilpasses i designbyggeren.",
    "display_mode_design_editor_link": "Åpne designbyggeren",
    "category_background_color_description": "Bakgrunnsfarge for hele kategorisiden (bak tittel, filtre og produkter).",
    "category_show_breadcrumbs": "Vis brødsmulesti",
    "category_show_breadcrumbs_description": "Stien øverst («Hjem / … / Kategori»). Skjuler den kun på kategori- og søkesider. Fargene styres av de globale brødsmule-innstillingene.",
    "category_filter_layout": "Plassering av filter",
    "category_filter_layout_description": "På mobil brukes alltid filterknapp med sidemeny, uavhengig av valget her.",
    "category_filter_layout_sidebar": "Sidekolonne",
    "category_filter_layout_horizontal": "Horisontal rad",
    "category_filter_layout_drawer": "Filtrering i sidemeny",
    "category_filter_layout_hidden": "Skjult",
    "category_columns_desktop": "Produkter i bredden – desktop",
    "category_columns_desktop_description": "«Automatisk» tilpasser antallet til skjermbredden, slik som i dag.",
    "category_columns_auto": "Automatisk",
    "category_columns_mobile": "Produkter i bredden – mobil",
    "category_grid_gap": "Avstand mellom produktkort",
    "category_grid_gap_compact": "Tett",
    "category_grid_gap_normal": "Normal",
    "category_grid_gap_airy": "Luftig",
    "category_default_sorting": "Standard sortering",
    "category_default_sorting_description": "Sorteringen produktene vises med når kunden åpner en kategori. Kategorier med manuell rekkefølge beholder den. Kunden kan alltid bytte i sorteringsvelgeren.",
    "category_default_sorting_manual_order_hint": "Denne kategorien har manuell rekkefølge, så standardsorteringen gjelder ikke her.",
    "category_default_sorting_newest": "Nyeste",
    "category_default_sorting_alphabetical": "Alfabetisk",
    "category_default_sorting_price_asc": "Pris lav til høy",
    "category_default_sorting_price_desc": "Pris høy til lav",
    "category_default_product_view": "Standard produktvisning",
    "category_default_product_view_description": "Hvilken visning kunden ser først. Kunden kan bytte selv hvis rutenett/liste-veksleren er på, og valget huskes i nettleseren.",
    "category_default_product_view_grid": "Rutenett",
    "category_default_product_view_list": "Liste",
    "category_show_view_toggle": "Vis rutenett/liste-veksler",
    "category_show_view_toggle_description": "Knappene som lar kunden bytte mellom rutenett- og listevisning.",
    "category_show_sorting": "Vis sortering",
    "category_show_product_count": "Vis produktantall",
    "category_description_position": "Kategoribeskrivelse",
    "category_description_position_description": "«Under produktene» passer for lengre SEO-tekst som ikke skal dytte produktene nedover.",
    "category_description_position_top": "Over produktene",
    "category_description_position_bottom": "Under produktene",
    "category_description_position_hidden": "Skjult",
    "category_subcategory_display": "Underkategori-navigasjon",
    "category_subcategory_display_description": "Gjelder alle kategorisider. «I sidekolonnen» følger filteret – vises sammen med filtrene i sidekolonnen eller sidemenyen. Med horisontalt eller skjult filter vises de i stedet som knapper øverst.",
    "category_subcategory_display_sidebar": "I sidekolonnen",
    "category_subcategory_display_chips": "Knapper øverst",
    "category_subcategory_display_dropdown": "Rullegardin øverst",
    "category_subcategory_display_image_cards": "Kategorikort øverst",
    "subcategory_nav_format": "Format",
    "subcategory_nav_format_description": "Formen på kortene i raden øverst på kategorisiden.",
    "subcategory_nav_format_square": "Kvadratisk",
    "subcategory_nav_format_landscape": "Liggende",
    "subcategory_nav_format_portrait": "Stående",
    "subcategory_nav_format_circle": "Rund",
    "subcategory_nav_size": "Størrelse",
    "subcategory_nav_size_description": "Hvor store kortene i raden er. Liten viser flere kort per rad.",
    "subcategory_nav_size_small": "Liten",
    "subcategory_nav_size_medium": "Medium",
    "subcategory_nav_size_large": "Stor",
    "subcategory_nav_text_size": "Tekststørrelse",
    "category_subcategory_display_hidden": "Skjult",
    "list": "Liste",
    "carousel": "Karusell",
    "compare_at_price_color": "Førpris-farge",
    "compare_at_price_color_description": "Farge på den overstrøkne førprisen ved salg.",
    "api_clients": "API-klienter",
    "api_clients_description": "Administrer maskin-til-maskin API-klienter med OAuth2 klientlegitimasjon.",
    "create_api_client": "Opprett API-klient",
    "edit_api_client": "Rediger API-klient",
    "client_secret_created": "API-klient opprettet. Kopier klienthemmeligheten nedenfor — den vises ikke igjen.",
    "client_secret_regenerated": "Klienthemmeligheten er regenerert. Kopier den nye hemmeligheten nedenfor — den vises ikke igjen.",
    "client_secret_label": "Klienthemmelighet",
    "client_expiration": "Klient-utløper",
    "currently_expires": "Utløper",
    "keep_current_expiration": "Behold nåværende",
    "never": "Aldri",
    "n_days": "{n} dager",
    "n_permissions": "{n} tillatelser",
    "danger_zone": "Faresone",
    "regenerate_secret": "Regenerer hemmelighet",
    "revoke_client": "Slett klient",
    "confirm_regenerate_secret": "Er du sikker? Den gjeldende hemmeligheten vil bli ugyldig umiddelbart.",
    "confirm_revoke_client": "Er du sikker på at du vil slette denne API-klienten? Alle tokens vil bli ugyldige.",
    "delete_api_client_confirmation": "Er du sikker på at du vil slette denne API-klienten?",
    "secret_shown_once": "Klienthemmeligheten vises kun én gang etter opprettelse.",
    "search_permissions": "Søk i tillatelser...",
    "api_clients_m2m_warning": "API-klienter bruker OAuth2 klientlegitimasjon for maskin-til-maskin tilgang. For personlige API-tokens, gå til",
    "your_profile": "din profil",
    "permissions_label": "Tillatelser",
    "n_of_total_permissions_selected": "{n} av {total} tillatelser valgt",
    "permission_groups.app-store": "Appbutikk",
    "permission_groups.blog": "Blogg",
    "permission_groups.form": "Skjema",
    "permission_groups.form.submission": "Henvendelser",
    "permission_groups.coupon": "Kuponger",
    "permission_groups.customer": "Kunder",
    "permission_groups.design": "Design",
    "permission_groups.design.menu": "Menyer",
    "permission_groups.marketing.newsletter.subscriber": "Nyhetsbrevabonnenter",
    "permission_groups.marketing.page": "Sider",
    "permission_groups.marketing.review": "Anmeldelser",
    "permission_groups.marketing.review.settings": "Anmeldelsesinnstillinger",
    "permission_groups.order": "Bestillinger",
    "permission_groups.product": "Produkter",
    "permission_groups.product.category": "Produktkategorier",
    "permission_groups.redirect": "Omdirigeringer",
    "permission_groups.report.sales": "Salgsrapporter",
    "permission_groups.settings": "Innstillinger",
    "permission_groups.settings.contact_info": "Kontaktinformasjon",
    "permission_groups.settings.shipping": "Frakt",
    "permission_groups.settings.logistics": "Logistikk",
    "permission_groups.settings.payment": "Betaling",
    "permission_groups.settings.store.status": "Butikkstatus",
    "permission_groups.settings.invoice": "Fakturaer",
    "permission_groups.users": "Brukere",
    "permission_groups.users.roles": "Roller",
    "permission_groups.webhook": "Webhooks",
    "permission_groups.api-client": "API-klienter",
    "permissions.users.view": "Se brukere",
    "permissions.users.store": "Opprett brukere",
    "permissions.users.update": "Oppdater brukere",
    "permissions.users.destroy": "Slett brukere",
    "permissions.users.roles.view": "Se roller",
    "permissions.users.roles.store": "Opprett roller",
    "permissions.users.roles.update": "Oppdater roller",
    "permissions.users.roles.destroy": "Slett roller",
    "permissions.order.view": "Se bestillinger",
    "permissions.order.edit": "Rediger bestillinger",
    "permissions.order.fulfill": "Oppfyll bestillinger",
    "permissions.order.refund": "Refunder bestillinger",
    "permissions.product.view": "Se produkter",
    "permissions.product.create": "Opprett produkter",
    "permissions.product.update": "Oppdater produkter",
    "permissions.product.delete": "Slett produkter",
    "permissions.product.category.view": "Se kategorier",
    "permissions.product.category.create": "Opprett kategorier",
    "permissions.product.category.update": "Oppdater kategorier",
    "permissions.product.category.delete": "Slett kategorier",
    "permissions.coupon.view": "Se kuponger",
    "permissions.coupon.create": "Opprett kuponger",
    "permissions.coupon.update": "Oppdater kuponger",
    "permissions.coupon.delete": "Slett kuponger",
    "permissions.customer.view": "Se kunder",
    "permissions.customer.create": "Opprett kunder",
    "permissions.customer.update": "Oppdater kunder",
    "permissions.customer.delete": "Slett kunder",
    "permissions.marketing.newsletter.subscriber.view": "Se abonnenter",
    "permissions.marketing.newsletter.subscriber.export": "Eksporter abonnenter",
    "permissions.marketing.page.view": "Se sider",
    "permissions.marketing.page.create": "Opprett sider",
    "permissions.marketing.page.update": "Oppdater sider",
    "permissions.marketing.page.delete": "Slett sider",
    "permissions.marketing.review.view": "Se anmeldelser",
    "permissions.marketing.review.publish": "Publiser anmeldelser",
    "permissions.marketing.review.settings.update": "Oppdater anmeldelsesinnstillinger",
    "permissions.blog.view": "Se blogginnlegg",
    "permissions.blog.create": "Opprett blogginnlegg",
    "permissions.blog.update": "Oppdater blogginnlegg",
    "permissions.blog.delete": "Slett blogginnlegg",
    "permissions.form.view": "Se skjema",
    "permissions.form.create": "Opprett skjema",
    "permissions.form.update": "Rediger skjema",
    "permissions.form.delete": "Slett skjema og henvendelsene deres",
    "permissions.form.submission.view": "Les henvendelser",
    "permissions.form.submission.manage": "Ta, ferdigbehandle og gjenåpne henvendelser",
    "permissions.form.submission.delete": "Slett henvendelser",
    "permissions.design.update": "Oppdater design",
    "permissions.design.menu.update": "Oppdater menyer",
    "permissions.report.sales.view": "Se salgsrapporter",
    "permissions.report.sales.export": "Eksporter salgsrapporter",
    "permissions.redirect.view": "Se omdirigeringer",
    "permissions.redirect.create": "Opprett omdirigeringer",
    "permissions.redirect.update": "Oppdater omdirigeringer",
    "permissions.redirect.delete": "Slett omdirigeringer",
    "permissions.webhook.view": "Se webhooks",
    "permissions.webhook.create": "Opprett webhooks",
    "permissions.webhook.update": "Oppdater webhooks",
    "permissions.webhook.delete": "Slett webhooks",
    "permissions.api-client.view": "Se API-klienter",
    "permissions.api-client.create": "Opprett API-klienter",
    "permissions.api-client.update": "Oppdater API-klienter",
    "permissions.api-client.delete": "Slett API-klienter",
    "permissions.app-store.view": "Se appbutikk",
    "permissions.app-store.install": "Installer apper",
    "permissions.app-store.update": "Oppdater apper",
    "permissions.settings.contact_info.edit": "Rediger kontaktinformasjon",
    "permissions.settings.shipping.edit": "Rediger frakt",
    "permissions.settings.logistics.edit": "Rediger logistikk",
    "permissions.settings.payment.edit": "Rediger betaling",
    "permissions.settings.store.status.change": "Endre butikkstatus",
    "permissions.settings.invoice.edit": "Rediger fakturaer",
    "permissions.settings.analytics": "Se analyse",
    "gift_certificate_liability": "Gavekortforpliktelse",
    "outstanding_gift_certificate_liability": "Utestående gavekortforpliktelse",
    "outstanding_certificates_list": "Utestående gavekort",
    "no_outstanding_certificates": "Ingen utestående gavekort på valgt dato.",
    "gift_card_liability_outstanding": "Utestående",
    "gift_card_liability_breakage": "Brekkasje",
    "across_active_certificates": "fordelt på {count} aktive gavekort",
    "issued": "Utstedt",
    "redeemed": "Innløst",
    "breakage_expired_unredeemed": "Bortfall (utløpt, ikke innløst)",
    "n_certificates": "{count} gavekort",
    "total_certificates": "Antall gavekort",
    "as_of": "Per",
    "no_gift_certificates_issued": "Ingen gavekort er utstedt ennå.",
    "gift_certificate_line_not_refundable": "Gavekortet kan ikke refunderes etter at det er tatt i bruk.",
    "gift_certificate_cannot_void_redeemed": "Gavekortet kan ikke annulleres etter at det er tatt i bruk.",
    "gift_certificate_not_supported_in_express": "Gavekort kan ikke brukes med Vipps Express. Fullfør kjøpet i vanlig kasse for å bruke gavekortet.",
    "gift_card": "Gavekort",
    "gift_card_app_description": "Selg gavekort kundene kan løse inn i kassen.",
    "gift_card_issued_success": "Gavekort :code er opprettet.",
    "gift_card_create": "Opprett gavekort",
    "gift_card_field_amount": "Beløp (kr)",
    "gift_card_field_recipient_email": "Mottakers e-post (valgfritt)",
    "gift_card_field_message": "Hilsen (valgfritt)",
    "gift_card_field_note": "Internt notat (valgfritt)",
    "gift_card_field_expires_at": "Utløpsdato (valgfritt)",
    "gift_card_field_send": "Send til mottaker",
    "gift_card_enabled": "Aktiver gavekort",
    "gift_card_enabled_description": "Når aktivert kan kundene kjøpe gavekort i nettbutikken.",
    "gift_card_add_to_menu": "Legg til i meny",
    "gift_card_add_to_menu_description": "Legg gavekortsiden til i en meny i nettbutikken.",
    "gift_card_add_to_menu_hint": "Aktiver gavekort først",
    "gift_card_min_amount": "Minimumsbeløp (kr)",
    "gift_card_min_amount_description": "Det minste gavekortbeløpet en kunde kan kjøpe.",
    "gift_card_max_amount": "Maksimumsbeløp (kr)",
    "gift_card_max_amount_description": "Det største gavekortbeløpet en kunde kan kjøpe.",
    "gift_card_max_amount_gte_min": "Maksimumsbeløpet må være større enn eller lik minimumsbeløpet.",
    "gift_card_validity_months": "Gyldighet (måneder)",
    "gift_card_validity_months_description": "Hvor mange måneder et utstedt gavekort er gyldig.",
    "gift_card_purchase_description": "Tekst på kjøpsside",
    "gift_card_purchase_description_description": "Vises til kunder på gavekortets kjøpsside.",
    "gift_card_email_body": "Tekst i leverings-e-post",
    "gift_card_email_body_description": "Introtekst i e-posten som leverer gavekortet.",
    "gift_card_image": "Gavekortbilde",
    "gift_card_image_description": "Bilde som vises på kjøpssiden og i leverings-e-posten.",
    "gift_card_heading": "Gavekort",
    "gift_card_sub_heading": "La kunder kjøpe gavekort til butikken din.",
    "advantages_with_gift_card": "Fordeler med gavekort",
    "advantages_with_gift_card_1": "Kunder kjøper nå og løser inn senere.",
    "advantages_with_gift_card_2": "Øk salget og få inn nye kunder.",
    "advantages_with_gift_card_3": "Saldoen kan brukes på flere kjøp.",
    "gift_card_issued": "Utstedte gavekort",
    "gift_card_search_placeholder": "Søk på kode eller e-post…",
    "gift_card_status_all": "Alle statuser",
    "gift_card_status_active": "Aktiv",
    "gift_card_status_depleted": "Brukt opp",
    "gift_card_status_voided": "Annullert",
    "gift_card_status_expired": "Utløpt",
    "gift_card_export_csv": "Eksporter CSV",
    "gift_card_export_hint": "CSV-eksporten inkluderer alle gavekort med gjeldende status, uavhengig av filtrene over.",
    "gift_card_face_value": "Pålydende",
    "gift_card_balance": "Saldo",
    "gift_card_expires": "Utløper",
    "gift_card_issued_at": "Utstedt",
    "gift_card_empty_title": "Ingen gavekort funnet",
    "gift_card_empty_hint": "Prøv et annet søk, eller vent til det er utstedt gavekort.",
    "gift_card_resend_email": "Send e-post på nytt",
    "gift_card_movement_history": "Historikk",
    "gift_card_movement_issued": "Utstedt",
    "gift_card_movement_redeemed": "Innløst",
    "gift_card_movement_restored": "Tilbakeført",
    "gift_card_movement_voided": "Annullert",
    "gift_card_movement_reactivated": "Reaktivert",
    "gift_card_movement_balance_after": "Saldo etter",
    "gift_card_movement_empty": "Ingen bevegelser",
    "gift_card_movement_date": "Dato",
    "gift_card_movement_type": "Hendelse",
    "gift_card_movement_amount": "Beløp",
    "gift_card_movement_order": "Ordre",
    "gift_card_movement_reason": "Årsak",
    "gift_card_movement_loading": "Laster…",
    "gift_card_movement_error": "Kunne ikke laste historikk",
    "gift_card_bulk_title": "Bulk-opprett gavekort",
    "gift_card_bulk_intro": "Last opp en CSV for å opprette flere gavekort på én gang. Last ned malen for å se kolonnene.",
    "gift_card_bulk_download_template": "Last ned mal",
    "gift_card_bulk_choose_file": "Velg CSV-fil",
    "gift_card_bulk_no_file": "Ingen fil valgt",
    "gift_card_bulk_preview": "Forhåndsvis",
    "gift_card_bulk_confirm": "Opprett gavekort",
    "gift_card_bulk_back": "Tilbake til gavekort",
    "gift_card_bulk_open": "Last opp CSV",
    "gift_card_bulk_col_line": "Rad",
    "gift_card_bulk_col_amount": "Beløp",
    "gift_card_bulk_col_recipient": "Mottaker",
    "gift_card_bulk_col_send": "Sendes",
    "gift_card_bulk_col_errors": "Feil",
    "gift_card_bulk_col_code": "Kode",
    "gift_card_bulk_all_valid": "Alle rader er gyldige. Klar til å opprette.",
    "gift_card_bulk_has_errors": "Noen rader har feil. Rett opp CSV-filen og last opp på nytt.",
    "gift_card_bulk_results_title": "Opprettede gavekort",
    "gift_card_bulk_download_results": "Last ned resultat",
    "gift_card_bulk_yes": "Ja",
    "gift_card_bulk_no": "Nei",
    "gift_card_bulk_search_code": "Søk etter kode",
    "gift_card_as_of_now": "Nå",
    "gift_card_viewing_as_of": "Viser status per {date}",
    "choose_image": "Velg bilde",
    "change_image": "Endre bilde",
    "order_already_locked_to_batch": "Ordren er allerede låst til en aktiv batch.",
    "picking_line_not_in_batch": "Varelinjen hører ikke til denne batchen.",
    "picking_nothing_to_fulfill": "Ingen enheter er registrert plukket for denne ordren.",
    "picking_order_not_in_batch": "Ordren er ikke en del av denne batchen.",
    "bulk_picking_batch_completed": "Batch fullført — {count} ordrer pakket og sendt.",
    "bulk_picking_batch_done_title": "Batch #{number} fullført",
    "bulk_picking_batch_done_subtitle": "Alle ordrer i økten er behandlet.",
    "bulk_picking_fully_fulfilled": "Fullt oppfylt",
    "bulk_picking_partially_fulfilled": "Delvis oppfylt",
    "bulk_picking_orders_count": "{count} ordrer",
    "bulk_picking_back_to_orders": "Tilbake til ordrer",
    "bulk_picking_batch_started": "Bulk-plukking startet — :count ordrer låst til batchen.",
    "bulk_picking_batch_started_skipped": "Bulk-plukking startet for :count ordrer. :skipped ordre ble hoppet over fordi de allerede er fullført eller kansellert.",
    "bulk_picking_no_eligible_orders": "Ingen av de valgte ordrene kunne plukkes — de er allerede fullført eller kansellert.",
    "bulk_picking_batch_released": "Batch frigjort — ordrene er låst opp.",
    "bulk_picking_order_released": "Ordren er frigjort fra batchen.",
    "bulk_picking_release_this_order": "Behandle senere",
    "bulk_picking_release_batch": "Frigjør batch",
    "bulk_picking_release_batch_title": "Frigjøre batchen?",
    "bulk_picking_release_batch_body": "Dette låser opp alle {orders} ordrene og forkaster all registrert plukk- og pakkeframgang i batchen. Kan ikke angres.",
    "bulk_picking_release_batch_confirm": "Frigjør og forkast",
    "bulk_picking_release_orders": "Frigjør fra plukking",
    "bulk_picking_release_orders_description": "Frigjør de valgte ordrene fra plukke-batchene sine.",
    "bulk_picking_release_orders_title": "Frigjøre de valgte ordrene?",
    "bulk_picking_release_orders_body": "Dette låser opp {orders} ordrer og forkaster registrert plukk- og pakkeframgang for dem. Kan ikke angres.",
    "bulk_picking_release_orders_confirm": "Frigjør og forkast",
    "bulk_picking_orders_released": ":count ordrer ble frigjort fra plukking.",
    "bulk_picking_orders_released_skipped": ":count ordrer ble frigjort fra plukking. :skipped ordre ble hoppet over fordi de ikke er låst til en batch.",
    "bulk_picking_no_locked_orders": "Ingen av de valgte ordrene er låst til en plukke-batch.",
    "bulk_picking_units_left": "{count} igjen",
    "bulk_picking_order_completed": "Ordre fullført og sendt.",
    "bulk_picking_pickup_point_unavailable": "Fant ingen hentested for denne ordren. Frigjør ordren og håndter den enkeltvis.",
    "bulk_picking_shipping_needs_attention": "Fraktmetoden er ikke koblet til en transportør. Fiks koblingen på Frakt-kobling, eller sett metoden til manuell.",
    "start_bulk_picking": "Start bulk-plukking",
    "start_bulk_picking_description": "Lås de valgte ordrene til en plukke-batch.",
    "lock_status": "Plukkeøkt",
    "locked": "Låst",
    "bulk_picking_locked_by": "Plukkes av {admin}",
    "release": "Frigivelse",
    "my_locks": "Mine",
    "available": "Ledige",
    "moments_ago": "nettopp",
    "bulk_picking_session_title": "Pakkesesjon",
    "pack_all": "Alle",
    "units_packed_of": "{picked} av {total} enheter pakket",
    "complete_order": "Fullfør ordre",
    "partial_pick_warning": "{picked} av {total} enheter plukket — resten forblir uoppfylt.",
    "bulk_picking_orders_packed_of": "{packed} av {total} ordrer pakket",
    "bulk_picking_mode_manual": "Manuell",
    "bulk_picking_mode_scan": "Skann",
    "bulk_picking_scan_later": "Skanning kommer senere",
    "bulk_picking_register_hint": "Registrer antall etter hvert som varene pakkes i esken.",
    "bulk_picking_units_of": "{picked} av {total} enheter",
    "bulk_picking_lines_hint": "Bruk − / +, skriv inn antall direkte, eller «Alle» for å fylle hele linjen. Delvise linjer markeres gult.",
    "bulk_picking_not_picked": "Ikke plukket",
    "bulk_picking_partly_picked": "Kun {picked} av {remaining} plukket",
    "bulk_picking_partial_badge": "Delvis",
    "bulk_picking_complete_badge": "Komplett",
    "bulk_picking_shipping": "Frakt",
    "bulk_picking_calculated": "(beregnet)",
    "bulk_picking_manual_shipping": "Manuell frakt — ingen etikett bookes",
    "bulk_picking_label_autoprint": "Hvis en Smartprint-skriver er satt opp, skrives etiketten ut automatisk når ordren fullføres.",
    "bulk_picking_incomplete_title": "Ufullstendig pakking",
    "bulk_picking_incomplete_body": "Bare {picked} av {total} enheter er registrert. Hvis du fullfører nå, oppfylles ordren delvis — de resterende enhetene forblir uoppfylt og kan plukkes senere.",
    "bulk_picking_back_to_packing": "Tilbake til pakking",
    "bulk_picking_complete_as_partial": "Fullfør som delvis",
    "bulk_picking_picklist_title": "Plukkeliste — alle ordrer samlet",
    "bulk_picking_picklist_hint": "Hent varene fra hyllene (sortert etter lokasjon) og registrer antall.",
    "bulk_picking_print_picklist": "Skriv ut plukkeliste",
    "bulk_picking_no_location_group": "Uten lokasjon — manuell henting",
    "bulk_picking_no_location": "uten lokasjon",
    "bulk_picking_picklist_sort_hint": "Sortert naturlig etter lokasjon (A-2 før A-10); varer uten lokasjon vises sist. Antall er summen på tvers av alle ordrene i batchen.",
    "bulk_picking_to_packing": "Til pakking",
    "bulk_picking_picking": "plukking",
    "bulk_picking_scan_start": "Start skanning",
    "bulk_picking_scan_pre_prompt": "Slå på kameraet for å skanne strekkoder. Manuell registrering fungerer fortsatt.",
    "bulk_picking_scan_starting": "Starter kamera …",
    "bulk_picking_scan_denied": "Fikk ikke tilgang til kameraet — bruk manuell registrering.",
    "bulk_picking_scan_now": "Skann nå",
    "bulk_picking_scan_not_on_order": "Produktet er ikke en del av denne ordren.",
    "bulk_picking_scan_already_done": "Alle {total} av {product} er allerede pakket.",
    "bulk_picking_scan_unknown": "Produktet er ikke en del av denne batchen.",
    "bulk_picking_scan_missing_codes": "{count} varer mangler strekkode og må registreres manuelt.",
    "bulk_picking_scan_qty_title": "Riktig vare ✓",
    "bulk_picking_scan_all_n": "Alle {count}",
    "bulk_picking_scan_qty_hint": "Hvor mange plukket du?",
    "bulk_picking_scan_qty_hint_pack": "Hvor mange la du i esken?",
    "bulk_picking_no_barcode": "uten strekkode",
    "bulk_picking_remaining": "gjenstår",
    "bulk_picking_pick_complete_title": "Alt plukket",
    "bulk_picking_pick_complete_hint": "Ta varene til pakkebordet.",
    "bulk_picking_review_list": "Se plukkelista",
    "bulk_picking_pack_complete_title": "Alt pakket",
    "bulk_picking_pack_complete_hint": "Ordre #{order} er klar til forsendelse.",
    "bulk_picking_edit_details": "Rediger detaljer",
    "bulk_picking_initiated_at": "startet {time}",
    "bulk_picking_shipping_unmapped_title": "Fraktmetoden er ikke koblet",
    "bulk_picking_shipping_unmapped_body": "Denne ordren har ingen transportørtjeneste koblet til fraktmetoden. Du kan koble den, eller fullføre manuelt uten etikett.",
    "bulk_picking_shipping_unmapped_cta": "Koble fraktmetoder",
    "bulk_picking_shipping_unmapped_count": "{count} ordrer mangler fraktkobling",
    "bulk_picking_pickup_missing_title": "Ingen hentested valgt",
    "bulk_picking_pickup_missing_body": "Nærmeste hentested velges automatisk når du fullfører ordren. Finnes ingen, må ordren håndteres enkeltvis.",
    "pickup_point_label": "Hentested",
    "pickup_point_loading": "Henter hentesteder…",
    "pickup_point_none_available": "Fant ingen hentested for denne adressen. Ordren kan ikke bookes med denne tjenesten.",
    "customer_group_applications": "Søknader",
    "customer_group_applications_none_available": "Det er for øyeblikket ingen kundegrupper du kan søke om medlemskap i.",
    "customer_group_application_status": "Status",
    "customer_group_application_status_pending": "Venter på godkjenning",
    "customer_group_application_status_approved": "Godkjent",
    "customer_group_application_status_rejected": "Avvist",
    "customer_group_application_status_all": "Alle",
    "customer_group_application_your_note": "Din kommentar",
    "customer_group_application_note_label": "Kommentar (valgfri)",
    "customer_group_application_cta": "Ja, jeg ønsker å bli medlem",
    "customer_group_application_submitted": "Forespørselen er sendt.",
    "customer_group_application_unknown_group": "Ukjent kundegruppe.",
    "customer_group_application_not_accepting": "Denne kundegruppen tar ikke imot søknader.",
    "customer_group_application_wrong_customer_type": "Du er ikke kvalifisert til å søke om medlemskap i denne kundegruppen.",
    "customer_group_application_already_applied": "Du har allerede sendt en forespørsel for denne kundegruppen.",
    "customer_group_application_already_decided": "Forespørselen er allerede behandlet.",
    "customer_group_application_approved": "Forespørselen er godkjent.",
    "customer_group_application_rejected": "Forespørselen er avvist.",
    "customer_group_application_confirm_approve": "Godkjenne forespørselen?",
    "customer_group_application_confirm_reject": "Avvise forespørselen?",
    "accepts_applications": "Tar imot søknader om medlemskap",
    "accepts_applications_help": "Lar kunder søke om å bli medlem av denne gruppen fra kundesiden.",
    "application_description": "Tekst som vises til kunden",
    "application_description_help": "Vises på kundesiden under «Søk om medlemskap». Du kan bruke HTML.",
    "application_allowed_customer_types": "Hvem kan søke",
    "application_allowed_customer_types_help": "Bestem hvilke kundetyper som kan søke om medlemskap i denne gruppen.",
    "application_show_discount": "Vis rabatt-info før påmelding",
    "application_show_discount_help": "Lar kunden se hvor mange prosent rabatt de får om søknaden godkjennes. Hvis av, vises rabatt først etter at de er medlem.",
    "all_customer_groups": "Alle kundegrupper",
    "applicants": "Søknader",
    "no_customer_group_applications": "Ingen søknader funnet.",
    "customer_group_applications_subtitle": "Behandle medlemskapssøknader fra kunder.",
    "customer_group_applications_heading": "Søknader om medlemskap",
    "customer_group_applications_approved": ":count søknader godkjent.",
    "customer_group_applications_rejected": ":count søknader avslått.",
    "customer_group_applications_approve_bulk_confirm": "Godkjenn {count} søknader?",
    "customer_group_applications_reject_bulk_confirm": "Avslå {count} søknader?",
    "pending_applications": "Venter på behandling",
    "search_applications_placeholder": "Søk etter navn, e-post eller selskap …",
    "view_full_note": "Vis hele notatet",
    "bulk_approve_selected": "Godkjenn valgte",
    "bulk_reject_selected": "Avslå valgte",
    "submitted_on": "sendt {date}",
    "apply_for_membership": "Søk om medlemskap",
    "your_application_was_received": "Søknaden din er mottatt",
    "you_are_a_member": "Du er medlem av denne kundegruppen",
    "your_application_was_rejected": "Søknaden din ble avslått",
    "customer_group_application_approve_title": "Godkjenn søknad",
    "customer_group_application_reject_title": "Avvis søknad",
    "customer_group_application_approve_confirm": "Vil du godkjenne søknaden fra {customer}?",
    "customer_group_application_reject_confirm": "Vil du avvise søknaden fra {customer}?",
    "notify_customer_via_email": "Send e-post til kunden om endringen",
    "edit_customer": "Rediger kunde",
    "all_groups": "Alle grupper",
    "approve": "Godkjenn",
    "reject": "Avvis",
    "previous": "Forrige",
    "submitted": "Sendt",
    "decided": "Behandlet",
    "customer_type": "Kundetype",
    "quick_install": "hurtiginstallasjon",
    "quick_install_intro": "Velg leverandør og lim inn ID-en din, så setter vi opp sporing, script og cookie-informasjon for deg.",
    "quick_install_pick_provider": "velg leverandør",
    "quick_install_paste_code": "lim inn kode",
    "quick_install_paste_help": "Lim inn sporingskoden du har fått tilsendt eller kopiert fra leverandøren, så finner vi ID-ene automatisk.",
    "quick_install_detect": "finn sporingskoder",
    "quick_install_no_matches": "Vi gjenkjente ingen sporingskode. Sjekk at du har limt inn hele script-taggen.",
    "quick_install_found": "fant",
    "quick_install_install_selected": "installer valgte",
    "quick_install_already_installed": "allerede installert",
    "quick_install_include_events": "inkluder e-handelshendelser (kjøp, produktvisninger)",
    "quick_install_note_label": "notat (valgfritt)",
    "quick_install_note_placeholder": "f.eks. Byrå X sin annonsekonto",
    "quick_install_confirm_title": "bekreft installasjon",
    "quick_install_confirm_text": "Dette oppretter sporingspartner, script og cookie-deklarasjoner for",
    "quick_install_success": "Sporingen ble installert.",
    "quick_install_invalid_value": "Verdien har feil format. Dobbeltsjekk at du limte inn riktig ID.",
    "quick_install_duplicate_text": "Denne leverandøren er allerede installert. Vil du oppdatere den med de nye verdiene?",
    "quick_install_update_existing": "oppdater eksisterende",
    "quick_install_ga4_extra_account": "legg til ekstra GA4-konto",
    "quick_install_ga4_primary_hint": "Butikkens primære GA4 settes opp via Analytics-innstillingene. Her legger du kun til ekstra kontoer.",
    "quick_install_ga4_becomes_primary_hint": "Blir butikkens primære GA4-konto. Du styrer den videre på Analytics-siden, også salgssporingen.",
    "quick_install_ga4_primary_installed": "GA4 er lagt inn som butikkens primære konto. Her styrer du den videre, også salgssporingen.",
    "quick_install_gtag_targets_title": "Google-kontoer i samme script",
    "quick_install_gtag_targets_help": "Disse ID-ene ligger i samme Google-script. Fjern en linje for å slutte å spore til den kontoen.",
    "quick_install_double_tracking_warning": "Hvis GA4 lastes inne i GTM trenger du kun GTM, ellers får du dobbel sporing.",
    "quick_install_conversion_id_help": "Finnes i Google Ads under Mål, Konverteringer, Tagoppsett.",
    "quick_install_remove_target": "fjern",
    "quick_install_install": "installer",
    "quick_install_primary_ga4_conflict": "Denne ID-en er allerede butikkens primære GA4 og settes opp via Analytics-innstillingene.",
    "quick_install_managed_partner_locked": "Denne partneren styres av hurtiginstallasjonen. Endre den der.",
    "quick_install_conflict_title": "sporing finnes allerede",
    "quick_install_conflict_unmanaged_text": "Vi fant denne leverandøren i en partner som ikke er satt opp via hurtiginstallasjon. Installerer du likevel, får butikken to tagger som teller det samme.",
    "quick_install_install_anyway": "installer likevel",
    "quick_install_detect_failed": "Vi fikk ikke sjekket koden. Prøv igjen.",
    "quick_install_install_failed": "Installasjonen feilet",
    "quick_install_managed_badge": "styres av hurtiginstallasjon",
    "failed": "Feilet",
    "line": "Linje",
    "auto_matched": "Auto-matchet",
    "adjustment": "Justering",
    "reference": "Referanse",
    "tripletex_app_name": "Tripletex Regnskap",
    "tripletex_app_description": "Send behandlede ordrer til Tripletex som fakturaer, og refusjoner som kreditnotaer.",
    "tripletex_landing_headline": "Tripletex regnskapsintegrasjon",
    "tripletex_landing_description": "Koble butikken til Tripletex for å sende behandlede ordrer over som fakturaer automatisk, og hold kreditnotaer synkronisert når du refunderer.",
    "tripletex_landing_features_title": "Dette får du",
    "tripletex_landing_feature_1": "Hver forsendelse blir en ubetalt faktura i Tripletex — delforsendelser gir én faktura per forsendelse.",
    "tripletex_landing_feature_2": "Refusjoner sendes over som kreditnotaer mot den opprinnelige fakturaen.",
    "tripletex_landing_feature_3": "Overfør automatisk når en ordre er behandlet, eller manuelt per forsendelse fra ordresiden.",
    "tripletex_landing_how_it_works_title": "Slik fungerer det",
    "tripletex_landing_how_it_works_description": "Legg inn Tripletex API-tokenene under Innstillinger og aktiver appen. Når den er aktivert, overføres behandlede ordrer som fakturaer og refusjoner som kreditnotaer.",
    "tripletex_landing_requirements_title": "Krav",
    "tripletex_landing_requirements_description": "En Tripletex-konto med API-tilgang (en forbruker-token og en bruker-token), og et registrert bankkontonummer på selskapet slik at fakturaer kan opprettes.",
    "tripletex_consumer_token": "Forbrukertoken",
    "tripletex_consumer_token_description": "Ditt Tripletex API-forbrukertoken.",
    "tripletex_employee_token": "Ansatttoken",
    "tripletex_employee_token_description": "Ditt Tripletex API-ansatttoken.",
    "tripletex_auto_transfer": "Overfør ordrer automatisk",
    "tripletex_auto_transfer_description": "Opprett en ubetalt faktura i Tripletex automatisk når en ordre er fullstendig behandlet.",
    "tripletex_send_invoice_to_customer": "Send fakturaer til kunden",
    "tripletex_send_invoice_to_customer_description": "La Tripletex sende fakturaen til kunden når den opprettes. La denne være av hvis kundene betaler med kort eller via en betalingsløsning i kassen.",
    "tripletex_invoice_date_override": "Overstyr fakturadato",
    "tripletex_invoice_date_override_description": "Tving denne datoen på alle fakturaer (ÅÅÅÅ-MM-DD). La stå tom for å bruke i dag.",
    "tripletex_invalid_credentials": "Kunne ikke autentisere mot Tripletex. Sjekk tokenene.",
    "tripletex_transfer_success": "Forsendelse overført til Tripletex.",
    "tripletex_transfer_failed": "Kunne ikke overføre forsendelsen til Tripletex.",
    "tripletex_transfer_confirm": "Overfør denne forsendelsen til Tripletex?",
    "tripletex_credit_note_success": "Kreditnota opprettet i Tripletex.",
    "tripletex_credit_note_failed": "Kunne ikke opprette kreditnota i Tripletex.",
    "tripletex_credit_note_confirm": "Opprett kreditnota for denne refusjonen i Tripletex?",
    "tripletex_credit_note_reference": "Kreditnota for faktura :invoice",
    "transfer_to_tripletex": "Overfør til Tripletex",
    "transfer_to_tripletex_description": "Legg de valgte ordrenes fakturaer og kreditnotaer i kø for overføring til Tripletex.",
    "accounting_transfer_failed_:system": "Overføring til :system feilet",
    "tripletex_fulfillment_not_transferred": "Forsendelsens faktura er ikke overført til Tripletex ennå — overfør fakturaen før kreditnotaen.",
    "tripletex_error_invoice_number_exists": "Fakturanummer :number er allerede i bruk i Tripletex — butikkens og Tripletex' nummerserier overlapper.",
    "tripletex_error_due_before_invoice_date": "Forfallsdatoen er før fakturadatoen.",
    "tripletex_error_company_missing_bank_account": "Tripletex-selskapet mangler bankkontonummer — registrer det i Tripletex før overføring.",
    "tripletex_error_company_missing_org_number": "Tripletex-selskapet mangler organisasjonsnummer — registrer det i Tripletex før overføring.",
    "tripletex_error_consumer_token": "Consumer-token for Tripletex er ugyldig eller utløpt — oppdater den i appinnstillingene.",
    "tripletex_error_employee_token": "Employee-token for Tripletex er ugyldig eller utløpt — oppdater den i appinnstillingene.",
    "tripletex_error_customer_missing": "Kunden finnes ikke i Tripletex.",
    "tripletex_error_invalid_vat_code": "Tripletex avviste mva-koden på en av fakturalinjene.",
    "tripletex_error_invalid_org_number": "Tripletex avviste kundens organisasjonsnummer (må ha 9 siffer uten skilletegn).",
    "tripletex_error_invalid_email": "Tripletex avviste kundens e-postadresse.",
    "tripletex_error_invalid_invoice_number": "Tripletex avviste fakturanummeret (må være 0 eller høyere).",
    "tripletex_error_invalid_date_field": "Tripletex avviste datoen i feltet :field.",
    "tripletex_error_customer_name_required": "Kunden mangler navn — Tripletex krever kundenavn.",
    "tripletex_error_unauthorized": "Tripletex avviste API-nøklene — sjekk tokenene i appinnstillingene.",
    "tripletex_error_forbidden": "API-brukeren i Tripletex mangler rettigheter til denne operasjonen.",
    "tripletex_error_not_found": "Posten det refereres til finnes ikke i Tripletex.",
    "tripletex_error_conflict": "Tripletex melder at posten allerede eksisterer.",
    "tripletex_error_rate_limited": "Tripletex begrenser antall forespørsler — prøv igjen om noen minutter.",
    "tripletex_error_server": "Tripletex hadde en intern feil — prøv igjen senere.",
    "tripletex_error_no_vat_code_for_rate": "Tripletex mangler utgående mva-kode for :rate % — produktets mva-sats er ikke en gyldig norsk sats.",
    "tripletex_error_connection": "Fikk ikke kontakt med Tripletex — sjekk tilkoblingen og prøv igjen.",
    "tripletex_error_session": "Kunne ikke logge inn i Tripletex med de lagrede API-nøklene.",
    "tripletex_error_unmapped": "Tripletex meldte: :message",
    "tripletex_error_generic": "Overføringen ble avvist av Tripletex uten nærmere begrunnelse.",
    "tripletex_bulk_transfer_queued": "Tripletex-overføring lagt i kø for :count ordrer.",
    "transferred_to_tripletex": "Overført til Tripletex",
    "create_tripletex_credit_note": "Opprett kreditnota i Tripletex",
    "tripletex_credit_note_created": "Kreditnota i Tripletex",
    "trial_tour_step_counter": "Steg {current}/{total}",
    "trial_tour_checkout_title": "Dette er en testbestilling",
    "trial_tour_checkout_body": "Vi har fylt inn navn, e-post og adresse for deg. Fyll inn telefonnummeret ditt selv, og gå videre gjennom frakt og betaling.",
    "trial_tour_checkout_switched": "Vi har satt kassen til Spennd for testbestillingen.",
    "trial_tour_checkout_no_payment": "Ingen betaling blir gjennomført – dette er kun en test.",
    "document_logo": "Dokumentlogo",
    "document_logo_dimensions_invalid": "Logoen må være mellom 100×30 og 4000×4000 piksler, og maks 8 ganger så bred som den er høy (eller 2 ganger så høy som den er bred).",
    "upload_a_document_logo_for_your_store": "Last opp en egen logo for e-poster og dokumenter (fakturaer, pakksedler osv.). Logoen må være i PNG- eller JPG-format, maks 2 MB, mellom 100×30 og 4000×4000 piksler, og ha en vanlig logofasong — maks 8 ganger så bred som den er høy. PNG med gjennomsiktig bakgrunn anbefales. Hvis ingen dokumentlogo er lastet opp, brukes butikknavnet i stedet.",
    "document_logo_updated": "Dokumentlogo oppdatert",
    "document_logo_deleted": "Dokumentlogo slettet",
    "crop_source_image_too_small": "Bildet er for lite til å beskjæres — det må være minst {width}×{height} piksler. Last opp et større bilde i stedet.",
    "Logistra": "Logistra",
    "aktiver": "aktiver",
    "logistra_sender_id": "Sender ID",
    "logistra_sender_id_description": "Deres sender id hentet ut fra cargonizer.no. Normalt bestående av 4-5 siffer.",
    "logistra_api_key": "API-nøkkel",
    "logistra_api_key_description": "Deres API-nøkkel hentet ut fra cargonizer.no.",
    "logistra_auto_transfer_to_transporter": "Automatisk overfør EDI til transportør",
    "logistra_auto_transfer_to_transporter_description": "Velg \"Overfør til Cargonizer og videre til transportør\" dersom du ønsker at informasjon om dine forsendelser automatisk skal sendes videre til transportøren. Dersom du velger å overføre videre til transportør er det altså ikke nødvendig å logge inn i Cargonizer for å overføre sendingene manuelt til transportør.",
    "logistra_auto_print": "Benytt autoprint hos logistra",
    "logistra_auto_print_description": "Skriver kun ut fraktetiketten, på en printer som er registrert i Cargonizer-kontoen din. Ordrebekreftelser, angrerettskjema og leveringsbekreftelser skrives ut av SmartPrint, og kun for 24Shipping-forsendelser — de skrives ikke ut for forsendelser booket via Logistra.",
    "logistra_automatically_choose_sole_printer": "Automatisk velg printer hvis det er bare én tilgjengelig",
    "logistra_automatically_choose_sole_printer_description": "Skjer under masse- og enkeltbehandling av ordre",
    "logistra_selected_printer": "Tilgjengelige printere",
    "logistra_selected_printer_description": "Printerne hentes fra Cargonizer-kontoen din og oppdateres automatisk. Disse er separate fra printerne som er satt opp under SmartPrint.",
    "transfer_to_cargonizer": "Overfør kun til Cargonizer",
    "transfer_to_cargonizer_and_transporter": "Overfør til Cargonizer og videre til transportør",
    "logistra_wrong_api_key": "API-nøkkelen er feil. Vennligst sjekk og prøv igjen.",
    "logistra_unknown_error": "En ukjent feil oppstod. Vennligst prøv igjen eller kontakt kundeservice.",
    "logistra_service_attributes_unsupported": "Denne frakttjenesten har tilleggsvalg som ennå ikke kan sendes til Logistra. Fjern verdiene på tilleggsvalgene, eller bestill sendingen i Cargonizer.",
    "logistra_service_identifier_invalid": "En valgt frakttjeneste ble ikke gjenkjent. Last siden på nytt og velg tjenesten igjen.",
    "logistra_transport_agreement_missing": "Fant ingen transportavtale hos Logistra for det valgte fraktproduktet. Kontroller at produktet fortsatt er tilgjengelig på Cargonizer-kontoen din.",
    "carrier_label_unavailable": "Fraktetiketten kunne ikke hentes fra transportøren. Vennligst prøv igjen om litt.",
    "carrier_label_url_rejected": "Denne etikettlenken ble avvist av sikkerhetsgrunner. Kontakt kundeservice hvis etiketten mangler.",
    "logistra_no_printers_found": "Fant ingen printere. Kontroller API-nøkkelen og lagre på nytt.",
    "logistra_api_key_rejected": "Logistra avviste API-nøkkelen. Kontroller nøkkelen i Cargonizer-kontoen din og prøv igjen.",
    "logistra_printer_service_unreachable": "Kunne ikke kontakte Logistra for å verifisere API-nøkkelen. Prøv igjen om litt.",
    "logistra_autoprint_label": "Skriv ut etiketten automatisk",
    "logistra_autoprint_no_printer": "Skriv ut etiketten automatisk (ingen printer er satt opp)",
    "fulfillment_autoprint_must_be_boolean": "Autoprint må være sann eller falsk",
    "fulfillment_dimensions_length_min_zero": "Lengde kan ikke være negativ",
    "fulfillment_dimensions_width_min_zero": "Bredde kan ikke være negativ",
    "fulfillment_dimensions_height_min_zero": "Høyde kan ikke være negativ",
    "fulfillment_dimensions_weight_min_zero": "Vekt kan ikke være negativ",
    "fulfillment_services_must_be_array": "Tjenester må være en liste",
    "fulfillment_services_not_supported_for_provider": "Tjenester kan ikke brukes ved manuell oppfyllelse",
    "fulfillment_service_must_be_array": "Hver tjeneste må være et objekt",
    "fulfillment_service_identifier_required": "Tjeneste-ID er påkrevd",
    "fulfillment_service_identifier_must_be_string": "Tjeneste-ID må være tekst",
    "fulfillment_service_identifier_duplicate": "Samme tjeneste er sendt inn flere ganger",
    "fulfillment_service_attributes_must_be_array": "Tjenesteegenskaper må være en liste",
    "fulfillment_service_attribute_must_be_array": "Hver tjenesteegenskap må være et objekt",
    "fulfillment_service_attribute_identifier_required": "ID for tjenesteegenskap er påkrevd",
    "fulfillment_service_attribute_identifier_must_be_string": "ID for tjenesteegenskap må være tekst",
    "fulfillment_service_attribute_value_missing": "Verdi for tjenesteegenskap mangler",
    "fulfillment_service_attribute_value_must_be_string": "Verdi for tjenesteegenskap må være tekst",
    "mapped_shipping_methods": "Kartlegg fraktmåter mot {name}",
    "mapped_shipping_methods_description": "Velg hvilke fraktmetoder i {name} som skal benyttes for hver av nettbutikkens fraktmåter ved behandling av ordre.",
    "logistra_description_label": "Innstillinger for Logistra",
    "logistra_description_text": "Fyll ut sender id og api-nøkkel for å aktivere Logistra i din nettbutikk. Du finner informasjonen i din Cargonizer-konto.",
    "logistra_link_label": "Kartlegging",
    "logistra_link_text": "Etter å ha konfigurert Logistra på her, gå til denne siden for å kartlegge nettbutikkens fraktmåter mot Logistras fraktmetoder.",
    "logistra_description": "Book fraktetiketter gjennom Logistra Cargonizer med dine egne transportøravtaler.",
    "logistra_app_headline": "Send med dine egne transportøravtaler gjennom Logistra",
    "logistra_app_sub_heading": "Logistra Cargonizer kobler nettbutikken til transportørene du allerede har avtale med, slik at du kan booke forsendelser og skrive ut etiketter direkte fra ordrebehandlingen.",
    "logistra_app_advantages": "Fordeler med Logistra:",
    "logistra_app_advantage_1": "Bruk <strong>dine egne transportøravtaler</strong> — Bring, PostNord, DHL Express, helthjem og flere.",
    "logistra_app_advantage_2": "Book forsendelser og skriv ut etiketter <strong>direkte fra ordrebehandlingen</strong>, én ordre om gangen eller i bulk.",
    "logistra_app_advantage_3": "Legg til tjenester som <strong>forsikring, varsling og postoppkrav</strong> per forsendelse.",
    "logistra_app_closer": "Fyll inn sender-ID og API-nøkkel fra Cargonizer for å komme i gang.",
    "logistra_unknown_return_product": "Det valgte returproduktet finnes ikke i Cargonizer-avtalene dine.",
    "logistics_sandbox_mode_active": "Sandboksmodus — forsendelsene er ikke reelle",
    "services": "Tjenester",
    "handover_schedule": "Utleveringsplan",
    "handover_schedule_updated": "Utleveringsplanen er oppdatert",
    "handover_schedule_help": "Velg hvilke dager og når du leverer pakkene til transportøren. Dette justerer forventet leveringsdato som vises i kassen.",
    "handover_closed_dates": "Stengte dager",
    "handover_prep_days": "Klargjøringstid (dager)",
    "handover_own_schedule": "Egen utleveringsplan",
    "handover_no_handover": "Ingen utlevering",
    "handover_add_closed_date": "Legg til dato",
    "handover_add_closed_range": "Legg til periode",
    "handover_closed_range_to": "til",
    "handover_closed_range_end_before_start": "Sluttdatoen må være samme dag som eller etter startdatoen.",
    "handover_note_placeholder": "Merknad",
    "handover_nothing_selected": "Ingen dager valgt – forventet leveringsdato beregnes som før.",
    "invalid_handover_weekday": "Ugyldig ukedag i utleveringsplanen",
    "monday": "mandag",
    "tuesday": "tirsdag",
    "wednesday": "onsdag",
    "thursday": "torsdag",
    "friday": "fredag",
    "saturday": "lørdag",
    "sunday": "søndag",
    "free_shipping_over_amount": "Gratis frakt over {amount}",
    "shipping_price_over_amount": "{price} over {amount}",
    "discard_changes_question": "Forkaste endringene?",
    "discard_changes_description": "Du har ulagrede endringer. Lukker du nå, går de tapt.",
    "keep_editing": "Fortsett å redigere",
    "reorder_shipping_method": "Endre rekkefølge for {name}. Bruk pil opp og pil ned.",
    "edit_shipping_method": "Rediger {name}",
    "toggle_shipping_method": "Aktiver {name}",
    "pricing_discount_from_list_price": "Priser (rabatt fra listepris)",
    "high_volume_contact_us": "Har du høyt volum? Ta kontakt for tilpassede priser.",
    "see_full_price_matrix": "Se hele prismatrisen",
    "handover_closed_date_expired": "Utløpt – datoen er passert",
    "weekday_short_1": "man",
    "weekday_short_2": "tir",
    "weekday_short_3": "ons",
    "weekday_short_4": "tor",
    "weekday_short_5": "fre",
    "weekday_short_6": "lør",
    "weekday_short_7": "søn",
    "handover_cutoff": "innleveringsfrist",
    "handover_summary_days": "Ingen dager | {n} dag | {n} dager",
    "handover_summary_at": "kl. {time}",
    "handover_not_configured": "Ikke satt opp",
    "handover_no_closed_dates": "Ingen stengte dager lagt inn.",
    "shipping_vat_state_on": "MVA beregnes på frakt",
    "shipping_vat_state_off": "Frakt uten MVA",
    "mailchimp_app_name": "Mailchimp",
    "mailchimp_app_description": "Synkroniser nyhetsbrevabonnenter til Mailchimp i sanntid.",
    "mailchimp_description_label": "Slik kobler du til",
    "mailchimp_description_text": "Lag en API-nøkkel i Mailchimp under Account & billing → Extras → API keys, lim den inn her og velg publikummet abonnentene skal legges i.",
    "mailchimp_api_key": "API-nøkkel",
    "mailchimp_api_key_description": "Nøkkelen slutter på datasenteret ditt, for eksempel -us21. Bruk Test tilkoblingen for å sjekke nøkkelen og hente publikummene dine.",
    "mailchimp_audience_id": "Publikum",
    "mailchimp_audience_id_description": "Publikummet i Mailchimp som nye abonnenter legges i. Test tilkoblingen for å hente listen fra kontoen din.",
    "mailchimp_api_key_invalid": "Mailchimp godtok ikke API-nøkkelen. Sjekk at den er kopiert riktig og ikke er slettet.",
    "mailchimp_api_key_unreachable": "Fikk ikke kontakt med Mailchimp. Prøv igjen om litt.",
    "mailchimp_api_key_missing": "Skriv inn en API-nøkkel først.",
    "mailchimp_api_key_verified": "Koblet til Mailchimp. Publikum funnet: {count}.",
    "mailchimp_verify_key_button": "Test tilkoblingen",
    "mailchimp_audience_not_found": "Publikummet finnes ikke i Mailchimp-kontoen. Test tilkoblingen for å hente listen igjen.",
    "mailchimp_landing_headline": "Mailchimp-integrasjon for nettbutikken din",
    "mailchimp_landing_description": "Koble nettbutikken til et Mailchimp-publikum. Nye nyhetsbrevabonnenter dukker opp i Mailchimp på sekunder, avmeldinger speiles, og du kan sende over eksisterende abonnenter med ett klikk.",
    "mailchimp_landing_features_title": "Dette får du",
    "mailchimp_landing_feature_1": "Sanntidssynkronisering av påmeldinger fra skjemaer og kassen.",
    "mailchimp_landing_feature_2": "Avmeldinger i nettbutikken speiles til Mailchimp.",
    "mailchimp_landing_feature_3": "Send over eksisterende abonnenter med ett klikk.",
    "mailchimp_landing_feature_4": "Abonnenter tagges med kilde, slik at du kan segmentere i Mailchimp.",
    "mailchimp_landing_how_it_works_title": "Slik fungerer det",
    "mailchimp_landing_how_it_works_description": "Lag en API-nøkkel i Mailchimp, lim den inn i innstillingene, velg publikum og slå på appen. Deretter synkroniseres hver ny abonnent automatisk.",
    "mailchimp_landing_requirements_title": "Krav",
    "mailchimp_landing_requirements_description": "Du trenger en Mailchimp-konto. Mailchimp prises etter antall kontakter, og gratisplanen dekker inntil 250 kontakter. Ingen kontakter sendes til Mailchimp før appen er slått på.",
    "mailchimp_sync_title": "Synkronisering",
    "mailchimp_sync_synced": "Synkronisert",
    "mailchimp_sync_pending": "I kø",
    "mailchimp_sync_failed": "Feilet",
    "mailchimp_sync_skipped": "Avvist av Mailchimp",
    "mailchimp_sync_not_synced": "Ikke synkronisert",
    "mailchimp_backfill_button": "Synkroniser eksisterende abonnenter",
    "mailchimp_backfill_helper": "{count} abonnenter vil bli lagt i kø.",
    "mailchimp_backfill_started": "Synkroniseringen er startet. Statusen oppdateres etter hvert som abonnentene sendes over.",
    "mailchimp_backfill_not_enabled": "Appen må være konfigurert og slått på før du kan synkronisere.",
    "mailchimp_backfill_already_running": "En synkronisering pågår allerede. Vent til den er ferdig.",
    "mailchimp_skipped_explanation": "Adresser Mailchimp avviser har meldt seg av eller er slettet i Mailchimp. De må melde seg på igjen via et Mailchimp-skjema.",
    "mailchimp_sync_column_email": "E-post",
    "mailchimp_sync_column_status": "Status",
    "mailchimp_sync_column_reason": "Årsak",
    "mailchimp_sync_column_time": "Tidspunkt",
    "ai_wallet": "AI-saldo",
    "ai_wallet_balance": "Saldo",
    "ai_wallet_balance_hint": "Brukes til AI-forslag til HS-koder. Du betaler kun for det du bruker.",
    "ai_wallet_topup_title": "Fyll på saldo",
    "ai_wallet_topup_hint": "Minste påfylling er {min}.",
    "ai_wallet_custom_amount": "Annet beløp",
    "ai_wallet_topup_button": "Fyll på {amount}",
    "ai_wallet_charged_card": "Belastes {card} umiddelbart.",
    "ai_wallet_change_card": "Endre kort",
    "ai_wallet_confirm_title": "Fylle på {amount}?",
    "ai_wallet_confirm_body": "Beløpet legges til AI-saldoen din med én gang og kan ikke refunderes til kortet.",
    "ai_wallet_confirm_button": "Bekreft og betal",
    "ai_wallet_topup_success": "{amount} er lagt til. Ny saldo: {balance}.",
    "ai_wallet_auto_title": "Automatisk påfylling",
    "ai_wallet_auto_hint": "Når saldoen faller under grensen, fyller vi på automatisk så AI-funksjonene ikke stopper midt i en oppgave.",
    "ai_wallet_auto_threshold": "Når saldoen er under",
    "ai_wallet_auto_amount": "Fyll på med",
    "ai_wallet_auto_cap": "Maks per måned (valgfritt)",
    "ai_wallet_auto_saved": "Innstillingene er lagret.",
    "ai_wallet_auto_failed": "Automatisk påfylling mislyktes {time} ({code}). Lagre innstillingene for å prøve igjen.",
    "ai_wallet_trial_title": "AI-saldo krever et betalt abonnement",
    "ai_wallet_trial_body": "I prøveperioden kan du ikke fylle på saldo. Oppgrader abonnementet for å ta i bruk AI-funksjonene.",
    "ai_wallet_trial_button": "Se abonnementer",
    "ai_wallet_no_card_body": "Påfyllinger belastes kortet som er registrert på butikken. Du har ikke registrert noe kort enda.",
    "ai_wallet_unavailable": "Saldoen din er trygg. Prøv igjen om litt, eller kontakt support hvis problemet vedvarer.",
    "ai_wallet_conflict": "Butikken er allerede registrert hos AI-tjenesten, men nøkkelen mangler her. Kontakt support.",
    "ai_wallet_error_code": "Feilkode: {code}",
    "ai_wallet_error_payment_failed": "Betalingen ble avvist ({code}). Sjekk kortet under Betalingskort.",
    "ai_wallet_error_validation": "AI-tjenesten avviste verdiene. Kontroller beløpene og prøv igjen.",
    "ai_wallet_error_generic": "Dette kunne ikke gjennomføres akkurat nå. Prøv igjen om litt.",
    "ai_wallet_attr_amount": "beløpet",
    "ai_wallet_attr_threshold": "grensen",
    "ai_wallet_attr_recharge_amount": "påfyllingsbeløpet",
    "ai_wallet_attr_monthly_cap": "månedsgrensen",
    "ai_wallet_validation_min": "Minste beløp er :min.",
    "ai_wallet_validation_max": "Største beløp er :max.",
    "ai_wallet_validation_recharge_gte_threshold": "Påfyllingsbeløpet må være minst like stort som grensen.",
    "ai_wallet_validation_cap_gte_recharge": "Månedsgrensen må være minst like stor som påfyllingsbeløpet.",
    "ai_wallet_unavailable_title": "AI-tjenesten svarer ikke",
    "ai_wallet_conflict_title": "Saldoen kan ikke hentes",
    "ai_wallet_custom_range": "Velg et beløp mellom {min} og {max}.",
    "ai_wallet_check_card": "Sjekk kortet",
    "ai_wallet_auto_off_hint": "Av. Når saldoen er brukt opp, stopper AI-funksjonene til du fyller på manuelt.",
    "ai_wallet_auto_summary": "Fyller på {amount} hver gang saldoen er under {threshold}.",
    "ai_wallet_auto_summary_cap": "Maks {cap} per måned.",
    "ai_wallet_ledger_title": "Bevegelser",
    "ai_wallet_ledger_more": "Vis flere",
    "ai_wallet_ledger_empty": "Ingen bevegelser enda. Den første påfyllingen din vises her.",
    "ai_wallet_ledger_unavailable": "Kunne ikke hente bevegelser.",
    "ai_wallet_ledger_topup": "Påfylling",
    "ai_wallet_ledger_auto_recharge": "Automatisk påfylling",
    "ai_wallet_ledger_hold": "Reservert: {task}",
    "ai_wallet_ledger_hold_items": "Reservert: {task}, {items} produkter",
    "ai_wallet_ledger_settlement": "Oppgjør: {task}",
    "ai_task_hs_code_suggestion": "HS-kode-forslag",
    "ai_task_product_optimization": "Produkttekst",
    "ai_task_store_profile": "Butikkprofil",
    "ai_task_product_review": "Produktgjennomgang",
    "ai_task_product_image": "Produktbilde",
    "ai_wallet_inline_intro": "AI-funksjoner betales fra butikkens AI-saldo. Kom i gang i to steg:",
    "ai_wallet_inline_step_card": "Legg til betalingskort",
    "ai_wallet_inline_card_added": "Kort lagt til",
    "ai_wallet_inline_step_topup": "Fyll på AI-saldo",
    "ai_wallet_inline_topped_up": "Saldo fylt på: {amount}",
    "ai_wallet_inline_auto_hint": "Vil du slippe dette neste gang?",
    "ai_wallet_inline_auto_link": "Slå på automatisk påfylling",
    "ai_wallet_inline_ask_admin": "Be en administrator fylle på AI-saldoen.",
    "ai_wallet_more_options": "Flere valg",
    "add_card_error_generic": "Kortet kunne ikke legges til akkurat nå. Prøv igjen om litt.",
    "please_provide_a_valid_email": "Butikken mangler en kontakt-e-postadresse. Legg den inn under Firmaopplysninger før du legger til et kort.",
    "add_card_gate_title": "Legg til et betalingskort",
    "add_card_button": "Legg til betalingskort",
    "add_card_description": "Legg til et kort for butikkens betalinger.",
    "add_card_stripe_notice": "Kortopplysningene håndteres av Stripe.",
    "add_card_cardholder": "Navn på kortet",
    "add_card_submit": "Legg til kort",
    "app_store_requires_payment_card": "Betalingskort kreves",
    "experiments": "A/B-testing",
    "experiments_new": "Ny test",
    "experiments_empty": "Du har ingen A/B-tester ennå. Lag en test for å sammenligne to maler mot hverandre.",
    "experiments_index_description": "Sammenlign to maler av forsiden eller produktsidene, og se hvilken som selger best.",
    "experiments_needs_two_templates_heading": "Du trenger én mal til",
    "experiments_template_guide_label": "Slik lager du en ny mal",
    "experiments_open_design_editor": "Åpne designbyggeren",
    "experiments_template_step_open": "Åpne designbyggeren og velg sidetypen du vil teste.",
    "experiments_template_step_duplicate": "Åpne «Side og mal»-velgeren øverst, hold musen over malen og velg «Dupliser mal».",
    "experiments_template_step_edit": "Gi kopien et navn, og endre designet slik du vil teste det.",
    "experiments_template_step_save": "Lagre. Kopien vises ikke i butikken før du starter en test med den, eller tar den i bruk selv.",
    "experiments_template_step_return": "Kom tilbake hit — den nye malen kan nå velges som utfordrer.",
    "experiments_needs_two_templates": "Du trenger én mal til for å kjøre en test. Lag en kopi av dagens mal i designbyggeren først.",
    "experiments_manage_from_list": "Testene dine styres fra A/B-testing-oversikten.",
    "experiments_settings_description": "Slå A/B-testing av eller på for butikken.",
    "experiments_enabled_description": "Når dette er av, blir ingen besøkende fordelt på varianter, og ingenting måles.",
    "experiments_status_on_title": "A/B-testing er på",
    "experiments_status_on_body": "Besøkende fordeles på malene i testene som pågår, og salget måles.",
    "experiments_status_off_title": "A/B-testing er av",
    "experiments_status_off_body": "Ingen besøkende fordeles på malene, og ingenting måles. En test som står som pågående, samler ikke tall før du slår på igjen.",
    "experiments_turn_on": "Slå på",
    "experiments_turn_off": "Slå av",
    "experiments_turn_off_confirm_title": "Slå av A/B-testing?",
    "experiments_when_on_heading": "Når A/B-testing er på",
    "experiments_cookie_title": "En nødvendig informasjonskapsel",
    "experiments_cookie_body": "Den husker hvilken mal den besøkende har fått. Den legges til i cookie-oversikten automatisk, og fjernes igjen når du slår av.",
    "experiments_cookie_link": "Se Konverteringssporing",
    "experiments_disabled_title": "A/B-testing er slått av",
    "experiments_disabled_body": "Ingen besøkende fordeles på malene, og ingenting måles, selv om en test står som pågående.",
    "experiments_disabled_link": "Gå til innstillingene",
    "experiment_control": "Kontroll",
    "experiment_challenger": "Utfordrer",
    "experiment_primary_metric": "Hovedmål",
    "experiment_primary_metric_help": "Bare hovedmålet kan kåre en vinner. De øvrige tallene vises som støtteinformasjon.",
    "conversion_rate": "Konverteringsrate",
    "revenue_per_visitor": "Omsetning per besøkende",
    "experiment_status_draft": "utkast",
    "experiment_status_running": "pågår",
    "experiment_status_stopped": "avsluttet",
    "experiment_start": "Start testen",
    "experiment_stop": "Avslutt testen",
    "experiment_started": "Testen er startet",
    "experiment_stopped": "Testen er avsluttet",
    "experiment_created": "Testen er opprettet",
    "experiment_promoted": "Malen er satt som standard",
    "experiment_decision_margin": "{winner} mot {loser}",
    "experiment_decision_lift": "— {lift} bedre",
    "experiment_choose_heading": "Velg mal videre",
    "experiment_choice_recommended": "Anbefalt",
    "experiment_choice_in_use": "Brukes nå",
    "experiment_choice_keep": "behold som i dag",
    "experiment_choice_apply": "Bruk valgt mal",
    "experiment_choice_no_recommendation": "Tallene peker ikke tydelig mot én av dem. Velger du ingen, fortsetter butikken som før.",
    "experiment_choice_confirm_title": "Bruke denne malen?",
    "experiment_choice_confirm_product": "Alle produkter uten egen mal får «{template}». Endringen gjelder med en gang.",
    "experiment_choice_confirm_category": "Alle kategorier uten egen mal får «{template}». Endringen gjelder med en gang.",
    "experiment_choice_confirm_home": "«{template}» blir forsiden besøkende ser. Endringen gjelder med en gang.",
    "experiment_verdict": "Resultat",
    "experiment_verdict_not_enough_data": "For lite data ennå",
    "experiment_verdict_sample_ratio_mismatch": "Skjev fordeling av besøkende",
    "experiment_verdict_sample_ratio_mismatch_help": "Malene har fått merkbart ulikt antall besøkende sammenlignet med fordelingen du valgte. Da kan ikke tallene sammenlignes — de besøkende som mangler, er ikke et tilfeldig utvalg. Åpne malen i butikken og sjekk at den fungerer. Ser alt riktig ut, kan det ha vært en tilfeldighet; start testen på nytt.",
    "experiment_verdict_challenger_harming": "Utfordrer B selger dårligere",
    "experiment_verdict_challenger_harming_help": "Utfordreren har solgt tydelig dårligere enn kontrollen så langt. Testen er ikke ferdig, så dette er ikke et endelig resultat — men forskjellen er stor nok til at det kan være noe galt med malen. Sjekk den i butikken, særlig på mobil. Lar du testen gå videre, koster ventetiden salg; avslutter du den, beholder du malen du allerede hadde.",
    "experiment_verdict_not_started": "Ikke startet",
    "experiment_verdict_not_started_help": "Start testen for å begynne å samle tall.",
    "experiment_verdict_ended_without_enough_data": "Avsluttet uten nok tall",
    "experiment_verdict_ended_short_help": "Testen ble avsluttet før nok besøkende hadde sett begge malene, så den kan ikke kåre en vinner.",
    "experiment_requirements_heading": "Testen kan ikke kåre en vinner før kravene under er oppfylt.",
    "experiment_requirement_days": "{have} av {need} dager",
    "experiment_requirement_visitors": "{have} av {need} besøkende i den minste varianten",
    "experiment_requirement_orders": "{have} av {need} ordre i den minste varianten",
    "experiment_requirement_carts": "{have} av {need} som la i handlekurven i den minste varianten",
    "experiment_verdict_no_clear_winner": "Ingen tydelig vinner",
    "experiment_verdict_control_wins": "Kontroll A vinner",
    "experiment_verdict_challenger_wins": "Utfordrer B vinner",
    "experiment_judged_on_conversion_rate": "Vurdert på konverteringsrate.",
    "experiment_judged_on_revenue_per_visitor": "Vurdert på omsetning per besøkende.",
    "experiment_exposures": "Besøkende",
    "experiment_orders": "Ordre",
    "experiment_winner": "Vinner",
    "experiment_device_breakdown": "Etter enhet",
    "experiment_device": "Enhet",
    "experiment_device_help": "Ingen vinner kåres per enhet. Tallene er her for å avsløre feil: gjør én av malene det mye dårligere på én skjermtype, ser den som regel ikke riktig ut der. Åpne siden på den enheten og sjekk.",
    "experiment_device_mobile": "Mobil",
    "experiment_device_tablet": "Nettbrett",
    "experiment_device_desktop": "Datamaskin",
    "experiment_device_unknown": "Ukjent",
    "experiment_device_too_little": "For få besøkende på {devices} til at tallene kan brukes.",
    "experiment_mde": "Minste forbedring testen skal kunne oppdage",
    "experiment_mde_help": "Dette er ikke hvor mye du tror malen forbedrer noe — det er den minste forbedringen testen har trafikk nok til å se. Er den virkelige forskjellen mindre, ender testen med «ingen tydelig vinner», og det er et ærlig svar. Å halvere tallet firedobler tiden testen må gå.",
    "experiment_mde_10": "10 % — fanger mindre forbedringer, men krever fire ganger så mye trafikk",
    "experiment_mde_20": "20 % — minste som er praktisk mulig for de fleste butikker",
    "experiment_mde_30": "30 % — raskere svar, fanger bare tydelige forbedringer",
    "experiment_mde_50": "50 % — bare store omlegginger, som en helt ny sidedesign",
    "experiment_verdict_days_remaining": "Omtrent {count} dager igjen med dagens trafikk, hvis alt annet er på plass.",
    "theme_published_experiment_stopped": "Temaet er publisert. A/B-testen «:experiment» ble avsluttet, fordi malene den testet hører til et annet tema.",
    "theme_editor_publish_stops_experiment": "Publiserer du dette temaet, avsluttes A/B-testen «{experiment}». Malene den tester hører til temaet som er aktivt nå, så testen kan ikke fortsette.",
    "theme_editor_experiment_running": "Denne malen er med i A/B-testen «{experiment}».",
    "theme_editor_experiment_control": "Den vises for {percent} % av de besøkende — resten ser utfordrermalen.",
    "theme_editor_experiment_challenger": "Den vises for {percent} % av de besøkende — resten ser malen butikken brukte før testen.",
    "theme_editor_experiment_warning": "Endrer du malen nå, endrer du det testen måler mens den måler det, og resultatet blir ubrukelig.",
    "experiment_progress_column": "Framdrift",
    "experiment_progress": "{percent} % av datagrunnlaget testen trenger",
    "experiment_guardrail_conflict": "Malen som vant, fikk flere til å legge i handlekurven, men solgte mindre enn den andre. Sjekk ordretallene under før du velger.",
    "experiment_numbers_provisional": "Foreløpige tall. Testen er ikke ferdig, og forskjellen du ser nå kan snu. Avslutter du testen fordi den ene malen ligger an til å vinne, tar du feil omtrent én gang av fire — det er derfor ingen vinner kåres før testen har nok data.",
    "experiment_stop_early_title": "Avslutte testen før den er ferdig?",
    "experiment_stop_early_warning": "Testen har ikke nok data ennå. Avslutter du nå, får du ingen vinner, og tallene under kan ikke brukes til å velge mal. Testen blir merket som avsluttet for tidlig.",
    "experiment_stop_early_confirm": "Avslutt likevel",
    "experiment_stopped_before_horizon": "Denne testen ble avsluttet før den hadde nok data. Tallene forteller hva som skjedde, men de kan ikke avgjøre hvilken mal som er best.",
    "add_to_cart": "La i handlekurv",
    "experiment_judged_on_add_to_cart": "Vurdert på hvor mange som la i handlekurven.",
    "experiment_results_heading": "Tallene",
    "experiment_diagnostics": "Støttetall",
    "experiment_add_to_cart": "La i handlekurv",
    "experiment_checkout_started": "Startet kassen",
    "experiment_revenue_gross": "Omsetning (varer, inkl. mva.)",
    "experiment_promote_heading": "Velg hvilken mal som skal gjelde videre",
    "experiment_promote_recommended": "Tallene peker mot «{label}».",
    "experiment_promote_no_recommendation": "Tallene peker ikke tydelig mot noen av malene. Du kan fortsatt velge selv.",
    "experiment_promote_template": "Bruk «{template}»",
    "experiment_promote_variant": "Bruk variant {label}",
    "experiment_already_promoted": "En mal fra denne testen er allerede satt som standard.",
    "experiment_needs_two_variants": "Testen mangler en kontroll og en utfordrer.",
    "experiment_surface_already_running": "Det kjører allerede en test på produktsider. Avslutt den før du starter en ny.",
    "experiment_stop_before_promoting": "Avslutt testen før du velger en vinnende mal.",
    "experiment_variant_mismatch": "Varianten hører ikke til denne testen.",
    "experiments_app_description": "Sammenlign to versjoner av forsiden eller produktsiden, og se hvilken som selger best.",
    "experiments_disable_confirm": "Da stopper all måling, og alle besøkende ser standardmalen igjen.",
    "experiments_landing_header_text": "Test butikken din mot seg selv",
    "experiments_subheading": "Vis to ulike maler til hver sin halvdel av de besøkende, og la tallene avgjøre hvilken du beholder.",
    "experiments_licence_title": "Inkludert i Premium og Premium Pluss",
    "experiments_licence_body": "A/B-testing følger med disse lisensene og koster ingenting ekstra. Appen kan ikke kjøpes separat.",
    "experiments_features_heading": "Dette får du",
    "experiments_feature_templates_title": "Bygg variantene i designbyggeren",
    "experiments_feature_templates_body": "En variant er en helt vanlig mal, så du lager og redigerer den slik du alltid har gjort.",
    "experiments_feature_split_title": "Jevn fordeling som står seg",
    "experiments_feature_split_body": "Hver besøkende havner i samme variant hver gang, også om de kommer tilbake senere.",
    "experiments_feature_funnel_title": "Hele veien til ordre",
    "experiments_feature_funnel_body": "Vi følger besøket videre til handlekurv, kasse og fullført ordre.",
    "experiments_feature_honest_title": "Ærlige tall",
    "experiments_feature_honest_body": "Du får ingen vinner før datagrunnlaget er stort nok til å stole på.",
    "experiments_get_started_heading": "Slik kommer du i gang",
    "experiments_get_started_step_1": "Lag en ny mal av forsiden, produktsiden eller kategorisiden i designbyggeren.",
    "experiments_get_started_step_2": "Opprett en test som sammenligner den nye malen med den du bruker i dag.",
    "experiments_get_started_step_3": "Start testen og la den gå til du har nok besøkende.",
    "choose": "Velg",
    "experiment_updated": "Testen er oppdatert",
    "experiment_deleted": "Testen er slettet",
    "experiment_archived": "Testen er arkivert",
    "experiment_unarchived": "Testen er hentet fram igjen",
    "experiment_cannot_delete_launched": "«:name» har vært i gang, og kan ikke slettes. Arkiver den i stedet, så beholder du tallene.",
    "experiment_cannot_edit_launched": "Testen har startet og kan ikke endres. Avslutt den og opprett en ny hvis du vil teste noe annet.",
    "experiment_archive_stopped_only": "Bare avsluttede tester kan arkiveres. Avslutt testen først.",
    "experiment_edit": "Endre testen",
    "experiment_delete": "Slett testen",
    "experiment_delete_warning": "Utkastet slettes for godt. Ingen besøkende har sett det, så ingen tall går tapt.",
    "experiment_archive": "Arkiver",
    "experiment_unarchive": "Hent fram igjen",
    "experiment_archive_help": "Arkiverte tester er ute av listen, men tallene er i behold.",
    "experiments_show_archived": "Vis arkiverte ({count})",
    "experiments_show_active": "Tilbake til aktive tester",
    "experiments_archived_empty": "Du har ingen arkiverte tester.",
    "experiments_index_description_all": "Sammenlign to maler av forsiden, produktsidene eller kategorisidene, og se hvilken som selger best.",
    "experiments_running_heading": "Pågår nå",
    "experiments_one_per_surface": "Du kan ha én test i gang per sidetype.",
    "experiments_no_test_running": "Ingen test i gang",
    "experiments_free_surface_help": "Start en test for å se hvilken mal som selger best.",
    "experiments_draft_ready": "Utkast klart til start | Utkast klare til start",
    "experiments_draft_ready_help": "Åpne utkastet for å se over oppsettet og starte testen. | Åpne et utkast for å se over oppsettet og starte testen.",
    "experiments_open_draft": "Åpne utkastet",
    "experiments_drafts_label": "Utkast: | Utkast:",
    "experiments_finished_heading": "Avsluttede tester",
    "experiments_all_finished_archived": "Alle avsluttede tester er arkivert.",
    "experiment_test": "Test",
    "experiment_period": "Periode",
    "experiment_duration_days": "{count} dag | {count} dager",
    "experiment_running_for": "har gått i {count} dag | har gått i {count} dager",
    "experiment_days_remaining_short": "Omtrent {count} dag igjen med dagens trafikk | Omtrent {count} dager igjen med dagens trafikk",
    "experiment_verdict_challenger_harming_short": "Sjekk malen i butikken, særlig på mobil. Mens testen går, koster ventetiden salg.",
    "experiment_verdict_sample_ratio_mismatch_short": "Malene har fått ulikt antall besøkende. Sjekk at malen fungerer i butikken.",
    "experiment_traffic_split": "Fordeling av trafikk",
    "experiment_traffic_split_help": "En 50/50-fordeling gir svar raskest.",
    "experiment_traffic_split_cost": "Skjev fordeling gjør testen tregere: den trenger omtrent {percent} % mer trafikk for samme sikkerhet.",
    "experiment_comparison": "Hva som sammenlignes",
    "experiment_control_is_live": "Vises i butikken nå",
    "experiment_help_label": "Hvordan testen fungerer",
    "experiment_control_fixed_help": "Testen sammenligner alltid med malen butikken viser i dag. Vil du ta utgangspunkt i en annen mal, gjør den til standardmalen i designbyggeren først.",
    "experiment_challenger_is_control": "Velg en annen mal enn den butikken viser i dag.",
    "experiment_surface_has_no_live_template": "Butikken har ingen standardmal for denne sidetypen ennå.",
    "experiment_split_share": "{percent} % av besøkende",
    "experiment_traffic_split_locked": "Fordelingen låses når testen starter, slik at ingen besøkende bytter mal underveis.",
    "experiment_progress_of_planned": "av planlagt størrelse",
    "experiment_progress_per_arm": "{have} av {need} besøkende per mal",
    "experiment_requirement_label_days": "Dager",
    "experiment_requirement_label_visitors": "Besøkende i minste mal",
    "experiment_requirement_label_orders": "Ordre i minste mal",
    "experiment_requirement_label_carts": "Handlekurver i minste mal",
    "experiment_requirement_value": "{have} av {need}",
    "experiment_scoreboard_running": "Slik ligger de an",
    "experiment_scoreboard_finished": "Slik endte det",
    "experiment_scoreboard_not_started": "Tallene kommer når testen er i gang.",
    "experiment_provisional": "Foreløpig",
    "experiment_lift_so_far": "{lift} hittil",
    "experiment_all_numbers": "Alle tall",
    "experiment_per_visitor": "Per besøkende",
    "experiment_choice_adopt": "ta den i bruk",
    "experiment_diagnostics_help": "Kasse, omsetning og enheter. Forklarer resultatet, men kan ikke kåre en vinner.",
    "experiment_create_intro": "Velg en side, og la en ny mal konkurrere mot den butikken bruker i dag.",
    "experiment_comparison_help": "A er malen butikken viser i dag. B er en kopi du har endret i designbyggeren.",
    "experiment_versus": "mot",
    "experiment_new_template_link": "Lag en ny mal i designbyggeren",
    "experiment_surface_reach_single": "Bruker malen «{template}»",
    "experiment_surface_reach_product": "{count} produkt bruker «{template}» | {count} produkter bruker «{template}»",
    "experiment_surface_reach_category": "{count} kategori bruker «{template}» | {count} kategorier bruker «{template}»",
    "experiment_surface_no_template": "Ingen standardmal ennå",
    "experiment_surface_ready": "Klar, {count} utfordrer | Klar, {count} utfordrere",
    "experiment_surface_needs_template": "Trenger én mal til",
    "experiment_split_preset_even": "Raskest svar",
    "experiment_split_preset_cautious": "Færre ser den nye malen",
    "experiment_split_preset_safest": "Tryggest, men tregest",
    "experiment_split_custom": "Tilpass fordelingen",
    "experiment_option_recommended": "Anbefalt",
    "experiment_metric_help_conversion_rate": "Andelen besøkende som legger inn en ordre. Det tryggeste valget for de fleste tester.",
    "experiment_metric_help_revenue_per_visitor": "Tar også med hvor mye kundene handler for. Passer når malen skal løfte handlekurvene.",
    "experiment_metric_help_add_to_cart": "Gir svar raskere, men et klikk i handlekurven er ikke et salg.",
    "experiment_name_heading": "Gi testen et navn",
    "experiment_name_hint": "Foreslått ut fra valgene dine. Du kan endre det så lenge testen er et utkast.",
    "experiment_name_suggestion": "{surface}: {control} mot {challenger}",
    "experiment_summary_heading": "Oppsummering",
    "experiment_summary_surface": "Side",
    "experiment_summary_split": "Fordeling",
    "experiment_summary_mde": "Minste forbedring",
    "experiment_summary_not_chosen": "Ikke valgt",
    "experiment_create": "Opprett test",
    "experiment_save_changes": "Lagre endringer",
    "experiment_create_draft_note": "Testen lagres som utkast. Du starter den selv når du er klar.",
    "experiment_scope_summary": "Testen omfatter {count} produkt som bruker malen «{template}». | Testen omfatter {count} produkter som bruker malen «{template}».",
    "experiment_scope_help": "Produkter som er satt opp med en annen mal, røres ikke — de beholder malen du har valgt for dem, og telles ikke med i resultatet.",
    "template_is_now_default": "Malen «:template» er nå standard",
    "home_template_is_now_live": "Forsiden «:template» er nå publisert",
    "template_default_locked_by_experiment": "Du kan ikke bytte standardmal mens testen «:experiment» pågår. Avslutt testen først.",
    "template_not_the_default": "Ikke standardmalen",
    "home_template_not_live": "Vises ikke i butikken",
    "use_this_template": "Bruk denne malen",
    "publish_home_template": "Publiser som forside",
    "publish_home_template_title": "Publisere denne forsiden?",
    "publish_home_template_warning": "Denne malen blir forsiden besøkende ser, med en gang. Den du bruker nå, blir liggende som utkast.",
    "publish_home_template_confirm": "Publiser forsiden",
    "experiment_scope_running": "Omfatter {count} produkt. | Omfatter {count} produkter.",
    "experiment_started_at": "Startet {date}",
    "experiment_stopped_at": "Avsluttet {date}",
    "experiment_ran_for": "gikk i {count} dag | gikk i {count} dager",
    "experiment_traffic_share_of": "{percent} % av trafikken",
    "experiment_traffic_share_locked": "Fordelingen kan ikke endres etter at testen er startet. Avslutt testen og opprett en ny hvis du vil teste en annen fordeling.",
    "template_in_use_by_script": "Malen brukes av skriptet «:script». Fjern begrensningen på skriptet før du sletter malen.",
    "theme_in_use_by_script": "Temaet har en mal som brukes av skriptet «:script». Fjern begrensningen på skriptet før du sletter temaet.",
    "template_in_use_by_experiment": "Malen brukes i A/B-testen «:experiment». Avslutt eller slett testen før du sletter malen.",
    "theme_in_use_by_experiment": "Temaet har en mal som brukes i A/B-testen «:experiment». Avslutt eller slett testen før du sletter temaet.",
    "home_template": "Forsidemal",
    "theme_editor_theme_label": "Tema",
    "theme_editor_themes_heading": "Temaer",
    "theme_editor_themes_help": "Et tema er hele butikkens utseende: farger, skrift, header og footer. Ett tema er aktivt i butikken om gangen.",
    "theme_editor_theme_active": "Aktivt",
    "theme_editor_add_theme": "Legg til tema",
    "theme_editor_duplicate_theme": "Dupliser tema",
    "theme_editor_delete_theme": "Slett tema",
    "theme_editor_theme_limit_reached": "Grensen for antall temaer er nådd",
    "theme_editor_startup_one_theme": "Startup-abonnementet lar deg jobbe med ett tema om gangen",
    "theme_editor_duplicate_theme_x": "Dupliser temaet {name}",
    "theme_editor_delete_theme_x": "Er du sikker på at du vil slette temaet {name}?",
    "theme_editor_theme_deleted": "Temaet er slettet",
    "theme_editor_page_and_template": "Side og mal",
    "theme_editor_page_type_heading": "Sidetype",
    "theme_editor_template_count": "{count} mal | {count} maler",
    "theme_editor_page_count": "{count} side | {count} sider",
    "theme_editor_home_templates_in_theme": "Forsidemaler i temaet {theme}",
    "theme_editor_product_templates_in_theme": "Produktmaler i temaet {theme}",
    "theme_editor_category_templates_in_theme": "Kategorimaler i temaet {theme}",
    "theme_editor_create_home_template": "Opprett forsidemal",
    "theme_editor_create_product_template": "Opprett produktmal",
    "theme_editor_create_category_template": "Opprett kategorimal",
    "theme_editor_template_is_default": "Brukes som standard",
    "theme_editor_home_template_is_live": "Vises i butikken",
    "theme_editor_confirm_delete_home_template": "Er du sikker på at du vil slette denne forsidemalen?",
    "theme_editor_ab_badge": "A/B-test",
    "theme_editor_ab_prompt": "Vil du vite hvilken mal som selger best?",
    "theme_editor_ab_start": "Start en A/B-test",
    "theme_editor_open_ab_testing": "Åpne A/B-testing",
    "theme_editor_preview_with": "Forhåndsvis med",
    "theme_editor_open_content_pages": "Åpne innholdssidene",
    "help_product_templates_feature_create_picker": "Lag en ny mal med «Opprett produktmal» i velgeren øverst — den starter med standardoppsettet.",
    "help_category_templates_feature_create_picker": "Lag en ny mal med «Opprett kategorimal» i velgeren øverst – den starter som en kopi av det du redigerer nå.",
    "home_template_copy_open": "Kopier «{name}» i stedet for forsiden som vises nå",
    "home_template_not_live_until_published": "Den nye malen vises ikke i butikken før du publiserer den som forside.",
    "cannot_delete_live_home_page_template": "Dette er forsiden butikken viser nå, og kan ikke slettes. Sett en annen mal som forside først.",
    "duplicate_default_home_page_template": "Temaet har allerede en forsidemal i bruk.",
    "script_template_scope": "Begrens til bestemte maler",
    "script_template_scope_description": "Velg malene dette skriptet hører til. Det kjører bare på sider som bruker en av dem — og følger dermed automatisk med i en A/B-test som viser malen.",
    "script_template_scope_empty_means_global": "Ingen valgt betyr at skriptet kjører overalt, som før.",
    "script_template_scope_receipt_warning": "Kvitteringssiden bruker ingen av disse malene. Et skript som skal registrere kjøp, må derfor stå uten begrensning.",
    "conversion_scope_group_product": "Produktsidemaler",
    "conversion_scope_group_home": "Forsidemaler",
    "conversion_scope_unknown": "Ukjent mal.",
    "experiment_surface": "Hva vil du teste?",
    "experiment_surface_product": "Produktsider",
    "experiment_surface_category": "Kategorisider",
    "conversion_scope_group_category": "Kategorisidemaler",
    "experiment_scope_summary_category": "Testen omfatter {count} kategori som bruker malen «{template}». | Testen omfatter {count} kategorier som bruker malen «{template}».",
    "experiment_scope_running_category": "Omfatter {count} kategori. | Omfatter {count} kategorier.",
    "experiment_surface_home": "Forsiden",
    "experiment_surface_help": "Du kan ha én test i gang per sidetype. En forsidetest og en produktsidetest kan derfor kjøre samtidig.",
    "experiment_scope_single_page": "Testen gjelder forsiden, som vises med malen «{template}».",
    "experiment_scope_running_home": "Gjelder forsiden.",
    "import_menu_head_title": "Import — forhåndsvisning av meny",
    "import_menu_overview": "Oversikt",
    "import_menu_title": "Forhåndsvisning av meny",
    "import_menu_intro": "Slik vil menyen i nettbutikken se ut etter import. Rett problemer her og se treet oppdatere seg.",
    "import_menu_view_as_list": "Vis som liste",
    "import_menu_orphaned_heading": "{count} kategorier hoppet over — uten tilknytning i {source}",
    "import_menu_orphaned_explanation": "Den overordnede kategorien deres ble slettet eller deaktivert i {source}, så de vises ikke der og blir ikke importert til menyen.",
    "import_menu_more_count": "+{count} til",
    "import_menu_selected_count": "{count} kategorier valgt",
    "import_menu_strategy": "Strategi",
    "import_menu_flatten_into_parent_suggested": "Slå sammen i overordnet (foreslått)",
    "import_menu_attribute_name": "Attributtnavn",
    "import_menu_attribute_placeholder": "f.eks. Modell",
    "import_menu_apply_count": "Bruk på {count}",
    "import_menu_no_menu_to_preview": "Denne kilden tilbyr ingen meny å forhåndsvise.",
    "import_menu_only_show_with_issues": "Vis bare kategorier med problemer",
    "import_menu_hide_disabled_in_source": "Skjul kategorier deaktivert i {source}",
    "import_menu_fix": "Rett",
    "import_menu_no_categories_with_issues": "Ingen kategorier med problemer.",
    "import_menu_before": "Før",
    "import_menu_after": "Etter",
    "import_overview_head_title": "Importverktøy — oversikt",
    "import_overview_title": "Importoversikt",
    "import_overview_intro_before": "En forhåndsvisning av hva denne importen vil opprette eller oppdatere. Ingenting skrives til butikken din før du velger ",
    "import_overview_intro_after": ".",
    "import_overview_meta": "Kjøring {id} · kilde {source} · status {status}",
    "import_overview_run_preflight": "Kjør forhåndssjekk",
    "import_overview_run_import": "Kjør import",
    "import_overview_failed_analysis": "importer kunne ikke analyseres ({labels}) og hoppes over i denne importen. Rett kildedataene og kjør forhåndssjekken på nytt for å få dem med.",
    "import_overview_not_analyzed": "Denne importen er ikke analysert ennå. Kjør forhåndssjekken for å forhåndsvise endringene og avdekke eventuelle problemer før import.",
    "import_overview_scanning": "Analyserer kildedataene – dette kan ta en stund for store butikker. Denne siden oppdateres automatisk når forhåndsvisningen er klar.",
    "import_overview_scanning_short": "Analyserer …",
    "import_overview_restart_scan": "Start analysen på nytt",
    "import_overview_scan_failed": "Analysen mislyktes før den ble fullført. Sjekk kildetilkoblingen og kjør forhåndssjekken på nytt.",
    "import_overview_unresolved": "poster trenger fortsatt en avgjørelse før denne importen kan kjøre. Åpne hver entitet nedenfor for å løse dem.",
    "import_overview_ready_to_run": "Ingen avgjørelser nødvendig — du er klar til å kjøre importen.",
    "import_overview_status_running": "Denne importen kjører. Åpne den for å følge fremdriften.",
    "import_overview_status_completed": "Denne importen er fullført. Importer på nytt for å kjøre en ny gjennomgang — beslutningene dine overføres.",
    "import_overview_status_finished": "Denne importen er allerede kjørt. Åpne den for å se resultatene.",
    "import_overview_view_progress": "Se fremdrift",
    "import_overview_view_results": "Se resultater",
    "import_overview_tag_analysis_failed": "Analyse mislyktes",
    "import_overview_tag_not_analyzed": "Ikke analysert",
    "import_overview_tag_analyzing": "Analyserer …",
    "import_overview_tag_needs_review": "Trenger gjennomgang",
    "import_overview_tag_ready": "Klar",
    "import_overview_preview_menu_link": "Forhåndsvis den importerte menyen og løs problemer →",
    "import_overview_resolve_link": "Gjennomgå og løs {count} poster →",
    "import_options_action_convert": "Gjør om til attributt",
    "import_options_action_drop": "Ikke importer",
    "import_options_action_import": "Importer som den er",
    "import_options_axis_counts": "{products} produkter · {values} verdier",
    "import_options_back": "Tilbake til oversikten",
    "import_options_bulk_capitalize": "Stor forbokstav",
    "import_options_bulk_lowercase": "små bokstaver",
    "import_options_bulk_trim": "Trim",
    "import_options_coexist_warning": "{count} produkter bruker flere av de sammenslåtte alternativene samtidig. Disse produktene beholder de opprinnelige alternativnavnene.",
    "import_options_empty": "Fant ingen produktalternativer i de skannede dataene.",
    "import_options_head_title": "Produktalternativer — import",
    "import_options_intro": "Disse alternativnavnene blir synlige filtre i butikken. Slå sammen dupliserte alternativer, rydd i verdinavn, eller dropp alternativer du ikke lenger trenger før importen kjøres.",
    "import_options_saved": "Lagret",
    "import_options_suggest_merge_axes": "Slå sammen til “{target}”:",
    "import_options_suggest_merge_values": "I “{axis}”, slå sammen til “{target}”:",
    "import_options_suggestion_accept": "Bruk",
    "import_options_suggestion_dismiss": "Avvis",
    "import_options_suggestions_title": "Foreslåtte oppryddinger",
    "import_options_tag_attribute": "Blir attributt",
    "import_options_tag_collapsed_only": "Importeres som attributt",
    "import_options_tag_dropped": "Importeres ikke",
    "import_options_tag_existing_attribute": "Matcher eksisterende attributt",
    "import_options_tag_existing_option": "Matcher eksisterende alternativ",
    "import_options_tag_merged": "Slås sammen med {names}",
    "import_options_title": "Produktalternativer",
    "import_options_unsafe_tooltip": "Noen produkter har flere verdier på dette alternativet, så det kan ikke droppes eller gjøres om:",
    "import_options_value_counts": "{products} produkter · {variants} varianter",
    "import_options_values_heading": "Verdier",
    "import_overview_options_link": "Gjennomgå produktalternativer →",
    "import_overview_no_entities": "Ingen importerbare entiteter ble valgt for denne kjøringen.",
    "import_connect_connection_successful": "Tilkobling vellykket.",
    "import_connect_connection_failed": "Tilkobling mislyktes.",
    "import_connect_connection_test_error": "Kunne ikke kjøre tilkoblingstesten.",
    "import_connect_page_title": "Importverktøy — koble til",
    "import_connect_heading": "Importverktøy",
    "import_connect_subtitle": "Koble til en kilde og velg hva som skal importeres.",
    "import_connect_source_help": "Hvilket system importerer du fra.",
    "import_connect_source_type": "Kildetype",
    "import_connect_connection": "Tilkobling",
    "import_connect_connection_help": "Hvordan nå kilden. Hver kilde definerer hva den trenger.",
    "import_connect_checking_connection": "Sjekker tilkobling…",
    "import_connect_connection_not_checked": "Tilkobling ikke sjekket ennå.",
    "import_connect_test_connection": "Test tilkobling",
    "import_connect_what_to_import": "Hva som skal importeres",
    "import_connect_what_to_import_help": "Velg entitetstypene som skal inkluderes i denne kjøringen.",
    "import_connect_no_entity_types": "Ingen importerbare entitetstyper er registrert.",
    "import_connect_start_run": "Start kjøring",
    "import_decision_point_source_of_truth": "Gjeldende kilde",
    "import_decision_point_category_flatten": "Utflating av kategori",
    "import_decision_point_menu_depth": "Menydybde",
    "import_decision_point_variant_removal": "Fjerning av varianter",
    "import_decision_point_variant_overflow": "For mange varianter",
    "import_decision_point_variant_tree": "Variantdata",
    "import_decision_point_empty_category": "Tom kategori",
    "import_decision_point_media_reconciliation": "Bildeendringer",
    "import_decision_point_new_product": "Nytt produkt",
    "import_decision_point_variant_addition": "Nye varianter",
    "import_strategy_label_mirror_source": "Speil kilden",
    "import_strategy_desc_mirror_source": "Legg til nye bilder, erstatt endrede og fjern bilder som ikke lenger finnes i kilden.",
    "import_strategy_desc_keep_target": "La produktets bilder stå nøyaktig som de er.",
    "import_strategy_label_custom": "Velg per bilde",
    "import_reason_message_media_reconciliation": "Produktets bilder avviker fra kilden — velg hvilke som skal beholdes.",
    "import_media_badge_new": "ny",
    "import_media_badge_missing": "mangler i kilden",
    "import_media_badge_changed": "innhold endret",
    "import_media_badge_unchanged": "uendret",
    "import_media_action_attach": "legg til",
    "import_media_action_detach": "fjern",
    "import_media_action_replace": "erstatt",
    "import_media_action_keep": "behold",
    "import_media_custom_active": "Egne valg per bilde er aktive",
    "import_media_target": "Denne butikken",
    "import_media_not_in_source": "ikke i kilden",
    "import_media_not_on_target": "ikke importert ennå",
    "import_reason_id_overlap": "ID-overlapp",
    "import_reason_source_of_truth": "Feltkonflikt",
    "import_reason_variant_overflow": "For mange varianter",
    "import_reason_menu_depth": "For dyp meny",
    "import_reason_variant_tree": "Feil i variantdata",
    "import_reason_message_id_overlap": "Kilde #{sourceId} samsvarer med en eksisterende oppføring med en annen ID — velg hvilken oppføring som gjelder.",
    "import_reason_message_source_of_truth": "{count} felt avviker fra den eksisterende oppføringen — velg hvilken kilde som gjelder.",
    "import_issue_too_many_variants": "Produktet har {count} varianter, som er over grensen på {limit}.",
    "import_issue_broken_variant_tree": "Produktet «{title}» har variantdata som ikke kunne leses: {error}",
    "import_run_counter_created": "Opprettet",
    "import_run_counter_updated": "Oppdatert",
    "import_run_counter_unchanged": "Uendret",
    "import_run_counter_skipped": "Hoppet over",
    "import_run_counter_remapped": "Koblet om",
    "import_run_counter_failed": "Feilet",
    "import_field_slug": "Slug",
    "import_field_meta_title": "Metatittel",
    "import_field_meta_description": "Metabeskrivelse",
    "import_field_show_title": "Vis tittel",
    "import_field_article_number": "Artikkelnummer",
    "import_field_ean": "EAN",
    "import_field_price_excl_vat": "Pris (eks. mva.)",
    "import_field_vat_rate": "Mva.-sats",
    "import_field_stock": "Lagerbeholdning",
    "import_field_google_product_category_id": "Google-produktkategori (ID)",
    "import_field_google_product_category_name": "Google-produktkategori (navn)",
    "import_field_google_product_condition": "Google-produkttilstand",
    "import_field_google_product_adult": "Google: voksenprodukt",
    "import_field_customer_type": "Kundetype",
    "import_field_billing_first_name": "Fornavn (fakturering)",
    "import_field_billing_last_name": "Etternavn (fakturering)",
    "import_field_billing_phone": "Telefon (fakturering)",
    "import_field_billing_street": "Gateadresse (fakturering)",
    "import_field_billing_street2": "Gateadresse 2 (fakturering)",
    "import_field_billing_postal_code": "Postnummer (fakturering)",
    "import_field_billing_city": "Poststed (fakturering)",
    "import_field_billing_country": "Land (fakturering)",
    "import_field_billing_organization_number": "Organisasjonsnummer (fakturering)",
    "import_field_billing_company_name": "Firmanavn (fakturering)",
    "import_field_billing_company_project": "Prosjekt (fakturering)",
    "import_field_billing_company_department": "Avdeling (fakturering)",
    "import_field_uses_shipping_address": "Bruker leveringsadresse",
    "import_field_shipping_first_name": "Fornavn (levering)",
    "import_field_shipping_last_name": "Etternavn (levering)",
    "import_field_shipping_phone": "Telefon (levering)",
    "import_field_shipping_street": "Gateadresse (levering)",
    "import_field_shipping_street2": "Gateadresse 2 (levering)",
    "import_field_shipping_postal_code": "Postnummer (levering)",
    "import_field_shipping_city": "Poststed (levering)",
    "import_field_shipping_country": "Land (levering)",
    "import_field_store_companyNumber": "Organisasjonsnummer",
    "import_field_store_storeDescription": "Butikkbeskrivelse",
    "import_field_contact_phone": "Kontakttelefon",
    "import_field_contact_email": "Kontakt-e-post",
    "import_field_billing_postalCode": "Postnummer (faktura)",
    "import_field_billing_email": "E-post (faktura)",
    "import_run_page_title": "Importverktøy — kjøring",
    "import_run_overview": "Oversikt",
    "import_run_heading": "Kjør import",
    "import_chunks_never_ran": ":count bolk(er) av denne enheten ble aldri kjørt, så postene ble ikke importert. Prøv importen på nytt.",
    "import_run_start_failed": "Importen kunne ikke startes. Løs eventuelle utestående beslutninger først.",
    "import_run_already_running": "Denne importen kjører allerede.",
    "import_run_already_completed": "Denne importen er allerede fullført. Start en ny import for å synkronisere på nytt.",
    "import_run_complete_message": "Denne importen er fullført. For å kjøre den på nytt, start en ny import — beslutningene dine overføres.",
    "import_run_reimport": "Importer på nytt",
    "import_run_start": "Start import",
    "import_run_failed_message": "Importen ble ikke fullført. Gjennomgå resultatene nedenfor, og prøv på nytt.",
    "import_run_retry": "Prøv på nytt",
    "import_run_partial_message": "Importen ble fullført, men noen partier mislyktes. Gjennomgå resultatene nedenfor, og prøv på nytt for å kjøre dem som ikke ble fullført.",
    "import_run_results": "Resultater",
    "import_run_failures": "Feil",
    "import_run_retry_failures": "Prøv mislykkede på nytt",
    "import_run_failure_chunk": "del",
    "import_run_failure_entity": "Enhet",
    "import_run_failure_source": "Kilde-ID",
    "import_run_failure_message": "Feil",
    "import_run_failure_all_entities": "Alle enheter",
    "import_run_messages": "Merknader",
    "import_run_messages_hint": "Elementer som ble hoppet over eller justert under importen",
    "import_run_message_message": "Merknad",
    "import_run_col_entity": "Enhet",
    "import_run_total": "Totalt",
    "import_run_total_operations": "{count} operasjoner",
    "import_run_auto_refresh": "Oppdater automatisk",
    "import_run_eta": "Anslått tid igjen",
    "import_run_eta_rough": "(grovt anslag)",
    "import_run_duration_lt_min": "under 1 min",
    "import_run_unit_min": "min",
    "import_run_unit_hour": "t",
    "import_entity_page_title": "Importverktøy — {entity}",
    "import_entity_overview": "Oversikt",
    "import_entity_record_count": "{count} oppføringer",
    "import_entity_source_id": "Kilde-ID",
    "import_entity_title_or_name": "Tittel / navn",
    "import_entity_match": "Treff",
    "import_entity_decision": "Beslutning",
    "import_entity_all_records": "Alle oppføringer",
    "import_entity_all_matches": "Alle treff",
    "import_entity_needs_review_any_reason": "Trenger gjennomgang — uansett årsak",
    "import_entity_empty_no_reason_match": "Ingen oppføringer samsvarer med denne årsaken.",
    "import_entity_empty_nothing_needs_review": "Ingenting trenger gjennomgang for denne entiteten.",
    "import_entity_empty_no_records_on_page": "Ingen oppføringer på denne siden.",
    "import_bulk_apply_strategy": "Bruk valg…",
    "import_bulk_apply_field_policy": "Bruk feltregel…",
    "import_bulk_apply_to_all_fields": "Bruk på alle felter",
    "import_bulk_keep_source": "Behold {source} (kilde)",
    "import_bulk_keep_target": "Behold 24Next (gjeldende)",
    "import_bulk_skip_field": "Hopp over felt",
    "import_field_backorder": "Tillat restordre",
    "import_field_stock_tracking": "Lagerstyring",
    "import_field_redirect": "Viderekobling fra V1-adressen",
    "import_bulk_page_selected": "Alle {count} på denne siden er valgt.",
    "import_bulk_select_all_matching": "Velg alle {total} treff",
    "import_bulk_all_selected": "Alle {count} treff er valgt.",
    "import_bulk_fix_button": "Løs samlet…",
    "import_bulk_fix_title": "Løs konflikter samlet",
    "import_bulk_fix_field_rules": "Feltregler",
    "import_bulk_fix_affected": "{count} poster",
    "import_bulk_fix_leave_undecided": "Ikke bestem nå",
    "import_bulk_fix_forced_heading": "Ekte konflikter",
    "import_bulk_fix_forced_hint": "Begge sider er endret siden forrige import. {source} er forhåndsvalgt — sett hele feltet samlet, eller endre per rad.",
    "import_bulk_fix_no_rules": "Ingen felt-avvik i utvalget.",
    "import_bulk_fix_apply": "Bruk på {count} poster",
    "import_bulk_scope_matching": "Ingen rader er krysset av, så masseendringer gjelder alle {count} poster i gjeldende filter.",
    "import_bulk_scope_selected": "Masseendringer gjelder de {count} valgte postene.",
    "import_bulk_fix_set_all": "Sett alle",
    "import_bulk_fix_group_rows": "{count} rader",
    "import_bulk_fix_group_sample": "Viser de {shown} første av {count} rader her. «Sett alle» gjelder alle {count}.",
    "import_bulk_strategy_title": "Bruk valg samlet",
    "import_bulk_strategy_hint": "Valget brukes på alle poster og variantrader i utvalget der det er tilgjengelig, også der en beslutning er påkrevd. Et valg her teller som en manuell beslutning. Valg som må fylles ut per post, tas i hver rad.",
    "import_bulk_strategy_none": "Ingen beslutninger å ta samlet i utvalget.",
    "import_bulk_strategy_child_rows": "{count} variantrader",
    "import_strategy_forced": "Påtvunget",
    "import_strategy_suggested": "foreslått",
    "import_strategy_split_target": "Delemål / valg",
    "import_strategy_split_placeholder": "f.eks. attributt å dele på",
    "import_fix_resolve_item": "Løs dette elementet",
    "import_fix_pick_placement": "Velg hvordan «{label}» skal plasseres. Forhåndsvisningen oppdateres mens du velger.",
    "import_fix_suggested": "Foreslått",
    "import_compare_match": "Treff",
    "import_compare_mismatch": "Avvik",
    "import_compare_update": "Oppdater",
    "import_compare_needs_decision": "Trenger avgjørelse",
    "import_compare_resolved": "Løst",
    "import_compare_mismatch_help": "Denne posten finnes allerede i 24Next. De uthevede kolonnene avviker — velg hvilken verdi du vil beholde for hver.",
    "import_compare_decisions": "Avgjørelser",
    "import_fielddiff_unchanged": "Uendret",
    "import_fielddiff_source_advanced": "Kilde oppdatert",
    "import_fielddiff_target_edited": "Redigert i 24Next",
    "import_fielddiff_conflict": "Konflikt",
    "import_fielddiff_field": "Felt",
    "import_fielddiff_base_col": "Grunnlag (forrige import)",
    "import_fielddiff_source_col": "Kilde ({source})",
    "import_fielddiff_current_col": "Nåværende (24Next)",
    "import_fielddiff_verdict": "Resultat",
    "import_fielddiff_keep": "Behold",
    "import_fielddiff_forced": "Tvunget",
    "import_fielddiff_no_differences": "Ingen forskjeller på feltnivå.",
    "import_variant_ui_update": "Oppdater",
    "import_variant_ui_review": "Gjennomgå",
    "import_variant_ui_count": "Varianter ({count})",
    "import_variant_ui_needs_decision": "trenger avgjørelse",
    "import_preview_images": "🖼️ Bilder",
    "import_preview_ready": "{count} klare",
    "import_preview_no_decisions": "Ingen avgjørelser nødvendig.",
    "import_preview_review_images": "Gjennomgå bilder",
    "import_preview_google_taxonomy": "🏷️ Google-taksonomi",
    "import_preview_issues": "⚠ {count} problemer",
    "import_preview_ready_status": "Klar",
    "import_preview_map_resolve_taxonomy": "Tilordne og løs taksonomi",
    "import_cluster_catalog": "Katalog",
    "import_cluster_customers": "Kunder og grupper",
    "import_cluster_pages": "Sider",
    "import_cluster_settings": "Butikkinnstillinger",
    "import_cluster_faqs": "FAQer",
    "import_cluster_blog": "Blogg",
    "import_cluster_content": "Innhold",
    "import_cluster_design": "Design",
    "import_cluster_other": "Annet",
    "import_field_answers": "Spørsmål og svar",
    "product_variants": "Produktvarianter",
    "customer_group_memberships": "Kundegruppemedlemskap",
    "customer_group_rules": "Kundegrupperegler",
    "company_settings": "Bedriftsinnstillinger",
    "product_google_taxonomy": "Google-taksonomi for produkter",
    "content_images": "Innholdsbilder",
    "content_urls": "Bildelenker i innhold",
    "scanning": "analyserer",
    "reviewing": "til gjennomgang",
    "running": "kjører",
    "failed": "mislyktes",
    "partial": "delvis",
    "import_strategy_label_faithful": "Tro mot kilden",
    "import_strategy_label_flatten_promote": "Løft opp til tillatt nivå",
    "import_strategy_label_truncate": "Fjern",
    "import_strategy_label_flatten_into_parent": "Slå sammen i overordnet",
    "import_strategy_label_skip": "Hopp over",
    "import_strategy_label_create": "Opprett",
    "import_strategy_label_add": "Legg til",
    "import_strategy_label_split_into_products": "Del opp i produkter",
    "import_strategy_label_source_of_truth": "Kilde som fasit",
    "import_strategy_label_keep_source": "Behold kilde",
    "import_strategy_label_keep_target": "Behold gjeldende",
    "import_strategy_label_merge": "Slå sammen",
    "import_strategy_label_convert_to_page": "Gjør om til side",
    "import_strategy_label_skip_empty": "Hopp over (ikke importer)",
    "import_strategy_label_import_as_category": "Importer som kategori",
    "import_strategy_label_merge_into_category": "Slå sammen i annen kategori",
    "import_strategy_label_overwrite": "Overskriv",
    "import_strategy_label_remap": "Importer med ny id",
    "import_strategy_label_deactivate": "Deaktiver",
    "import_strategy_label_delete_if_unreferenced": "Slett hvis ubrukt",
    "import_strategy_label_keep": "Behold",
    "import_strategy_label_cap_first_n": "Behold de første {limit}",
    "import_strategy_label_collapse_to_master": "Slå sammen til hovedvariant",
    "import_strategy_label_import_without_variants": "Importer uten varianter",
    "import_strategy_label_skip_product": "Hopp over produktet",
    "import_strategy_desc_convert_to_page": "Lager en innholdsside av kategorien i stedet for en kategori i butikken.",
    "import_strategy_desc_import_as_category": "Importerer som en vanlig kategori selv om den ikke har produkter.",
    "import_strategy_desc_skip_empty": "Importerer ikke denne kategorien i det hele tatt.",
    "import_strategy_desc_merge": "Beholder den eksisterende v3-oppføringen og fyller bare inn felter som er tomme.",
    "import_strategy_desc_overwrite": "Overskriver den eksisterende v3-oppføringen med verdiene fra V1.",
    "import_strategy_desc_remap": "Importerer som en ny oppføring med ny id og lar den eksisterende være urørt.",
    "import_strategy_desc_skip": "Hopper over – beholder den eksisterende v3-oppføringen og importerer ikke denne.",
    "import_strategy_desc_faithful": "Importerer alt nøyaktig slik det er i V1, uten endringer.",
    "import_strategy_desc_flatten_into_parent": "Flytter produktene opp til den overordnede kategorien og merker dem med et attributt for filtrering.",
    "import_strategy_desc_flatten_promote": "Løfter menypunkter som ligger for dypt opp til største tillatte dybde.",
    "import_strategy_desc_merge_into_category": "Slår sammen i en annen kategori og merker produktene med et attributt.",
    "import_strategy_desc_truncate": "Fjerner menypunkter som ligger dypere enn grensen.",
    "import_strategy_desc_deactivate": "Deaktiverer varianten, men beholder den for ordrehistorikk.",
    "import_strategy_desc_delete_if_unreferenced": "Sletter varianten bare hvis ingen ordre viser til den.",
    "import_strategy_desc_keep": "Beholder varianten uendret.",
    "import_strategy_desc_cap_first_n": "Beholder de første {limit} variantene og forkaster resten.",
    "import_strategy_desc_collapse_to_master": "Slår sammen til én hovedvariant; variantvalgene blir til attributter.",
    "import_strategy_desc_split_into_products": "Deler opp i flere selvstendige produkter basert på et variantvalg.",
    "import_strategy_desc_import_without_variants": "Importerer som et enkelt produkt og dropper variantene som ikke kan leses.",
    "import_strategy_desc_skip_product": "Hopper over hele produktet – det blir ikke importert.",
    "import_menu_converted_to_page": "\u2192 side",
    "import_menu_empty_category_action": "Tomme kategorier",
    "import_issue_too_deep": "Menyelementet «{name}» ligger på nivå {depth}, som er dypere enn grensen på {limit}.",
    "import_overview_rerun_preflight": "Kjør forhåndssjekk på nytt",
    "import_overview_changes_new": "{count} nye",
    "import_overview_changes_updated": "{count} oppdateres",
    "import_overview_changes_unchanged": "{count} uendret",
    "import_fix_applies_to_count": "Denne løsningen brukes på {count} kategorier.",
    "import_menu_indirect_product": "Ligger i en underkategori",
    "import_merge_proposal_heading": "{count} kategorier inneholder «{label}»",
    "import_merge_proposals_heading": "Forslag til sammenslåing",
    "import_merge_proposal_explanation": "Slå dem sammen til én kategori og merk produktene med et attributt, så kan kundene filtrere i butikken.",
    "import_merge_proposal_review": "Se forslag",
    "import_merge_proposal_dismiss": "Avvis",
    "import_merge_target_heading": "Målkategori",
    "import_merge_target_new": "Opprett ny kategori",
    "import_merge_target_existing": "Bruk eksisterende kategori",
    "import_merge_target_name": "Navn",
    "import_merge_target_placement": "Plassering",
    "import_merge_target_top_level": "Toppnivå",
    "import_merge_attribute_value": "Attributtverdi",
    "import_merge_members_heading": "Kategorier som slås sammen",
    "import_merge_new_category_badge": "Ny",
    "import_merge_source_count": "{count} slått sammen",
    "import_merge_apply": "Slå sammen {count}",
    "customer_type": "Kundetype",
    "bulk_picking_booked_not_captured": "Betalingen feilet: :cause Frakten er booket med sporingsnummer :tracking_number, og etiketten kan være skrevet ut. Ordren er ikke sendt.",
    "bulk_picking_too_many_orders": "Velg maks {max} ordrer til én plukkrunde. Snevre inn filteret og prøv igjen.",
    "datatable_filter_mode_include": "Inneholder",
    "datatable_filter_mode_exclude": "Inneholder ikke",
    "datatable_filter_without": "uten",
    "datatable_filter_no_products_chosen": "Ingen produkter valgt ennå",
    "datatable_sort": "Sortering",
    "datatable_sort_help": "Sorter på flere kolonner i prioritert rekkefølge. Klikk på en kolonneoverskrift erstatter dette med den kolonnen alene.",
    "datatable_sort_column": "Kolonne",
    "datatable_sort_add_level": "Legg til nivå",
    "datatable_sort_apply": "Bruk",
    "datatable_sort_reset": "Tilbakestill",
    "datatable_sort_ascending": "Stigende",
    "datatable_sort_descending": "Synkende",
    "datatable_sort_move_up": "Flytt opp",
    "datatable_sort_move_down": "Flytt ned",
    "datatable_sort_remove_level": "Fjern nivå",
    "datatable_all_items_selected": "Alle {count} valgt",
    "select_x_items_across_all_pages": "Velg alle {count} på tvers av alle sider",
    "order_index_partially_fulfilled": "Delbehandlet",
    "order_filter_product_search": "Vare",
    "order_filter_product_search_placeholder": "Navn, SKU eller GTIN",
    "order_filter_products": "Produkter",
    "order_filter_line_count": "Varelinjer",
    "order_filter_item_quantity": "Antall varer",
    "order_sort_product_name": "Varenavn",
    "order_sort_product_location": "Vareplassering",
    "order_filter_stock_location": "Vareplassering",
    "order_filter_without_stock_location": "Uten vareplassering",
    "order_filter_help_stock_location": "Ordrer med varer som står på den valgte hylla eller i den valgte bingen.",
    "order_filter_warehouse": "Varelager",
    "order_filter_help_warehouse": "Ordrer med varer som står på det valgte lageret.",
    "order_filter_max_line_quantity": "Største linjeantall",
    "order_filter_total": "Ordreverdi",
    "order_filter_without_shipping_method": "Uten fraktmetode",
    "order_filter_gift_certificate": "Gavekort (helt eller delvis)",
    "order_filter_customer_type": "Kundetype",
    "order_filter_without_customer_group": "Uten kundegruppe",
    "order_filter_cancellation": "Kansellering og refusjon",
    "order_filter_cancellation_requested": "Kanselleringsforespørsel fra kunde",
    "order_filter_has_cancellations": "Har kanselleringer",
    "order_filter_has_refunds": "Har refusjoner",
    "order_filter_accounting_status": "Regnskapsstatus",
    "order_filter_accounting_transferred": "Overført",
    "order_filter_accounting_failed": "Feilet",
    "order_filter_accounting_none": "Ikke overført",
    "list_customise_title": "Tilpass",
    "list_customise_intro": "Velg hvilke filtre og kolonner du vil se, og dra dem i den rekkefølgen du vil ha.",
    "list_customise_filters": "Filtre",
    "list_customise_preview": "Slik blir det",
    "list_customise_preview_empty": "Ingen filtre valgt",
    "list_customise_add_filter": "Legg til filter",
    "list_customise_no_filters_found": "Ingen filtre passer søket",
    "list_favourite_menu": "Favoritter",
    "list_favourite_empty": "Ingen lagrede visninger ennå",
    "list_favourite_save_current": "Lagre denne visningen",
    "list_favourite_name_placeholder": "Gi visningen et navn",
    "list_favourite_applied_partially": "Visningen ble brukt, men {count} av filtrene finnes ikke lenger",
    "datatable_selection_across_pages": "{count} valgt, {onPage} på denne siden",
    "order_filter_group_content": "Vare og innhold",
    "order_filter_group_customer": "Kunde",
    "order_filter_group_commerce": "Betaling og frakt",
    "order_filter_group_status": "Status og dato",
    "order_filter_help_date_range": "Ordrer lagt inn i en periode",
    "order_filter_help_product_search": "Ordrer med en varelinje som treffer navn, SKU eller GTIN",
    "order_filter_help_products": "Ordrer som inneholder produkter du velger",
    "order_filter_help_line_count": "Hvor mange varelinjer ordren har",
    "order_filter_help_item_quantity": "Hvor mange varer ordren inneholder til sammen",
    "order_filter_help_max_line_quantity": "Det største antallet på én enkelt linje",
    "order_filter_help_shipping_method": "Fraktmetoden ordren ble lagt inn med",
    "order_filter_help_payment_method": "Betalingsmetode, medregnet gavekort",
    "order_filter_help_total": "Ordreverdi inkludert mva",
    "order_filter_help_customer_type": "Privatkunder eller bedrifter",
    "order_filter_help_customer_group": "Kundegruppen ordren hører til",
    "order_filter_help_cancellation": "Kanselleringsforespørsler, kanselleringer og refusjoner",
    "order_filter_help_accounting_status": "Om ordren kom fram til regnskapssystemet",
    "order_filter_help_lock_status": "Ordrer som er låst for plukking",
    "list_rule_menu": "Regler",
    "list_rule_empty": "Ingen lagrede regler ennå",
    "list_rule_save": "Lagre som regel",
    "list_rule_name_placeholder": "Gi regelen et navn",
    "list_customise_no_filters_chosen": "Ingen filtre i denne regelen ennå",
    "list_customise_n_chosen": "{count} valgt",
    "order_filter_products_excluded": "Uten produkter",
    "order_filter_help_products_excluded": "Ordrer som ikke inneholder produktene du velger",
    "list_rule_group_store": "Butikkens regler",
    "list_rule_group_mine": "Mine regler",
    "list_rule_share_with_store": "Del med butikken",
    "list_rule_saved_in_customise": "Regler lagres fra Tilpass",
    "list_rule_limit_reached": "Du kan ha maks {max} regler her. Slett en først.",
    "add_tag_criterion": "Legg til tag-kriterie",
    "add_tag_criterion_action_description": "Legg til et tag-kriterie på de valgte smart kategoriene",
    "remove_tag_criterion": "Fjern tag-kriterie",
    "remove_tag_criterion_action_description": "Fjern et tag-kriterie fra de valgte smart kategoriene",
    "add_tag_criterion_to_x_amount_of_categories": "Legg til tag-kriterie på {count} smart kategori | Legg til tag-kriterie på {count} smart kategorier",
    "remove_tag_criterion_from_x_amount_of_categories": "Fjern tag-kriterie fra {count} smart kategori | Fjern tag-kriterie fra {count} smart kategorier",
    "add_x_tag_criteria": "Legg til {count} kriterie | Legg til {count} kriterier",
    "remove_x_tag_criteria": "Fjern {count} kriterie | Fjern {count} kriterier",
    "add_tag_criterion_modal_description": "En smart kategori henter produktene sine automatisk ut fra kriteriene den har. Dette legger til ett kriterie: produktet må ha taggen du velger.",
    "remove_tag_criterion_modal_description": "Dette sletter kriteriet som ser etter taggen du velger. En smart kategori som står igjen uten kriterier viser ingen produkter.",
    "x_categories_updated": ":count smart kategori oppdatert|:count smart kategorier oppdatert",
    "x_categories_skipped_not_smart": ":count valgt kategori ble hoppet over, den er ikke en smart kategori.|:count valgte kategorier ble hoppet over, de er ikke smart kategorier.",
    "which_tag_should_the_criterion_look_for": "Hvilken tag skal kriteriet se etter?",
    "no_tags_found": "Fant ingen tags",
    "how_should_the_criteria_be_combined": "Hvordan skal kriteriene kombineres?",
    "category_match_keep": "La dette stå som det er",
    "category_match_keep_hint": "Hver kategori beholder innstillingen den har i dag.",
    "category_match_all": "Alle kriterier må være oppfylt",
    "category_match_all_hint": "Dette gjør kategorien smalere. Produkter som ligger der nå faller ut hvis de ikke også har taggen du velger.",
    "category_match_any": "Ett av kriteriene må være oppfylt",
    "category_match_any_hint": "Dette gjør kategorien bredere. Produkter som ligger der nå blir værende, og alt som har taggen du velger kommer i tillegg.",
    "x_products_with_this_tag": "{count} produkt | {count} produkter",
    "x_categories_selected": "{count} smart kategori markert | {count} smart kategorier markert",
    "no_categories_needed_changing": "Ingen smart kategorier trengte endring, de stemte allerede med det du valgte.",
    "product_does_not_track_stock": "Produktet sporer ikke lager",
    "master_variant_holds_no_stock": "Hovedvarianten har ikke eget lager når produktet har varianter",
    "bulk_stock_updated": "Lagerantall oppdatert for :count produkter",
    "bulk_stock_updated_skipped_untracked": "Lagerantall oppdatert for :count produkter, hoppet over :skipped som ikke sporer lager",
    "stock_units": "på lager",
    "without_stock": "uten lager",
    "stock_negative": "Negativt",
    "not_tracking_stock": "sporer ikke lager",
    "no_stock_location": "ingen plassering",
    "n_variants": "{count} variant | {count} varianter",
    "variants_empty": "{count} variant tom | {count} varianter tomme",
    "search_products_sku_gtin": "Søk produkt, SKU eller GTIN",
    "select_rows": "velg",
    "change_location": "Endre plassering",
    "stock_available": "tilgjengelig",
    "stock_reserved": "reservert",
    "stock_adjustment": "lagerendring",
    "reserved_units_in_orders": "{units} stk i {orders} ordre | {units} stk i {orders} ordre",
    "opening_stock": "startlager",
    "adjust_stock_on_x_variants": "Juster lagerantall for {count} variant | Juster lagerantall for {count} varianter",
    "stock_how_it_works": "Hvordan fungerer lagret",
    "stock_help_numbers_title": "Slik fungerer lagertallene",
    "stock_help_numbers": "Varelageret viser tre ulike tall som sammen gir deg oversikt over lagerstatusen:\n\n• Totalt: Antall varer du fysisk skal ha på lager..\n• Tilgjengelig: Antall varer som er tilgjengelige for kundene å kjøpe akkurat nå..\n• Reservert: Antall varer som er knyttet til ordrer som ennå ikke er ferdig behandlet..\nTotalt = Tilgjengelig + Reservert\nVil du se hvilke ordrer de reserverte varene tilhører? Klikk på tallet under Reservert for å få opp en oversikt.",
    "stock_help_orders_title": "Varelagerendring ved salg",
    "stock_help_orders": "Når det opprettes en ny ordre (salg i butikken), trekkes varene fra Tilgjengelig med en gang og telles som Reservert. Totalt endres ikke før ordren er behandlet og varene er sendt. Kanselleringer og refusjoner legger varene tilbake bare hvis du velger å legge dem tilbake på lager når du gjør det.",
    "stock_help_adjust_title": "Slik justerer du varelageret",
    "stock_help_adjust": "Du skriver alltid endringen, ikke det nye antallet: +5 legger til fem, −2 trekker fra to. Endringen lagres med en gang, uten Lagre-knapp, og havner i Lagerloggen. Angre en feil ved å skrive det motsatte tallet. Skriver du et tall og så trykker + eller −, justeres tallet i feltet før det lagres; lagringen skjer når du enten klikker på pluss- eller minus-tegnet, eller når du forlater feltet.",
    "stock_help_negative_title": "Negativt lager",
    "stock_help_negative": "Lageret kan bli negativt når det selges flere varer enn det som er tilgjengelig på lager. Dette kan for eksempel skje ved restordre, eller dersom flere kunder kjøper de siste varene samtidig.\nEt negativt lagertall betyr at du har solgt varer som ennå ikke er registrert som tilgjengelige på lager. Salget gjennomføres som normalt, og antallet som mangler blir registrert på de aktuelle ordrene.\n\nEksempel: Har du 2 varer på lager og selger 3, vil tilgjengelig lager vise −1.\nNår du mottar nye varer, registrerer du dem med en positiv lagerjustering. Har du −1 på lager og legger inn 10 nye varer, vil tilgjengelig lager bli 9.",
    "stock_help_variants_title": "Varianter og lagersporing",
    "stock_help_variants": "På produkter med varianter ligger lageret på hver enkelt variant. Produktlinjen viser summen og kan ikke justeres direkte, åpne variantene i stedet. Produkter uten lagersporing vises uten felt. Sporing slås på under valget “Varelager” på produktsiden.",
    "new_variants_get_stock_on_save": "Nye varianter får startlageret sitt når du lagrer produktet.",
    "stock_saved_with_product": "Lagerantallet lagres når du lagrer produktet.",
    "stock_adjustment_hint": "Skriv hvor mange du legger til eller tar ut, for eksempel +5 eller -3.",
    "stock_adjustment_column_hint": "Lagerendring: skriv hvor mange du legger til eller tar ut per variant, for eksempel +5 eller -3.",
    "stock_available_now": "tilgjengelig nå",
    "stock_your_change": "din endring",
    "stock_available_after_save": "tilgjengelig etter lagring",
    "stock_after_save": "etter lagring",
    "stock_moved_since_load_title": "Lageret har endret seg siden du åpnet siden",
    "stock_moved_since_load_text": "Endringen din legges på antallet som gjelder nå. Sjekk at det fortsatt stemmer før du lagrer.",
    "stock_when_you_opened": "da du åpnet siden",
    "stock_now": "nå",
    "save_anyway": "Lagre likevel",
    "role_permission_groups": {
        "users": "Brukere og roller",
        "order": "Ordre",
        "product": "Produkter",
        "category": "Kategorier",
        "coupon": "Rabattkoder",
        "marketing": "Markedsføring",
        "design": "Design",
        "report": "Rapporter",
        "redirect": "Viderekoblinger",
        "webhook": "Webhooks",
        "settings": "Innstillinger",
        "app-store": "Apps",
        "customer": "Kunder",
        "blog": "Blogg",
        "customer_group": "Kundegrupper",
        "api-client": "API-klienter",
        "listings": "Oppføringer",
        "booking": "Booking",
        "customer_club": "Kundeklubb",
        "gift_certificate": "Gavekort",
        "v1import": "Import",
        "accounting": "Regnskap",
        "ai": "AI",
        "experiment": "A/B-testing",
        "form": "Skjema"
    },
    "roles_new_title": "Ny rolle",
    "roles_permissions_heading": "Tilganger",
    "roles_search_placeholder": "Søk i tilganger",
    "roles_no_search_results": "Ingen tilganger passer «{query}»",
    "roles_clear_search": "Tøm søket",
    "roles_group_count": "{selected} av {total}",
    "roles_select_group": "Velg alle tilganger i {group}",
    "roles_selected_heading": "Valgte tilganger",
    "roles_of_total": "av {total}",
    "roles_locked_title": "Administratorrollen kan ikke endres",
    "roles_locked_text": "Den følger med butikken. Skal noen ha færre tilganger, legger du til en ny rolle for dem.",
    "roles_granted": "Har tilgang",
    "roles_not_granted": "Har ikke tilgang",
    "trustpilot_app_name": "Trustpilot",
    "trustpilot_app_description": "Inviter kundene dine automatisk til å anmelde butikken på Trustpilot når hele ordren er sendt.",
    "trustpilot_description_label": "Slik kobler du til Trustpilot",
    "trustpilot_description_text": "Se Trustpilots veiledning",
    "trustpilot_enabled_description": "Når hele ordren er sendt, ber vi Trustpilot invitere kunden til å anmelde butikken.",
    "trustpilot_afs_email": "Trustpilot AFS-e-postadresse",
    "trustpilot_afs_email_description": "Den unike adressen fra Trustpilot Business. Den slutter vanligvis på {'@'}invite.trustpilot.com.",
    "trustpilot_landing_headline": "Flere ekte anmeldelser, helt automatisk",
    "trustpilot_landing_description": "Når hele ordren er sendt, ber vi Trustpilot sende kunden en verifisert invitasjon til å anmelde butikken din.",
    "trustpilot_landing_how_it_works_title": "Slik fungerer det",
    "trustpilot_landing_how_it_works_1": "Du kopierer AFS-adressen din fra Trustpilot Business og limer den inn i innstillingene.",
    "trustpilot_landing_how_it_works_2": "Når alle varene i en ordre er sendt, eller resten er kansellert etter en delsending, sender vi én e-post til Trustpilot med ordrenummer, navn og e-postadresse.",
    "trustpilot_landing_how_it_works_3": "Trustpilot sender invitasjonen til kunden etter forsinkelsen og malen du har valgt der.",
    "trustpilot_landing_requirements": "Krever en Trustpilot Business-konto. Automatic Feedback Service er inkludert i alle Trustpilot-planer, også gratisplanen.",
    "add_variant_type": "Legg til en varianttype",
    "product_variant": "Produktvariant",
    "product_variants_tooltip_text": "Produktvarianter lar deg selge ulike versjoner av et produkt, for eksempel i flere farger eller størrelser.<br><br>Legg til en varianttype, for eksempel Farge, med alternativene kunden kan velge mellom, som Rød, Blå og Gul. Hver kombinasjon av alternativer blir en egen produktvariant med pris, lager og galleribilde i tabellen under.<br><br>Under Visningsregler bestemmer du hvordan alternativene vises i nettbutikken: som tekst, fargeprøver eller små bilder. Varianttypene brukes også i filtrene på kategorisidene.<br><br>Merk: En varianttype kan ikke ha samme navn som en attributt på produktet.",
    "variant_image_scope_legend": "Bruk bildet på",
    "variant_image_scope_value": "Alle med {value} ({count})",
    "variant_image_scope_single": "Bare denne produktvarianten",
    "variant_photo_button": "Galleribilde – klikk for å bytte",
    "variant_photo_button_empty": "Velg galleribilde for denne produktvarianten",
    "variant_photo_picker_title": "Galleribilde for {variant}",
    "variant_photo_picker_description": "Galleriet på produktsiden bytter til dette bildet når kunden velger produktvarianten. Bildet vises også i handlekurven.",
    "variant_type": "Varianttype",
    "variant_type_name_placeholder": "Skriv for å finne en varianttype eller lage en ny, for eksempel Farge",
    "variant_type_values": "Alternativer",
    "variant_type_values_help": "Skriv inn alternativene kunden skal kunne velge mellom, for eksempel S, M og L. Velg fra listen eller lag nye.",
    "variant_type_drag": "Dra for å endre rekkefølgen",
    "variant_type_delete": "Slett varianttypen {option}",
    "variant_type_remove_value": "Fjern {value}",
    "variant_type_add_value_placeholder": "Legg til alternativ",
    "variant_type_shown_as_text": "Vises som tekstknapper",
    "variant_type_shown_as_colors": "Vises som fargeprøver",
    "variant_type_shown_as_images": "Vises som bildeknapper",
    "variant_type_used_on_cards": "Brukes på produktkortene",
    "variant_type_values_missing_color": "{count} alternativ mangler farge | {count} alternativer mangler farge",
    "variant_type_values_missing_image": "{count} alternativ mangler bilde | {count} alternativer mangler bilde",
    "variant_display_rules": "Visningsregler",
    "variant_display_rules_intro": "Bestem hvordan kunden ser og velger produktvariantene i nettbutikken.",
    "variant_display_heading": "Visning i nettbutikken",
    "variant_display_heading_description": "Velg hvordan produktvariantene skal vises på produktsiden og i produktoversikter.",
    "variant_display_text_description": "Alternativene vises som knapper med tekst, for eksempel S, M og L eller Rød, Blå og Gul.",
    "variant_display_color_description": "Alternativene vises som fargeprøver. Du velger én farge for hvert alternativ.",
    "variant_display_image_description": "Alternativene vises som små bilder, for eksempel av stoff, mønster eller materiale. Du laster opp ett bilde for hvert alternativ.",
    "variant_display_design_editor_note": "I designbyggeren velger du om alternativene skal vises i produktoversikter, og hvordan de skal se ut.",
    "variant_display_open_design_editor": "Åpne designbyggeren",
    "variant_display_value_missing_color": "Mangler farge – vises bare med navn, og ikke på produktkortene",
    "variant_display_value_missing_image": "Mangler bilde – vises bare med navn, og ikke på produktkortene",
    "variant_display_color_values_heading": "Farge for hvert alternativ",
    "variant_display_color_values_description": "Fargen vises i knappen kunden trykker på.",
    "variant_display_pick_color_for": "Velg farge for {value}",
    "variant_display_hex_for": "Fargekode for {value}",
    "variant_display_image_values_heading": "Bilde for hvert alternativ",
    "variant_display_image_values_description": "Bruk et nærbilde av stoffet eller mønsteret. Bildet vises i knappen kunden trykker på – det er ikke produktbildet.",
    "variant_display_choose_image_for": "Velg bilde for {value}",
    "variant_display_upload_image": "Last opp",
    "variant_display_pick_uploaded_image": "Eller velg et bilde du har lastet opp før:",
    "variant_display_cards_heading": "Produktoversikter",
    "variant_display_cards_description": "Produktkortene i kategorier og søk viser alternativene fra én varianttype. Velg hvilken.",
    "variant_display_card_text": "Tekstknapper",
    "variant_display_card_color": "Fargeprøver",
    "variant_display_card_image": "Bildeknapper",
    "variant_display_illustration_help": "Slik ser kunden det. Trykk på et alternativ for å se hvilket galleribilde som vises.",
    "variant_display_illustration_caption": "Illustrasjon av produktsiden og et produktkort som viser hvor visningsreglene brukes",
    "variant_display_product_page": "Produktsiden",
    "variant_display_product_listing": "Produktoversikt",
    "variant_display_legend_photo": "Galleribilde.",
    "variant_display_legend_buttons": "Valgknapper.",
    "variant_display_legend_buttons_text": "Det du bestemmer i dette vinduet.",
    "variant_display_legend_card": "Produktkort.",
    "variant_display_gallery_hint_empty": "Bildet galleriet viser. Det velges for hver produktvariant i kolonnen Galleribilde.",
    "variant_display_gallery_hint_photo": "Når kunden velger {value}, bytter galleriet til galleribildet du har valgt for den produktvarianten.",
    "variant_display_gallery_hint_main": "{value} har ikke eget galleribilde, så galleriet blir stående på hovedbildet. Du velger det i kolonnen Galleribilde i tabellen Produktvarianter.",
    "variant_display_saved_with_product": "Endringene lagres når du lagrer produktet.",
    "gallery_badge_option_button": "Knapp: {value}",
    "variant_display_card_hint": "Viser {option} når alternativene er slått på i designbyggeren.",
    "variant_gallery_column": "Galleri",
    "variant_gallery_explainer_label": "Hva er galleribildet?",
    "variant_gallery_explainer_title": "Galleribildet",
    "variant_gallery_explainer_text": "Når kunden velger en produktvariant på produktsiden, bytter galleriet til bildet du velger her.",
    "variant_photo_preview_hint": "Hold over et bilde for å se det i galleriet.",
    "variant_display_cards_examples_heading": "Se hvordan det kan se ut på produktkortene",
    "variant_display_cards_description_single": "Produktkortene i kategorier og søk viser alternativene for {option}.",
    "lead_paragraph_placeholder": "Kort beskrivelse av produktet",
    "add_product_description": "Legg til beskrivelse",
    "add_product_description_hint": "Blir en egen fane på produktsiden, f.eks. Størrelsesguide",
    "wysiwyg_tabs_select_label": "Velg fane",
    "hide_price": "Skjul pris",
    "hide_buy_button": "Skjul kjøpsknapp",
    "hide_buy_button_hint": "Kunder kan ikke legge produktet i handlekurven.",
    "hide_buy_button_contact_form_link": "Kombiner gjerne med kontaktskjema.",
    "x_of_y_variants": "{count} av {total} varianter",
    "always_hidden_when_price_hidden": "Alltid skjult når prisen er skjult"
}
